/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Adding scalar types which are not built in and need to be defined explicitly
   * The AWSDate scalar type represents a valid extended ISO 8601 Date string. In other words, this scalar
   * type accepts date strings of the form YYYY-MM-DD. This scalar type can also accept time zone offsets.
   * For example, 1970-01-01Z, 1970-01-01-07:00 and 1970-01-01+05:30 are all valid dates. The time zone
   * offset must either be Z (representing the UTC time zone) or be in the format ±hh:mm:ss. The seconds
   * field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard.
   */
  AWSDate: { input: any; output: any };
  /**
   * The AWSDateTime scalar type represents a valid extended ISO 8601 DateTime string.
   * In other words, this scalar type accepts datetime strings of the form YYYY-MM-DDThh:mm:ss.sssZ. The field after
   * the seconds field is a nanoseconds field. It can accept between 1 and 9 digits. The seconds and nanoseconds
   * fields are optional (the seconds field must be specified if the nanoseconds field is to be used). The time zone
   * offset is compulsory for this scalar. The time zone offset must either be Z (representing the UTC time zone) or
   * be in the format ±hh:mm:ss. The seconds field in the timezone offset will be considered valid even though it is
   * not part of the ISO 8601 standard.
   */
  AWSDateTime: { input: any; output: any };
  /**
   * The AWSEmail scalar type represents an Email address string that complies with RFC 822. For example, username@example.com
   *  is a valid Email address.
   */
  AWSEmail: { input: any; output: any };
  /** The AWSIPAddress scalar type represents a valid IPv4 or IPv6 address string. */
  AWSIPAddress: { input: any; output: any };
  /**
   * The AWSJSON scalar type represents a JSON string that complies with RFC 8259. Maps like {"upvotes": 10},
   * lists like [1,2,3], and scalar values like "AWSJSON example string", 1, and true are accepted as valid JSON.
   * They will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values
   * rather than as the literal input strings. Invalid JSON strings like {a: 1}, {'a': 1} and Unquoted string will
   * throw GraphQL validation errors.
   */
  AWSJSON: { input: any; output: any };
  /**
   * The AWSPhone scalar type represents a valid Phone Number. Phone numbers are serialized and deserialized as Strings.
   * Phone numbers provided may be whitespace delimited or hyphenated. The number can specify a country code at the
   * beginning but this is not required.
   */
  AWSPhone: { input: any; output: any };
  /**
   * The AWSTimestamp scalar type represents the number of seconds that have elapsed since 1970-01-01T00:00Z.
   * Timestamps are serialized and deserialized as numbers. Negative values are also accepted and these represent the
   * number of seconds till 1970-01-01T00:00Z.
   */
  AWSTimestamp: { input: any; output: any };
  /**
   * The AWSURL scalar type represents a valid URL string. The URL may use any scheme and may also be a local URL
   * (Ex: <http://localhost/>). URLs without schemes are considered invalid. URLs which contain double slashes are
   * also considered invalid.
   */
  AWSURL: { input: any; output: any };
};

export enum AcceptValidation {
  MultipleApptsAtTimeslot = 'MULTIPLE_APPTS_AT_TIMESLOT',
  ReachedMaxLimit = 'REACHED_MAX_LIMIT',
  Success = 'SUCCESS'
}

export type AccountConfig = {
  __typename?: 'AccountConfig';
  faviconUrl?: Maybe<Scalars['String']['output']>;
  hideCventFooter?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountMobileSettings = {
  __typename?: 'AccountMobileSettings';
  accessCodePrefix: Scalars['String']['output'];
};

export type Achievement = {
  __typename?: 'Achievement';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  goals: Array<Maybe<Goal>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stickerName: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type AchievementProgress = {
  __typename?: 'AchievementProgress';
  achievementId: Scalars['ID']['output'];
  achievementName: Scalars['String']['output'];
  fractionCompleted?: Maybe<Scalars['Float']['output']>;
  goalProgress?: Maybe<Array<Maybe<GoalProgress>>>;
  level?: Maybe<Scalars['Int']['output']>;
  stickerName: Scalars['String']['output'];
  totalPoints?: Maybe<Scalars['Int']['output']>;
};

export type AdCounts = {
  __typename?: 'AdCounts';
  draft: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
};

/** Models */
export enum AdLocation {
  ExhibitorList = 'EXHIBITOR_LIST',
  HomePage = 'HOME_PAGE',
  SessionList = 'SESSION_LIST'
}

export type AdLocationSetting = {
  __typename?: 'AdLocationSetting';
  adFrequency?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  location: AdLocation;
  numberOfPlacements?: Maybe<Scalars['Int']['output']>;
};

export type AdLocationSettings = {
  __typename?: 'AdLocationSettings';
  locations: Array<AdLocationSetting>;
};

export type AddReactionInput = {
  reactionType: Scalars['Int']['input'];
  streamOffsetSecs: Scalars['Int']['input'];
};

export type AddReactionOutput = {
  __typename?: 'AddReactionOutput';
  accountMappingId: Scalars['ID']['output'];
  attendeeId: Scalars['ID']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  reactionType: Scalars['Int']['output'];
  sessionId: Scalars['ID']['output'];
  streamOffsetSecs: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  /** regionName should only be used when no region code available for the given country */
  regionName?: InputMaybe<Scalars['String']['input']>;
};

export enum AdjustmentType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

/** Admission Item object */
export type AdmissionItem = {
  __typename?: 'AdmissionItem';
  amount?: Maybe<Scalars['Float']['output']>;
  attendeeCanUpgradeAdmissionItem?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdmissionItemSettings = AttendeeHubConfigInterface & {
  __typename?: 'AdmissionItemSettings';
  admissionItemUpgradeVisible: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type AdmissionItemSettingsInput = {
  admissionItemUpgradeVisible: Scalars['Boolean']['input'];
};

export type AgendaDate = {
  __typename?: 'AgendaDate';
  agendaDate: Scalars['String']['output'];
};

export type AgendaDatesInput = {
  preferredTimezone: Scalars['String']['input'];
};

export type AgendaDatesResponse = {
  __typename?: 'AgendaDatesResponse';
  data: Array<AgendaDate>;
};

export type AgendaItem = {
  __typename?: 'AgendaItem';
  appointmentStatus?: Maybe<ApptStatus>;
  apptType?: Maybe<AppointmentType>;
  availableAttendeeActions?: Maybe<AppointmentAttendeeActions>;
  capacity?: Maybe<CapacityRemaining>;
  category?: Maybe<SessionCategory>;
  code?: Maybe<Scalars['String']['output']>;
  conflict?: Maybe<Scalars['Boolean']['output']>;
  contentTags?: Maybe<Array<ContentTag>>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['AWSDateTime']['output'];
  enrolled?: Maybe<Scalars['Boolean']['output']>;
  exhibitors: Array<SessionExhibitor>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  fee?: Maybe<SessionFee>;
  id: Scalars['ID']['output'];
  /**
   * IDs of the agenda-items which got impacted due to action on this agenda-item, eg. IDs of the appointments which got
   * updated when the user accepted this appointment agenda-item
   */
  impactedAgendaItems?: Maybe<Array<ImpactedAgendaItem>>;
  included?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SessionLocation>;
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  openForAttendeeHub?: Maybe<Scalars['Boolean']['output']>;
  openForRegistration?: Maybe<Scalars['Boolean']['output']>;
  parentLocationDisplayName?: Maybe<Scalars['String']['output']>;
  participants: Array<AppointmentParticipant>;
  requestees?: Maybe<Array<ApptAttendee>>;
  requesters?: Maybe<Array<ApptAttendee>>;
  speakers?: Maybe<Array<Speaker>>;
  start: Scalars['AWSDateTime']['output'];
  status?: Maybe<AppointmentConfirmationStatus>;
  type: AgendaItemType;
  virtual?: Maybe<Scalars['Boolean']['output']>;
  virtualLink?: Maybe<Scalars['String']['output']>;
  webcast?: Maybe<Webcast>;
};

export type AgendaItemCapacityArgs = {
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AgendaItemType {
  Appointment = 'APPOINTMENT',
  PersonalTime = 'PERSONAL_TIME',
  ReservedTime = 'RESERVED_TIME',
  Session = 'SESSION'
}

export enum AgendaItemTypeFilter {
  All = 'ALL',
  Appointments = 'APPOINTMENTS',
  PersonalTimes = 'PERSONAL_TIMES',
  Sessions = 'SESSIONS'
}

export type AgendaPaginatedResults = {
  __typename?: 'AgendaPaginatedResults';
  data: Array<AgendaItem>;
  pagination?: Maybe<Pagination>;
};

export type Answer = {
  __typename?: 'Answer';
  answerType: Scalars['String']['output'];
  choice?: Maybe<Scalars['String']['output']>;
  choiceId?: Maybe<Scalars['String']['output']>;
  decimalValue?: Maybe<Scalars['Float']['output']>;
  longValue?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type AnswerInfoInput = {
  answerType?: InputMaybe<Scalars['String']['input']>;
  choice?: InputMaybe<Scalars['String']['input']>;
  choiceId?: InputMaybe<Scalars['String']['input']>;
  decimalValue?: InputMaybe<Scalars['String']['input']>;
  longValue?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerInput = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInfoInput>>>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * (Deprecated - Reference AttendeeHubConfig)
 * AppConfig model. Defines the appConfig and versioning
 */
export type AppConfig = {
  __typename?: 'AppConfig';
  appConfigString?: Maybe<Scalars['String']['output']>;
  appType?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  lastPublished?: Maybe<Scalars['AWSDateTime']['output']>;
  liveDisplayConfigString?: Maybe<Scalars['String']['output']>;
  publish?: Maybe<Scalars['Boolean']['output']>;
  publishDetails?: Maybe<Array<Maybe<PublishDetails>>>;
  publishedVersionId?: Maybe<Scalars['String']['output']>;
  savedVersionId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  webConfig?: Maybe<WebConfig>;
};

/** App Feature */
export type AppFeature = {
  __typename?: 'AppFeature';
  enabled: Scalars['Boolean']['output'];
  experimentVersion?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/**
 * A single app feature to resolve. Defines the backing experiment and the version
 * the variant must on or above for the feature to be enabled.
 */
export type AppFeatureInput = {
  experimentName: Scalars['String']['input'];
  featureVersion: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export enum AppType {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type Appointment = AppointmentBase & {
  __typename?: 'Appointment';
  actions?: Maybe<AppointmentActions>;
  /** Appointment status */
  appointmentStatus: Scalars['String']['output'];
  /**
   * Overall status of the attendee in the appointment for whom this Appointment was fetched (computed based on other
   * participants' statuses)
   */
  apptConfirmationStatus?: Maybe<Scalars['String']['output']>;
  apptEventId?: Maybe<Scalars['String']['output']>;
  apptType: AppointmentType;
  apptTypeId: Scalars['String']['output'];
  boothLocationName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  exhibitorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAutoAcceptAttendees?: Maybe<Scalars['Boolean']['output']>;
  isEnforceScheduleRules?: Maybe<Scalars['Boolean']['output']>;
  isInternalLocation?: Maybe<Scalars['Boolean']['output']>;
  isLocationAtLimit?: Maybe<Scalars['Boolean']['output']>;
  isPlannerCreated?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedOn?: Maybe<Scalars['String']['output']>;
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  otherOrganizationCount?: Maybe<Scalars['Int']['output']>;
  parentLocationDisplayName?: Maybe<Scalars['String']['output']>;
  parentLocationId?: Maybe<Scalars['ID']['output']>;
  privateNote?: Maybe<Scalars['String']['output']>;
  privateNoteViewers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requesteeAnswers?: Maybe<Array<Maybe<AppointmentAnswer>>>;
  requestees?: Maybe<Array<Maybe<ApptAttendee>>>;
  requesterAnswers?: Maybe<Array<Maybe<AppointmentAnswer>>>;
  requesterAnswersViewers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requesters?: Maybe<Array<Maybe<ApptAttendee>>>;
  selectedBoothId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['AWSDateTime']['output'];
  /** Individual status of the attendee in the appointment for whom this Appointment was fetched */
  status: Scalars['String']['output'];
  timeSlotId: Scalars['String']['output'];
  virtualAccess?: Maybe<Scalars['Boolean']['output']>;
  virtualLink?: Maybe<Scalars['String']['output']>;
};

export type AppointmentActions = {
  __typename?: 'AppointmentActions';
  canAccept?: Maybe<Scalars['Boolean']['output']>;
  canAddPrivateNotes?: Maybe<Scalars['Boolean']['output']>;
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  canCheckIn?: Maybe<Scalars['Boolean']['output']>;
  canDecline?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canProposeNewTime?: Maybe<Scalars['Boolean']['output']>;
  canUndoCheckIn?: Maybe<Scalars['Boolean']['output']>;
};

export type AppointmentAnswer = {
  __typename?: 'AppointmentAnswer';
  answers?: Maybe<Array<Maybe<Answer>>>;
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
};

export type AppointmentAttendeeActions = {
  __typename?: 'AppointmentAttendeeActions';
  accept?: Maybe<Scalars['Boolean']['output']>;
  decline?: Maybe<Scalars['Boolean']['output']>;
};

export type AppointmentAttendeeInfo = {
  __typename?: 'AppointmentAttendeeInfo';
  code: Scalars['String']['output'];
};

export type AppointmentBase = {
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isAutoAcceptAttendees?: Maybe<Scalars['Boolean']['output']>;
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  requestees?: Maybe<Array<Maybe<ApptAttendee>>>;
  requesters?: Maybe<Array<Maybe<ApptAttendee>>>;
  startTime: Scalars['AWSDateTime']['output'];
  timeSlotId: Scalars['String']['output'];
};

export enum AppointmentConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Denied = 'DENIED',
  Pending = 'PENDING',
  Tentative = 'TENTATIVE'
}

export type AppointmentEvent = {
  __typename?: 'AppointmentEvent';
  apptEventCode?: Maybe<Scalars['String']['output']>;
  apptEventType: ApptEventType;
  id: Scalars['ID']['output'];
  readOnly: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AppointmentListItem = AppointmentBase & {
  __typename?: 'AppointmentListItem';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isAutoAcceptAttendees?: Maybe<Scalars['Boolean']['output']>;
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  requestees?: Maybe<Array<Maybe<ApptAttendee>>>;
  requesters?: Maybe<Array<Maybe<ApptAttendee>>>;
  startTime: Scalars['AWSDateTime']['output'];
  timeSlotId: Scalars['String']['output'];
};

export type AppointmentParticipant = {
  __typename?: 'AppointmentParticipant';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AppointmentSearchInput = {
  apptEventId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Appointment Selector */
export type AppointmentSelector = {
  appointmentCode: Scalars['String']['input'];
  confirmationNumber: Scalars['String']['input'];
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  allowAttachments?: Maybe<Scalars['Boolean']['output']>;
  allowBoothStaffCreate: Scalars['Boolean']['output'];
  attendeeRole: Scalars['String']['output'];
  autoAccept?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  confirmRequesters?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hideAttendeesFlag?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includeBooth: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  needsPlannerApproval?: Maybe<Scalars['Boolean']['output']>;
  requesteeQuestions: Array<Maybe<ApptQuestion>>;
  requesterQuestions: Array<Maybe<ApptQuestion>>;
  requireRequestees?: Maybe<Scalars['Boolean']['output']>;
  timeSlotType: Scalars['String']['output'];
  virtualMeetingSolution?: Maybe<VirtualMeetingSolution>;
};

export type AppointmentTypes = {
  __typename?: 'AppointmentTypes';
  data: Array<Maybe<AppointmentType>>;
};

export type AppointmentsResponse = {
  __typename?: 'AppointmentsResponse';
  data?: Maybe<Array<AppointmentListItem>>;
  paging?: Maybe<OffsetPagination>;
};

export type ApptAttendee = {
  __typename?: 'ApptAttendee';
  attendance?: Maybe<ApptAttendeeAttendance>;
  company?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['String']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<ApptAttendeeEntityType>;
  firstName: Scalars['String']['output'];
  inviteeStub: Scalars['ID']['output'];
  isColleague?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  status: ApptAttendeeStatus;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ApptAttendeeAttendance {
  Checkedin = 'CHECKEDIN',
  Noshow = 'NOSHOW',
  Unknown = 'UNKNOWN'
}

export enum ApptAttendeeEntityType {
  Contact = 'CONTACT',
  Exhibitor = 'EXHIBITOR',
  Invitee = 'INVITEE'
}

export type ApptAttendeeInput = {
  attendance?: InputMaybe<ApptAttendeeAttendance>;
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export enum ApptAttendeeStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Declined = 'declined',
  Pending = 'pending',
  PendingProposed = 'pending_proposed',
  Tentative = 'tentative'
}

export type ApptEventAttendee = {
  __typename?: 'ApptEventAttendee';
  apptEventId: Scalars['ID']['output'];
  canRequest?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inviteeStub: Scalars['ID']['output'];
  isBoothStaff?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether this attendee is from same organisation as the user (evaluated based on company & email domain) */
  isColleague?: Maybe<Scalars['Boolean']['output']>;
  isTeamMember?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ApptEventAttendees = {
  __typename?: 'ApptEventAttendees';
  attendees?: Maybe<Array<Maybe<ApptEventAttendee>>>;
  searchId?: Maybe<Scalars['ID']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ApptEventType {
  PlannerCoordinated = 'PLANNER_COORDINATED',
  Simple = 'SIMPLE',
  Standard = 'STANDARD',
  Universal = 'UNIVERSAL'
}

export type ApptEventUpgradableStatus = {
  __typename?: 'ApptEventUpgradableStatus';
  activeAppointments: Scalars['Boolean']['output'];
  incorrectAccountConfiguration: Scalars['Boolean']['output'];
  insufficientPermission: Scalars['Boolean']['output'];
  linkedRegEventArchived: Scalars['Boolean']['output'];
};

export type ApptEventWebsiteSettings = {
  __typename?: 'ApptEventWebsiteSettings';
  attendeeAppointmentsAccess: Scalars['Boolean']['output'];
};

export type ApptEventWebsiteSettingsInput = {
  apptEventId: Scalars['String']['input'];
  attendeeAppointmentsAccess: Scalars['Boolean']['input'];
};

export type ApptImportError = {
  __typename?: 'ApptImportError';
  attendees?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  errorKeys?: Maybe<Array<ApptImportErrorKey>>;
  errorType: Scalars['String']['output'];
  hosts?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAttendeeAutoAccepted?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
};

export type ApptImportErrorKey = {
  __typename?: 'ApptImportErrorKey';
  errorEmail?: Maybe<Scalars['String']['output']>;
  errorKey: Scalars['String']['output'];
  fieldName?: Maybe<Scalars['String']['output']>;
};

export type ApptImportHistory = {
  __typename?: 'ApptImportHistory';
  data?: Maybe<Array<ApptImportHistoryItem>>;
  paging: OffsetPagination;
};

export type ApptImportHistoryInput = {
  apptEventId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ApptImportHistoryItem = {
  __typename?: 'ApptImportHistoryItem';
  apptEventStub: Scalars['ID']['output'];
  completedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  failedRecords?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  modifiedBy?: Maybe<Scalars['ID']['output']>;
  modifiedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApptImportHistoryStatus>;
  successfulRecords?: Maybe<Scalars['Int']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  uploadedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  uploaderName?: Maybe<Scalars['String']['output']>;
};

export enum ApptImportHistoryStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ApptImportSummary = {
  __typename?: 'ApptImportSummary';
  importRowErrors?: Maybe<Array<ApptImportError>>;
};

export type ApptImportSummaryInput = {
  apptEventId: Scalars['String']['input'];
  importId: Scalars['String']['input'];
};

export type ApptProposedTime = {
  __typename?: 'ApptProposedTime';
  apptId?: Maybe<Scalars['ID']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  inviteeStub: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  locationStub?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['AWSDateTime']['output'];
};

export type ApptQuestion = {
  __typename?: 'ApptQuestion';
  apptTypes: Array<Maybe<Scalars['String']['output']>>;
  consentFlag: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  question: QuestionInfo;
  questionServiceEntityType: Scalars['String']['output'];
  showOnWizard: Scalars['Boolean']['output'];
};

export enum ApptStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingApprovalAndAssignment = 'PENDING_APPROVAL_AND_ASSIGNMENT',
  PendingAssignment = 'PENDING_ASSIGNMENT',
  PendingHostAssignment = 'PENDING_HOST_ASSIGNMENT'
}

export enum ApptTimeSlotType {
  Adhoc = 'ADHOC',
  Standard = 'STANDARD'
}

export enum ApptTypeCategory {
  CustomAppointment = 'CUSTOM_APPOINTMENT',
  ExhibitorNetworking = 'EXHIBITOR_NETWORKING',
  SelfSignUp = 'SELF_SIGN_UP',
  VahAttendeeNetworking = 'VAH_ATTENDEE_NETWORKING'
}

export type ApptTypesInput = {
  attendeeId?: InputMaybe<Scalars['String']['input']>;
  exhibitorId?: InputMaybe<Scalars['String']['input']>;
  includeQuestions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Asset = {
  __typename?: 'Asset';
  altText?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['ID']['output'];
  assetType?: Maybe<AssetType>;
  extension?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isSecure: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  size: Scalars['Int']['output'];
};

export type AssetInfo = {
  __typename?: 'AssetInfo';
  altText?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isSecure: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Update to MediaLibrary Images */
export enum AssetType {
  Document = 'DOCUMENT',
  Media = 'MEDIA'
}

/** Input request to assign session to an existing widget */
export type AssignSessionsInput = {
  sessions: Array<WidgetSessionInput>;
  widgetId: Scalars['ID']['input'];
};

export type AssignedSession = {
  __typename?: 'AssignedSession';
  code?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['AWSDateTime']['output'];
};

export type AssignedWidgetSession = {
  __typename?: 'AssignedWidgetSession';
  code?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  widgetIcon?: Maybe<Scalars['String']['output']>;
  widgetId: Scalars['ID']['output'];
  widgetTitle?: Maybe<Scalars['String']['output']>;
};

export type AssignedWidgetsCount = {
  __typename?: 'AssignedWidgetsCount';
  sessionId: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

/** Used in the Ah-Web */
export type Attendee = {
  __typename?: 'Attendee';
  address?: Maybe<Address>;
  admissionItem?: Maybe<AdmissionItem>;
  allowAppointmentPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  allowPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  answers?: Maybe<Array<RegQuestionAnswer>>;
  attendeeSegmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  bio?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use headline instead */
  biography?: Maybe<Scalars['String']['output']>;
  canMeet: Scalars['Boolean']['output'];
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  connectionStatus: AttendeeConnectionStatus;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used / should only return null (potential pii) */
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  guest?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  prefix?: Maybe<Scalars['String']['output']>;
  professionalInterests?: Maybe<Array<AttendeeInterestComparisonResult>>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  registrationPath?: Maybe<NamedObject>;
  registrationType?: Maybe<NamedObject>;
  title?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  virtual: Scalars['Boolean']['output'];
  visibility?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Used in the Ah-Web */
export type AttendeeAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AttendeeConnection = AttendeeConnectionContact & {
  __typename?: 'AttendeeConnection';
  attendeeId: Scalars['ID']['output'];
  canMeet: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  connectedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  contactId: Scalars['ID']['output'];
  createdDate: Scalars['AWSDateTime']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['AWSURL']['output']>;
  requestedDate: Scalars['AWSDateTime']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  visibility: AttendeeVisibility;
};

export type AttendeeConnectionContact = {
  attendeeId: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['ID']['output'];
  createdDate: Scalars['AWSDateTime']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['AWSURL']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
};

export type AttendeeConnectionPaginatedResults = {
  __typename?: 'AttendeeConnectionPaginatedResults';
  data: Array<AttendeeConnection>;
  paging?: Maybe<Pagination>;
};

export type AttendeeConnectionPendingCount = {
  __typename?: 'AttendeeConnectionPendingCount';
  pendingCount: Scalars['Int']['output'];
};

export type AttendeeConnectionSearchCriteria = {
  direction?: InputMaybe<AttendeeConnectionSearchDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AttendeeConnectionSearchSortBy>;
  status?: InputMaybe<AttendeeConnectionSearchableStatus>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum AttendeeConnectionSearchDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AttendeeConnectionSearchSortBy {
  Company = 'COMPANY',
  ConnectedDate = 'CONNECTED_DATE',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  RequestedDate = 'REQUESTED_DATE',
  Title = 'TITLE'
}

export enum AttendeeConnectionSearchableStatus {
  Connected = 'CONNECTED',
  Pending = 'PENDING'
}

export enum AttendeeConnectionStatus {
  AwaitingResponse = 'AWAITING_RESPONSE',
  Connected = 'CONNECTED',
  Declined = 'DECLINED',
  NotConnected = 'NOT_CONNECTED',
  Pending = 'PENDING'
}

export type AttendeeConnectionStatusResponse = {
  __typename?: 'AttendeeConnectionStatusResponse';
  status: AttendeeConnectionStatus;
};

export type AttendeeConnectionUpdatedFields = {
  __typename?: 'AttendeeConnectionUpdatedFields';
  action?: Maybe<AttendeePendingConnectionAction>;
  attendeeId: Scalars['ID']['output'];
  eventId: Scalars['ID']['output'];
  initiatorAttendeeId?: Maybe<Scalars['ID']['output']>;
  pendingConnectionsCount: Scalars['Int']['output'];
};

export type AttendeeConsent = {
  __typename?: 'AttendeeConsent';
  /** empty response when terms are disabled */
  hasAccepted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AttendeeFetchCriteria = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageCriteria?: InputMaybe<AttendeePageCriteria>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type AttendeeFieldCompletionResult = {
  __typename?: 'AttendeeFieldCompletionResult';
  allFieldGroupNames?: Maybe<Array<Scalars['String']['output']>>;
  hasProfilePicture: Scalars['Boolean']['output'];
  percentComplete: Scalars['Int']['output'];
  unfilledFieldGroupNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type AttendeeFilterCriteria = {
  regQuestions: Array<RegQuestionsFilter>;
};

export type AttendeeHasChannels = {
  __typename?: 'AttendeeHasChannels';
  hasChannels?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  resetAt?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AttendeeHubConfig = {
  __typename?: 'AttendeeHubConfig';
  admissionItemSettings?: Maybe<AdmissionItemSettings>;
  attendeeListFilters: AttendeeListFilters;
  attendeeWebsiteSettings: AttendeeWebsiteSettings;
  availableQuickLinks: Array<AvailableQuickLinks>;
  checklistSettings?: Maybe<ChecklistSettings>;
  contentVisibilityGroups: ContentVisibilityGroups;
  contentVisibilitySettings: ContentVisibilitySettings;
  customPageSettings?: Maybe<Array<Maybe<CustomPageSettings>>>;
  defaultPageSettings: DefaultPageSettings;
  eventDefaultSettings: EventDefaultSettings;
  eventGuideSettings: EventGuideSettings;
  eventGuideSettingsV2: EventGuideSettingsV2;
  eventMobileSettings: EventMobileSettings;
  featureSettings: Array<Maybe<FeatureSettings>>;
  headerThemeSettings: HeaderThemeSettings;
  homeSchedulerSettings: HomeSchedulerSettings;
  linkedAppointmentEvent: Array<LinkedAppointmentEvent>;
  liveDisplaySettings: LiveDisplaySettings;
  mobileAssets: MobileAssets;
  mobilePublishDetails?: Maybe<PublishDetails>;
  morePageSettings: MorePageSettings;
  pageBannerPageSettingsBulk: Array<PageBannerPageSettings>;
  pageBannerSettings?: Maybe<Array<PageBannerSettings>>;
  plannerPermissions?: Maybe<PlannerPermissions>;
  privacySettings: PrivacySettings;
  profileSettings: ProfileSettings;
  registrationQuestions: Array<Maybe<RegistrationQuestions>>;
  securitySettings: SecuritySettings;
  themeSettings: ThemeSettings;
  venueMapSettings: VenueMapSettings;
  webPublishDetails?: Maybe<PublishDetails>;
};

/** Below are all for the V2 app config graph. */
export type AttendeeHubConfigInterface = {
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type AttendeeHubDefaultPage = {
  __typename?: 'AttendeeHubDefaultPage';
  containsSubPages: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platform: Platform;
};

export enum AttendeeHubDefaultPages {
  Event = 'EVENT',
  Sessions = 'SESSIONS'
}

export type AttendeeHubFeaturedPage = {
  __typename?: 'AttendeeHubFeaturedPage';
  containsSubPages: Scalars['Boolean']['output'];
  featureName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: Platform;
};

export enum AttendeeHubFeaturedPages {
  AttendeeConnections = 'ATTENDEE_CONNECTIONS',
  AttendeeList = 'ATTENDEE_LIST',
  AttendeeProfile = 'ATTENDEE_PROFILE',
  Event = 'EVENT',
  Exhibitors = 'EXHIBITORS',
  Game = 'GAME',
  OnDemandContentLibrary = 'ON_DEMAND_CONTENT_LIBRARY',
  Schedule = 'SCHEDULE',
  Sessions = 'SESSIONS',
  Speakers = 'SPEAKERS',
  SpeedNetworking = 'SPEED_NETWORKING',
  Sponsors = 'SPONSORS',
  UpcomingEvents = 'UPCOMING_EVENTS',
  VideoDiscussions = 'VIDEO_DISCUSSIONS',
  YourEvents = 'YOUR_EVENTS'
}

export enum AttendeeHubFeatures {
  AttendeeConnections = 'ATTENDEE_CONNECTIONS',
  AttendeeList = 'ATTENDEE_LIST',
  AttendeeProfile = 'ATTENDEE_PROFILE',
  ExhibitorList = 'EXHIBITOR_LIST',
  Game = 'GAME',
  MySchedule = 'MY_SCHEDULE',
  OnDemandContentLibrary = 'ON_DEMAND_CONTENT_LIBRARY',
  SpeedNetworking = 'SPEED_NETWORKING',
  UpcomingEvents = 'UPCOMING_EVENTS',
  VideoDiscussions = 'VIDEO_DISCUSSIONS',
  YourEvents = 'YOUR_EVENTS'
}

export enum AttendeeHubPageGroups {
  AttendeePages = 'ATTENDEE_PAGES',
  Community = 'COMMUNITY',
  Expo = 'EXPO',
  Schedule = 'SCHEDULE'
}

export enum AttendeeHubPageType {
  AttendeeConnections = 'ATTENDEE_CONNECTIONS',
  AttendeeList = 'ATTENDEE_LIST',
  AttendeeProfile = 'ATTENDEE_PROFILE',
  Community = 'COMMUNITY',
  CustomPages = 'CUSTOM_PAGES',
  DiscussionTopic = 'DISCUSSION_TOPIC',
  DocumentCustomPages = 'DOCUMENT_CUSTOM_PAGES',
  Event = 'EVENT',
  Exhibitors = 'EXHIBITORS',
  ExternalCustomPages = 'EXTERNAL_CUSTOM_PAGES',
  FloorPlanDetails = 'FLOOR_PLAN_DETAILS',
  FloorPlanList = 'FLOOR_PLAN_LIST',
  Game = 'GAME',
  Messages = 'MESSAGES',
  OnDemandContentLibrary = 'ON_DEMAND_CONTENT_LIBRARY',
  ProfileMenu = 'PROFILE_MENU',
  QrCode = 'QR_CODE',
  Schedule = 'SCHEDULE',
  Sessions = 'SESSIONS',
  SessionDetails = 'SESSION_DETAILS',
  Speakers = 'SPEAKERS',
  SpeakerDetails = 'SPEAKER_DETAILS',
  SpeedNetworking = 'SPEED_NETWORKING',
  Sponsors = 'SPONSORS',
  Surveys = 'SURVEYS',
  TravelDetails = 'TRAVEL_DETAILS',
  UpcomingEvents = 'UPCOMING_EVENTS',
  VideoDiscussions = 'VIDEO_DISCUSSIONS',
  VirtualBooth = 'VIRTUAL_BOOTH',
  YourEvents = 'YOUR_EVENTS'
}

export type AttendeeHubPages = {
  __typename?: 'AttendeeHubPages';
  customPages: Array<CustomPages>;
  defaultPages: Array<DefaultPage>;
  documentCustomPages: Array<CustomPages>;
  enabledPages: Array<EnabledPages>;
  externalCustomPages: Array<CustomPages>;
};

export type AttendeeHubPagesEntitiesResponse = {
  __typename?: 'AttendeeHubPagesEntitiesResponse';
  data?: Maybe<Array<AttendeeHubPagesEntity>>;
  paging?: Maybe<Pagination>;
};

export type AttendeeHubPagesEntity = {
  __typename?: 'AttendeeHubPagesEntity';
  endTime?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageType?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type AttendeeHubPagesResponse = {
  __typename?: 'AttendeeHubPagesResponse';
  defaultPages: Array<AttendeeHubDefaultPage>;
  featuredPages?: Maybe<Array<AttendeeHubFeaturedPage>>;
};

export type AttendeeInterestComparisonResult = {
  __typename?: 'AttendeeInterestComparisonResult';
  commonInterest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type AttendeeInterestsResponse = {
  __typename?: 'AttendeeInterestsResponse';
  data: Array<InterestChoice>;
};

export type AttendeeJoinUrl = {
  __typename?: 'AttendeeJoinUrl';
  joinUrl?: Maybe<Scalars['String']['output']>;
};

export type AttendeeListFilter = {
  __typename?: 'AttendeeListFilter';
  filterName: Scalars['String']['output'];
  filterOrder: Scalars['Int']['output'];
  questionId: Scalars['ID']['output'];
};

export type AttendeeListFilterInput = {
  filterName: Scalars['String']['input'];
  filterOrder: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type AttendeeListFilters = AttendeeHubConfigInterface & {
  __typename?: 'AttendeeListFilters';
  attendeeListFilters?: Maybe<Array<AttendeeListFilter>>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type AttendeeListFiltersInput = {
  attendeeListFilters: Array<InputMaybe<AttendeeListFilterInput>>;
};

export type AttendeeMessagingChannel = {
  __typename?: 'AttendeeMessagingChannel';
  attendeeIds: Array<Scalars['ID']['output']>;
  eventId: Scalars['ID']['output'];
};

export type AttendeeMutualConnection = AttendeeConnectionContact & {
  __typename?: 'AttendeeMutualConnection';
  attendeeId: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  connectionStatus?: Maybe<AttendeeConnectionStatus>;
  contactId: Scalars['ID']['output'];
  createdDate: Scalars['AWSDateTime']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mutual?: Maybe<Scalars['Boolean']['output']>;
  profileImageUrl?: Maybe<Scalars['AWSURL']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
};

export type AttendeeMutualConnectionPaginatedResults = {
  __typename?: 'AttendeeMutualConnectionPaginatedResults';
  data: Array<AttendeeMutualConnection>;
  paging?: Maybe<Pagination>;
};

export type AttendeeMutualConnectionSearchCriteria = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AttendeeMutualConnectionSort>>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum AttendeeMutualConnectionSearchSortBy {
  Company = 'COMPANY',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Mutual = 'MUTUAL',
  ProfileImg = 'PROFILE_IMG',
  Title = 'TITLE'
}

export type AttendeeMutualConnectionSort = {
  direction: SortDirection;
  sortBy: AttendeeMutualConnectionSearchSortBy;
};

export type AttendeePageCriteria = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type AttendeePaginatedResults = {
  __typename?: 'AttendeePaginatedResults';
  data: Array<Maybe<Attendee>>;
  pagination?: Maybe<Pagination>;
};

export enum AttendeePendingConnectionAction {
  Cancel = 'CANCEL',
  Connect = 'CONNECT'
}

export type AttendeePoll = Poll & {
  __typename?: 'AttendeePoll';
  eventId: Scalars['ID']['output'];
  isModeratorEditable?: Maybe<Scalars['Boolean']['output']>;
  myChoices?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name: Scalars['String']['output'];
  operation?: Maybe<Scalars['String']['output']>;
  pollId: Scalars['ID']['output'];
  questions: Array<PollQuestion>;
  sessionId: Scalars['ID']['output'];
  timeSetting?: Maybe<TimeSettingType>;
};

export type AttendeePreference = {
  __typename?: 'AttendeePreference';
  id: Scalars['ID']['output'];
  preferenceType: AttendeePreferenceType;
  preferenceValue: Scalars['String']['output'];
};

export type AttendeePreferenceInput = {
  preferenceType: AttendeePreferenceType;
  preferenceValue: Scalars['String']['input'];
};

export enum AttendeePreferenceType {
  OnboardingProgress = 'ONBOARDING_PROGRESS'
}

export type AttendeeRecommendation = {
  __typename?: 'AttendeeRecommendation';
  canMeet: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  connectionStatus: AttendeeConnectionStatus;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  dismissed: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AttendeeRegistrationInput = {
  webcastId: Scalars['String']['input'];
};

export type AttendeeSearchCriteria = {
  attendeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<AttendeeFilterCriteria>;
  pageCriteria?: InputMaybe<AttendeePageCriteria>;
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Attendee Details Embedded Virtual Meeting Status */
export type AttendeeStatus = {
  __typename?: 'AttendeeStatus';
  attendeeId: Scalars['ID']['output'];
  exhibitorId: Scalars['ID']['output'];
  meetingId?: Maybe<Scalars['ID']['output']>;
  meetingStatus?: Maybe<MeetingStatus>;
  requester?: Maybe<MeetingRequester>;
  status: Status;
};

/** Used in planner side */
export type AttendeeUnsecured = {
  __typename?: 'AttendeeUnsecured';
  address?: Maybe<Address>;
  admissionItem?: Maybe<AdmissionItem>;
  allowAppointmentPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  allowPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  answers?: Maybe<Array<RegQuestionAnswer>>;
  bio?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use headline instead */
  biography?: Maybe<Scalars['String']['output']>;
  canMeet: Scalars['Boolean']['output'];
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  connectionStatus: AttendeeConnectionStatus;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used / should only return null (potential pii) */
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  prefix?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  registrationPath?: Maybe<NamedObject>;
  registrationType?: Maybe<NamedObject>;
  title?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Used in planner side */
export type AttendeeUnsecuredAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AttendeeUnsecuredPaginatedResults = {
  __typename?: 'AttendeeUnsecuredPaginatedResults';
  data: Array<Maybe<AttendeeUnsecured>>;
  pagination?: Maybe<Pagination>;
};

export enum AttendeeVisibility {
  Private = 'Private',
  Public = 'Public'
}

export type AttendeeWebsiteSettings = AttendeeHubConfigInterface & {
  __typename?: 'AttendeeWebsiteSettings';
  coverImage?: Maybe<Scalars['AWSURL']['output']>;
  coverImageAltText?: Maybe<Scalars['String']['output']>;
  coverImageId?: Maybe<Scalars['ID']['output']>;
  coverImageName?: Maybe<Scalars['String']['output']>;
  coverImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  footerImage?: Maybe<Scalars['AWSURL']['output']>;
  footerImageAltText?: Maybe<Scalars['String']['output']>;
  footerImageId?: Maybe<Scalars['ID']['output']>;
  footerImageName?: Maybe<Scalars['String']['output']>;
  footerImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  headerImage?: Maybe<Scalars['AWSURL']['output']>;
  headerImageAltText?: Maybe<Scalars['String']['output']>;
  headerImageId?: Maybe<Scalars['ID']['output']>;
  headerImageName?: Maybe<Scalars['String']['output']>;
  headerImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  loginBackgroundImage?: Maybe<Scalars['AWSURL']['output']>;
  loginBackgroundImageAltText?: Maybe<Scalars['String']['output']>;
  loginBackgroundImageId?: Maybe<Scalars['ID']['output']>;
  loginBackgroundImageName?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['AWSURL']['output']>;
  logoImageAltText?: Maybe<Scalars['String']['output']>;
  logoImageId?: Maybe<Scalars['ID']['output']>;
  logoImageName?: Maybe<Scalars['String']['output']>;
  logoImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  secondaryHeaderImage?: Maybe<Scalars['AWSURL']['output']>;
  secondaryHeaderImageAltText?: Maybe<Scalars['String']['output']>;
  secondaryHeaderImageId?: Maybe<Scalars['ID']['output']>;
  secondaryHeaderImageName?: Maybe<Scalars['String']['output']>;
  secondaryHeaderImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  sessionHeaderImage?: Maybe<Scalars['AWSURL']['output']>;
  sessionHeaderImageAltText?: Maybe<Scalars['String']['output']>;
  sessionHeaderImageId?: Maybe<Scalars['ID']['output']>;
  sessionHeaderImageName?: Maybe<Scalars['String']['output']>;
  sessionHeaderImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
};

export type AttendeeWebsiteSettingsInput = {
  coverImage?: InputMaybe<Scalars['AWSURL']['input']>;
  coverImageAltText?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['ID']['input']>;
  coverImageName?: InputMaybe<Scalars['String']['input']>;
  footerImage?: InputMaybe<Scalars['AWSURL']['input']>;
  footerImageAltText?: InputMaybe<Scalars['String']['input']>;
  footerImageId?: InputMaybe<Scalars['ID']['input']>;
  footerImageName?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['AWSURL']['input']>;
  headerImageAltText?: InputMaybe<Scalars['String']['input']>;
  headerImageId?: InputMaybe<Scalars['ID']['input']>;
  headerImageName?: InputMaybe<Scalars['String']['input']>;
  loginBackgroundImage?: InputMaybe<Scalars['AWSURL']['input']>;
  loginBackgroundImageAltText?: InputMaybe<Scalars['String']['input']>;
  loginBackgroundImageId?: InputMaybe<Scalars['ID']['input']>;
  loginBackgroundImageName?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<Scalars['AWSURL']['input']>;
  logoImageAltText?: InputMaybe<Scalars['String']['input']>;
  logoImageId?: InputMaybe<Scalars['ID']['input']>;
  logoImageName?: InputMaybe<Scalars['String']['input']>;
  secondaryHeaderImage?: InputMaybe<Scalars['AWSURL']['input']>;
  secondaryHeaderImageAltText?: InputMaybe<Scalars['String']['input']>;
  secondaryHeaderImageId?: InputMaybe<Scalars['ID']['input']>;
  secondaryHeaderImageName?: InputMaybe<Scalars['String']['input']>;
  sessionHeaderImage?: InputMaybe<Scalars['AWSURL']['input']>;
  sessionHeaderImageAltText?: InputMaybe<Scalars['String']['input']>;
  sessionHeaderImageId?: InputMaybe<Scalars['ID']['input']>;
  sessionHeaderImageName?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthenticationType {
  External = 'External',
  None = 'None',
  OAuth = 'OAuth',
  Password = 'Password',
  Unknown = 'Unknown'
}

export type Availability = {
  __typename?: 'Availability';
  attendeeId: Scalars['ID']['output'];
  isAtLimit: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityByTimeRangeInput = {
  attendeeIds: Array<Scalars['String']['input']>;
  endTime: Scalars['AWSDateTime']['input'];
  excludeAgendaItemId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['AWSDateTime']['input'];
};

export type AvailabilityHeartbeatResponse = {
  __typename?: 'AvailabilityHeartbeatResponse';
  status: Scalars['Int']['output'];
};

export type AvailableLocation = {
  __typename?: 'AvailableLocation';
  capacityPerAppointment: Scalars['Int']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /** Meaningful only when isConsolidated is true (ie Location has tables). If true, table will be assigned only when appointment gets confirmed. If false, table will be assigned immediately. */
  hasDelayAssignment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isConsolidated: Scalars['Boolean']['output'];
};

export type AvailableLocationsInput = {
  apptTypeId: Scalars['ID']['input'];
  endDate: Scalars['AWSDateTime']['input'];
  excludedAppt?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['AWSDateTime']['input'];
};

export type AvailableQuickLinks = {
  __typename?: 'AvailableQuickLinks';
  id: Scalars['String']['output'];
  isCustomPage: Scalars['String']['output'];
};

export type BlockedAttendee = {
  __typename?: 'BlockedAttendee';
  wasBlocked: Scalars['Boolean']['output'];
};

export type BoothStaffAvailaility = {
  __typename?: 'BoothStaffAvailaility';
  attendeeId?: Maybe<Scalars['ID']['output']>;
  meeting?: Maybe<Meeting>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Booth Staff Embedded Virtual Meeting Status */
export type BoothStaffStatus = {
  __typename?: 'BoothStaffStatus';
  attendeeId: Scalars['ID']['output'];
  exhibitorId: Scalars['ID']['output'];
  meetingStatus?: Maybe<MeetingStatus>;
  status: Status;
};

export enum BottomNavMode {
  PrimaryAsBackground = 'PRIMARY_AS_BACKGROUND',
  PrimaryAsIcons = 'PRIMARY_AS_ICONS'
}

export enum BottomNavigationTheme {
  Mood = 'MOOD',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Input Attendee Status to broadcast */
export type BroadcastAttendeeStatus = {
  attendeeId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  meetingId?: InputMaybe<Scalars['ID']['input']>;
  meetingStatus?: InputMaybe<MeetingStatus>;
  requester?: InputMaybe<InputMeetingRequester>;
  status: Status;
};

/** Input Booth Staff Status to broadcast */
export type BroadcastBoothStaffStatus = {
  attendeeId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
  meetingStatus?: InputMaybe<MeetingStatus>;
  status: Status;
};

export type BroadcastCurrentQuestion = {
  currentQuestionType: CurrentQuestionType;
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

/** Input question to broadcast votes */
export type BroadcastQuestion = {
  answer?: InputMaybe<Scalars['String']['input']>;
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  attendeeName?: InputMaybe<Scalars['String']['input']>;
  createDateTime: Scalars['String']['input'];
  displayDateTime?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAnonymous: Scalars['Boolean']['input'];
  isCurrentQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  isMine?: InputMaybe<Scalars['Boolean']['input']>;
  isVoted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  status: QuestionStatusType;
  statusChangeDateTime: Scalars['String']['input'];
  text: Scalars['String']['input'];
  voteCount: Scalars['Int']['input'];
};

export type BroadcastReactions = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  reactionsData: Array<ReactionsWithOffset>;
  sessionId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};

export type BulkOperation = {
  __typename?: 'BulkOperation';
  ids?: Maybe<Array<Scalars['ID']['output']>>;
  operation: Scalars['String']['output'];
};

export type BulkPageBannerPageSettingsInput = {
  id: Scalars['ID']['input'];
  location: PageBannerPlacementLocation;
  locationId?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
  placementOrder: Array<Scalars['ID']['input']>;
  placements: Array<BulkPageBannerPlacementSettingsInput>;
  rotationInterval?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkPageBannerPageSettingsUpdateResult = {
  __typename?: 'BulkPageBannerPageSettingsUpdateResult';
  pages: Array<PageBannerPageSettings>;
};

export type BulkPageBannerPlacementSettingsInput = {
  activeTimes?: InputMaybe<Array<InputMaybe<PageBannerPlacementTimeInput>>>;
  bannerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  location: PageBannerPlacementLocation;
  locationId?: InputMaybe<Scalars['String']['input']>;
  placementId: Scalars['ID']['input'];
  visibility: PageBannerPlacementVisibility;
};

export type CcpaData = {
  __typename?: 'CCPAData';
  ccpaButtonText?: Maybe<Scalars['String']['output']>;
  ccpaConfirmationText?: Maybe<Scalars['String']['output']>;
  ccpaDoNotSellUrl?: Maybe<Scalars['String']['output']>;
  ccpaExplanationText?: Maybe<Scalars['String']['output']>;
  ccpaExternalDoNotSellUrl?: Maybe<Scalars['String']['output']>;
  ccpaInviteeValidationText?: Maybe<Scalars['String']['output']>;
  ccpaLinkText?: Maybe<Scalars['String']['output']>;
  ccpaOptOutFormType?: Maybe<Scalars['String']['output']>;
  showCCPA?: Maybe<Scalars['Boolean']['output']>;
  showCcpaSectionFlag?: Maybe<Scalars['Boolean']['output']>;
};

export enum CcpaFormType {
  CompanyForm = 'CompanyForm',
  CventForm = 'CventForm',
  Unknown = 'Unknown'
}

export type Calendar = {
  __typename?: 'Calendar';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  calName: Scalars['String']['output'];
  calNote?: Maybe<Scalars['String']['output']>;
  calTagName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum CalendarEventType {
  Event = 'EVENT',
  Item = 'ITEM',
  Session = 'SESSION'
}

export type CalendarEventsFilterFields = {
  __typename?: 'CalendarEventsFilterFields';
  id?: Maybe<Scalars['String']['output']>;
  isCustomField?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<CustomFilterOptions>>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
};

export type CancelDeclineApptInput = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type CapacityRemaining = {
  __typename?: 'CapacityRemaining';
  active?: Maybe<Scalars['Boolean']['output']>;
  availableCapacity?: Maybe<Scalars['Int']['output']>;
  totalCapacityAvailable?: Maybe<Scalars['Int']['output']>;
};

export enum CardType {
  Airplus = 'AIRPLUS',
  AmericanExpress = 'AMERICAN_EXPRESS',
  Aurora = 'AURORA',
  Aurore = 'AURORE',
  Authorizenetsim = 'AUTHORIZENETSIM',
  Banktransfer = 'BANKTRANSFER',
  Bcmc = 'BCMC',
  Billy = 'BILLY',
  Cash = 'CASH',
  Cb = 'CB',
  Check = 'CHECK',
  Cofinoga = 'COFINOGA',
  Credit = 'CREDIT',
  Cybersourcehostedorderpage = 'CYBERSOURCEHOSTEDORDERPAGE',
  Cybersourcesecureacceptance = 'CYBERSOURCESECUREACCEPTANCE',
  Dankort = 'DANKORT',
  Dinersclub = 'DINERSCLUB',
  Discover = 'DISCOVER',
  Eurocardmastercard = 'EUROCARDMASTERCARD',
  Invoice = 'INVOICE',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Maestrouk = 'MAESTROUK',
  Mastercard = 'MASTERCARD',
  Mastercarddebit = 'MASTERCARDDEBIT',
  Moneyorder = 'MONEYORDER',
  Netreserve = 'NETRESERVE',
  Other = 'OTHER',
  Other2 = 'OTHER2',
  Other3 = 'OTHER3',
  Paygov = 'PAYGOV',
  Paymentcredits = 'PAYMENTCREDITS',
  Paypal = 'PAYPAL',
  Privilege = 'PRIVILEGE',
  Purchaseorder = 'PURCHASEORDER',
  Solo = 'SOLO',
  Touchnet = 'TOUCHNET',
  Uatp = 'UATP',
  Unionpay = 'UNIONPAY',
  Visa = 'VISA',
  Visadebit = 'VISADEBIT',
  Visaelectron = 'VISAELECTRON',
  Wpm = 'WPM'
}

export enum CatalogOwner {
  OnDemand = 'ON_DEMAND',
  VideoHub = 'VIDEO_HUB'
}

export type CatalogSectionPaging = {
  /** latestPaginationId: the webcastId or sessionId of the last video fetched */
  latestPaginationId?: InputMaybe<Scalars['ID']['input']>;
  sectionId: Scalars['ID']['input'];
  sectionLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum CatalogSectionType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export enum CatalogType {
  List = 'LIST',
  Sections = 'SECTIONS'
}

/** Lighter weight exhibitor to be used in exhibitor categories */
export type CategoryPreviewExhibitor = {
  __typename?: 'CategoryPreviewExhibitor';
  id: Scalars['ID']['output'];
  /** @deprecated Use logoUrlOptimized instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlOptimized?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum ChatEntityType {
  Discussion = 'DISCUSSION',
  Exhibitor = 'EXHIBITOR',
  Session = 'SESSION'
}

export type ChatModeratorVerification = {
  __typename?: 'ChatModeratorVerification';
  isModerator?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  resetAt?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export enum ChatServiceStatus {
  Busy = 'busy',
  Completed = 'completed',
  Error = 'error'
}

export type ChatSettings = {
  __typename?: 'ChatSettings';
  isEnabled: Scalars['Boolean']['output'];
  stream?: Maybe<ChatStreamSettings>;
  timeRange?: Maybe<ChatSettingsTimeRange>;
};

export type ChatSettingsTimeRange = {
  __typename?: 'ChatSettingsTimeRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type ChatStreamSettings = {
  __typename?: 'ChatStreamSettings';
  channelId: Scalars['ID']['output'];
  channelType: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatToken = {
  __typename?: 'ChatToken';
  apiKey: Scalars['String']['output'];
  expiration: Scalars['String']['output'];
  token: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ChatVerification = {
  __typename?: 'ChatVerification';
  errorKey?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorValue?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  resetAt?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type CheckinApptInput = {
  apptId: Scalars['ID']['input'];
  attendance: Scalars['String']['input'];
  attendeeId: Scalars['ID']['input'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  id: Scalars['ID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type ChecklistItemInput = {
  id: Scalars['ID']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ChecklistSettings = AttendeeHubConfigInterface & {
  __typename?: 'ChecklistSettings';
  checklist?: Maybe<Array<Maybe<ChecklistItem>>>;
  isDefaultChecklistAdded: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type ChecklistSettingsInput = {
  checklist?: InputMaybe<Array<InputMaybe<ChecklistItemInput>>>;
  isDefaultChecklistAdded: Scalars['Boolean']['input'];
};

export type Choice = {
  __typename?: 'Choice';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** Input request to update choices by text and choiceId */
export type ChoiceInput = {
  choiceId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type CodeSnippet = {
  __typename?: 'CodeSnippet';
  applicableOn?: Maybe<SnippetApplicableOn>;
  canDisableCodeSnippet?: Maybe<Scalars['Boolean']['output']>;
  category: CodeSnippetCategory;
  codeSnippetValue: Scalars['String']['output'];
  dataTagCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum CodeSnippetCategory {
  Functionality = 'Functionality',
  Marketing = 'Marketing',
  Performance = 'Performance',
  StrictlyNecessary = 'StrictlyNecessary',
  Unknown = 'Unknown'
}

export type ConfigSession = {
  __typename?: 'ConfigSession';
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  sessionId: Scalars['ID']['output'];
};

export type ConflictingAgendaItems = {
  __typename?: 'ConflictingAgendaItems';
  conflictType: AgendaItemType;
  end: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  start: Scalars['AWSDateTime']['output'];
};

export type ContentTag = {
  __typename?: 'ContentTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContentVisibilityGroupDetails = {
  __typename?: 'ContentVisibilityGroupDetails';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContentVisibilityGroups = {
  __typename?: 'ContentVisibilityGroups';
  admissionItems: Array<Maybe<ContentVisibilityGroupDetails>>;
  attendeeSegments: Array<Maybe<ContentVisibilityGroupDetails>>;
  registrationTypes: Array<Maybe<ContentVisibilityGroupDetails>>;
};

export type ContentVisibilitySetting = {
  __typename?: 'ContentVisibilitySetting';
  admissionItemIds: Array<Maybe<Scalars['ID']['output']>>;
  attendeeSegmentIds: Array<Maybe<Scalars['ID']['output']>>;
  registrationTypeIds: Array<Maybe<Scalars['ID']['output']>>;
};

export type ContentVisibilitySettingInput = {
  admissionItemIds: Array<InputMaybe<Scalars['ID']['input']>>;
  attendeeSegmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  registrationTypeIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ContentVisibilitySettings = AttendeeHubConfigInterface & {
  __typename?: 'ContentVisibilitySettings';
  allSessions?: Maybe<ContentVisibilitySetting>;
  attendees?: Maybe<ContentVisibilitySetting>;
  customPages?: Maybe<Array<CustomPageContentVisibilitySetting>>;
  exhibitors?: Maybe<ContentVisibilitySetting>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  onDemand?: Maybe<ContentVisibilitySetting>;
  speakers?: Maybe<ContentVisibilitySetting>;
  speedNetworking?: Maybe<ContentVisibilitySetting>;
  sponsors?: Maybe<ContentVisibilitySetting>;
  videoDiscussions?: Maybe<ContentVisibilitySetting>;
};

export type ContentVisibilitySettingsInput = {
  allSessions?: InputMaybe<ContentVisibilitySettingInput>;
  attendees?: InputMaybe<ContentVisibilitySettingInput>;
  customPages?: InputMaybe<Array<CustomPageContentVisibilitySettingInput>>;
  exhibitors?: InputMaybe<ContentVisibilitySettingInput>;
  onDemand?: InputMaybe<ContentVisibilitySettingInput>;
  speakers?: InputMaybe<ContentVisibilitySettingInput>;
  speedNetworking?: InputMaybe<ContentVisibilitySettingInput>;
  sponsors?: InputMaybe<ContentVisibilitySettingInput>;
  videoDiscussions?: InputMaybe<ContentVisibilitySettingInput>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CreateApptInput = {
  apptEventId: Scalars['String']['input'];
  apptTypeId: Scalars['String']['input'];
  /** Determines custom location name. This is meaningful only for freeform appointment type */
  customLocationName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['AWSDateTime']['input'];
  exhibitorId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Determines id of a planner created location */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  privateNote?: InputMaybe<PrivateNote>;
  requesteeAnswers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  requestees?: InputMaybe<Array<InputMaybe<ApptAttendeeInput>>>;
  requesterAnswers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  requesterAnswersViewers?: InputMaybe<Array<Scalars['String']['input']>>;
  requesters?: InputMaybe<Array<InputMaybe<ApptAttendeeInput>>>;
  selectedBoothId?: InputMaybe<Scalars['ID']['input']>;
  sendTo?: InputMaybe<SendTo>;
  startDate: Scalars['AWSDateTime']['input'];
  virtualAccess: Scalars['Boolean']['input'];
};

export type CreatePersonalTimeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['AWSDateTime']['input'];
  inputId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['AWSDateTime']['input'];
};

export type CreateSpaceInput = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input request to create a new widget */
export type CreateWidgetInput = {
  icon: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Credits = {
  __typename?: 'Credits';
  inviteeCredits?: Maybe<Array<InviteeCredit>>;
  totalCredits: Scalars['Float']['output'];
  yearToDateCredits: Scalars['Float']['output'];
};

/** The current question: a Live Q&A or Live Polling Question */
export type CurrentQuestion = {
  __typename?: 'CurrentQuestion';
  currentQuestionType?: Maybe<CurrentQuestionType>;
  eventId: Scalars['ID']['output'];
  livePollQuestion?: Maybe<PollQuestion>;
  sessionId: Scalars['ID']['output'];
  sessionQaQuestion?: Maybe<Question>;
};

export enum CurrentQuestionType {
  LivePolling = 'livePolling',
  SessionQa = 'sessionQA',
  Unset = 'unset'
}

/** Custom hours of an exhibitor */
export type CustomBoothHours = {
  __typename?: 'CustomBoothHours';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type CustomField = CustomFieldBase & {
  __typename?: 'CustomField';
  category?: Maybe<CustomFieldCategories>;
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  details: CustomFieldDetails;
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: CustomFieldType;
};

export type CustomFieldBase = {
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  details: CustomFieldDetails;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomFieldCategories {
  Abstract = 'Abstract',
  Appointment = 'Appointment',
  BudgetItem = 'BudgetItem',
  Campaign = 'Campaign',
  Contact = 'Contact',
  Event = 'Event',
  Resource = 'Resource',
  Rfp = 'Rfp',
  Session = 'Session',
  Survey = 'Survey',
  User = 'User'
}

export type CustomFieldChoice = {
  __typename?: 'CustomFieldChoice';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldDetails = {
  __typename?: 'CustomFieldDetails';
  answerFormat?: Maybe<Scalars['String']['output']>;
  choices?: Maybe<Array<CustomFieldChoice>>;
  defaultToCurrentDate?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<DateTimeDisplayFormat>;
  from?: Maybe<Scalars['AWSDateTime']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type CustomFieldFilter = {
  __typename?: 'CustomFieldFilter';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CustomFieldFilterInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type CustomFieldPaginatedResponse = {
  __typename?: 'CustomFieldPaginatedResponse';
  data?: Maybe<Array<CustomFieldResponse>>;
  paging?: Maybe<Pagination>;
};

export type CustomFieldPaginatedResults = {
  __typename?: 'CustomFieldPaginatedResults';
  data?: Maybe<Array<CustomField>>;
  pagination?: Maybe<Pagination>;
};

export type CustomFieldResponse = CustomFieldBase & {
  __typename?: 'CustomFieldResponse';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  details: CustomFieldDetails;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export enum CustomFieldType {
  ChoiceMultipleAnswers = 'ChoiceMultipleAnswers',
  ChoiceSingleAnswer = 'ChoiceSingleAnswer',
  OpenEndedTextCommentBox = 'OpenEndedTextCommentBox',
  OpenEndedTextDateTime = 'OpenEndedTextDateTime',
  OpenEndedTextOneLine = 'OpenEndedTextOneLine'
}

export type CustomFilterFieldTag = {
  __typename?: 'CustomFilterFieldTag';
  id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type CustomFilterOptions = {
  __typename?: 'CustomFilterOptions';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resourceKey?: Maybe<Scalars['String']['output']>;
};

export type CustomFont = {
  __typename?: 'CustomFont';
  fallbackFont: Scalars['String']['output'];
  fallbackFontId: Scalars['Int']['output'];
  files: Array<FontFile>;
  fontFamily: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type CustomIcon = {
  __typename?: 'CustomIcon';
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type CustomIconInput = {
  name: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type CustomPageContentVisibilitySetting = {
  __typename?: 'CustomPageContentVisibilitySetting';
  admissionItemIds: Array<Maybe<Scalars['ID']['output']>>;
  attendeeSegmentIds: Array<Maybe<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  registrationTypeIds: Array<Maybe<Scalars['ID']['output']>>;
};

export type CustomPageContentVisibilitySettingInput = {
  admissionItemIds: Array<InputMaybe<Scalars['ID']['input']>>;
  attendeeSegmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  registrationTypeIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type CustomPageSettings = AttendeeHubConfigInterface & {
  __typename?: 'CustomPageSettings';
  description?: Maybe<Scalars['AWSJSON']['output']>;
  documentAsset?: Maybe<Scalars['AWSJSON']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageAsset?: Maybe<Scalars['AWSJSON']['output']>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  pageIcon: Scalars['String']['output'];
  pageId: Scalars['ID']['output'];
  pageName: Scalars['String']['output'];
  pageType?: Maybe<Scalars['String']['output']>;
};

export type CustomPageSettingsInput = {
  description?: InputMaybe<Scalars['AWSJSON']['input']>;
  documentAsset?: InputMaybe<Scalars['AWSJSON']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<Scalars['AWSJSON']['input']>;
  pageIcon: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  pageType?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPages = {
  __typename?: 'CustomPages';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomValidTheme = {
  __typename?: 'CustomValidTheme';
  headerTheme: ValidTheme;
  id: Scalars['ID']['output'];
};

export type CustomValidThemeInput = {
  headerTheme: ValidTheme;
  id: Scalars['ID']['input'];
};

export type CventPrivacyPolicy = {
  __typename?: 'CventPrivacyPolicy';
  cventPrivacyPolicyLinkText?: Maybe<Scalars['String']['output']>;
  showCventPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>;
};

export enum DateTimeDisplayFormat {
  DateAndTimeDayFirst12HourTime = 'DateAndTimeDayFirst12HourTime',
  DateAndTimeDayFirst24HourTime = 'DateAndTimeDayFirst24HourTime',
  DateAndTimeMonthFirst12HourTime = 'DateAndTimeMonthFirst12HourTime',
  DateAndTimeMonthFirst24HourTime = 'DateAndTimeMonthFirst24HourTime',
  DateOnlyDayFirst = 'DateOnlyDayFirst',
  DateOnlyMonthFirst = 'DateOnlyMonthFirst'
}

export type DeepLink = {
  __typename?: 'DeepLink';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DefaultPage = {
  __typename?: 'DefaultPage';
  groupName?: Maybe<AttendeeHubPageGroups>;
  value?: Maybe<AttendeeHubDefaultPages>;
};

export type DefaultPageSettings = AttendeeHubConfigInterface & {
  __typename?: 'DefaultPageSettings';
  attendees: Scalars['Boolean']['output'];
  exhibitors: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  onDemand: Scalars['Boolean']['output'];
  schedule: Scalars['Boolean']['output'];
  speakers: Scalars['Boolean']['output'];
  sponsors: Scalars['Boolean']['output'];
};

export type DefaultPageSettingsInput = {
  attendees: Scalars['Boolean']['input'];
  exhibitors: Scalars['Boolean']['input'];
  onDemand: Scalars['Boolean']['input'];
  schedule: Scalars['Boolean']['input'];
  speakers: Scalars['Boolean']['input'];
  sponsors: Scalars['Boolean']['input'];
};

export type DeleteAttendeeAccountResult = {
  __typename?: 'DeleteAttendeeAccountResult';
  isAccessTokenDeleted: Scalars['Boolean']['output'];
  isAccountDeleted: Scalars['Boolean']['output'];
  isAttendeeVisibilityPrivate: Scalars['Boolean']['output'];
  isEmailSentToPlanner: Scalars['Boolean']['output'];
};

export type DeletePreFilterResponse = {
  __typename?: 'DeletePreFilterResponse';
  filterListId: Scalars['ID']['output'];
};

/** Input request to delete an existing widget */
export type DeleteWidgetInput = {
  widgetId: Scalars['ID']['input'];
};

export type Discount = {
  __typename?: 'Discount';
  code: Scalars['String']['output'];
  isAuto?: Maybe<Scalars['Boolean']['output']>;
};

/** DiscountInput - contains code and reg cart Id to which the code should be applied */
export type DiscountInput = {
  cardType?: InputMaybe<CardType>;
  code: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  regCartId: Scalars['ID']['input'];
};

export type DismissAttendeeRecommendationInput = {
  attendeeId: Scalars['ID']['input'];
};

/** Login Response for Live Display */
export type DisplayCodeLoginResponse = {
  __typename?: 'DisplayCodeLoginResponse';
  bearerToken?: Maybe<Scalars['String']['output']>;
  csrfToken?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Maybe<LiveQaSession>>>;
};

export enum DisplayCodeType {
  LocationCode = 'LocationCode',
  SessionCode = 'SessionCode',
  SessionOrLocationCode = 'SessionOrLocationCode'
}

export enum DocumentSetupStatus {
  Failure = 'failure',
  Success = 'success'
}

export type ElementWithTags = {
  __typename?: 'ElementWithTags';
  elementId: Scalars['String']['output'];
  elementType: Scalars['String']['output'];
  elementTypeId: Scalars['Int']['output'];
  tags: Array<Maybe<Tag>>;
};

export type EnabledPages = {
  __typename?: 'EnabledPages';
  feature?: Maybe<AttendeeHubFeatures>;
  groupName?: Maybe<AttendeeHubPageGroups>;
  value?: Maybe<AttendeeHubFeaturedPages>;
};

export enum EncounterMode {
  Checkin = 'CHECKIN',
  Checkout = 'CHECKOUT',
  Heartbeat = 'HEARTBEAT'
}

export type EnrollmentError = {
  __typename?: 'EnrollmentError';
  code?: Maybe<Scalars['String']['output']>;
  details: Array<EnrollmentErrorDetail>;
  message?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentErrorDetail = {
  __typename?: 'EnrollmentErrorDetail';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tokens: EnrollmentErrorTokens;
};

export type EnrollmentErrorTokens = {
  __typename?: 'EnrollmentErrorTokens';
  attendeeId?: Maybe<Scalars['ID']['output']>;
  eventRegistrationId?: Maybe<Scalars['ID']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  session1?: Maybe<Scalars['ID']['output']>;
  session2?: Maybe<Scalars['ID']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  warningMessage?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  accountConfig?: Maybe<AccountConfig>;
  appConfig?: Maybe<AppConfig>;
  appointmentEvents: Array<AppointmentEvent>;
  archiveAfter?: Maybe<Scalars['AWSDateTime']['output']>;
  attendeeHubLaunched?: Maybe<Scalars['Boolean']['output']>;
  browserLocaleDetection?: Maybe<Scalars['Boolean']['output']>;
  ccpaData: CcpaData;
  codeSnippets?: Maybe<Array<CodeSnippet>>;
  connectionsCount: Scalars['Int']['output'];
  cultureCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<EventCustomField>>>;
  cventPrivacyPolicyText?: Maybe<Scalars['String']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  defaultPages?: Maybe<DefaultPageSettings>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['AWSDateTime']['output'];
  eventTheme?: Maybe<EventInfoTheme>;
  features?: Maybe<EventFeatures>;
  feedbackSurveys?: Maybe<Array<Maybe<EventFeedbackSurvey>>>;
  format?: Maybe<Format>;
  gameInfo?: Maybe<Array<Maybe<GameInfo>>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inviteeCredit?: Maybe<Array<InviteeCredit>>;
  links: EventLinks;
  liveAndUpcoming: Array<Session>;
  pageGroups?: Maybe<Array<PageGroup>>;
  phone?: Maybe<Scalars['String']['output']>;
  resourceOverrides?: Maybe<ResourceOverrides>;
  /** @deprecated Use sessionFilters query instead */
  sessionCategories: Array<SessionCategory>;
  /** @deprecated Use sessionFilters query instead */
  sessionDateTimes?: Maybe<Array<Scalars['AWSDateTime']['output']>>;
  /** @deprecated Use sessionFilters query instead */
  sessionFilters?: Maybe<Array<Maybe<SessionFilter>>>;
  showCookieBanner?: Maybe<Scalars['Boolean']['output']>;
  showCookieBannerPrivacyPolicyLink?: Maybe<Scalars['Boolean']['output']>;
  showNonEssentialCookieBanner?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['AWSDateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  supportedEventLocales?: Maybe<Array<EventLocale>>;
  timezone?: Maybe<Scalars['String']['output']>;
  timezoneId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalCredit?: Maybe<Scalars['Float']['output']>;
  venues?: Maybe<Array<Maybe<Venue>>>;
  websiteStatus?: Maybe<WebsiteStatus>;
};

export type EventLiveAndUpcomingArgs = {
  sessionCriteria?: InputMaybe<SearchSessionCriteria>;
};

export type EventResourceOverridesArgs = {
  locale: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

export type EventCustomField = {
  __typename?: 'EventCustomField';
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  plannerSelected?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  value: Array<Maybe<Scalars['String']['output']>>;
};

export type EventDefaultSettings = AttendeeHubConfigInterface & {
  __typename?: 'EventDefaultSettings';
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  myScheduleView: MyScheduleView;
};

export type EventDefaultSettingsInput = {
  myScheduleView: MyScheduleView;
};

export type EventFeatures = {
  __typename?: 'EventFeatures';
  exhibitorManagement: Scalars['Boolean']['output'];
  exhibitorsPresent: Scalars['Boolean']['output'];
  floorPlans?: Maybe<Scalars['Boolean']['output']>;
  gamePresent: Scalars['Boolean']['output'];
  livePolling: Scalars['Boolean']['output'];
  onDemand: Scalars['Boolean']['output'];
  onDemandCatalog: Scalars['Boolean']['output'];
  registration: Scalars['Boolean']['output'];
  sessionQA: Scalars['Boolean']['output'];
  sessionRecommendations: Scalars['Boolean']['output'];
  sessions: Scalars['Boolean']['output'];
  showExhibitorList: Scalars['Boolean']['output'];
  showSponsorList: Scalars['Boolean']['output'];
  speakers: Scalars['Boolean']['output'];
  sponsors: Scalars['Int']['output'];
};

export type EventFeedbackSurvey = FeedbackSurvey & {
  __typename?: 'EventFeedbackSurvey';
  audience: SurveyAudience;
  chapterId: Scalars['ID']['output'];
  closeOffset?: Maybe<Scalars['Int']['output']>;
  closeTimeUnit?: Maybe<SurveyTimeUnit>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTimeUnit?: Maybe<SurveyTimeUnit>;
  surveyAvailability?: Maybe<EventSurveyAvailability>;
  surveyClose?: Maybe<EventSurveyAvailability>;
  surveyId: Scalars['ID']['output'];
  surveyUrl: Scalars['String']['output'];
};

export enum EventFormat {
  Hybrid = 'Hybrid',
  InPerson = 'InPerson',
  Virtual = 'Virtual'
}

export type EventGuideCard = {
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
};

export enum EventGuideCardType {
  LinkCard = 'LinkCard',
  LinkGalleryCard = 'LinkGalleryCard',
  VideoCard = 'VideoCard',
  VideoGalleryCard = 'VideoGalleryCard'
}

export type EventGuideLink = EventGuideLinkable & {
  __typename?: 'EventGuideLink';
  displayOnHome: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['AWSURL']['output']>;
  type: EventGuideLinkType;
  url?: Maybe<Scalars['String']['output']>;
};

export type EventGuideLinkCard = EventGuideCard & {
  __typename?: 'EventGuideLinkCard';
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  link: EventGuideUrlLink;
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
};

export type EventGuideLinkGallery = EventGuideLinkable & {
  __typename?: 'EventGuideLinkGallery';
  associatedLinks: Array<Maybe<Scalars['ID']['output']>>;
  displayOnHome: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EventGuideLinkGalleryCard = EventGuideCard & {
  __typename?: 'EventGuideLinkGalleryCard';
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  links: Array<EventGuideUrlLink>;
  name: Scalars['String']['output'];
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
};

export type EventGuideLinkGalleryInput = {
  associatedLinks: Array<InputMaybe<Scalars['ID']['input']>>;
  displayOnHome: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EventGuideLinkInput = {
  displayOnHome?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  linkText: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['AWSURL']['input']>;
  thumbnailOptimized?: InputMaybe<Scalars['AWSURL']['input']>;
  type: EventGuideLinkType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum EventGuideLinkType {
  AttendeeHubPage = 'ATTENDEE_HUB_PAGE',
  Dynamic = 'DYNAMIC',
  Web = 'WEB'
}

export type EventGuideLinkable = {
  displayOnHome: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type EventGuideScheduleTime = {
  __typename?: 'EventGuideScheduleTime';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type EventGuideSettings = AttendeeHubConfigInterface & {
  __typename?: 'EventGuideSettings';
  afterEvent: EventGuideStageSettings;
  beforeEvent: EventGuideStageSettings;
  duringEvent: EventGuideStageSettings;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type EventGuideSettingsInput = {
  afterEvent: EventGuideStageSettingsInput;
  beforeEvent: EventGuideStageSettingsInput;
  duringEvent: EventGuideStageSettingsInput;
};

export type EventGuideSettingsV2 = {
  __typename?: 'EventGuideSettingsV2';
  cards: Array<EventGuideCard>;
  quickLinks: Array<Maybe<QuickLink>>;
  showQuickLinks: Scalars['Boolean']['output'];
};

export type EventGuideStageSettings = {
  __typename?: 'EventGuideStageSettings';
  cardsOrder?: Maybe<Array<Scalars['ID']['output']>>;
  linkGalleries?: Maybe<Array<Maybe<EventGuideLinkGallery>>>;
  links?: Maybe<Array<Maybe<EventGuideLink>>>;
  quickLinks: Array<Maybe<QuickLink>>;
  showFeaturedSessions: Scalars['Boolean']['output'];
  showFeaturedSpeakers: Scalars['Boolean']['output'];
  showFeaturedSponsors: Scalars['Boolean']['output'];
  showQuickLinks: Scalars['Boolean']['output'];
  showVenueMap: Scalars['Boolean']['output'];
  videoGalleries?: Maybe<Array<Maybe<EventGuideVideoGallery>>>;
  videos?: Maybe<Array<Maybe<EventGuideVideo>>>;
};

export type EventGuideStageSettingsInput = {
  cardsOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkGalleries?: InputMaybe<Array<InputMaybe<EventGuideLinkGalleryInput>>>;
  links?: InputMaybe<Array<InputMaybe<EventGuideLinkInput>>>;
  quickLinks: Array<InputMaybe<QuickLinkInput>>;
  showFeaturedSessions: Scalars['Boolean']['input'];
  showFeaturedSpeakers: Scalars['Boolean']['input'];
  showFeaturedSponsors: Scalars['Boolean']['input'];
  showQuickLinks: Scalars['Boolean']['input'];
  showVenueMap: Scalars['Boolean']['input'];
  videoGalleries?: InputMaybe<Array<InputMaybe<EventGuideVideoGalleryInput>>>;
  videos?: InputMaybe<Array<InputMaybe<EventGuideVideoInput>>>;
};

export type EventGuideUrlLink = {
  __typename?: 'EventGuideUrlLink';
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['AWSURL']['output']>;
  type: EventGuideLinkType;
  url?: Maybe<Scalars['String']['output']>;
};

export type EventGuideVideo = EventGuideLinkable & {
  __typename?: 'EventGuideVideo';
  displayOnHome: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['AWSURL']['output']>;
  url: Scalars['String']['output'];
};

export type EventGuideVideoCard = EventGuideCard & {
  __typename?: 'EventGuideVideoCard';
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
  video: EventGuideVideoLink;
};

export type EventGuideVideoGallery = EventGuideLinkable & {
  __typename?: 'EventGuideVideoGallery';
  associatedVideos: Array<Maybe<Scalars['ID']['output']>>;
  displayOnHome: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EventGuideVideoGalleryCard = EventGuideCard & {
  __typename?: 'EventGuideVideoGalleryCard';
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
  videos: Array<EventGuideVideoLink>;
};

export type EventGuideVideoGalleryInput = {
  associatedVideos: Array<InputMaybe<Scalars['ID']['input']>>;
  displayOnHome: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EventGuideVideoInput = {
  displayOnHome?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  linkText: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['AWSURL']['input']>;
  thumbnailOptimized?: InputMaybe<Scalars['AWSURL']['input']>;
  url: Scalars['String']['input'];
  videoId?: InputMaybe<Scalars['ID']['input']>;
  videoName?: InputMaybe<Scalars['String']['input']>;
};

export type EventGuideVideoLink = {
  __typename?: 'EventGuideVideoLink';
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['AWSURL']['output']>;
  url: Scalars['String']['output'];
  videoId?: Maybe<Scalars['ID']['output']>;
  videoName?: Maybe<Scalars['String']['output']>;
};

export type EventInfo = {
  __typename?: 'EventInfo';
  ccpaData: CcpaData;
  codeSnippets?: Maybe<Array<CodeSnippet>>;
  customDomain?: Maybe<Scalars['String']['output']>;
  cventPrivacyPolicy?: Maybe<CventPrivacyPolicy>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['AWSDateTime']['output']>;
  eventInfoTheme: EventInfoTheme;
  eventLicenseTypeName?: Maybe<Scalars['String']['output']>;
  eventPrivacyPolicy?: Maybe<EventPrivacyPolicy>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<FeatureSettings>>;
  hideCventFooter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isOpenAccessEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isSignUpEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSignUpFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  links: EventLinks;
  locales?: Maybe<Array<EventLocale>>;
  resourceOverrides?: Maybe<ResourceOverrides>;
  sessions?: Maybe<Array<Session>>;
  showCookieBanner?: Maybe<Scalars['Boolean']['output']>;
  showCookieBannerPrivacyPolicyLink?: Maybe<Scalars['Boolean']['output']>;
  showNonEssentialCookieBanner?: Maybe<Scalars['Boolean']['output']>;
  speakers?: Maybe<Array<Speaker>>;
  speedNetworkingConfiguration?: Maybe<SpeedNetworkingConfiguration>;
  start?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<EventStatus>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  venues?: Maybe<Array<Venue>>;
};

/** For the event info theme and logo */
export type EventInfoTheme = {
  __typename?: 'EventInfoTheme';
  /** @deprecated Unused */
  add1?: Maybe<Scalars['String']['output']>;
  /** @deprecated Aliased by background */
  add2?: Maybe<Scalars['String']['output']>;
  /** @deprecated Unused */
  add3?: Maybe<Scalars['String']['output']>;
  background: Scalars['String']['output'];
  bodyFont?: Maybe<FontDescriptor>;
  bottomNavMode?: Maybe<Scalars['String']['output']>;
  bottomNavigationTheme?: Maybe<BottomNavigationTheme>;
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageAltText?: Maybe<Scalars['String']['output']>;
  coverImageOptimized?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  headingFont?: Maybe<FontDescriptor>;
  icons?: Maybe<IconSettings>;
  id?: Maybe<Scalars['String']['output']>;
  illustrations?: Maybe<IllustrationSettings>;
  loginBackgroundImage?: Maybe<Scalars['String']['output']>;
  loginBackgroundImageAltText?: Maybe<Scalars['String']['output']>;
  loginBackgroundImageOptimized?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  logoImageName?: Maybe<Scalars['String']['output']>;
  logoImageOptimized?: Maybe<Scalars['String']['output']>;
  mood: Scalars['String']['output'];
  preferFormula?: Maybe<ThemeFormulaType>;
  primary: Scalars['String']['output'];
  safeMode?: Maybe<Scalars['Boolean']['output']>;
  secondary: Scalars['String']['output'];
  themeTemplate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EventLinks = {
  __typename?: 'EventLinks';
  appointment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use ccpaData instead */
  ccpa?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<LinkData>;
  registration?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  surveys?: Maybe<Scalars['String']['output']>;
};

export type EventLocale = {
  __typename?: 'EventLocale';
  cultureCode: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  languageCountry: Scalars['String']['output'];
  languageName: Scalars['String']['output'];
  localeId: Scalars['Int']['output'];
};

export type EventLocalesInfo = {
  __typename?: 'EventLocalesInfo';
  browserLocaleDetection?: Maybe<Scalars['Boolean']['output']>;
  supportedEventLocales?: Maybe<Array<EventLocale>>;
};

export type EventMobileSettings = AttendeeHubConfigInterface & {
  __typename?: 'EventMobileSettings';
  accessCodeSuffix?: Maybe<Scalars['String']['output']>;
  appId: Scalars['ID']['output'];
  calendarId?: Maybe<Scalars['ID']['output']>;
  consentEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  loginRequired: Scalars['Boolean']['output'];
  mobileEnabled: Scalars['Boolean']['output'];
  showTerms: Scalars['Boolean']['output'];
  spaceId?: Maybe<Scalars['ID']['output']>;
  spaceName?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<EventVisibility>;
};

export type EventMobileSettingsInput = {
  accessCodeSuffix?: InputMaybe<Scalars['String']['input']>;
  appId: Scalars['ID']['input'];
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  consentEnabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  loginRequired: Scalars['Boolean']['input'];
  mobileEnabled: Scalars['Boolean']['input'];
  showTerms: Scalars['Boolean']['input'];
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<EventVisibility>;
};

export type EventPageCriteria = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type EventPaginatedResults = {
  __typename?: 'EventPaginatedResults';
  data: Array<Maybe<Event>>;
  pagination?: Maybe<Pagination>;
};

export type EventPrivacyPolicy = {
  __typename?: 'EventPrivacyPolicy';
  privacyPolicyLinkText?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  showPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>;
};

export type EventProfileSettings = {
  __typename?: 'EventProfileSettings';
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  profileCardDesignSettings: ProfileCardDesignSettingsWrapper;
  profileFieldGroupSettings: ProfileFieldGroupSettingsWrapper;
};

export type EventSearchCriteria = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['AWSDateTime']['input'];
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageCriteria?: InputMaybe<EventPageCriteria>;
  pastOrFuture: PastOrFuture;
  start: Scalars['AWSDateTime']['input'];
};

/** Event Settings for Live Q&A */
export type EventSettings = {
  __typename?: 'EventSettings';
  liveDisplayShortUrl?: Maybe<Scalars['String']['output']>;
  moderatorApprovalLimit?: Maybe<Scalars['Int']['output']>;
  qaEnabled: Scalars['Boolean']['output'];
};

export enum EventStatus {
  Active = 'Active',
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Deleted = 'Deleted',
  NoRegistrationRequired = 'NoRegistrationRequired',
  Pending = 'Pending',
  Processing = 'Processing'
}

export enum EventSurveyAvailability {
  AfterEventEnd = 'AfterEventEnd',
  AfterEventStart = 'AfterEventStart',
  BeforeEventEnd = 'BeforeEventEnd',
  BeforeEventStart = 'BeforeEventStart',
  OnEventEnd = 'OnEventEnd',
  OnEventStart = 'OnEventStart'
}

export enum EventVisibility {
  Hidden = 'hidden',
  PublicLocked = 'public_locked',
  PublicUnlocked = 'public_unlocked'
}

/** Exhibitor list item data */
export type Exhibitor = {
  __typename?: 'Exhibitor';
  categories?: Maybe<Array<ExhibitorCategory>>;
  eventSponsor: Scalars['Boolean']['output'];
  exhibitorCode?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  hasVirtualBooth: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use logoUrlOptimized instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlOptimized?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use sponsorshipLevels instead */
  sponsorshipLevel?: Maybe<Scalars['String']['output']>;
  sponsorshipLevels?: Maybe<Array<Scalars['String']['output']>>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type ExhibitorBoothLocation = {
  __typename?: 'ExhibitorBoothLocation';
  boothLocation?: Maybe<Scalars['String']['output']>;
  exhibitorId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  staffInviteeIds: Array<Scalars['String']['output']>;
};

export type ExhibitorBoothLocations = {
  __typename?: 'ExhibitorBoothLocations';
  data: Array<Maybe<ExhibitorBoothLocation>>;
};

/** Exhibitor booth staff info */
export type ExhibitorBoothStaff = {
  __typename?: 'ExhibitorBoothStaff';
  attendeeId?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<BoothStaffAvailaility>;
  company?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ExhibitorCategory = {
  __typename?: 'ExhibitorCategory';
  description?: Maybe<Scalars['String']['output']>;
  exhibitorCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use imageUrlOptimized instead */
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrlOptimized?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previewExhibitors: Array<CategoryPreviewExhibitor>;
  type: ExhibitorCategoryType;
};

export enum ExhibitorCategoryType {
  Banner = 'BANNER',
  Logo = 'LOGO'
}

export type ExhibitorConsentAnswer = {
  __typename?: 'ExhibitorConsentAnswer';
  answerId?: Maybe<Scalars['String']['output']>;
  attendeeId: Scalars['String']['output'];
  choice?: Maybe<ExhibitorConsentChoiceAnswerResponse>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
};

export type ExhibitorConsentAnswerInput = {
  choiceAnswer: ExhibitorConsentChoiceAnswerInput;
  locale?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  questionText: Scalars['String']['input'];
};

export type ExhibitorConsentAnswerResponse = {
  __typename?: 'ExhibitorConsentAnswerResponse';
  answer?: Maybe<ExhibitorConsentAnswer>;
};

export type ExhibitorConsentChoiceAnswerInput = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ExhibitorConsentChoiceAnswerResponse = {
  __typename?: 'ExhibitorConsentChoiceAnswerResponse';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ExhibitorConsentQuestion = {
  __typename?: 'ExhibitorConsentQuestion';
  /** empty response when consent question not configured */
  id?: Maybe<Scalars['ID']['output']>;
  optInId?: Maybe<Scalars['String']['output']>;
  optInText?: Maybe<Scalars['String']['output']>;
  optOutId?: Maybe<Scalars['String']['output']>;
  optOutText?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Exhibitor provided content */
export type ExhibitorContent = {
  __typename?: 'ExhibitorContent';
  files: Array<ExhibitorContentFile>;
  weblinks: Array<ExhibitorContentLink>;
};

/** Exhibitor provided file */
export type ExhibitorContentFile = {
  __typename?: 'ExhibitorContentFile';
  displayName?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Exhibitor provided link */
export type ExhibitorContentLink = {
  __typename?: 'ExhibitorContentLink';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Custom Fields criteria for exhibitor search */
export type ExhibitorCustomFieldsCriteria = {
  choices: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

/** Exhibitor details */
export type ExhibitorDetails = {
  __typename?: 'ExhibitorDetails';
  bannerImageAltText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use bannerUrlOptimized instead */
  bannerUrl?: Maybe<Scalars['String']['output']>;
  bannerUrlOptimized?: Maybe<Scalars['String']['output']>;
  boothStaff: Array<Maybe<ExhibitorBoothStaff>>;
  canRequestAppointment?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<ExhibitorCategory>>;
  chatSettings?: Maybe<ChatSettings>;
  content?: Maybe<ExhibitorContent>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventSponsor: Scalars['Boolean']['output'];
  exhibitorCode?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  floorPlan?: Maybe<FloorPlanWithoutMarkers>;
  id: Scalars['ID']['output'];
  inboundLeadsEnabled: Scalars['Boolean']['output'];
  links?: Maybe<ExhibitorLinks>;
  location?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use logoUrlOptimized instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  logoUrlOptimized?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officePhone?: Maybe<Scalars['String']['output']>;
  sessions: Array<Session>;
  showfloorSettings: ShowfloorSettings;
  /** @deprecated Use 'sessions' instead */
  sponsoredSessions: Array<SponsoredSession>;
  /** @deprecated Use sponsorshipLevels instead */
  sponsorshipLevel?: Maybe<SponsorshipLevel>;
  sponsorshipLevels?: Maybe<Array<SponsorshipLevel>>;
  tagline?: Maybe<Scalars['String']['output']>;
  videos: Array<ExhibitorVideo>;
  virtualBoothUrl?: Maybe<Scalars['String']['output']>;
  virtualHostKey?: Maybe<Scalars['String']['output']>;
  virtualMeetingsEnabled: Scalars['Boolean']['output'];
  virtualMeetingsExhibitorEnabled: Scalars['Boolean']['output'];
};

/** Exhibitor Inbound Lead Applications */
export enum ExhibitorInboundLeadApplication {
  EngagementhubMobile = 'engagementhub_mobile',
  EngagementhubWeb = 'engagementhub_web'
}

/** Exhibitor Inbound Lead Input */
export type ExhibitorInboundLeadInput = {
  application: ExhibitorInboundLeadApplication;
  exhibitorId: Scalars['ID']['input'];
  localCreatedAt: Scalars['Int']['input'];
  localId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  referenceId: Scalars['ID']['input'];
};

/** Exhibitor Inbound Lead Response */
export type ExhibitorInboundLeadResponse = {
  __typename?: 'ExhibitorInboundLeadResponse';
  application: ExhibitorInboundLeadApplication;
  exhibitorId: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  localCreatedAt: Scalars['Int']['output'];
  localId: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  referenceId: Scalars['ID']['output'];
  source: ExhibitorInboundLeadSource;
  sourceEventId: Scalars['ID']['output'];
};

/** Exhibitor Inbound Lead Sources */
export enum ExhibitorInboundLeadSource {
  Inbound = 'inbound'
}

export type ExhibitorInfo = {
  __typename?: 'ExhibitorInfo';
  boothLocation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Exhibitor links */
export type ExhibitorLinks = {
  __typename?: 'ExhibitorLinks';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** Page criteria for exhibitor search */
export type ExhibitorPageCriteria = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Return paginated data for exhibitor list */
export type ExhibitorPaginatedResults = {
  __typename?: 'ExhibitorPaginatedResults';
  categories?: Maybe<Array<ExhibitorCategory>>;
  data: Array<Exhibitor>;
  filterableCustomFields: Array<FilterableCustomFields>;
  hasVirtualBooths: Scalars['Boolean']['output'];
  pagination?: Maybe<Pagination>;
  sponsorshipLevels: Array<SponsorshipLevel>;
  totalInCategory?: Maybe<Scalars['Int']['output']>;
};

/** Filters for exhibitorSearch */
export type ExhibitorSearchCriteria = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Array<ExhibitorCustomFieldsCriteria>>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSponsorOnlyExhibitor?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  hasVirtualBooth?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreHidden?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreSponsorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pageCriteria?: InputMaybe<ExhibitorPageCriteria>;
  prioritizeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBySponsorshipLevel?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorshipLevelId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Exhibitor provided video */
export type ExhibitorVideo = {
  __typename?: 'ExhibitorVideo';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated All v1 format videos have been migrated to v2 */
  name?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated All v1 format videos have been migrated to v2 */
  universalVideo?: Maybe<Scalars['Boolean']['output']>;
  videoServiceId?: Maybe<Scalars['String']['output']>;
};

export type ExhibitorsBoothLocationInput = {
  staffInviteeIds: Array<Scalars['String']['input']>;
};

/** Experiment */
export type Experiment = {
  __typename?: 'Experiment';
  experimentName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Status of a mutation attempting to expire an experiment */
export type ExperimentExpiryStatus = {
  __typename?: 'ExperimentExpiryStatus';
  message?: Maybe<Scalars['String']['output']>;
  successful: Scalars['Boolean']['output'];
};

export type FeatureSettingInput = {
  featureCode?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
};

export type FeatureSettings = AttendeeHubConfigInterface & {
  __typename?: 'FeatureSettings';
  featureCode: Scalars['String']['output'];
  hasVisibleToggle?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAppBuilderManaged?: Maybe<Scalars['Boolean']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  platform: Platform;
  type: Scalars['String']['output'];
};

export type FeatureSettingsInput = {
  featureSettings: Array<InputMaybe<FeatureSettingInput>>;
};

export type FeedbackSurvey = {
  audience: SurveyAudience;
  chapterId: Scalars['ID']['output'];
  surveyId: Scalars['ID']['output'];
  surveyUrl: Scalars['String']['output'];
};

export type FileInfo = {
  __typename?: 'FileInfo';
  location: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  __typename?: 'Filter';
  customFilterType?: Maybe<SessionCustomFieldType>;
  details?: Maybe<CustomFieldDetails>;
  filterName?: Maybe<Scalars['String']['output']>;
  filterType: FilterType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  selected: Scalars['Boolean']['output'];
};

export type FilterApptEventAttendeesInput = {
  apptTypeId: Scalars['ID']['input'];
  endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  excludeAgendaItemId?: InputMaybe<Scalars['ID']['input']>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  showAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  showRequestableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showTeamMemberInfo?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type FilterExhibitorBoothStaffAttendeesInput = {
  apptTypeId: Scalars['ID']['input'];
  endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  exhibitorId?: InputMaybe<Scalars['ID']['input']>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  showAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  showBoothStaffOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showPossibleHostsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showRequestableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type FilterFieldsConfig = {
  __typename?: 'FilterFieldsConfig';
  filterFields?: Maybe<Array<CalendarEventsFilterFields>>;
};

export enum FilterType {
  Custom = 'Custom',
  Standard = 'Standard'
}

/** Filterable Custom Fields */
export type FilterableCustomFields = {
  __typename?: 'FilterableCustomFields';
  choices: Array<FilterableCustomFieldsChoice>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

/** Filterable Custom Fields Choice */
export type FilterableCustomFieldsChoice = {
  __typename?: 'FilterableCustomFieldsChoice';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type FloorPlan = FloorPlanInterface & {
  __typename?: 'FloorPlan';
  createdDate: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  floorPlanOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image: FloorPlanImage;
  isFeatured: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  markerCount?: Maybe<Scalars['Int']['output']>;
  markers?: Maybe<Array<Maybe<FloorPlanMarker>>>;
  name: Scalars['String']['output'];
};

export type FloorPlanImage = {
  __typename?: 'FloorPlanImage';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlOptimized?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanInterface = {
  createdDate: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  floorPlanOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image: FloorPlanImage;
  isFeatured: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  markerCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type FloorPlanMarker = {
  __typename?: 'FloorPlanMarker';
  coordinates: Coordinates;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  location: Location;
};

export type FloorPlanMarkerPayload = {
  coordinates: XyCoordinates;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location: LocationPayload;
};

export type FloorPlanPayload = {
  description?: InputMaybe<Scalars['String']['input']>;
  image: ImagePayload;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible: Scalars['Boolean']['input'];
  markers?: InputMaybe<Array<InputMaybe<FloorPlanMarkerPayload>>>;
  name: Scalars['String']['input'];
};

export type FloorPlanWithoutMarkers = FloorPlanInterface & {
  __typename?: 'FloorPlanWithoutMarkers';
  createdDate: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  floorPlanOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image: FloorPlanImage;
  isFeatured: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  markerCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type FontDescriptor = {
  __typename?: 'FontDescriptor';
  customFontId?: Maybe<Scalars['ID']['output']>;
  fallbackFont?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  styles?: Maybe<Array<FontStyle>>;
};

export type FontDescriptorInput = {
  customFontId?: InputMaybe<Scalars['ID']['input']>;
  fallbackFont?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  styles?: InputMaybe<Array<FontStyleInput>>;
};

export type FontFile = {
  __typename?: 'FontFile';
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum FontFormat {
  Opentype = 'opentype',
  Truetype = 'truetype',
  Woff = 'woff',
  Woff2 = 'woff2'
}

export type FontStyle = {
  __typename?: 'FontStyle';
  format?: Maybe<FontFormat>;
  style: FontStyleType;
  url: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type FontStyleInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  style: FontStyleType;
  url: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export enum FontStyleType {
  Italic = 'italic',
  Normal = 'normal'
}

export enum Format {
  Hybrid = 'Hybrid',
  InPerson = 'In_person',
  Virtual = 'Virtual'
}

export type Game = {
  __typename?: 'Game';
  achievements?: Maybe<Array<Achievement>>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Leaderboard>;
  leaderboardEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  player?: Maybe<Player>;
  rules?: Maybe<Scalars['String']['output']>;
  statsEnabled: Scalars['Boolean']['output'];
  totalJoinedPlayers?: Maybe<Scalars['Int']['output']>;
  validEnd: Scalars['String']['output'];
  validStart: Scalars['String']['output'];
};

export type GameInfo = {
  __typename?: 'GameInfo';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rules?: Maybe<Scalars['String']['output']>;
  validEnd: Scalars['String']['output'];
  validStart: Scalars['String']['output'];
};

export type GameOptInStatus = {
  __typename?: 'GameOptInStatus';
  game?: Maybe<Scalars['ID']['output']>;
  optIn?: Maybe<Scalars['Boolean']['output']>;
};

export type GenericDownloadLink = {
  __typename?: 'GenericDownloadLink';
  genericDownloadLink?: Maybe<DeepLink>;
};

export type GenericEventGuideCard = EventGuideCard & {
  __typename?: 'GenericEventGuideCard';
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  scheduledTimes: Array<EventGuideScheduleTime>;
  type: EventGuideCardType;
};

/** Input request to list widgets associated to a session */
export type GetAssignedWidgetsInput = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type GetCustomFieldsCriteria = {
  pageCriteria?: InputMaybe<PageCriteria>;
};

/** Input request to list widgets for an event */
export type GetWidgetsInput = {
  pageCriteria?: InputMaybe<PageCriteria>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type Goal = {
  __typename?: 'Goal';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  taxonomyId?: Maybe<Scalars['String']['output']>;
};

export type GoalProgress = {
  __typename?: 'GoalProgress';
  count?: Maybe<Scalars['Int']['output']>;
  fractionCompleted?: Maybe<Scalars['Float']['output']>;
  goalId: Scalars['ID']['output'];
  points?: Maybe<Scalars['Int']['output']>;
};

export type GoogleMap = {
  __typename?: 'GoogleMap';
  signature: Scalars['String']['output'];
};

export type HasReactionsGetResponse = {
  __typename?: 'HasReactionsGetResponse';
  hasData: Scalars['Boolean']['output'];
};

export type HeaderThemeSettings = AttendeeHubConfigInterface & {
  __typename?: 'HeaderThemeSettings';
  attendeeHeaderTheme: ValidTheme;
  customHeaderTheme?: Maybe<Array<Maybe<CustomValidTheme>>>;
  eventGuideHeaderTheme: ValidTheme;
  exhibitorHeaderTheme: ValidTheme;
  gameHeaderTheme: ValidTheme;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  loginHeaderTheme: ValidTheme;
  moreTabHeaderTheme: ValidTheme;
  onDemandHeaderTheme?: Maybe<ValidTheme>;
  profileHeaderTheme: ValidTheme;
  scheduleHeaderTheme: ValidTheme;
  speakerHeaderTheme: ValidTheme;
  sponsorHeaderTheme: ValidTheme;
  venueMapHeaderTheme: ValidTheme;
};

/** To-do HUB-99191  make onDemandHeaderTheme Required */
export type HeaderThemeSettingsInput = {
  attendeeHeaderTheme: ValidTheme;
  customHeaderTheme?: InputMaybe<Array<InputMaybe<CustomValidThemeInput>>>;
  eventGuideHeaderTheme: ValidTheme;
  exhibitorHeaderTheme: ValidTheme;
  gameHeaderTheme: ValidTheme;
  loginHeaderTheme: ValidTheme;
  moreTabHeaderTheme: ValidTheme;
  onDemandHeaderTheme?: InputMaybe<ValidTheme>;
  profileHeaderTheme: ValidTheme;
  scheduleHeaderTheme: ValidTheme;
  speakerHeaderTheme: ValidTheme;
  sponsorHeaderTheme: ValidTheme;
  venueMapHeaderTheme: ValidTheme;
};

export type HeartbeatInput = {
  extendSession?: InputMaybe<Scalars['Boolean']['input']>;
  sendBoothStaffAvailabilityHeartbeat?: InputMaybe<Scalars['Boolean']['input']>;
  videoActivity?: InputMaybe<VideoActivityInput>;
};

export type HeartbeatResponse = {
  __typename?: 'HeartbeatResponse';
  boothStaffAvailabilityHeartbeatStatus?: Maybe<Scalars['Int']['output']>;
  encounterPublished?: Maybe<Scalars['Boolean']['output']>;
  sessionExtendedStatus?: Maybe<Scalars['Int']['output']>;
};

export type HomeCard = {
  __typename?: 'HomeCard';
  associatedCards?: Maybe<Array<HomeCard>>;
  associatedLinks?: Maybe<Array<Scalars['String']['output']>>;
  associatedVideos?: Maybe<Array<Scalars['String']['output']>>;
  cardType: HomeCardType;
  displayOnHome?: Maybe<Scalars['Boolean']['output']>;
  exhibitorId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isThumbnailOverridden?: Maybe<Scalars['Boolean']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  range?: Maybe<Array<Maybe<Range>>>;
  staffDisplayOnHome?: Maybe<Scalars['Boolean']['output']>;
  staffLinkText?: Maybe<Scalars['String']['output']>;
  staffName?: Maybe<Scalars['String']['output']>;
  staffTargetName?: Maybe<Scalars['String']['output']>;
  staffTargetType?: Maybe<AttendeeHubPageType>;
  targetName?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<AttendeeHubPageType>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailOptimized?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['ID']['output']>;
  videoName?: Maybe<Scalars['String']['output']>;
};

export type HomeCardInput = {
  associatedCards?: InputMaybe<Array<HomeCardInput>>;
  associatedLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  associatedVideos?: InputMaybe<Array<Scalars['String']['input']>>;
  cardType: HomeCardType;
  displayOnHome?: InputMaybe<Scalars['Boolean']['input']>;
  exhibitorId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  staffDisplayOnHome?: InputMaybe<Scalars['Boolean']['input']>;
  staffLinkText?: InputMaybe<Scalars['String']['input']>;
  staffName?: InputMaybe<Scalars['String']['input']>;
  staffTargetName?: InputMaybe<Scalars['String']['input']>;
  staffTargetType?: InputMaybe<AttendeeHubPageType>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<AttendeeHubPageType>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnailOptimized?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['ID']['input']>;
  videoName?: InputMaybe<Scalars['String']['input']>;
};

export enum HomeCardType {
  AppointmentCard = 'AppointmentCard',
  LinkCard = 'LinkCard',
  LinkGalleryCard = 'LinkGalleryCard',
  VideoCard = 'VideoCard',
  VideoGalleryCard = 'VideoGalleryCard'
}

export type HomeSchedulerConfig = {
  __typename?: 'HomeSchedulerConfig';
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  quickLinksFormat?: Maybe<QuickLinksFormatType>;
  scheduledCards?: Maybe<SchedulerData>;
  unscheduledCards?: Maybe<SchedulerData>;
};

export type HomeSchedulerCriteria = {
  eventId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HomeSchedulerInput = {
  quickLinksFormat?: InputMaybe<QuickLinksFormatType>;
  scheduledCards?: InputMaybe<SchedulerDataInput>;
  unscheduledCards?: InputMaybe<SchedulerDataInput>;
};

export type HomeSchedulerSettings = {
  __typename?: 'HomeSchedulerSettings';
  hasActiveAppointments: Scalars['Boolean']['output'];
  hasGamesContent: Scalars['Boolean']['output'];
  hasSurveyContent: Scalars['Boolean']['output'];
  isAgendaEnabled: Scalars['Boolean']['output'];
  isAppointmentEventUpgradable: Scalars['Boolean']['output'];
  isAppointmentsEnabled: Scalars['Boolean']['output'];
  isDiscussionsEnabled: Scalars['Boolean']['output'];
  isExhibitorsEnabled: Scalars['Boolean']['output'];
  isGamesEnabled: Scalars['Boolean']['output'];
  isLiveAndUpcomingEnabled: Scalars['Boolean']['output'];
  isMonetizeEnabled: Scalars['Boolean']['output'];
  isMyBadgeEnabled: Scalars['Boolean']['output'];
  isSpeakersEnabled: Scalars['Boolean']['output'];
  isSurveyEnabled: Scalars['Boolean']['output'];
  isVideosEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HrefPath = {
  __typename?: 'HrefPath';
  href?: Maybe<Scalars['String']['output']>;
};

export type HttpHeader = {
  __typename?: 'HttpHeader';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type IconSettings = {
  __typename?: 'IconSettings';
  customIcons?: Maybe<Array<CustomIcon>>;
  pack?: Maybe<Scalars['String']['output']>;
  reassignedIcons?: Maybe<Array<ReassignedIcon>>;
};

export type IconSettingsInput = {
  customIcons?: InputMaybe<Array<CustomIconInput>>;
  pack?: InputMaybe<Scalars['String']['input']>;
  reassignedIcons?: InputMaybe<Array<ReassignedIconInput>>;
};

export type IllustrationSettings = {
  __typename?: 'IllustrationSettings';
  hideAll?: Maybe<Scalars['Boolean']['output']>;
};

export type IllustrationSettingsInput = {
  hideAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAssetInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  assetUri?: InputMaybe<Scalars['String']['input']>;
  assetUriOptimized?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSecure?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  thumbnailImageUri?: InputMaybe<Scalars['String']['input']>;
  thumbnailImageUriOptimized?: InputMaybe<Scalars['String']['input']>;
};

export type ImageInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};

export type ImageMeta = {
  __typename?: 'ImageMeta';
  height?: Maybe<Scalars['Int']['output']>;
  isCdnUrl?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImagePayload = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlOptimized?: InputMaybe<Scalars['String']['input']>;
};

export type ImageSearchCriteria = {
  __typename?: 'ImageSearchCriteria';
  assetType: AssetType;
  eventId: Scalars['ID']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  fullFileName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  searchInCventLibrary?: Maybe<Scalars['Boolean']['output']>;
};

export type ImpactedAgendaItem = {
  __typename?: 'ImpactedAgendaItem';
  id: Scalars['ID']['output'];
};

export type InitiateRegModInput = {
  admissionItemToUpgrade: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Input Meeting Requester */
export type InputMeetingRequester = {
  company?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InterestChoice = {
  __typename?: 'InterestChoice';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type InterestChoicesResponse = {
  __typename?: 'InterestChoicesResponse';
  data: Array<InterestChoice>;
  pagination: Pagination;
};

export type InviteeCredit = {
  __typename?: 'InviteeCredit';
  creditExpirationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  creditName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum InviteeMeetingStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type InviteeProfileImage = {
  __typename?: 'InviteeProfileImage';
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export enum InviteeStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  DeniedApproval = 'DeniedApproval',
  NoResponse = 'NoResponse',
  PendingApproval = 'PendingApproval',
  Visited = 'Visited',
  Waitlisted = 'Waitlisted'
}

export type LanguageLiveCaptionsInput = {
  languageCode: Scalars['String']['input'];
  words: Array<LiveCaptionsWordInput>;
};

export type LatestVersions = {
  __typename?: 'LatestVersions';
  brandedAppVersion: Scalars['String']['output'];
  cventAppVersion: Scalars['String']['output'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  players?: Maybe<Array<Maybe<LeaderboardPlayer>>>;
};

export type LeaderboardPlayer = {
  __typename?: 'LeaderboardPlayer';
  attendeeId: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  totalScore?: Maybe<Scalars['Int']['output']>;
};

export type LinkData = {
  __typename?: 'LinkData';
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkedAppointmentEvent = {
  __typename?: 'LinkedAppointmentEvent';
  accountId: Scalars['Int']['output'];
  apptEventType: ApptEventType;
  id: Scalars['ID']['output'];
  linkedRegEventStub: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type LiveCaptionsContent = {
  __typename?: 'LiveCaptionsContent';
  endTimeMs: Scalars['Int']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  isPartial: Scalars['Boolean']['output'];
  languages: Array<LiveCaptionsLanguage>;
  sessionId: Scalars['ID']['output'];
  startTimeMs: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type LiveCaptionsContentInput = {
  endTimeMs: Scalars['Int']['input'];
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  isPartial: Scalars['Boolean']['input'];
  languages: Array<LanguageLiveCaptionsInput>;
  sessionId: Scalars['ID']['input'];
  startTimeMs: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type LiveCaptionsLanguage = {
  __typename?: 'LiveCaptionsLanguage';
  languageCode: Scalars['String']['output'];
  words: Array<LiveCaptionsWord>;
};

export type LiveCaptionsWord = {
  __typename?: 'LiveCaptionsWord';
  endTimeMs: Scalars['Int']['output'];
  isPunctuation: Scalars['Boolean']['output'];
  startTimeMs: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type LiveCaptionsWordInput = {
  endTimeMs: Scalars['Int']['input'];
  isPunctuation: Scalars['Boolean']['input'];
  startTimeMs: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export enum LiveDisplayPageStyles {
  Body = 'BODY',
  Header = 'HEADER',
  None = 'NONE'
}

export type LiveDisplaySettings = AttendeeHubConfigInterface & {
  __typename?: 'LiveDisplaySettings';
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  pageStyle: LiveDisplayPageStyles;
  selectedThemeColor: ValidTheme;
  useEventIcon: Scalars['Boolean']['output'];
};

export type LiveDisplaySettingsInput = {
  pageStyle: LiveDisplayPageStyles;
  selectedThemeColor: ValidTheme;
  useEventIcon: Scalars['Boolean']['input'];
};

/** LiveDisplayTheme model. Defines the theming and styling for Live Display */
export type LiveDisplayTheme = {
  __typename?: 'LiveDisplayTheme';
  liveDisplayConfigString?: Maybe<Scalars['String']['output']>;
};

/**
 * Session object for Live Q&A
 * TODO: WAX-1272 Refactor this out in preference for using Session
 */
export type LiveQaSession = {
  __typename?: 'LiveQaSession';
  endTime: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  included?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sessionAccessCode?: Maybe<Scalars['String']['output']>;
  sessionCheckIn?: Maybe<SessionCheckIn>;
  startTime: Scalars['AWSDateTime']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
  webcast?: Maybe<Webcast>;
};

export type LiveQaSessionPaginatedResults = {
  __typename?: 'LiveQaSessionPaginatedResults';
  data?: Maybe<Array<Maybe<LiveQaSession>>>;
  pagination?: Maybe<Pagination>;
};

export type LiveStatusUpdateResponse = {
  __typename?: 'LiveStatusUpdateResponse';
  eventId?: Maybe<Scalars['ID']['output']>;
  playerId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
  streamStatus: PlayerStreamStatus;
  webcastId: Scalars['ID']['output'];
};

export type LivestreamJob = {
  __typename?: 'LivestreamJob';
  id: Scalars['ID']['output'];
  status: LivestreamStatus;
};

export enum LivestreamStatus {
  Cancelled = 'Cancelled',
  Cancelling = 'Cancelling',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Failed = 'Failed',
  Finished = 'Finished',
  Finishing = 'Finishing',
  Processing = 'Processing',
  Standby = 'Standby',
  Waiting = 'Waiting'
}

export type LocalizedLocation = {
  __typename?: 'LocalizedLocation';
  locationCode?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationTranslation?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type LocationFilter = {
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPayload = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: LocationType;
};

export enum LocationType {
  Exhibitor = 'EXHIBITOR',
  Other = 'OTHER',
  Session = 'SESSION'
}

export type LogoutInput = {
  revokeTokensIssuedBefore: Scalars['String']['input'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  revokeStreamTokens?: Maybe<ChatServiceStatus>;
};

export type MarkReportReadResult = {
  __typename?: 'MarkReportReadResult';
  message?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MarkerFilterCriteria = {
  entityTypes?: InputMaybe<Array<LocationType>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type Meeting = {
  __typename?: 'Meeting';
  status?: Maybe<Scalars['String']['output']>;
};

/** Meeting Requester Details Embedded Virtual Meeting Status */
export type MeetingRequester = {
  __typename?: 'MeetingRequester';
  company?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum MeetingStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Requested = 'REQUESTED',
  Started = 'STARTED'
}

export type MessagingChannel = {
  __typename?: 'MessagingChannel';
  channelId?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  resetAt?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type MobileAssets = AttendeeHubConfigInterface & {
  __typename?: 'MobileAssets';
  eventImageAltText?: Maybe<Scalars['String']['output']>;
  eventImageId?: Maybe<Scalars['ID']['output']>;
  eventImageName?: Maybe<Scalars['String']['output']>;
  eventImageUrl?: Maybe<Scalars['AWSURL']['output']>;
  eventImageUrlOptimized?: Maybe<Scalars['AWSURL']['output']>;
  eventSplashImageAltText?: Maybe<Scalars['String']['output']>;
  eventSplashImageId?: Maybe<Scalars['ID']['output']>;
  eventSplashImageName?: Maybe<Scalars['String']['output']>;
  eventSplashImageUrl?: Maybe<Scalars['AWSURL']['output']>;
  eventSplashImageUrlOptimized?: Maybe<Scalars['AWSURL']['output']>;
  isCompactHeader?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
};

export type MobileAssetsInput = {
  eventImageAltText?: InputMaybe<Scalars['String']['input']>;
  eventImageId?: InputMaybe<Scalars['ID']['input']>;
  eventImageName?: InputMaybe<Scalars['String']['input']>;
  eventImageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  eventSplashImageAltText?: InputMaybe<Scalars['String']['input']>;
  eventSplashImageId?: InputMaybe<Scalars['ID']['input']>;
  eventSplashImageName?: InputMaybe<Scalars['String']['input']>;
  eventSplashImageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  isCompactHeader?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input request to update the code snippet for an associated widget session */
export type ModifyAssignedWidgetSessionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};

/** Input request to modify an existing widget */
export type ModifyWidgetInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  widgetId: Scalars['ID']['input'];
};

export type MorePageSettings = AttendeeHubConfigInterface & {
  __typename?: 'MorePageSettings';
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  pageGroups: Array<Maybe<PageGroup>>;
  showAboutInfo: Scalars['Boolean']['output'];
  showEventLocation: Scalars['Boolean']['output'];
};

export type MorePageSettingsInput = {
  pageGroups: Array<InputMaybe<PageGroupInput>>;
  showAboutInfo: Scalars['Boolean']['input'];
  showEventLocation: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an appointment */
  acceptAppointment?: Maybe<AgendaItem>;
  /** Accept a connection between two contacts */
  acceptAttendeeConnection: SuccessfulMutationResponse;
  /** Verify user can access chat as well as promote/demote moderators in stream chat */
  accessExhibitorChat?: Maybe<ChatVerification>;
  /**
   * Create a new poll instance
   * Authorization: Planner
   */
  addPoll?: Maybe<PlannerPoll>;
  /**
   * 1. Add a poll question to the moderator-editable poll of the session
   * 2. Publish the poll
   * note: If the moderator-editable poll of the session does not exist, it will be created
   * Authorization: Moderator
   */
  addPollQuestionInModeratorPoll?: Maybe<AttendeePoll>;
  /**
   * Add a poll question to a poll instance
   * Authorization: Planner
   */
  addQuestion?: Maybe<PlannerPoll>;
  /** Add attendee reaction to session videos */
  addReaction?: Maybe<AddReactionOutput>;
  /** Create a new Widget */
  addWidget?: Maybe<Widget>;
  /** apply discount to items in reg cart */
  applyDiscount?: Maybe<OrderSummary>;
  /** Set the assigned sessions of an existing Widget */
  assignSessionsToWidget?: Maybe<Array<Maybe<AssignedWidgetSession>>>;
  /**
   * Extends the TTL of attendee availability
   * Authorization: bearer
   */
  availabilityHeartbeat?: Maybe<AvailabilityHeartbeatResponse>;
  /**
   * Broadcast status updates to attendees
   * Authorization: API_KEY or bearer
   */
  broadcastAttendeeStatus?: Maybe<AttendeeStatus>;
  /**
   * Broadcast booth staff status updates to attendees
   * Authorization: API_KEY or bearer
   */
  broadcastBoothStaffStatus?: Maybe<BoothStaffStatus>;
  /** Update live captions */
  broadcastLiveCaptions?: Maybe<LiveCaptionsContent>;
  /**
   * Broadcast upvotes to attendees
   * Authorization: API Key
   */
  broadcastQuestionVotes?: Maybe<Question>;
  /**
   * Broadcast reactions to attendees
   * Authorization: API Key
   */
  broadcastReactions?: Maybe<ReactionsBroadcastOutput>;
  /**
   * Broadcast Session Settings changed by the Planner in Core
   * Authorization: API Key
   */
  broadcastSessionSettings?: Maybe<SessionSettings>;
  /**
   * Update  a floor plan and it's markers for an event -
   * eventId, FloorPlanId, deletedMarkersIds, inputFloorPlan, FloorPlanMarkerPayload has to be passed in
   */
  bulkFloorPlanOperations?: Maybe<FloorPlan>;
  /** Cancel an appointment */
  cancelAppointment?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel or remove a connection between two contacts */
  cancelOrRemoveAttendeeConnection: SuccessfulMutationResponse;
  /** Check in an appointment attendee */
  checkinAppointment?: Maybe<Appointment>;
  /**
   * Clear Dismissed Attendee Recommendations
   * Only used for testing purposes
   */
  clearDismissedAttendeeRecommendations?: Maybe<Scalars['Boolean']['output']>;
  /** Create an appointment */
  createAppointment?: Maybe<AgendaItem>;
  createCustomPage: CustomPageSettings;
  createEventMobileSettings: EventMobileSettings;
  /**
   * Create a Floor Plan for an event -
   * eventId has to be passed in, inputPayload for FloorPlan has to be passed in
   */
  createFloorPlan?: Maybe<FloorPlan>;
  /** Create generic download link */
  createGenericDownloadLink?: Maybe<GenericDownloadLink>;
  /** Create an attendee to exhibitor inbound lead */
  createInboundLead?: Maybe<ExhibitorInboundLeadResponse>;
  /**
   * Create a report for a message
   * Authorization: Attendee
   */
  createMessageReport?: Maybe<ReportPostResult>;
  /**
   * Create a new channel for attendee 1:1 messaging
   * @deprecated Use createMessagingChannelV2 instead
   */
  createMessagingChannel?: Maybe<MessagingChannel>;
  /** Create a new channel for attendee 1:1 or group messaging */
  createMessagingChannelV2?: Maybe<MessagingChannel>;
  createPageBanner: PageBannerSettings;
  /** Create reserved time */
  createPersonalTime?: Maybe<AgendaItem>;
  /**
   * Create a new Question
   * Authorization: Attendees
   */
  createQuestion?: Maybe<Question>;
  /**
   * Create a simple appointment event
   * Authorization: Planner
   */
  createSimpleAppointmentEvent?: Maybe<AppointmentEvent>;
  createSpace: Space;
  /** Creates an upload link at the given path. Currently supports discussion type. */
  createUploadImageLink?: Maybe<PresignedUploadUrl>;
  /**
   * Creates an upload link at the given path
   * @deprecated Use createUploadImageLink instead
   */
  createUploadLink?: Maybe<PresignedUploadUrl>;
  /** Decline an appointment */
  declineAppointment?: Maybe<Scalars['Boolean']['output']>;
  /** Decline a connection between two contacts */
  declineAttendeeConnection: SuccessfulMutationResponse;
  /** Let attendee request the deletion of their account by the planner */
  deleteAttendeeAccount?: Maybe<DeleteAttendeeAccountResult>;
  deleteCustomPage: SuccessfulMutationResponse;
  deleteEventMobileSettings: SuccessfulMutationResponse;
  /**
   * Delete the Floor Plan for an event -
   * eventId has to be passed in, FloorPlanId has to be passed in
   */
  deleteFloorPlan?: Maybe<SuccessfulMutationResponse>;
  /** Mutation to delete a message and create report with resolve(deleted) status */
  deleteMessage?: Maybe<ReportPostResult>;
  deletePageBanner: SuccessfulMutationResponse;
  /** Delete reserved time */
  deletePersonalTime?: Maybe<PersonalTimeDeleteResponse>;
  /**
   * 1. Delete a poll question in the moderator-editable poll of a session
   * note: for the last question of the poll, delete the poll itself
   * 2. Publish the poll
   * Authorization: Moderator
   */
  deletePollQuestionInModeratorPoll?: Maybe<BulkOperation>;
  /**
   * Delete multiple poll questions
   * Authorization: Planner
   */
  deletePollQuestions?: Maybe<BulkOperation>;
  /**
   * Delete multiple polls
   * Authorization: Planner
   */
  deletePolls?: Maybe<BulkOperation>;
  /** Delete individual preFilter list */
  deletePreFilterList?: Maybe<DeletePreFilterResponse>;
  /** Delete professional interest choices */
  deleteProfessionalInterestChoices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Delete a reactions session configuration */
  deleteReactionsSessionConfig: SuccessfulMutationResponse;
  deleteSpace: SuccessfulMutationResponse;
  deleteVenueMapSettings: SuccessfulMutationResponse;
  /** Delete an existing Widget */
  deleteWidget?: Maybe<Scalars['Boolean']['output']>;
  /** Dismiss Attendee Recommendation */
  dismissAttendeeRecommendation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Notify Meeting Invitee Status Changed
   * Authorization: API_KEY, bearer
   */
  exhibitorMeetingInviteeStatusChanged?: Maybe<MeetingInviteeStatusChangedResponse>;
  /** Register attendee to video conference & generate join URL */
  generateAttendeeJoinUrl?: Maybe<AttendeeJoinUrl>;
  /**
   * Generate an authorization token to communicate with stream.io.
   * If useShortExpiry is set to false or omitted, then the default 5 hours tokens will get generated providing backwards
   * compatibility. Set to true to generate tokens with shorter TTL, thus reducing the chances of malicious users getting
   * a valid token to exploit. See https://jira.cvent.com/browse/HUB-132773
   */
  generateChatToken?: Maybe<ChatToken>;
  /**
   * Generate an exhibitor authorization token to communicate with stream.io.
   * If useShortExpiry is set to false or omitted, then the default 5 hours tokens will get generated providing backwards
   * compatibility. Set to true to generate tokens with shorter TTL, thus reducing the chances of malicious users getting
   * a valid token to exploit. See https://jira.cvent.com/browse/HUB-132773
   */
  generateExhibitorChatToken?: Maybe<ChatToken>;
  /** Generate Webcast Signature */
  generateWebcastSignatureV2?: Maybe<WebcastSignature>;
  /**
   * A no-op that has the effect of extending a user's session
   * @deprecated Use heartbeatV2 instead
   */
  heartbeat: Scalars['Boolean']['output'];
  /**
   * Refresh/extend auth token, publish encounters, and extend booth staff
   * availability.
   */
  heartbeatV2?: Maybe<HeartbeatResponse>;
  initiateOrderCheckout?: Maybe<Scalars['Boolean']['output']>;
  /** Upgrade admission item and session details for invitee */
  initiateRegModAndGetOrderSummaryDetails?: Maybe<OrderSummary>;
  /** Leave group channel */
  leaveGroupMessagingChannel?: Maybe<MessagingChannel>;
  /**
   * Login to Live Display
   * Authorization: None
   */
  login?: Maybe<DisplayCodeLoginResponse>;
  /**
   * Extendable Logout Mutation:
   * 1. Revokes stream chat json web tokens so that
   * attendees cannot back door Stream APIs after logging out
   */
  logout?: Maybe<LogoutResponse>;
  /** Mutation to mark report read for a moderator */
  markReportRead: Array<MarkReportReadResult>;
  /** Update the code snippet for an associated widget session */
  modifyAssignedWidgetSession?: Maybe<AssignedWidgetSession>;
  /**
   * Update poll instance
   * Authorization: Planner
   */
  modifyPoll?: Maybe<PlannerPoll>;
  /**
   * 1. Modify an existing moderator-editable poll question by ID
   * 2. Publish the poll
   * note: The existing poll question and moderator-editable poll must exist
   * Authorization: Moderator
   */
  modifyPollQuestionInModeratorPoll?: Maybe<AttendeePoll>;
  /**
   * Modify a poll question by ID in a poll instance
   * Authorization: Planner
   */
  modifyQuestion?: Maybe<PlannerPoll>;
  /** Update an existing Widget */
  modifyWidget?: Maybe<Widget>;
  /**
   * Mutation to trigger so that attendees can
   * connect to stream client in real time
   */
  notifyAttendeeHasChannels?: Maybe<StreamClientConnectTriggerStatus>;
  /** Notify subscribers that their pending connections count has changed for a particular event */
  notifyAttendeePendingConnectionsChanged: AttendeeConnectionUpdatedFields;
  /** Notifies that the config object for an event has changes */
  notifyConfigChanged?: Maybe<AppConfig>;
  /** Notify subscribers that a new device session has been started for the session id */
  notifyNewDeviceSession?: Maybe<ConfigSession>;
  /** Opts a player into the game */
  optInPlayer?: Maybe<Player>;
  /** Opts a player out of the game */
  optOutPlayer?: Maybe<Player>;
  /**
   * Re-order the questions of a poll instance
   * Authorization: Planner
   */
  orderQuestions?: Maybe<PlannerPoll>;
  patchEventMobileSettings: EventMobileSettings;
  /** Update individual preFilter list */
  preFilterList?: Maybe<PreFilterList>;
  /**
   * Create or Refresh respondents for polls for specific session in an event
   * Authorization: Attendees
   */
  prepareRespondents?: Maybe<PrepareRespondentsResponse>;
  /** Propose new time */
  proposeNewTime?: Maybe<AgendaItem>;
  publishAttendeeHubConfig: SuccessfulMutationResponse;
  /** Publish encounter to Rabbit for Attendance tracking */
  publishEncounter?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Publish a poll instance
   * A poll instance contains saved, but published changes
   * The poll is not visible to Attendees until the changes are published
   * Authorization: Planner
   */
  publishPoll?: Maybe<PlannerPoll>;
  /**
   * Publish all poll instances in an event
   * A poll instance contains saved, but published changes
   * The poll is not visible to Attendees until the changes are published
   * Authorization: Planner
   */
  publishPolls?: Maybe<Array<Maybe<PublishPollResult>>>;
  /** Publish the widget */
  publishWidget?: Maybe<Widget>;
  /**
   * Register an attendee to an event. This is unauthenticated since it's called from publicly accessible pages.
   * API_KEY auth is temporary while development is ongoing. This is to prevent unknown actors from calling this.
   */
  registerAttendee: Scalars['Boolean']['output'];
  /** remove applied discount from reg cart */
  removeDiscount?: Maybe<OrderSummary>;
  /** Request a connection between another contact */
  requestAttendeeConnection: SuccessfulMutationResponse;
  requestMeeting?: Maybe<AttendeeStatus>;
  /** Mutation to resolve a message report. Message reports are created when an attendee report a message in a chat channel */
  resolveMessageReport?: Maybe<ReportPostResult>;
  /**
   * Post response to specific question
   * Authorization: Attendees
   */
  respondToQuestion?: Maybe<SubscribablePollQuestionChoiceResultsByQuestion>;
  /**
   * Revoke pubNub authKey for an anonymous user
   * authorization: none
   */
  revokeAnonymousPubNubAuthKey?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Revoke pubNub authKey for an Attendee
   * authorization: attendee
   */
  revokePubNubAuthKey?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Session Enroll
   * @deprecated Use sessionEnrollment mutation instead
   */
  sessionEnroll?: Maybe<Scalars['Boolean']['output']>;
  /** Session enroll, unenroll, and swap */
  sessionEnrollment?: Maybe<SessionEnrollmentResponse>;
  /** Update the session guide (list of preFilter lists) */
  sessionGuide?: Maybe<SessionGuide>;
  /**
   * Session swap
   * @deprecated Use sessionEnrollment mutation instead
   */
  sessionSwap?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Session Un-enroll
   * @deprecated Use sessionEnrollment mutation instead
   */
  sessionUnenroll?: Maybe<Scalars['Boolean']['output']>;
  setAdmissionItemSettings: AdmissionItemSettings;
  /**
   * Set the assigned sessions of a poll instance
   * Note: moderator-editable polls cannot be assigned
   * Authorization: Planner
   */
  setAssignedSessions?: Maybe<PlannerPoll>;
  setAttendeeWebsiteSettings: AttendeeWebsiteSettings;
  setChecklistSettings: ChecklistSettings;
  setContentVisibilitySettings: ContentVisibilitySettings;
  setEventGuideSettings: EventGuideSettings;
  setHeaderThemeSettings: HeaderThemeSettings;
  /**
   * Mark an existing Question as the Current Question
   * If no questionId is given, this un-displays the current question.
   * This is a new API needed to replace the setCurrentQuestion query and to support backwards compatibility.
   * Authorization: Attendees with Moderator Role
   */
  setLiveDisplayQuestion?: Maybe<CurrentQuestion>;
  setLiveDisplaySettings: LiveDisplaySettings;
  setMobileAssets: MobileAssets;
  setMorePageSettings: MorePageSettings;
  setPrivacySettings: PrivacySettings;
  /**
   * Mutations for AttendeeHubConfig
   * @deprecated Use updateProfileSettings instead
   */
  setProfileSettings: ProfileSettings;
  /**
   * Set question text
   * Authorization: Attendees with Moderator Role
   */
  setQuestionTextAnswer?: Maybe<Question>;
  setSecuritySettings: SecuritySettings;
  /**
   * Set website settings for simple appointment event
   * Authorization: Planner
   */
  setSimpleApptEventSettings?: Maybe<ApptEventWebsiteSettings>;
  setThemeSettings: ThemeSettings;
  setVenueMapSettings: VenueMapSettings;
  /** Soft block an attendee in attendee messaging */
  softBlockAttendee?: Maybe<BlockedAttendee>;
  /** Soft un-block an attendee in attendee messaging */
  softUnblockAttendee?: Maybe<UnblockedAttendee>;
  /** Studio End Session */
  studioEndSession?: Maybe<StudioEndSessionResponse>;
  subscriptionToken?: Maybe<OneTimeToken>;
  testManualSubscription?: Maybe<TestSubscription>;
  testOnAttendeeHasChannelsV2Trigger?: Maybe<TestSubscription>;
  testSubscription?: Maybe<TestSubscription>;
  /**
   * Soft-undeletes multiple poll questions
   * Authorization: Planner
   */
  unDeletePollQuestions?: Maybe<BulkOperation>;
  /**
   * Undelete multiple soft-deleted polls
   * Authorization: Planner
   */
  unDeletePolls?: Maybe<BulkOperation>;
  /**
   * Upvote an existing Question
   * Authorization: Attendees
   */
  upVoteQuestion?: Maybe<Question>;
  /**
   * Update all floor plans of the event through this mutation
   * FloorPlanOrder, isFeatured fields can also be updated through this mutation -
   * eventId, array of all the floorPlans has to be passed in
   */
  updateAllFloorPlans?: Maybe<Array<Maybe<FloorPlanWithoutMarkers>>>;
  /** Update Profile Field Group Settings */
  updateAllProfileFieldGroupSettings?: Maybe<Array<Maybe<ProfileFieldGroupSettings>>>;
  /** Update appointment */
  updateAppointment?: Maybe<AgendaItem>;
  /** Update attendee compliance - CCPA Request */
  updateAttendeeCompliance: RequestDoNotSellResult;
  updateAttendeeConsent?: Maybe<AttendeeConsent>;
  updateAttendeeListFilters: AttendeeListFilters;
  /**
   * Update Availability Status
   * Authorization: bearer
   */
  updateAvailability?: Maybe<BoothStaffStatus>;
  updateCustomPage: CustomPageSettings;
  updateDefaultPageSettings: DefaultPageSettings;
  updateEventDefaultSettings: EventDefaultSettings;
  /** @deprecated Use patchEventMobileSettings instead */
  updateEventMobileSettings: EventMobileSettings;
  updateExhibitorConsentAnswer?: Maybe<ExhibitorConsentAnswerResponse>;
  updateFeatureSettings: Array<Maybe<FeatureSettings>>;
  /** Updates a group messaging channel to add new members */
  updateGroupMessagingChannelMembers?: Maybe<MessagingChannel>;
  /** Updates a group messaging channel to change the channel name */
  updateGroupMessagingChannelName?: Maybe<MessagingChannel>;
  updateHomeSchedulerConfig: HomeSchedulerConfig;
  /** Update livestream status */
  updateLivestreamStatus?: Maybe<UpdateLivestreamStatusResponse>;
  updateMeetingInviteeStatus?: Maybe<AttendeeStatus>;
  updatePageBanner: PageBannerSettings;
  updatePageBannerPageSettingsBulk: BulkPageBannerPageSettingsUpdateResult;
  /** Update reserved time */
  updatePersonalTime?: Maybe<AgendaItem>;
  /** Update the catalog that contains sessions with on demand content for the planner's event */
  updatePlannerOnDemandCatalog?: Maybe<OnDemandCatalog>;
  /** Update selected filters in falcon planner */
  updatePlannerSelectedFilters: SelectedFiltersMutationSuccess;
  /**
   * Update the poll status (open/closed)
   * Authorization: Moderator
   */
  updatePollQuestionStatus?: Maybe<SubscribablePollQuestionStatus>;
  /** Invalidate / refresh live polling response aggregation for an event session */
  updatePollsAggregation: SubscribableAttendeePoll;
  /** Update attendee interest choices */
  updateProfessionalInterestChoices: Array<Maybe<InterestChoice>>;
  /** Update Profile Card Design Settings */
  updateProfileCardDesignSettings?: Maybe<ProfileCardDesignSettingsWrapper>;
  /** Update user's attendee profile */
  updateProfileSecured?: Maybe<User>;
  /**
   * Update badgeEditingEnabled setting. The field profileEditingEnabled is deprecated, and should not be changed, even though
   * it is still a required input by the falcon-planner service.
   * For updating profile edit settings use Mutation.updateAllProfileFieldGroupSettings
   */
  updateProfileSettings: ProfileSettings;
  /**
   * Update the status of an existing Question
   * Authorization: Attendees with Moderator Role
   */
  updateQuestionStatus?: Maybe<Question>;
  /** Update a reactions session configuration */
  updateReactionsSessionConfig: ReactionsSessionConfigOutput;
  updateRegCart?: Maybe<OrderSummary>;
  /** update reg cart status for third party secure */
  updateRegCartStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Mutation to update the resolution note of all reports resolved by a moderator */
  updateResolutionNotes?: Maybe<UpdateResolutionNotesResult>;
  /**
   * Update Live Q&A Session settings
   * Authorization: Attendees with Moderator Role
   */
  updateSessionSettings?: Maybe<SessionSettings>;
  updateSpace: Space;
  /** Update Webcast Configuration */
  updateWebcastConfig?: Maybe<WebcastConfigUpdateResponse>;
  /** Update Webcast Stream Status (V2) */
  updateWebcastLiveStatus?: Maybe<LiveStatusUpdateResponse>;
  /**
   * Upgrade a simple appointment event to premium event
   * Authorization: Planner
   */
  upgradeSimpleAppointmentEvent?: Maybe<AppointmentEvent>;
  /** Upsert attendee preferences */
  upsertAttendeePreferences: Array<AttendeePreference>;
  /** Upsert Preferences */
  upsertPreferences: Array<Maybe<Preference>>;
  /** Validates a code for a scavenger hunt goal */
  validateScavengerHuntCode?: Maybe<ScavengerHuntCodeValidationResult>;
  /** Verify user can access chat */
  verifyExhibitorChatAccess?: Maybe<ChatVerification>;
  /** Verify user can access session chat */
  verifySessionChat?: Maybe<ChatVerification>;
  /** Verify user should or should not be session chat moderator */
  verifySessionChatModerator?: Maybe<ChatModeratorVerification>;
};

export type MutationAcceptAppointmentArgs = {
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationAcceptAttendeeConnectionArgs = {
  contactId: Scalars['ID']['input'];
};

export type MutationAccessExhibitorChatArgs = {
  exhibitorId: Scalars['ID']['input'];
};

export type MutationAddPollArgs = {
  eventId: Scalars['ID']['input'];
  input: PlannerPollRequest;
};

export type MutationAddPollQuestionInModeratorPollArgs = {
  eventId: Scalars['ID']['input'];
  input: PollQuestionRequest;
  sessionId: Scalars['ID']['input'];
};

export type MutationAddQuestionArgs = {
  eventId: Scalars['ID']['input'];
  input: PollQuestionRequest;
  pollId: Scalars['ID']['input'];
};

export type MutationAddReactionArgs = {
  input: AddReactionInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationAddWidgetArgs = {
  eventId: Scalars['ID']['input'];
  input: CreateWidgetInput;
};

export type MutationApplyDiscountArgs = {
  input: DiscountInput;
};

export type MutationAssignSessionsToWidgetArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<AssignSessionsInput>;
};

export type MutationAvailabilityHeartbeatArgs = {
  input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationBroadcastAttendeeStatusArgs = {
  input: BroadcastAttendeeStatus;
};

export type MutationBroadcastBoothStaffStatusArgs = {
  input: BroadcastBoothStaffStatus;
};

export type MutationBroadcastLiveCaptionsArgs = {
  captions: LiveCaptionsContentInput;
};

export type MutationBroadcastQuestionVotesArgs = {
  eventId: Scalars['ID']['input'];
  question: BroadcastQuestion;
  sessionId: Scalars['ID']['input'];
};

export type MutationBroadcastReactionsArgs = {
  reactions?: InputMaybe<BroadcastReactions>;
};

export type MutationBroadcastSessionSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: SessionSettingsPlannerInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationBulkFloorPlanOperationsArgs = {
  deletedMarkersIds: Array<InputMaybe<Scalars['ID']['input']>>;
  eventId: Scalars['ID']['input'];
  floorPlanId: Scalars['ID']['input'];
  inputFloorPlan?: InputMaybe<FloorPlanPayload>;
  inputMarkers: Array<InputMaybe<FloorPlanMarkerPayload>>;
};

export type MutationCancelAppointmentArgs = {
  params: CancelDeclineApptInput;
};

export type MutationCancelOrRemoveAttendeeConnectionArgs = {
  contactId: Scalars['ID']['input'];
};

export type MutationCheckinAppointmentArgs = {
  params: CheckinApptInput;
};

export type MutationCreateAppointmentArgs = {
  data: CreateApptInput;
};

export type MutationCreateCustomPageArgs = {
  eventId: Scalars['ID']['input'];
  input: CustomPageSettingsInput;
};

export type MutationCreateEventMobileSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: EventMobileSettingsInput;
};

export type MutationCreateFloorPlanArgs = {
  eventId: Scalars['ID']['input'];
  input: FloorPlanPayload;
};

export type MutationCreateGenericDownloadLinkArgs = {
  eventId: Scalars['ID']['input'];
};

export type MutationCreateInboundLeadArgs = {
  input: ExhibitorInboundLeadInput;
};

export type MutationCreateMessageReportArgs = {
  input: ReportPostInput;
};

export type MutationCreateMessagingChannelArgs = {
  attendeeId: Scalars['String']['input'];
};

export type MutationCreateMessagingChannelV2Args = {
  attendeeIds: Array<Scalars['String']['input']>;
};

export type MutationCreatePageBannerArgs = {
  eventId: Scalars['ID']['input'];
  input: PageBannerSettingsInput;
};

export type MutationCreatePersonalTimeArgs = {
  data: CreatePersonalTimeInput;
};

export type MutationCreateQuestionArgs = {
  eventId: Scalars['ID']['input'];
  input: NewQuestionInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationCreateSimpleAppointmentEventArgs = {
  eventId: Scalars['ID']['input'];
};

export type MutationCreateSpaceArgs = {
  appId: Scalars['ID']['input'];
  input: CreateSpaceInput;
};

export type MutationCreateUploadImageLinkArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type MutationCreateUploadLinkArgs = {
  filename: Scalars['String']['input'];
};

export type MutationDeclineAppointmentArgs = {
  params: CancelDeclineApptInput;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeclineAttendeeConnectionArgs = {
  contactId: Scalars['ID']['input'];
};

export type MutationDeleteCustomPageArgs = {
  eventId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteEventMobileSettingsArgs = {
  eventId: Scalars['ID']['input'];
};

export type MutationDeleteFloorPlanArgs = {
  eventId: Scalars['ID']['input'];
  floorPlanId: Scalars['ID']['input'];
};

export type MutationDeleteMessageArgs = {
  input: ReportPostInput;
};

export type MutationDeletePageBannerArgs = {
  eventId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeletePersonalTimeArgs = {
  personalTimeId: Scalars['ID']['input'];
};

export type MutationDeletePollQuestionInModeratorPollArgs = {
  eventId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationDeletePollQuestionsArgs = {
  eventId: Scalars['ID']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  pollId: Scalars['ID']['input'];
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationDeletePollsArgs = {
  eventId: Scalars['ID']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  pollIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationDeletePreFilterListArgs = {
  eventId: Scalars['ID']['input'];
  filterListId: Scalars['ID']['input'];
};

export type MutationDeleteProfessionalInterestChoicesArgs = {
  eventId: Scalars['ID']['input'];
  interestChoiceIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MutationDeleteReactionsSessionConfigArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationDeleteSpaceArgs = {
  appId: Scalars['ID']['input'];
  spaceId: Scalars['ID']['input'];
};

export type MutationDeleteVenueMapSettingsArgs = {
  eventId: Scalars['ID']['input'];
};

export type MutationDeleteWidgetArgs = {
  eventId: Scalars['ID']['input'];
  input: DeleteWidgetInput;
};

export type MutationDismissAttendeeRecommendationArgs = {
  input?: InputMaybe<DismissAttendeeRecommendationInput>;
};

export type MutationExhibitorMeetingInviteeStatusChangedArgs = {
  input: MeetingInviteeStatusChangedInput;
};

export type MutationGenerateAttendeeJoinUrlArgs = {
  attendeeRegistrationInput?: InputMaybe<AttendeeRegistrationInput>;
};

export type MutationGenerateChatTokenArgs = {
  useShortExpiry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationGenerateExhibitorChatTokenArgs = {
  useShortExpiry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationGenerateWebcastSignatureV2Args = {
  sessionId: Scalars['ID']['input'];
};

export type MutationHeartbeatV2Args = {
  heartbeatInput: HeartbeatInput;
};

export type MutationInitiateOrderCheckoutArgs = {
  orderCheckoutInput: OrderCheckoutInput;
};

export type MutationInitiateRegModAndGetOrderSummaryDetailsArgs = {
  input: InitiateRegModInput;
};

export type MutationLeaveGroupMessagingChannelArgs = {
  channelId: Scalars['String']['input'];
};

export type MutationLoginArgs = {
  code: Scalars['String']['input'];
  displayCodeType: DisplayCodeType;
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

export type MutationLogoutArgs = {
  input: LogoutInput;
};

export type MutationMarkReportReadArgs = {
  reportIds: Array<Scalars['ID']['input']>;
};

export type MutationModifyAssignedWidgetSessionArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<ModifyAssignedWidgetSessionInput>;
};

export type MutationModifyPollArgs = {
  eventId: Scalars['ID']['input'];
  input: PlannerUpdateRequest;
  pollId: Scalars['ID']['input'];
};

export type MutationModifyPollQuestionInModeratorPollArgs = {
  eventId: Scalars['ID']['input'];
  input: PollQuestionRequest;
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationModifyQuestionArgs = {
  eventId: Scalars['ID']['input'];
  input: PollQuestionRequest;
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export type MutationModifyWidgetArgs = {
  eventId: Scalars['ID']['input'];
  input: ModifyWidgetInput;
};

export type MutationNotifyAttendeeHasChannelsArgs = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type MutationNotifyAttendeePendingConnectionsChangedArgs = {
  action?: InputMaybe<AttendeePendingConnectionAction>;
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  initiatorAttendeeId?: InputMaybe<Scalars['ID']['input']>;
  pendingConnectionsCount: Scalars['Int']['input'];
};

export type MutationNotifyConfigChangedArgs = {
  appConfigString: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationNotifyNewDeviceSessionArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MutationOrderQuestionsArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationPatchEventMobileSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: PatchEventMobileSettingsInput;
};

export type MutationPreFilterListArgs = {
  eventId: Scalars['ID']['input'];
  preFilterList: PreFilterListInput;
};

export type MutationPrepareRespondentsArgs = {
  input?: InputMaybe<PrepareRespondentsRequest>;
};

export type MutationProposeNewTimeArgs = {
  params: ProposeNewTimeInput;
};

export type MutationPublishAttendeeHubConfigArgs = {
  eventId: Scalars['ID']['input'];
  input: PublishInput;
};

export type MutationPublishEncounterArgs = {
  encounterMode: EncounterMode;
  relativeTime?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type MutationPublishPollArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
};

export type MutationPublishPollsArgs = {
  eventId: Scalars['ID']['input'];
};

export type MutationPublishWidgetArgs = {
  eventId: Scalars['ID']['input'];
  input: PublishWidgetInput;
};

export type MutationRegisterAttendeeArgs = {
  input: RegisterAttendeeInput;
};

export type MutationRemoveDiscountArgs = {
  input: DiscountInput;
};

export type MutationRequestAttendeeConnectionArgs = {
  contactId: Scalars['ID']['input'];
};

export type MutationRequestMeetingArgs = {
  input: RequestMeetingInput;
};

export type MutationResolveMessageReportArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<ChatEntityType>;
  messageReportId: Scalars['ID']['input'];
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
  resolveAll?: InputMaybe<Scalars['Boolean']['input']>;
  status: ReportPostStatus;
};

export type MutationRespondToQuestionArgs = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRevokeAnonymousPubNubAuthKeyArgs = {
  authKey: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type MutationRevokePubNubAuthKeyArgs = {
  authKey: Scalars['ID']['input'];
};

export type MutationSessionEnrollArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type MutationSessionEnrollmentArgs = {
  sessionEnrollmentInput?: InputMaybe<SessionEnrollmentInput>;
};

export type MutationSessionGuideArgs = {
  eventId: Scalars['ID']['input'];
  sessionGuide: SessionGuideInput;
};

export type MutationSessionSwapArgs = {
  sessionSwapInput?: InputMaybe<SessionSwapInput>;
};

export type MutationSessionUnenrollArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MutationSetAdmissionItemSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: AdmissionItemSettingsInput;
};

export type MutationSetAssignedSessionsArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  sessionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationSetAttendeeWebsiteSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: AttendeeWebsiteSettingsInput;
};

export type MutationSetChecklistSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ChecklistSettingsInput;
};

export type MutationSetContentVisibilitySettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ContentVisibilitySettingsInput;
};

export type MutationSetEventGuideSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: EventGuideSettingsInput;
};

export type MutationSetHeaderThemeSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: HeaderThemeSettingsInput;
};

export type MutationSetLiveDisplayQuestionArgs = {
  currentQuestionType: CurrentQuestionType;
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  pollId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationSetLiveDisplaySettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: LiveDisplaySettingsInput;
};

export type MutationSetMobileAssetsArgs = {
  eventId: Scalars['ID']['input'];
  input: MobileAssetsInput;
};

export type MutationSetMorePageSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: MorePageSettingsInput;
};

export type MutationSetPrivacySettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: PrivacySettingsInput;
};

export type MutationSetProfileSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ProfileSettingsInput;
};

export type MutationSetQuestionTextAnswerArgs = {
  input: QuestionAnswerInput;
};

export type MutationSetSecuritySettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: SecuritySettingsInput;
};

export type MutationSetSimpleApptEventSettingsArgs = {
  params: ApptEventWebsiteSettingsInput;
};

export type MutationSetThemeSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ThemeSettingsInput;
};

export type MutationSetVenueMapSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: VenueMapSettingsInput;
};

export type MutationSoftBlockAttendeeArgs = {
  attendeeId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
};

export type MutationSoftUnblockAttendeeArgs = {
  attendeeId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
};

export type MutationStudioEndSessionArgs = {
  sessionId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
};

export type MutationSubscriptionTokenArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationTestManualSubscriptionArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<Scalars['String']['input']>;
};

export type MutationTestOnAttendeeHasChannelsV2TriggerArgs = {
  attendeeIds: Array<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
};

export type MutationTestSubscriptionArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUnDeletePollQuestionsArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUnDeletePollsArgs = {
  eventId: Scalars['ID']['input'];
  pollIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpVoteQuestionArgs = {
  eventId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationUpdateAllFloorPlansArgs = {
  eventId: Scalars['ID']['input'];
  input: Array<UpdateAllFloorPlansPayload>;
};

export type MutationUpdateAllProfileFieldGroupSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: Array<ProfileFieldGroupSettingsInput>;
};

export type MutationUpdateAppointmentArgs = {
  data: CreateApptInput;
};

export type MutationUpdateAttendeeConsentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  termsId: Scalars['ID']['input'];
};

export type MutationUpdateAttendeeListFiltersArgs = {
  eventId: Scalars['ID']['input'];
  input: AttendeeListFiltersInput;
};

export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};

export type MutationUpdateCustomPageArgs = {
  eventId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: CustomPageSettingsInput;
};

export type MutationUpdateDefaultPageSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: DefaultPageSettingsInput;
};

export type MutationUpdateEventDefaultSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: EventDefaultSettingsInput;
};

export type MutationUpdateEventMobileSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: EventMobileSettingsInput;
};

export type MutationUpdateExhibitorConsentAnswerArgs = {
  consentAnswer: ExhibitorConsentAnswerInput;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateFeatureSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: FeatureSettingsInput;
};

export type MutationUpdateGroupMessagingChannelMembersArgs = {
  attendeeIds: Array<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
};

export type MutationUpdateGroupMessagingChannelNameArgs = {
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
};

export type MutationUpdateHomeSchedulerConfigArgs = {
  eventId: Scalars['ID']['input'];
  homeScreenSchedulerSettings: HomeSchedulerInput;
};

export type MutationUpdateLivestreamStatusArgs = {
  action: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
};

export type MutationUpdateMeetingInviteeStatusArgs = {
  input: MeetingRequestResponseInput;
};

export type MutationUpdatePageBannerArgs = {
  eventId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: PageBannerSettingsInput;
};

export type MutationUpdatePageBannerPageSettingsBulkArgs = {
  eventId: Scalars['ID']['input'];
  input: Array<BulkPageBannerPageSettingsInput>;
};

export type MutationUpdatePersonalTimeArgs = {
  data: CreatePersonalTimeInput;
  personalTimeId: Scalars['ID']['input'];
};

export type MutationUpdatePlannerOnDemandCatalogArgs = {
  data: OnDemandCatalogInput;
  eventId: Scalars['ID']['input'];
};

export type MutationUpdatePlannerSelectedFiltersArgs = {
  eventId: Scalars['ID']['input'];
  selectedFiltersInput: SelectedFiltersSettingsInput;
};

export type MutationUpdatePollQuestionStatusArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<StatusType>;
};

export type MutationUpdatePollsAggregationArgs = {
  input: UpdatePollsAggregationInput;
};

export type MutationUpdateProfessionalInterestChoicesArgs = {
  eventId: Scalars['ID']['input'];
  interestChoiceValues: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MutationUpdateProfileCardDesignSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ProfileCardDesignSettingsInput;
};

export type MutationUpdateProfileSecuredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  profile: ProfileSecuredUpdateInput;
};

export type MutationUpdateProfileSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: ProfileSettingsInput;
};

export type MutationUpdateQuestionStatusArgs = {
  eventId: Scalars['ID']['input'];
  input: QuestionStatusInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationUpdateReactionsSessionConfigArgs = {
  input: ReactionsSessionConfigInput;
};

export type MutationUpdateRegCartArgs = {
  input: RegCartInput;
};

export type MutationUpdateRegCartStatusArgs = {
  input: RegCartStatusInput;
};

export type MutationUpdateResolutionNotesArgs = {
  entityId: Scalars['ID']['input'];
  entityType: ChatEntityType;
  messageId: Scalars['String']['input'];
  resolutionNotes: Scalars['String']['input'];
};

export type MutationUpdateSessionSettingsArgs = {
  eventId: Scalars['ID']['input'];
  input: SessionSettingsInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationUpdateSpaceArgs = {
  appId: Scalars['ID']['input'];
  input: UpdateSpaceInput;
  spaceId: Scalars['ID']['input'];
};

export type MutationUpdateWebcastConfigArgs = {
  input: UpdateWebcastConfigInput;
};

export type MutationUpdateWebcastLiveStatusArgs = {
  input: UpdateWebcastLiveStatusInput;
};

export type MutationUpgradeSimpleAppointmentEventArgs = {
  apptEventId: Scalars['ID']['input'];
};

export type MutationUpsertAttendeePreferencesArgs = {
  preferences: Array<AttendeePreferenceInput>;
  preview: Scalars['Boolean']['input'];
};

export type MutationUpsertPreferencesArgs = {
  eventId: Scalars['ID']['input'];
  preferences: Array<InputMaybe<PreferenceInput>>;
};

export type MutationValidateScavengerHuntCodeArgs = {
  achievementId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  gameId: Scalars['String']['input'];
  goalId: Scalars['String']['input'];
  validationMethod: ScavengerHuntCodeValidationMethod;
};

export type MutationVerifyExhibitorChatAccessArgs = {
  exhibitorId: Scalars['ID']['input'];
};

export type MutationVerifySessionChatArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MutationVerifySessionChatModeratorArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MyAgendaCriteria = {
  agendaTypes?: InputMaybe<Array<AgendaItemType>>;
  end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageCriteria?: InputMaybe<PageCriteria>;
  registrationTypeId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['AWSDateTime']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export enum MyScheduleView {
  Calendar = 'CALENDAR',
  List = 'LIST'
}

export type NamedObject = {
  __typename?: 'NamedObject';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input request to create a new session Q&A Question */
export type NewQuestionInput = {
  isAnonymous: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export type NewReportSubscriptionEvent = {
  __typename?: 'NewReportSubscriptionEvent';
  entityId: Scalars['ID']['output'];
  eventId: Scalars['ID']['output'];
};

/** Offset based pagination */
export type OffsetPagination = {
  __typename?: 'OffsetPagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OnDemandCatalog = {
  __typename?: 'OnDemandCatalog';
  catalogOwner: CatalogOwner;
  catalogType: CatalogType;
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['AWSDateTime']['output'];
  sectionCount?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<OnDemandCatalogSection>>>;
};

export type OnDemandCatalogInput = {
  catalogOwner: CatalogOwner;
  catalogType: CatalogType;
  created: Scalars['AWSDateTime']['input'];
  id: Scalars['ID']['input'];
  lastModified: Scalars['AWSDateTime']['input'];
  sections: Array<InputMaybe<OnDemandCatalogSectionInput>>;
};

export type OnDemandCatalogSection = {
  __typename?: 'OnDemandCatalogSection';
  id: Scalars['ID']['output'];
  sectionType: CatalogSectionType;
  title?: Maybe<Scalars['String']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  videos?: Maybe<Array<OnDemandCatalogVideo>>;
};

export type OnDemandCatalogSectionInput = {
  id: Scalars['ID']['input'];
  sectionType: CatalogSectionType;
  title: Scalars['String']['input'];
  videoCount: Scalars['Int']['input'];
  videos: Array<InputMaybe<OnDemandCatalogVideoInput>>;
};

export type OnDemandCatalogVideo = {
  __typename?: 'OnDemandCatalogVideo';
  displayName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  session?: Maybe<Session>;
  sessionId: Scalars['ID']['output'];
  status: VideoStatus;
  thumbnail?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
  webcastId?: Maybe<Scalars['ID']['output']>;
};

export type OnDemandCatalogVideoInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<VideoStatus>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
};

/**
 * This fragment is deprecated, it was replaced by OnDemandCatalog below.
 * TODO: HUB-43336 Remove this deprecated fragment
 */
export type OnDemandContent = {
  __typename?: 'OnDemandContent';
  catalogType: CatalogType;
  created: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['AWSDateTime']['output'];
  sections?: Maybe<Array<Maybe<OnDemandCatalogSection>>>;
};

export type OnDemandPageInput = {
  latestPaginationId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  sectionLimit?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type OneTimeToken = {
  __typename?: 'OneTimeToken';
  token: Scalars['String']['output'];
};

export type OrderCheckoutInput = {
  browserLandingURL?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
  creditCardType?: InputMaybe<Scalars['String']['input']>;
  paymentAmount: Scalars['Float']['input'];
  regCartId: Scalars['ID']['input'];
};

export type OrderCheckoutStatus = {
  __typename?: 'OrderCheckoutStatus';
  admissionItem?: Maybe<AdmissionItem>;
  code: OrderCheckoutStatusCode;
  progress: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['AWSURL']['output']>;
};

export enum OrderCheckoutStatusCode {
  Completed = 'COMPLETED',
  ErrorOther = 'ERROR_OTHER',
  ErrorPayment = 'ERROR_PAYMENT',
  Processing = 'PROCESSING',
  Redirect = 'REDIRECT'
}

export type OrderCheckoutStatusInput = {
  attemptNumber: Scalars['Int']['input'];
  regCartId: Scalars['ID']['input'];
};

export type OrderSummary = {
  __typename?: 'OrderSummary';
  applicationId?: Maybe<Scalars['String']['output']>;
  configurationId?: Maybe<Scalars['ID']['output']>;
  /** Array of discount codes , that are successfuly applied to the cart */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  paymentAmountServiceFees?: Maybe<Array<Maybe<ServiceFee>>>;
  paymentSummary: PaymentSummary;
  paymentTypeServiceFees?: Maybe<Array<Maybe<ServiceFee>>>;
  refundSummary: RefundSummary;
  regCartId: Scalars['ID']['output'];
  taxes?: Maybe<Array<Maybe<Tax>>>;
};

export enum OsType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type OtherAnswerMetadata = {
  __typename?: 'OtherAnswerMetadata';
  text?: Maybe<Scalars['String']['output']>;
};

export enum PageBannerContainerBackground {
  Blur = 'BLUR',
  CustomColor = 'CUSTOM_COLOR',
  SecondaryColor = 'SECONDARY_COLOR',
  ThemeColor = 'THEME_COLOR'
}

export enum PageBannerImageAlignment {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum PageBannerLinkAttendeeHubDestinationType {
  AttendeeConnections = 'ATTENDEE_CONNECTIONS',
  AttendeeList = 'ATTENDEE_LIST',
  AttendeeProfile = 'ATTENDEE_PROFILE',
  Community = 'COMMUNITY',
  CustomPages = 'CUSTOM_PAGES',
  DiscussionTopic = 'DISCUSSION_TOPIC',
  DocumentCustomPages = 'DOCUMENT_CUSTOM_PAGES',
  Event = 'EVENT',
  Exhibitors = 'EXHIBITORS',
  ExternalCustomPages = 'EXTERNAL_CUSTOM_PAGES',
  FloorPlanDetails = 'FLOOR_PLAN_DETAILS',
  FloorPlanList = 'FLOOR_PLAN_LIST',
  Game = 'GAME',
  Home = 'HOME',
  Messages = 'MESSAGES',
  OnDemandContentLibrary = 'ON_DEMAND_CONTENT_LIBRARY',
  ProfileMenu = 'PROFILE_MENU',
  QrCode = 'QR_CODE',
  Schedule = 'SCHEDULE',
  Sessions = 'SESSIONS',
  SessionDetails = 'SESSION_DETAILS',
  Speakers = 'SPEAKERS',
  SpeakerDetails = 'SPEAKER_DETAILS',
  SpeedNetworking = 'SPEED_NETWORKING',
  Sponsors = 'SPONSORS',
  Surveys = 'SURVEYS',
  TravelDetails = 'TRAVEL_DETAILS',
  UpcomingEvents = 'UPCOMING_EVENTS',
  VideoDiscussions = 'VIDEO_DISCUSSIONS',
  VirtualBooth = 'VIRTUAL_BOOTH',
  YourEvents = 'YOUR_EVENTS'
}

export enum PageBannerLinkDestinationType {
  AttendeeHubPage = 'ATTENDEE_HUB_PAGE',
  DiscussionTopic = 'DISCUSSION_TOPIC',
  ExternalUrl = 'EXTERNAL_URL',
  FloorPlanDetails = 'FLOOR_PLAN_DETAILS',
  SessionDetails = 'SESSION_DETAILS',
  SpeakerDetails = 'SPEAKER_DETAILS',
  VirtualBooth = 'VIRTUAL_BOOTH'
}

export type PageBannerPageSettings = AttendeeHubConfigInterface & {
  __typename?: 'PageBannerPageSettings';
  id: Scalars['ID']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  location: PageBannerPlacementLocation;
  locationId?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['ID']['output'];
  placementOrder: Array<Scalars['ID']['output']>;
  placements: Array<PageBannerPlacementSettings>;
  rotationInterval?: Maybe<Scalars['Int']['output']>;
};

export type PageBannerPageSettingsInput = {
  placementOrder: Array<Scalars['ID']['input']>;
  rotationInterval?: InputMaybe<Scalars['Int']['input']>;
};

export enum PageBannerPlacementLocation {
  ExhibitorList = 'EXHIBITOR_LIST',
  Home = 'HOME',
  SponsorList = 'SPONSOR_LIST'
}

export type PageBannerPlacementSettings = {
  __typename?: 'PageBannerPlacementSettings';
  activeTimes?: Maybe<Array<Maybe<PageBannerPlacementTime>>>;
  banner?: Maybe<PageBannerSettings>;
  bannerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  location: PageBannerPlacementLocation;
  locationId?: Maybe<Scalars['String']['output']>;
  placementId: Scalars['ID']['output'];
  visibility: PageBannerPlacementVisibility;
};

export type PageBannerPlacementTime = {
  __typename?: 'PageBannerPlacementTime';
  endTime: Scalars['AWSDateTime']['output'];
  startTime: Scalars['AWSDateTime']['output'];
};

export type PageBannerPlacementTimeInput = {
  endTime: Scalars['AWSDateTime']['input'];
  startTime: Scalars['AWSDateTime']['input'];
};

export enum PageBannerPlacementVisibility {
  AlwaysVisible = 'ALWAYS_VISIBLE',
  CustomTimes = 'CUSTOM_TIMES',
  EventDates = 'EVENT_DATES',
  Hidden = 'HIDDEN'
}

export type PageBannerSettings = AttendeeHubConfigInterface & {
  __typename?: 'PageBannerSettings';
  body?: Maybe<Scalars['String']['output']>;
  bodyTranslationKey?: Maybe<Scalars['String']['output']>;
  containerBackground?: Maybe<PageBannerContainerBackground>;
  containerBackgroundCustomColor?: Maybe<Scalars['String']['output']>;
  exhibitorAttribution?: Maybe<Scalars['ID']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageAlignment?: Maybe<PageBannerImageAlignment>;
  imageAsset?: Maybe<ImageAsset>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  linkAttendeeHubDestinationType?: Maybe<PageBannerLinkAttendeeHubDestinationType>;
  linkDestination?: Maybe<Scalars['String']['output']>;
  linkDestinationType?: Maybe<PageBannerLinkDestinationType>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkTextTranslationKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  template: PageBannerTemplateType;
  textAlignment?: Maybe<PageBannerTextAlignment>;
  title?: Maybe<Scalars['String']['output']>;
  titleTranslationKey?: Maybe<Scalars['String']['output']>;
};

export type PageBannerSettingsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  containerBackground?: InputMaybe<PageBannerContainerBackground>;
  containerBackgroundCustomColor?: InputMaybe<Scalars['String']['input']>;
  exhibitorAttribution?: InputMaybe<Scalars['ID']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<PageBannerImageAlignment>;
  imageAsset?: InputMaybe<ImageAssetInput>;
  linkAttendeeHubDestinationType?: InputMaybe<PageBannerLinkAttendeeHubDestinationType>;
  linkDestination?: InputMaybe<Scalars['String']['input']>;
  linkDestinationType?: InputMaybe<PageBannerLinkDestinationType>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  template: PageBannerTemplateType;
  textAlignment?: InputMaybe<PageBannerTextAlignment>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PageBannerTemplateType {
  FullImage = 'FULL_IMAGE',
  InsetImage = 'INSET_IMAGE',
  TextAndColor = 'TEXT_AND_COLOR'
}

export enum PageBannerTextAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Page Criteria */
export type PageCriteria = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PageGroup = {
  __typename?: 'PageGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PageGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PageType {
  CustomPages = 'CUSTOM_PAGES',
  DiscussionsTopic = 'DISCUSSIONS_TOPIC',
  Exhibitors = 'EXHIBITORS',
  FloorPlans = 'FLOOR_PLANS',
  Sessions = 'SESSIONS',
  Speakers = 'SPEAKERS'
}

export type PaginatedElementToTagRelations = {
  __typename?: 'PaginatedElementToTagRelations';
  data: Array<ElementWithTags>;
  paging?: Maybe<Pagination>;
};

/** Pagination Metadata */
export type Pagination = {
  __typename?: 'Pagination';
  currentToken: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  nextToken?: Maybe<Scalars['String']['output']>;
  previousToken?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum PastOrFuture {
  Future = 'Future',
  Past = 'Past'
}

export type PatchEventMobileSettingsInput = {
  accessCodeSuffix?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['ID']['input']>;
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  consentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  loginRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  showTerms?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<EventVisibility>;
};

export type PaymentMethodServiceFee = {
  __typename?: 'PaymentMethodServiceFee';
  fees?: Maybe<Array<Maybe<ServiceFee>>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  admissionItemPrice?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

export type Permissions = {
  __typename?: 'Permissions';
  isGlobalModerator: Scalars['Boolean']['output'];
  roles: Roles;
  sessionsToModerate: Array<Maybe<Scalars['String']['output']>>;
};

export type PersonalTime = {
  __typename?: 'PersonalTime';
  attendees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['AWSDateTime']['output'];
  status?: Maybe<PersonalTimeStatus>;
};

export type PersonalTimeDeleteResponse = {
  __typename?: 'PersonalTimeDeleteResponse';
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
};

export type PersonalTimeInput = {
  apptEventId?: InputMaybe<Scalars['String']['input']>;
  attendeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personalTimeId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<PersonalTimeStatus>;
};

export enum PersonalTimeStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export enum PlannerAccessLevel {
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS',
  MeetingRequestOnly = 'MEETING_REQUEST_ONLY',
  NoAccess = 'NO_ACCESS',
  NoPublicSavedReportAccess = 'NO_PUBLIC_SAVED_REPORT_ACCESS',
  PrivateAccess = 'PRIVATE_ACCESS',
  PublicSavedReportAccess = 'PUBLIC_SAVED_REPORT_ACCESS',
  ReadOnly = 'READ_ONLY'
}

/** For the nav redesign */
export type PlannerEventFeatures = {
  __typename?: 'PlannerEventFeatures';
  attendees: Scalars['Boolean']['output'];
  exhibitors: Scalars['Boolean']['output'];
  onDemand: Scalars['Boolean']['output'];
  schedule: Scalars['Boolean']['output'];
  speakers: Scalars['Boolean']['output'];
  sponsors: Scalars['Boolean']['output'];
};

export type PlannerPermissions = {
  __typename?: 'PlannerPermissions';
  attendeeHubDesign?: Maybe<PlannerAccessLevel>;
  attendeeHubPublish?: Maybe<PlannerAccessLevel>;
  customFonts?: Maybe<PlannerAccessLevel>;
  eventManagement?: Maybe<PlannerAccessLevel>;
  eventPrivacy?: Maybe<PlannerAccessLevel>;
  exhibitorManagementAccess?: Maybe<PlannerAccessLevel>;
  videoLibraryAccess?: Maybe<PlannerAccessLevel>;
};

export type PlannerPoll = Poll & {
  __typename?: 'PlannerPoll';
  answeredQuestions?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  createdDateTime?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  isModeratorEditable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  operation?: Maybe<Scalars['String']['output']>;
  pollId: Scalars['ID']['output'];
  publishStatus?: Maybe<PublishStatus>;
  publishedDateTime?: Maybe<Scalars['String']['output']>;
  questions: Array<PollQuestion>;
  sessions?: Maybe<Array<Maybe<LiveQaSession>>>;
  snapshotVersion?: Maybe<Scalars['Int']['output']>;
  timeSetting?: Maybe<TimeSettingType>;
  updatedDateTime?: Maybe<Scalars['String']['output']>;
};

/** Input request to create a new poll */
export type PlannerPollRequest = {
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  timeSetting?: InputMaybe<Scalars['String']['input']>;
};

export type PlannerPolls = {
  __typename?: 'PlannerPolls';
  data?: Maybe<Array<Maybe<PlannerPoll>>>;
  pagination?: Maybe<Pagination>;
};

export type PlannerSessionFiltersResponse = {
  __typename?: 'PlannerSessionFiltersResponse';
  eventId?: Maybe<Scalars['ID']['output']>;
  lastModifiedBy?: Maybe<Scalars['ID']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  settings?: Maybe<Array<Filter>>;
};

/** Input request to update a poll */
export type PlannerUpdateRequest = {
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timeSetting?: InputMaybe<Scalars['String']['input']>;
};

export enum Platform {
  All = 'ALL',
  App = 'APP',
  Web = 'WEB'
}

export type Player = {
  __typename?: 'Player';
  gameOptInStatuses?: Maybe<Array<Maybe<GameOptInStatus>>>;
  id?: Maybe<Scalars['ID']['output']>;
  leaderboardOptOut?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Array<Maybe<AchievementProgress>>>;
  rank?: Maybe<Scalars['Int']['output']>;
  totalScore?: Maybe<Scalars['Int']['output']>;
};

export type PlayerStream = {
  __typename?: 'PlayerStream';
  id?: Maybe<Scalars['ID']['output']>;
  recording?: Maybe<PlayerStreamRecording>;
  status?: Maybe<PlayerStreamStatus>;
};

export type PlayerStreamRecording = {
  __typename?: 'PlayerStreamRecording';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<PlayerStreamRecordingStatus>;
};

export enum PlayerStreamRecordingStatus {
  Cancelled = 'cancelled',
  Cancelling = 'cancelling',
  CreatingAsset = 'creating_asset',
  Error = 'error',
  Failed = 'failed',
  Finished = 'finished',
  Processing = 'processing',
  Waiting = 'waiting',
  WaitingFinishLive = 'waiting_finish_live'
}

export enum PlayerStreamStatus {
  Cancelled = 'Cancelled',
  Cancelling = 'Cancelling',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Failed = 'Failed',
  Finished = 'Finished',
  Finishing = 'Finishing',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Standby = 'Standby',
  Starving = 'Starving',
  Waiting = 'Waiting'
}

/** Models */
export type Poll = {
  eventId: Scalars['ID']['output'];
  isModeratorEditable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  pollId: Scalars['ID']['output'];
  questions: Array<PollQuestion>;
  timeSetting?: Maybe<TimeSettingType>;
};

export type PollQuestion = {
  __typename?: 'PollQuestion';
  choices?: Maybe<Array<Maybe<PollQuestionChoice>>>;
  displayType: ResultsDisplayType;
  pollId?: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<PollQuestionChoiceResult>>>;
  status?: Maybe<PollQuestionStatus>;
  text: Scalars['String']['output'];
  type: QuestionType;
};

export type PollQuestionChoice = {
  __typename?: 'PollQuestionChoice';
  choice: Scalars['String']['output'];
  choiceId: Scalars['ID']['output'];
};

export type PollQuestionChoiceResult = {
  __typename?: 'PollQuestionChoiceResult';
  choiceId: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
};

/** Input request to create a new question */
export type PollQuestionRequest = {
  choiceInputs?: InputMaybe<Array<ChoiceInput>>;
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  displayType: ResultsDisplayType;
  text: Scalars['String']['input'];
  type: QuestionType;
};

export type PollQuestionStatus = PollQuestionStatusInterface & {
  __typename?: 'PollQuestionStatus';
  closedDateTime?: Maybe<Scalars['String']['output']>;
  openedDateTime?: Maybe<Scalars['String']['output']>;
  status: StatusType;
};

export type PollQuestionStatusInterface = {
  closedDateTime?: Maybe<Scalars['String']['output']>;
  openedDateTime?: Maybe<Scalars['String']['output']>;
  status: StatusType;
};

/** Poll Search Criteria */
export type PollSearchCriteria = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pageCriteria?: InputMaybe<PageCriteria>;
  sessionLimit?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type PostRegRedirectUrl = {
  __typename?: 'PostRegRedirectUrl';
  id: Scalars['String']['output'];
  verificationId: Scalars['String']['output'];
};

export type PostRegRedirectUrlResponse = {
  __typename?: 'PostRegRedirectUrlResponse';
  postRegRedirectUrl?: Maybe<PostRegRedirectUrl>;
  redirect: Scalars['Boolean']['output'];
};

export type PotentialConflictsInfo = {
  __typename?: 'PotentialConflictsInfo';
  data?: Maybe<Array<ConflictingAgendaItems>>;
  paging?: Maybe<PagingInfo>;
};

export type PotentialConflictsInput = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PreAcceptValidationResponse = {
  __typename?: 'PreAcceptValidationResponse';
  acceptValidation?: Maybe<AcceptValidation>;
};

export type PreFilter = {
  __typename?: 'PreFilter';
  displayName?: Maybe<Scalars['String']['output']>;
  filterId: Scalars['ID']['output'];
  /** @deprecated Use 'filterId' instead */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options: Array<PreFilterOption>;
  optionsWithSpeakers: Array<PreFilterOptionWithSpeakers>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<PreFilterType>;
};

export type PreFilterData = {
  __typename?: 'PreFilterData';
  eventId: Scalars['ID']['output'];
  sessionDerivedData?: Maybe<SessionDerivedData>;
  speakers?: Maybe<Array<Speaker>>;
  tags?: Maybe<Array<Tag>>;
};

export type PreFilterInput = {
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  options: Array<PreFilterOptionInput>;
  order: Scalars['Int']['input'];
  type: PreFilterType;
};

export type PreFilterList = {
  __typename?: 'PreFilterList';
  eventId?: Maybe<Scalars['ID']['output']>;
  filters?: Maybe<Array<PreFilter>>;
  id: Scalars['ID']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type PreFilterListInput = {
  filters: Array<PreFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PreFilterListResponse = {
  __typename?: 'PreFilterListResponse';
  eventId?: Maybe<Scalars['ID']['output']>;
  filters?: Maybe<Array<PreFilterResponse>>;
  id: Scalars['ID']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type PreFilterOption = {
  __typename?: 'PreFilterOption';
  /** @deprecated Use 'optionId' instead */
  id?: Maybe<Scalars['ID']['output']>;
  optionId?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PreFilterOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PreFilterOptionResponse = {
  __typename?: 'PreFilterOptionResponse';
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PreFilterOptionWithSpeakers = PreFilterOption | SessionSpeakerFilterValue;

export type PreFilterOrder = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type PreFilterResponse = {
  __typename?: 'PreFilterResponse';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options: Array<PreFilterOptionResponse>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<PreFilterType>;
};

export enum PreFilterType {
  Category = 'Category',
  CustomField = 'CustomField',
  Location = 'Location',
  Speakers = 'Speakers',
  Tags = 'Tags'
}

export type Preference = {
  __typename?: 'Preference';
  id: Scalars['ID']['output'];
  preferenceType: PreferenceType;
  preferenceValue: Scalars['String']['output'];
};

export type PreferenceInput = {
  preferenceType: PreferenceType;
  preferenceValue: Scalars['String']['input'];
};

export enum PreferenceType {
  FloorPlanView = 'FloorPlanView',
  PageVisibilityWarning = 'PageVisibilityWarning'
}

export type PresignedUploadUrl = {
  __typename?: 'PresignedUploadUrl';
  location: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  uniqueFilename: Scalars['String']['output'];
};

export type PrivacySettings = AttendeeHubConfigInterface & {
  __typename?: 'PrivacySettings';
  anonymousPolls: Scalars['Boolean']['output'];
  attendeesVisible: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  signUp: Scalars['Boolean']['output'];
  signUpFeatureEnabled: Scalars['Boolean']['output'];
};

/**
 * signUp controls the sign up settings state, signUpFeatureEnabled must be true as a prerequisite
 * signUpFeatureEnabled controls whether or not signUp is available for planners to use
 */
export type PrivacySettingsInput = {
  anonymousPolls: Scalars['Boolean']['input'];
  attendeesVisible: Scalars['Boolean']['input'];
  signUp?: InputMaybe<Scalars['Boolean']['input']>;
  signUpFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrivateNote = {
  noteText?: InputMaybe<Scalars['String']['input']>;
  viewList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProfileCardDesignSettingsInput = {
  profileCardDesignSettingsList: Array<ProfileCardSettingsInput>;
};

export type ProfileCardDesignSettingsWrapper = {
  __typename?: 'ProfileCardDesignSettingsWrapper';
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  profileCardDesignSettingsList: Array<ProfileCardSettings>;
};

export type ProfileCardSettings = {
  __typename?: 'ProfileCardSettings';
  alignment: Scalars['String']['output'];
  border: Scalars['String']['output'];
  eventBranding: Scalars['String']['output'];
};

export type ProfileCardSettingsInput = {
  alignment: Scalars['String']['input'];
  border: Scalars['String']['input'];
  eventBranding: Scalars['String']['input'];
};

export type ProfileField = {
  __typename?: 'ProfileField';
  name: Scalars['String']['output'];
  valueRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type ProfileFieldGroupSettings = {
  __typename?: 'ProfileFieldGroupSettings';
  enabled: Scalars['Boolean']['output'];
  fields: Array<ProfileField>;
  forceReadOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ProfileFieldGroupSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  readOnly: Scalars['Boolean']['input'];
};

export type ProfileFieldGroupSettingsListInput = {
  profileFieldGroupsList: Array<ProfileFieldGroupSettingsInput>;
};

export type ProfileFieldGroupSettingsResponse = {
  __typename?: 'ProfileFieldGroupSettingsResponse';
  fieldGroups: Array<ProfileFieldGroupSettings>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ProfileFieldGroupSettingsWrapper = {
  __typename?: 'ProfileFieldGroupSettingsWrapper';
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  profileFieldGroupsList: Array<ProfileFieldGroupSettings>;
};

export type ProfileSecuredUpdateInput = {
  address?: InputMaybe<AddressInput>;
  allowAppointmentPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  allowPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use headline instead */
  biography?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  professionalInterestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<AttendeeVisibility>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileSettings = AttendeeHubConfigInterface & {
  __typename?: 'ProfileSettings';
  badgeEditingEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  profileEditingEnabled: Scalars['Boolean']['output'];
};

export type ProfileSettingsInput = {
  badgeEditingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  profileEditingEnabled: Scalars['Boolean']['input'];
};

export type ProfileUpdateInput = {
  allowAppointmentPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  allowPushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use headline instead */
  biography?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<AttendeeVisibility>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProposeNewTimeInput = {
  apptTypeId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  customLocationName?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['AWSDateTime']['input'];
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['AWSDateTime']['input'];
};

export enum PubNubChannelType {
  Attendee = 'ATTENDEE',
  Exhibitor = 'EXHIBITOR',
  Public = 'PUBLIC',
  Session = 'SESSION'
}

export enum PubNubClientType {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type PubNubConfig = {
  __typename?: 'PubNubConfig';
  authKey: Scalars['ID']['output'];
  channels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publishKey: Scalars['String']['output'];
  subscribeKey: Scalars['String']['output'];
};

export type PubNubConfigV2 = {
  __typename?: 'PubNubConfigV2';
  authKey: Scalars['ID']['output'];
  channels: Array<Maybe<Scalars['String']['output']>>;
  inApp: PubNubKey;
  isDefault: Scalars['Boolean']['output'];
  push?: Maybe<PubNubKey>;
};

export type PubNubKey = {
  __typename?: 'PubNubKey';
  publishKey: Scalars['String']['output'];
  subscribeKey: Scalars['String']['output'];
};

export type PubNubMessage = {
  channelType: PubNubChannelType;
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  environment: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type PubNubMessageData = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** PublishDetails model. Defines publish and last updated timestamps */
export type PublishDetails = {
  __typename?: 'PublishDetails';
  appType: AppType;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  publishedDate: Scalars['AWSDateTime']['output'];
};

export type PublishInput = {
  appType: AppType;
};

export type PublishPollResult = {
  __typename?: 'PublishPollResult';
  pollId: Scalars['ID']['output'];
  publishedDateTime?: Maybe<Scalars['String']['output']>;
  snapshotVersion?: Maybe<Scalars['Int']['output']>;
  updatedDateTime?: Maybe<Scalars['String']['output']>;
};

export enum PublishStatus {
  Published = 'published',
  Publishing = 'publishing',
  Queued = 'queued',
  SoftDeleted = 'softDeleted'
}

/** Input request to publish a widget */
export type PublishWidgetInput = {
  widgetId: Scalars['ID']['input'];
};

export type PublishedAttendeeHubConfig = {
  __typename?: 'PublishedAttendeeHubConfig';
  config?: Maybe<AttendeeHubConfig>;
};

export type Query = {
  __typename?: 'Query';
  /** Get appointment import summary */
  apptImportSummary?: Maybe<ApptImportSummary>;
  /** Get attendee hub pages entities */
  attendeeHubPagesEntities?: Maybe<AttendeeHubPagesEntitiesResponse>;
  /** Get attendee hub pages entity by pageId */
  attendeeHubPagesEntity?: Maybe<AttendeeHubPagesEntity>;
  /**
   * Fetch all available AttendeeHubPages data -
   * New query to get available pages data
   */
  attendeeHubPagesV2?: Maybe<AttendeeHubPagesResponse>;
  /**
   * Authorizes the attendees to receive entity-specific channels for PubNub subscriptions
   * authorization: attendee
   */
  authorizePubNubEntity?: Maybe<PubNubConfig>;
  /** Get list of community safety chat reports */
  chatReports: Array<ReportPost>;
  /** Fetch the visibility of admission item upgrade setting on attendee website builder based on the event configuration */
  checkAdmissionItemUpgradeVisibility?: Maybe<Visibility>;
  /** Check is logged in attendee has messages */
  checkAttendeeHasChannels?: Maybe<AttendeeHasChannels>;
  /**
   * Check the status of the app builder configuration.
   * @deprecated Previously supported fetchConfig, S3 no longer used
   */
  checkConfig?: Maybe<StorageStatus>;
  /**
   * Check if the given file exists.
   * @deprecated Use checkImageFileExists instead
   */
  checkFileExists?: Maybe<FileInfo>;
  /** Check if the given file exists. Currently supports discussion type. */
  checkImageFileExists?: Maybe<FileInfo>;
  /** Get the custom fonts for an account */
  customFonts?: Maybe<Array<CustomFont>>;
  eventAdCounts?: Maybe<AdCounts>;
  eventAdSettings?: Maybe<AdLocationSettings>;
  eventAdSettingsForAttendee?: Maybe<AdLocationSettings>;
  /**
   * Fetch the Event info needed by the public landing page shown to un-authenticated users.
   * API key is the auth method. If features is not passed, the query gets all the event features.
   * If specific features are requested, only valid features (determined by event tier) are returned
   */
  eventInfo: EventInfo;
  /** Query to fetch the list of event locales supported in an event and the device detection boolean */
  eventLocaleInfo?: Maybe<EventLocalesInfo>;
  /**
   * Fetch the Mobile App builder Configuration with planner bearer token
   * @deprecated Use getAttendeeHubConfig instead
   */
  fetchConfig?: Maybe<AppConfig>;
  /**
   * Fetch the Mobile App builder Configuration with attendee bearer token
   * @deprecated Relies on AppConfig, which is now deprecated. Use getAttendeeHubConfig once supported.
   */
  fetchConfigForAttendee?: Maybe<AppConfig>;
  /** Get details for a single exhibitor */
  fetchExhibitor?: Maybe<ExhibitorDetails>;
  /** Get a single exhibitor content file */
  fetchExhibitorContentLink?: Maybe<ExhibitorContentLink>;
  /** Get signature */
  generateMapSignature?: Maybe<GoogleMap>;
  /** Get generic download link */
  genericDownloadLink?: Maybe<GenericDownloadLink>;
  /** Fetch account mobile settings using a bearer token */
  getAccountMobileSettings: AccountMobileSettings;
  /** Get active tags */
  getActiveTags?: Maybe<Tags>;
  /** Get list of agenda dates */
  getAgendaDates?: Maybe<AgendaDatesResponse>;
  /** Fetch all spaces for an app using a bearer token */
  getAllSpaces: SpaceListResponse;
  /**
   * Get pubNub config for an anonymous user
   * returns the authKey and channels for PubNub subscriptions
   * authorization: none
   */
  getAnonymousPubNubConfig?: Maybe<PubNubConfig>;
  /**
   * Get pubNub config for an anonymous user
   * returns the authKey and channels for PubNub subscriptions
   * authorization: none
   */
  getAnonymousPubNubConfigV2?: Maybe<PubNubConfigV2>;
  /** Get the app features derived from experiments. The accountId or eventId is required for api key access. */
  getAppFeatures?: Maybe<Array<Maybe<AppFeature>>>;
  /** Get an appointment */
  getAppointment?: Maybe<Appointment>;
  /** Get appointment as an agenda item object */
  getAppointmentAgendaItem?: Maybe<AgendaItem>;
  /** Get list of appointment types */
  getAppointmentTypes?: Maybe<AppointmentTypes>;
  /**
   * Get appointments for an appointment event
   * Authorization: Planner
   */
  getAppointments: AppointmentsResponse;
  /** Get attendees */
  getApptEventAttendees?: Maybe<ApptEventAttendees>;
  /**
   * Get a list of Polls assigned to a session
   * Results can be filtered by pollId
   * Authorization: Attendees, Moderator TODO FAL-15439
   */
  getAssignedPolls: Array<Maybe<AttendeePoll>>;
  /** Get a list of Widgets assigned to a session */
  getAssignedWidgets?: Maybe<Array<Maybe<AssignedWidgetSession>>>;
  /** Get a list with the count of widgets assigned to each session */
  getAssignedWidgetsCount?: Maybe<Array<Maybe<AssignedWidgetsCount>>>;
  /** Get an attendee */
  getAttendee?: Maybe<Attendee>;
  /** Get connection status between two attendees */
  getAttendeeConnectionStatus: AttendeeConnectionStatusResponse;
  /**
   * Get attendee fields which are unfilled out with list of all enabled fields to compare against
   * @deprecated Use getAttendeeFieldCompletionV2 instead
   */
  getAttendeeFieldCompletion?: Maybe<AttendeeFieldCompletionResult>;
  /** Get attendee fields which are unfilled out with list of all enabled fields to compare against */
  getAttendeeFieldCompletionV2?: Maybe<AttendeeFieldCompletionResult>;
  /**
   * Fetch the AttendeeHubConfig Configuration using a bearer token
   * eventId has to be passed in if it is not present in the token metadata
   */
  getAttendeeHubConfig: AttendeeHubConfig;
  /**
   * Fetch the AttendeeHubPages using a planner bearer token
   * locale has to be passed to get translated custom page settings
   * @deprecated Use attendeeHubPagesV2 instead
   */
  getAttendeeHubPages: AttendeeHubPages;
  /**
   * Get the catalog that contains sessions with on demand content for an attendee
   * (content visibility/enrollment rules applied)
   * @deprecated Use getAttendeeOnDemandCatalogV2 instead
   */
  getAttendeeOnDemandCatalog?: Maybe<OnDemandCatalog>;
  getAttendeeOnDemandCatalogV2?: Maybe<OnDemandCatalog>;
  /** Get list of recommendation */
  getAttendeeRecommendations?: Maybe<RecommendationPaginatedResults>;
  /**
   * Get paginated list of attendees in an event
   * This query needs to have a planner token verification in order to run.
   * We do not want to secure this information on the planner side.
   * This is not to be used in ah-web.
   */
  getAttendees?: Maybe<AttendeeUnsecuredPaginatedResults>;
  /** Get availability by time-range */
  getAvailabilityByTimeRange?: Maybe<Array<Maybe<Availability>>>;
  /** Get availabile locations */
  getAvailableLocations?: Maybe<Array<Maybe<AvailableLocation>>>;
  /** Get list of available times */
  getAvailableTimes?: Maybe<TimeRanges>;
  /**
   * Fetch the Calendar list using a bearer token
   * accountId has to be passed in if it is not present in the token metadata
   */
  getCalendarList: Array<Calendar>;
  /** Get Image's CDN url. Currently supports discussion type. */
  getCdnImageUrl?: Maybe<ImageMeta>;
  /** Fetch Event Credits */
  getCredits: Credits;
  /** Fetch the existence of sessions, speakers, exhibitors and sponsors */
  getDefaultPagesInfo: DefaultPagesInfo;
  /**
   * Fetch the Event using a bearer token
   * eventId has to be passed in if it is not present in the token metadata
   */
  getEvent: Event;
  /**
   * Fetch the getEventGuideSettings Configuration using a bearer token
   * eventId has to be passed in if it is not present in the token metadata
   * date is an optional param to sort the returned data
   *
   * If date paramter is being passed in, the custom cards will be filtered
   * so that the following will be returned:
   * - if a card has no endDate and the start date is before the date passed in
   * - if the date passed in is after the card's startEnd and before its endDate
   * - if card has neither startDate and endDate
   * @deprecated Use getAttendeeHubConfig instead
   */
  getEventGuideSettings: EventGuideSettingsV2;
  /** Fetch all Event Profile Settings */
  getEventProfileSettings?: Maybe<EventProfileSettings>;
  /**
   * Get Live Q&A Event settings
   * Authorization: Attendees with Moderator Role
   */
  getEventSettings?: Maybe<EventSettings>;
  /**
   * Get Live Q&A Event settings
   * Authorization: Planner
   */
  getEventSettingsPlanner?: Maybe<EventSettings>;
  /**
   * Fetch the events using a bearer token
   * Get a list of event Details for contact Id
   */
  getEvents?: Maybe<EventPaginatedResults>;
  /** Get attendees as Exhibitor Booth Staff */
  getExhibitorBoothStaffAttendees?: Maybe<ApptEventAttendees>;
  /** Get exhibitor info */
  getExhibitorInfo?: Maybe<ExhibitorInfo>;
  /** Fetch the existance of exhibitors and sponsors */
  getExhibitorsInfo: ExhibitorsInfo;
  /** Get list of exhibitors with booth-location based on staff invitee-stubs */
  getExhibitorsWithBoothLocation?: Maybe<ExhibitorBoothLocations>;
  /**
   * Get the experiment. The accountId is only required
   * for api key access.
   */
  getExperiment?: Maybe<Experiment>;
  /**
   * Fetch the Floor Plan for an event -
   * eventId has to be passed in, FloorPlanId has to be passed in
   */
  getFloorPlan?: Maybe<FloorPlan>;
  /**
   * Fetch all the floor plans for an event -
   * Get a list of floor plans
   */
  getFloorPlans?: Maybe<Array<Maybe<FloorPlanWithoutMarkers>>>;
  /** Get Game for event */
  getGame?: Maybe<Game>;
  /** Fetch whether or not a session has attendee reactions data */
  getHasReactionsData?: Maybe<HasReactionsGetResponse>;
  getHomeSchedulerConfig: HomeSchedulerConfig;
  /**
   * Get appointments import history
   * Authorization: Planner
   */
  getImportHistory?: Maybe<ApptImportHistory>;
  /**
   * Get the currently displayed question. This is a new API needed to replace the getCurrentQuestion query and to support
   * backwards compatibility.
   * Authorization: Live Display & Attendee
   */
  getLiveDisplayQuestion?: Maybe<CurrentQuestion>;
  /** Get a localized locations, US location name and location code */
  getLocalizedLocations?: Maybe<Array<Maybe<LocalizedLocation>>>;
  /** Get a list of sessions with video */
  getOnDemandSessions?: Maybe<SessionPaginatedResults>;
  /**
   * Get status information to display appropriate processing
   * step to user after checkout
   */
  getOrderCheckoutStatus?: Maybe<OrderCheckoutStatus>;
  /** Fetch Reg Cart Order Summary by Id */
  getOrderSummaryDetails?: Maybe<OrderSummary>;
  /**
   * Get a list of paginated Sessions in an Event
   * Authorization: Planner
   * @deprecated Use searchPlannerSessions instead
   */
  getPaginatedSessions?: Maybe<LiveQaSessionPaginatedResults>;
  /** Get list of applicable service fees on payment methods */
  getPaymentMethodServiceFees?: Maybe<Array<PaymentMethodServiceFee>>;
  /** Get pending connection count for self */
  getPendingAttendeeConnectionCount: AttendeeConnectionPendingCount;
  /** Get list of reserved times */
  getPersonalTimes?: Maybe<Array<Maybe<PersonalTime>>>;
  /** Get list of custom fields from universal-custom-fields-service */
  getPlannerCustomFields?: Maybe<CustomFieldPaginatedResults>;
  /**
   * Get the catalog that contains sessions with on demand content for the planner's event
   * (no content visibility/enrollment rules applied)
   */
  getPlannerOnDemandCatalog?: Maybe<OnDemandCatalog>;
  /**
   * Get a list of Polls in an Event
   * Results can be filtered by pollId
   * Authorization: Planner
   */
  getPolls?: Maybe<PlannerPolls>;
  /** Get conflicting agenda items */
  getPotentialConflicts?: Maybe<PotentialConflictsInfo>;
  /** Pre Accept Validations for Unconfirmed Appt type */
  getPreAcceptValidation?: Maybe<PreAcceptValidationResponse>;
  /** Fetch preference by type */
  getPreference?: Maybe<Preference>;
  /** Get attendee interest choices */
  getProfessionalInterestChoices?: Maybe<InterestChoicesResponse>;
  /** Fetch Profile Field Group Settings */
  getProfileFieldGroupSettings?: Maybe<ProfileFieldGroupSettingsResponse>;
  /** Get proposed times */
  getProposedTimes?: Maybe<Array<Maybe<ApptProposedTime>>>;
  /**
   * Get pubNub config
   * returns the attendees authKey and channels for PubNub subscriptions
   * authorization: attendee
   */
  getPubNubConfig?: Maybe<PubNubConfig>;
  /**
   * Get pubNub config for Attendee
   * returns the attendees authKey and channels for PubNub subscriptions
   * authorization: attendee
   */
  getPubNubConfigV2?: Maybe<PubNubConfigV2>;
  /**
   * Get a list of authorized questions for the user
   * Questions are tagged with isVoted, and isCurrentQuestion as appropriate
   * Authorization: Attendees, Moderator
   */
  getQuestions?: Maybe<QuestionConnection>;
  /** Get random invitee profile images */
  getRandomInviteeProfileImages?: Maybe<Array<Maybe<InviteeProfileImage>>>;
  /**
   * Get an array (raw) attendee reaction values by range of seconds
   * @deprecated The getReactions function now has raw reactions. Used only for backwards compatibility
   */
  getRawReactions?: Maybe<ReactionsGetResponse>;
  /** Get attendee reaction values by range of seconds */
  getReactions?: Maybe<ReactionsGetResponse>;
  /** Get reactions session config planner side */
  getReactionsSessionConfig?: Maybe<ReactionsSessionConfigOutput>;
  /** Get reactions session config attendee side */
  getReactionsSessionConfigAttendee?: Maybe<ReactionsSessionConfigOutput>;
  /** Get reactions session config planner side (bulk) */
  getReactionsSessionConfigBulk?: Maybe<Array<Maybe<ReactionsSessionConfigOutput>>>;
  /**
   * Get Attendee List Filter Configuration with Registration and Internal Information Question Choices
   * TODO: Fix query and adjust authorization rules HUB-115849
   */
  getRegQuestionFilters?: Maybe<Array<RegQuestionFilters>>;
  /** Get list of requestable exhibitors */
  getRequestableExhibitors?: Maybe<RequestableExhibitors>;
  getSecureLink?: Maybe<SecureLink>;
  /** Get self attendee info */
  getSelfAttendeeInfo?: Maybe<AppointmentAttendeeInfo>;
  /**
   * Get Session Information for Live Display
   * Authorization: Live Display
   */
  getSession?: Maybe<LiveQaSession>;
  /**
   * Get Live Q&A Location and Access Codes
   * Authorization: Attendees with Moderator Role
   */
  getSessionCodes?: Maybe<SessionCodes>;
  /** Get list of selected custom filters from falcon planner */
  getSessionFilters?: Maybe<SessionFilters>;
  /** Get the number of live viewers for a particular session */
  getSessionLiveViewerCount?: Maybe<SessionLiveViewerCount>;
  /** Get the number of live viewers for a particular session at a certain offset time (time in minutes from the start of the session) */
  getSessionLiveViewerCountAtOffset?: Maybe<SessionLiveViewerCountAtOffset>;
  /** Fetch all the session locations in an event */
  getSessionLocations?: Maybe<Array<SessionLocation>>;
  /** Get the attendee participant status of a particular session */
  getSessionParticipantStatus?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Get Live Q&A Sessions settings for non-authenticated users
   * Authorization: None
   */
  getSessionSettings?: Maybe<SessionSettings>;
  /**
   * Get Live Q&A Sessions settings for authorized attendee
   * Authorization: Attendee
   */
  getSessionSettingsForAttendee?: Maybe<SessionSettings>;
  /**
   * Get a list of Sessions in an Event
   * Authorization: Planner
   */
  getSessions?: Maybe<Array<Maybe<LiveQaSession>>>;
  /**
   * Get all of the sessions that are associated with the speaker ids passed in the criteria
   * @deprecated Use 'searchSessions' instead
   */
  getSessionsBySpeaker: SessionsBySpeakerPaginatedResults;
  getSpeakerBio: SpeakerBio;
  getSpeakerList: SpeakerPaginatedResults;
  /** Get list of Upgradable AdmissionItems */
  getUpgradableAdmissionItems?: Maybe<Array<AdmissionItem>>;
  /** Fetch webcast links for a given webcast in a session */
  getWebcastLinks?: Maybe<WebcastLinks>;
  /**
   * Get a list of Widgets in an Event
   * Results can be filtered by widgetId
   */
  getWidgets?: Maybe<Widgets>;
  /** Check if the user can schedule an appointment of any appointment type as per the schedule rules */
  hasAppointmentTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Get latest versions */
  latestVersions?: Maybe<LatestVersions>;
  /**
   * Tactical solution to query livestream status directly; Will be replaced with
   * webcast -> player -> status eventually.
   */
  livestreamJob?: Maybe<LivestreamJob>;
  /** Information on the currently logged-in user */
  me?: Maybe<User>;
  /** Agenda for the currently logged-in user */
  myAgenda?: Maybe<AgendaPaginatedResults>;
  /**
   * Returns the On-Demand Video Details of the given video ID primarily for the Dry Run feature.
   * This query should NOT be used for attendee video playback/simulive video, use the 'videoOnDemandPlaybackDetails' query instead.
   */
  onDemandVideoDetailsForDryRun?: Maybe<VideoPlaybackDetailsForDryRun>;
  /**
   * Get the redirect URL after webinar registration completed. This will query for the attendeeId
   * if it's not passed.
   */
  postRegRedirectUrl?: Maybe<PostRegRedirectUrlResponse>;
  /** Get possible answers for session prefilter setup page */
  preFilterAnswers?: Maybe<PreFilterData>;
  /** Get individual preFilter list */
  preFilterList?: Maybe<PreFilterList>;
  promotedEventsCalendar?: Maybe<UpcomingEventsCalendar>;
  resourceOverrides?: Maybe<ResourceOverrides>;
  /** Get paginated list of attendee connections */
  searchAttendeeConnections?: Maybe<AttendeeConnectionPaginatedResults>;
  /** Get paginated list of another attendee's connections */
  searchAttendeeMutualConnections?: Maybe<AttendeeMutualConnectionPaginatedResults>;
  /** Get list of attendees */
  searchAttendees?: Maybe<AttendeePaginatedResults>;
  /** Get list of exhibitors */
  searchExhibitors?: Maybe<ExhibitorPaginatedResults>;
  /**
   * Get list of sessions for the planner; Should not be used for attendee-facing workflows
   * Authorization: Planner
   */
  searchPlannerSessions?: Maybe<SessionPaginatedResults>;
  /** Get list of available sessions */
  searchSessions?: Maybe<SessionPaginatedResults>;
  /** Get list of sponsors */
  searchSponsors?: Maybe<ExhibitorPaginatedResults>;
  /** Get additional details on a particular session */
  sessionDetail?: Maybe<SessionDetail>;
  /** Get list of session filters for the attendee */
  sessionFilters: SessionFiltersAndDates;
  /** Get the session guide (list of preFilter lists) */
  sessionGuide?: Maybe<SessionGuide>;
  /** Get list of session recommendations for attendee */
  sessionRecommendations?: Maybe<SessionRecommendations>;
  /** Get Tags for Element types */
  tagsForElementTypes?: Maybe<PaginatedElementToTagRelations>;
  /** Get unread report count */
  unreadReports?: Maybe<ReportPostsUnread>;
  upcomingEventsCalendar?: Maybe<UpcomingEventsCalendar>;
  /** Returns video details, including playback URLs, for the provided video ID. This query is for videos that aren't associated with an event entity (I.e. custom cards). Use 'videoOnDemandPlaybackDetails' for session and/or exhibitor video playback. */
  videoDetails: VideoWithRenditions;
  /** Returns playback details for the given video & entity */
  videoOnDemandPlaybackDetails?: Maybe<VideoPlaybackDetails>;
};

export type QueryApptImportSummaryArgs = {
  params: ApptImportSummaryInput;
};

export type QueryAttendeeHubPagesEntitiesArgs = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  pageCriteria?: InputMaybe<PageCriteria>;
  pageType: PageType;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAttendeeHubPagesEntityArgs = {
  eventId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  pageType: PageType;
};

export type QueryAttendeeHubPagesV2Args = {
  eventId: Scalars['ID']['input'];
};

export type QueryAuthorizePubNubEntityArgs = {
  authKey: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type QueryChatReportsArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCheckAdmissionItemUpgradeVisibilityArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCheckConfigArgs = {
  key: Scalars['String']['input'];
};

export type QueryCheckFileExistsArgs = {
  filePath: Scalars['String']['input'];
};

export type QueryCheckImageFileExistsArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};

export type QueryEventAdCountsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryEventAdSettingsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryEventInfoArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
};

export type QueryEventLocaleInfoArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFetchConfigArgs = {
  key: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFetchExhibitorArgs = {
  appt?: InputMaybe<AppointmentSelector>;
  editBannerFlow?: InputMaybe<Scalars['Boolean']['input']>;
  enableSessionCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  exhibitorTranslationsFlag?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFetchExhibitorContentLinkArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGenerateMapSignatureArgs = {
  osType: OsType;
  url: Scalars['String']['input'];
};

export type QueryGenericDownloadLinkArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetActiveTagsArgs = {
  pageCriteria?: InputMaybe<PageCriteria>;
  tagSearchCriteria?: InputMaybe<TagSearchCriteria>;
};

export type QueryGetAgendaDatesArgs = {
  params: AgendaDatesInput;
};

export type QueryGetAllSpacesArgs = {
  appId: Scalars['ID']['input'];
};

export type QueryGetAnonymousPubNubConfigArgs = {
  clientType?: InputMaybe<PubNubClientType>;
  eventId: Scalars['ID']['input'];
};

export type QueryGetAnonymousPubNubConfigV2Args = {
  clientType?: InputMaybe<PubNubClientType>;
  eventId: Scalars['ID']['input'];
};

export type QueryGetAppFeaturesArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  appFeatures: Array<AppFeatureInput>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAppointmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetAppointmentAgendaItemArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetAppointmentTypesArgs = {
  params?: InputMaybe<ApptTypesInput>;
};

export type QueryGetAppointmentsArgs = {
  params: AppointmentSearchInput;
};

export type QueryGetApptEventAttendeesArgs = {
  params: FilterApptEventAttendeesInput;
};

export type QueryGetAssignedPollsArgs = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  pollId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type QueryGetAssignedWidgetsArgs = {
  eventId: Scalars['ID']['input'];
  input: GetAssignedWidgetsInput;
};

export type QueryGetAssignedWidgetsCountArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetAttendeeArgs = {
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAttendeeConnectionStatusArgs = {
  contactId: Scalars['ID']['input'];
};

export type QueryGetAttendeeFieldCompletionArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetAttendeeHubConfigArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAttendeeHubPagesArgs = {
  eventId: Scalars['ID']['input'];
  includeSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAttendeeOnDemandCatalogArgs = {
  criteria?: InputMaybe<SearchSessionCriteria>;
};

export type QueryGetAttendeeOnDemandCatalogV2Args = {
  criteria?: InputMaybe<OnDemandPageInput>;
};

export type QueryGetAttendeeRecommendationsArgs = {
  pageCriteria?: InputMaybe<PageCriteria>;
};

export type QueryGetAttendeesArgs = {
  criteria?: InputMaybe<AttendeeFetchCriteria>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAvailabilityByTimeRangeArgs = {
  params: AvailabilityByTimeRangeInput;
};

export type QueryGetAvailableLocationsArgs = {
  params: AvailableLocationsInput;
};

export type QueryGetAvailableTimesArgs = {
  params: TimeSuggestionInput;
};

export type QueryGetCdnImageUrlArgs = {
  input?: InputMaybe<ImageInput>;
};

export type QueryGetCreditsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetDefaultPagesInfoArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetEventArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetEventGuideSettingsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetEventProfileSettingsArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetEventSettingsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetEventSettingsPlannerArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetEventsArgs = {
  criteria?: InputMaybe<EventSearchCriteria>;
};

export type QueryGetExhibitorBoothStaffAttendeesArgs = {
  params: FilterExhibitorBoothStaffAttendeesInput;
};

export type QueryGetExhibitorInfoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetExhibitorsInfoArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetExhibitorsWithBoothLocationArgs = {
  params: ExhibitorsBoothLocationInput;
};

export type QueryGetExperimentArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  experimentName: Scalars['String']['input'];
};

export type QueryGetFloorPlanArgs = {
  criteria?: InputMaybe<MarkerFilterCriteria>;
  eventId: Scalars['ID']['input'];
  floorPlanId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFloorPlansArgs = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetGameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetHasReactionsDataArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryGetHomeSchedulerConfigArgs = {
  criteria: HomeSchedulerCriteria;
};

export type QueryGetImportHistoryArgs = {
  params: ApptImportHistoryInput;
};

export type QueryGetLiveDisplayQuestionArgs = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type QueryGetLocalizedLocationsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};

export type QueryGetOnDemandSessionsArgs = {
  criteria?: InputMaybe<SearchSessionCriteria>;
};

export type QueryGetOrderCheckoutStatusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  orderCheckoutStatusInput: OrderCheckoutStatusInput;
};

export type QueryGetOrderSummaryDetailsArgs = {
  input: RegCartStatusInput;
};

export type QueryGetPaginatedSessionsArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<SessionPagination>;
};

export type QueryGetPersonalTimesArgs = {
  params: PersonalTimeInput;
};

export type QueryGetPlannerCustomFieldsArgs = {
  criteria?: InputMaybe<GetCustomFieldsCriteria>;
};

export type QueryGetPlannerOnDemandCatalogArgs = {
  eventId: Scalars['ID']['input'];
  pageInput?: InputMaybe<Array<InputMaybe<CatalogSectionPaging>>>;
};

export type QueryGetPollsArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<PollSearchCriteria>;
  pollId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetPotentialConflictsArgs = {
  params: PotentialConflictsInput;
};

export type QueryGetPreAcceptValidationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPreferenceArgs = {
  eventId: Scalars['ID']['input'];
  preferenceType: Scalars['String']['input'];
};

export type QueryGetProfessionalInterestChoicesArgs = {
  eventId: Scalars['ID']['input'];
  pageCriteria?: InputMaybe<PageCriteria>;
};

export type QueryGetProfileFieldGroupSettingsArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetProposedTimesArgs = {
  apptId: Scalars['ID']['input'];
};

export type QueryGetPubNubConfigArgs = {
  clientType?: InputMaybe<PubNubClientType>;
};

export type QueryGetPubNubConfigV2Args = {
  clientType?: InputMaybe<PubNubClientType>;
};

export type QueryGetQuestionsArgs = {
  eventId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<QuestionStatusType>>>;
};

export type QueryGetRandomInviteeProfileImagesArgs = {
  eventId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetRawReactionsArgs = {
  endSecs: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
  startSecs: Scalars['Int']['input'];
};

export type QueryGetReactionsArgs = {
  endSecs: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
  startSecs: Scalars['Int']['input'];
};

export type QueryGetReactionsSessionConfigArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetReactionsSessionConfigAttendeeArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetReactionsSessionConfigBulkArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetRegQuestionFiltersArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetRequestableExhibitorsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  params: RequestableExhibitorsInput;
};

export type QueryGetSecureLinkArgs = {
  filePath: Scalars['String']['input'];
  ttl: Scalars['Int']['input'];
};

export type QueryGetSessionArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionCodesArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionFiltersArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetSessionLiveViewerCountArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionLiveViewerCountAtOffsetArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionLocationsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetSessionParticipantStatusArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionSettingsArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionSettingsForAttendeeArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryGetSessionsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetSessionsBySpeakerArgs = {
  criteria: SearchSessionsBySpeakerCriteria;
};

export type QueryGetSpeakerBioArgs = {
  criteria: SpeakerCriteria;
};

export type QueryGetSpeakerListArgs = {
  criteria: SpeakerListCriteria;
};

export type QueryGetUpgradableAdmissionItemsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetWebcastLinksArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryGetWidgetsArgs = {
  eventId: Scalars['ID']['input'];
  input?: InputMaybe<GetWidgetsInput>;
};

export type QueryLatestVersionsArgs = {
  applicationId: Scalars['ID']['input'];
};

export type QueryLivestreamJobArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMyAgendaArgs = {
  criteria?: InputMaybe<MyAgendaCriteria>;
  exhibitorTranslationsFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOnDemandVideoDetailsForDryRunArgs = {
  sessionId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
};

export type QueryPostRegRedirectUrlArgs = {
  attendeeEmail: Scalars['String']['input'];
  attendeeId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};

export type QueryPreFilterAnswersArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryPreFilterListArgs = {
  eventId: Scalars['ID']['input'];
  filterListId: Scalars['ID']['input'];
};

export type QueryPromotedEventsCalendarArgs = {
  criteria?: InputMaybe<UpcomingEventsSearchCriteria>;
};

export type QueryResourceOverridesArgs = {
  locale: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

export type QuerySearchAttendeeConnectionsArgs = {
  criteria?: InputMaybe<AttendeeConnectionSearchCriteria>;
};

export type QuerySearchAttendeeMutualConnectionsArgs = {
  attendeeId: Scalars['ID']['input'];
  criteria?: InputMaybe<AttendeeMutualConnectionSearchCriteria>;
};

export type QuerySearchAttendeesArgs = {
  criteria?: InputMaybe<AttendeeSearchCriteria>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySearchExhibitorsArgs = {
  criteria?: InputMaybe<ExhibitorSearchCriteria>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchPlannerSessionsArgs = {
  criteria?: InputMaybe<SearchPlannerSessionsCriteria>;
};

export type QuerySearchSessionsArgs = {
  criteria?: InputMaybe<SearchSessionCriteria>;
};

export type QuerySearchSponsorsArgs = {
  criteria?: InputMaybe<SponsorSearchCriteria>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySessionDetailArgs = {
  exhibitorTranslationsFlag?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  qaLimit?: InputMaybe<Scalars['Int']['input']>;
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySessionFiltersArgs = {
  criteria?: InputMaybe<SessionFilterCriteria>;
};

export type QuerySessionGuideArgs = {
  criteria?: InputMaybe<SessionGuideCriteria>;
};

export type QuerySessionRecommendationsArgs = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type QueryTagsForElementTypesArgs = {
  elementTypes: Array<TagElementType>;
  eventId: Scalars['ID']['input'];
  pageCriteria?: InputMaybe<PageCriteria>;
};

export type QueryUpcomingEventsCalendarArgs = {
  criteria?: InputMaybe<UpcomingEventsSearchCriteria>;
};

export type QueryVideoDetailsArgs = {
  videoId: Scalars['ID']['input'];
};

export type QueryVideoOnDemandPlaybackDetailsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: VideoAssociationEntityType;
  videoId: Scalars['ID']['input'];
};

/** Question object for Live Q&A */
export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Scalars['String']['output']>;
  attendeeId?: Maybe<Scalars['ID']['output']>;
  attendeeName?: Maybe<Scalars['String']['output']>;
  createDateTime: Scalars['String']['output'];
  displayDateTime?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  isCurrentQuestion?: Maybe<Scalars['Boolean']['output']>;
  isMine?: Maybe<Scalars['Boolean']['output']>;
  isVoted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
  status: QuestionStatusType;
  statusChangeDateTime: Scalars['String']['output'];
  text: Scalars['String']['output'];
  voteCount: Scalars['Int']['output'];
};

export type QuestionAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

/** Paginated list of Questions for Live Q&A */
export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  eventId?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<Question>>>;
  pageToken?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
};

export type QuestionInfo = {
  __typename?: 'QuestionInfo';
  id: Scalars['ID']['output'];
  questionTypeInfo: QuestionTypeInfo;
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

/**
 * Identifies the source of a question.
 * Note: that at the time of writing, this only has the "Internal Information"
 * questions value as the other question types are not populating this field.
 * See https://stash.cvent.net/projects/QUES/repos/questions/browse/src/main/java/com/cvent/questions.
 * This enum should be updated when the other question types are updated to populate this field.
 */
export enum QuestionServiceEntityType {
  InternalInfoQuestion = 'InternalInfoQuestion'
}

/** Input request to update a Question Status by ID */
export type QuestionStatusInput = {
  id: Scalars['ID']['input'];
  status: QuestionStatusType;
};

export enum QuestionStatusType {
  Answered = 'answered',
  Approved = 'approved',
  Declined = 'declined',
  Pending = 'pending'
}

export enum QuestionType {
  MultipleChoice = 'multipleChoice',
  SingleChoice = 'singleChoice'
}

export type QuestionTypeInfo = {
  __typename?: 'QuestionTypeInfo';
  answerFormatType?: Maybe<Scalars['String']['output']>;
  choices?: Maybe<Array<Maybe<Choice>>>;
  displayFormatTypeId?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  otherAnswer?: Maybe<OtherAnswerMetadata>;
  questionType: Scalars['String']['output'];
  scores: Array<Maybe<Scalars['String']['output']>>;
};

export type QuickLink = {
  __typename?: 'QuickLink';
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickLinkInput = {
  icon: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum QuickLinksFormatType {
  Grid = 'GRID',
  Pills = 'PILLS'
}

export type QuickLinksSettings = {
  __typename?: 'QuickLinksSettings';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<AttendeeHubPageType>;
};

export type QuickLinksSettingsInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<AttendeeHubPageType>;
};

export type Range = {
  __typename?: 'Range';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type RangeInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type ReactionsBroadcastOutput = {
  __typename?: 'ReactionsBroadcastOutput';
  environment?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  reactionsData: Array<ReactionsWithOffsetOutput>;
  sessionId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type ReactionsCountTuple = {
  counts: Scalars['Int']['input'];
  reactionType: Scalars['Int']['input'];
};

export type ReactionsCountTupleOutput = {
  __typename?: 'ReactionsCountTupleOutput';
  counts: Array<Scalars['Int']['output']>;
  reactionType: Scalars['Int']['output'];
};

export type ReactionsCountTuplesOutput = {
  __typename?: 'ReactionsCountTuplesOutput';
  counts: Scalars['Int']['output'];
  reactionType: Scalars['Int']['output'];
};

export type ReactionsGetResponse = {
  __typename?: 'ReactionsGetResponse';
  environment?: Maybe<Scalars['String']['output']>;
  reactionCountsByType: Array<ReactionsCountTupleOutput>;
  sessionId: Scalars['String']['output'];
  streamTimeEnd: Scalars['Int']['output'];
  streamTimeStart: Scalars['Int']['output'];
};

export type ReactionsSessionConfigInput = {
  enabled: Scalars['Boolean']['input'];
  eventId: Scalars['ID']['input'];
  reactionTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sessionId: Scalars['ID']['input'];
};

export type ReactionsSessionConfigOutput = {
  __typename?: 'ReactionsSessionConfigOutput';
  accountId: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  eventId: Scalars['ID']['output'];
  reactionTypes?: Maybe<Array<Scalars['Int']['output']>>;
  sessionId: Scalars['ID']['output'];
};

export type ReactionsWithOffset = {
  reactionCountTuples: Array<ReactionsCountTuple>;
  streamOffsetSecs: Scalars['Int']['input'];
};

export type ReactionsWithOffsetOutput = {
  __typename?: 'ReactionsWithOffsetOutput';
  reactionCountTuples: Array<ReactionsCountTuplesOutput>;
  streamOffsetSecs: Scalars['Int']['output'];
};

export type ReassignedIcon = {
  __typename?: 'ReassignedIcon';
  name: Scalars['String']['output'];
  reassignment: Scalars['String']['output'];
};

export type ReassignedIconInput = {
  name: Scalars['String']['input'];
  reassignment: Scalars['String']['input'];
};

export type RecommendationPaginatedResults = {
  __typename?: 'RecommendationPaginatedResults';
  data?: Maybe<Array<Maybe<AttendeeRecommendation>>>;
  pagination?: Maybe<Pagination>;
};

export type RefundSummary = {
  __typename?: 'RefundSummary';
  admissionItemPrice?: Maybe<Scalars['Float']['output']>;
};

export type RegCartInput = {
  cardType?: InputMaybe<CardType>;
  locale?: InputMaybe<Scalars['String']['input']>;
  regCartId: Scalars['ID']['input'];
};

export type RegCartStatusInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  regCartId: Scalars['ID']['input'];
};

export type RegQuestionAnswer = {
  __typename?: 'RegQuestionAnswer';
  filterName: Scalars['String']['output'];
  filterOrder: Scalars['Int']['output'];
  questionId: Scalars['ID']['output'];
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Filters + Registration/Internal Information Questions model. */
export type RegQuestionChoices = {
  __typename?: 'RegQuestionChoices';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RegQuestionFilters = {
  __typename?: 'RegQuestionFilters';
  choices?: Maybe<Array<RegQuestionChoices>>;
  filterName: Scalars['String']['output'];
  filterOrder: Scalars['Int']['output'];
  questionId: Scalars['String']['output'];
  questionServiceEntityType?: Maybe<QuestionServiceEntityType>;
  questionType: Scalars['String']['output'];
};

export type RegQuestionsFilter = {
  questionId: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};

export type RegisterAttendeeInput = {
  attendee: SignUpRegistrationAttendee;
  eventId: Scalars['ID']['input'];
  platform?: InputMaybe<RegistrationPlatform>;
};

export enum RegistrationPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type RegistrationQuestion = {
  __typename?: 'RegistrationQuestion';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type RegistrationQuestions = {
  __typename?: 'RegistrationQuestions';
  question: RegistrationQuestion;
  questionServiceEntityType?: Maybe<Scalars['String']['output']>;
};

export type Rendition = {
  __typename?: 'Rendition';
  height?: Maybe<Scalars['Int']['output']>;
  location: HrefPath;
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ReportPost = {
  __typename?: 'ReportPost';
  entity?: Maybe<ReportPostChatEntity>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  message: ReportPostMessageSnapshot;
  numberOfReports: Scalars['Int']['output'];
  reportCategory: Array<Scalars['String']['output']>;
  reportComment?: Maybe<Scalars['String']['output']>;
  reportedAt: Scalars['String']['output'];
  reportedBy?: Maybe<ReportPostAttendee>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<ReportPostAttendee>;
  sentBy?: Maybe<ReportPostAttendee>;
  status: ReportPostStatus;
};

export type ReportPostAttendee = {
  __typename?: 'ReportPostAttendee';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export enum ReportPostCategoryType {
  Discrimination = 'Discrimination',
  Harassment = 'Harassment',
  OffensiveContent = 'OffensiveContent',
  Other = 'Other',
  Spam = 'Spam'
}

export type ReportPostChatEntity = {
  __typename?: 'ReportPostChatEntity';
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ChatEntityType;
};

export type ReportPostInput = {
  channelId: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: ChatEntityType;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['String']['input'];
  reportCategory: Array<ReportPostCategoryType>;
  reportComment?: InputMaybe<Scalars['String']['input']>;
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ReportPostMessageAttachment = {
  __typename?: 'ReportPostMessageAttachment';
  height?: Maybe<Scalars['Int']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ReportPostMessageSnapshot = {
  __typename?: 'ReportPostMessageSnapshot';
  attachments: Array<ReportPostMessageAttachment>;
  channelId: Scalars['String']['output'];
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parentMessageId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ReportPostResult = {
  __typename?: 'ReportPostResult';
  limit?: Maybe<Scalars['Int']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['Int']['output']>;
  status: ChatServiceStatus;
};

export enum ReportPostStatus {
  Deleted = 'Deleted',
  Dismissed = 'Dismissed',
  New = 'New'
}

export type ReportPostsUnread = {
  __typename?: 'ReportPostsUnread';
  unreadCount: Scalars['Int']['output'];
};

export enum ReportReadStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

export type ReportReadSubscriptionEvent = {
  __typename?: 'ReportReadSubscriptionEvent';
  attendeeId: Scalars['ID']['output'];
  eventId: Scalars['ID']['output'];
  reportIds: Array<Scalars['ID']['output']>;
};

export type RequestDoNotSellResult = {
  __typename?: 'RequestDoNotSellResult';
  requestReceived: Scalars['Boolean']['output'];
};

export type RequestableExhibitors = {
  __typename?: 'RequestableExhibitors';
  data: Array<Maybe<Exhibitor>>;
};

export type RequestableExhibitorsInput = {
  apptTypeId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceOverride = {
  __typename?: 'ResourceOverride';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ResourceOverrides = {
  __typename?: 'ResourceOverrides';
  locale: Scalars['String']['output'];
  overrides: Array<Maybe<ResourceOverride>>;
};

export enum ResultsDisplayType {
  Horizontal = 'horizontal',
  Pie = 'pie',
  Vertical = 'vertical'
}

export type RevokeTokensRequest = {
  __typename?: 'RevokeTokensRequest';
  accountId: Scalars['Int']['output'];
  attendees: Array<Scalars['ID']['output']>;
  environment: Scalars['String']['output'];
  eventId: Scalars['ID']['output'];
  revokeTokensIssuedBefore: Scalars['String']['output'];
};

export enum Role {
  Host = 'HOST',
  Participant = 'PARTICIPANT'
}

export type Roles = {
  __typename?: 'Roles';
  audienceEngagement: Array<Maybe<Scalars['String']['output']>>;
  boothStaff?: Maybe<Scalars['Boolean']['output']>;
  speakerRoom: Array<Maybe<Scalars['String']['output']>>;
  videoHost: Array<Maybe<Scalars['String']['output']>>;
};

export enum ScavengerHuntCodeValidationMethod {
  Passcode = 'Passcode',
  QrCode = 'QRCode'
}

export type ScavengerHuntCodeValidationResult = {
  __typename?: 'ScavengerHuntCodeValidationResult';
  validationSucceeded: Scalars['Boolean']['output'];
};

export type SchedulerData = {
  __typename?: 'SchedulerData';
  appointmentCard?: Maybe<Array<Maybe<HomeCard>>>;
  cardsOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkGalleries?: Maybe<Array<Maybe<HomeCard>>>;
  links?: Maybe<Array<Maybe<HomeCard>>>;
  quickLinksSettings?: Maybe<Array<Maybe<QuickLinksSettings>>>;
  systemCards?: Maybe<Array<Maybe<SystemCard>>>;
  videoGalleries?: Maybe<Array<Maybe<HomeCard>>>;
  /**
   * Shape of schema does not match expected body shape in falcon-planner
   * Some fields are transformed from keyed objects to arrays
   * (maps by id for cards, maps by cardType for systemCards)
   */
  videos?: Maybe<Array<Maybe<HomeCard>>>;
};

export type SchedulerDataInput = {
  appointmentCard?: InputMaybe<Array<InputMaybe<HomeCardInput>>>;
  cardsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkGalleries?: InputMaybe<Array<InputMaybe<HomeCardInput>>>;
  links?: InputMaybe<Array<InputMaybe<HomeCardInput>>>;
  quickLinksSettings?: InputMaybe<Array<InputMaybe<QuickLinksSettingsInput>>>;
  systemCards?: InputMaybe<Array<InputMaybe<SystemCardInput>>>;
  videoGalleries?: InputMaybe<Array<InputMaybe<HomeCardInput>>>;
  /**
   * Shape of Input does not match expected body shape in falcon-planner
   * Some fields are transformed from keyed objects to arrays
   * (maps by id for cards, maps by cardType for systemCards)
   */
  videos?: InputMaybe<Array<InputMaybe<HomeCardInput>>>;
};

export type SearchPlannerSessionsCriteria = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFieldFilters?: InputMaybe<Array<CustomFieldFilterInput>>;
  eventId: Scalars['ID']['input'];
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageCriteria?: InputMaybe<PageCriteria>;
  sort?: InputMaybe<SessionSortBy>;
  speakerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeframes?: InputMaybe<Array<Timeframe>>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  searchFolderList: Array<SearchedAsset>;
  totalCount: Scalars['Int']['output'];
};

export type SearchSessionCriteria = {
  admissionItemId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFieldFilters?: InputMaybe<Array<CustomFieldFilterInput>>;
  /** @deprecated Field no longer supported */
  exhibitorTranslationsFlag?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  hasFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeUpgradeSessions?: InputMaybe<Scalars['Boolean']['input']>;
  liveAndUpcoming?: InputMaybe<Timeframe>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageCriteria?: InputMaybe<PageCriteria>;
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  registrationTypeId?: InputMaybe<Scalars['ID']['input']>;
  sessionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skipEnrollmentData?: InputMaybe<Scalars['Boolean']['input']>;
  speakerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<SessionStatus>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeframes?: InputMaybe<Array<Timeframe>>;
  useDisplayInAttendeeHub?: InputMaybe<Scalars['Boolean']['input']>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchSessionsBySpeakerCriteria = {
  admissionItemId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFieldFilters?: InputMaybe<Array<CustomFieldFilterInput>>;
  exhibitorTranslationsFlag?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  hasFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeUpgradeSessions?: InputMaybe<Scalars['Boolean']['input']>;
  liveAndUpcoming?: InputMaybe<Timeframe>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageCriteria?: InputMaybe<PageCriteria>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  registrationTypeId?: InputMaybe<Scalars['ID']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skipEnrollmentData?: InputMaybe<Scalars['Boolean']['input']>;
  speakerIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<SessionStatus>;
  term?: InputMaybe<Scalars['String']['input']>;
  timeframes?: InputMaybe<Array<Timeframe>>;
};

/** New Speaker List & Bio Page Schemas */
export type SearchSpeakerCriteria = {
  admissionItemId?: InputMaybe<Scalars['ID']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  pageCriteria?: InputMaybe<PageCriteria>;
  registrationTypeId?: InputMaybe<Scalars['ID']['input']>;
  speakerCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  speakerCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchedAsset = {
  __typename?: 'SearchedAsset';
  assets: Array<Asset>;
};

export type SecureLink = {
  __typename?: 'SecureLink';
  url: Scalars['String']['output'];
};

export type SecuritySettings = AttendeeHubConfigInterface & {
  __typename?: 'SecuritySettings';
  authenticationType?: Maybe<AuthenticationType>;
  documentSharingEnabled: Scalars['Boolean']['output'];
  exhibitorsLoginRequired: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  scheduleLoginRequired: Scalars['Boolean']['output'];
  sessionRegistrationRequired?: Maybe<Scalars['Boolean']['output']>;
  speakersLoginRequired: Scalars['Boolean']['output'];
};

export type SecuritySettingsInput = {
  documentSharingEnabled: Scalars['Boolean']['input'];
  exhibitorsLoginRequired: Scalars['Boolean']['input'];
  scheduleLoginRequired: Scalars['Boolean']['input'];
  sessionRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  speakersLoginRequired: Scalars['Boolean']['input'];
};

export type SelectedFilterInput = {
  filterName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type SelectedFiltersMutationSuccess = {
  __typename?: 'SelectedFiltersMutationSuccess';
  settings?: Maybe<Array<Filter>>;
};

export type SelectedFiltersSettingsInput = {
  settings?: InputMaybe<Array<SelectedFilterInput>>;
};

export enum SendTo {
  All = 'all',
  Changed = 'changed'
}

export type ServiceFee = {
  __typename?: 'ServiceFee';
  adjustmentType?: Maybe<AdjustmentType>;
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Session = {
  __typename?: 'Session';
  admissionItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  capacity?: Maybe<CapacityRemaining>;
  category?: Maybe<SessionCategory>;
  code?: Maybe<Scalars['String']['output']>;
  contentTags?: Maybe<Array<ContentTag>>;
  customFields?: Maybe<Array<SessionCustomField>>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['AWSDateTime']['output'];
  enrolled: Scalars['Boolean']['output'];
  exhibitors?: Maybe<Array<Maybe<SessionExhibitor>>>;
  featured: Scalars['Boolean']['output'];
  fee?: Maybe<SessionFee>;
  group?: Maybe<SessionGroup>;
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  location?: Maybe<SessionLocation>;
  name: Scalars['String']['output'];
  onDemandVideo?: Maybe<Video>;
  openForAttendeeHub: Scalars['Boolean']['output'];
  openForRegistration: Scalars['Boolean']['output'];
  recommended?: Maybe<Scalars['Boolean']['output']>;
  sessionSpeakers?: Maybe<Array<Speaker>>;
  /** @deprecated Use contentTags instead */
  sessionTags?: Maybe<Array<Scalars['String']['output']>>;
  speakers?: Maybe<Array<Scalars['ID']['output']>>;
  speakersDetails?: Maybe<Array<Speaker>>;
  start: Scalars['AWSDateTime']['output'];
  /** @deprecated Use contentTags instead */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  upgrade?: Maybe<Scalars['Boolean']['output']>;
  virtual: Scalars['Boolean']['output'];
  webcast?: Maybe<Webcast>;
};

export type SessionCapacityArgs = {
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionCategory = {
  __typename?: 'SessionCategory';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type SessionCheckIn = {
  __typename?: 'SessionCheckIn';
  checkInRequired?: Maybe<Scalars['Boolean']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  minutesBeforeEnd?: Maybe<Scalars['Int']['output']>;
  minutesBeforeStart?: Maybe<Scalars['Int']['output']>;
};

/** Session Setting Codes for Live Q&A */
export type SessionCodes = {
  __typename?: 'SessionCodes';
  accessCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  locationCode?: Maybe<Scalars['String']['output']>;
  qaCustomTimeFrameEnabled: Scalars['Boolean']['output'];
  qaEnabled: Scalars['Boolean']['output'];
  qaEndDateTime?: Maybe<Scalars['String']['output']>;
  qaStartDateTime?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
};

export type SessionCustomField = {
  __typename?: 'SessionCustomField';
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated No longer needed, will always be true */
  plannerSelected?: Maybe<Scalars['Boolean']['output']>;
  type: SessionCustomFieldType;
  value: Array<Maybe<Scalars['String']['output']>>;
};

export enum SessionCustomFieldType {
  AutoIncrement = 'AutoIncrement',
  ConsentQuestion = 'ConsentQuestion',
  Currency = 'Currency',
  Date = 'Date',
  DateTime = 'DateTime',
  Decimal = 'Decimal',
  Email = 'Email',
  FileUpload = 'FileUpload',
  FreeText = 'FreeText',
  General = 'General',
  MultiSelect = 'MultiSelect',
  Number = 'Number',
  SingleSelect = 'SingleSelect',
  UsPhoneNumber = 'USPhoneNumber',
  Unknown = 'Unknown'
}

export type SessionDerivedData = {
  __typename?: 'SessionDerivedData';
  categories?: Maybe<Array<SessionCategory>>;
  customFields?: Maybe<Array<SessionCustomField>>;
  locations?: Maybe<Array<Location>>;
};

export type SessionDetail = {
  __typename?: 'SessionDetail';
  capacity?: Maybe<CapacityRemaining>;
  category?: Maybe<SessionCategory>;
  chatSettings?: Maybe<ChatSettings>;
  code?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<SessionCustomField>>>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<SessionDocument>>;
  end: Scalars['AWSDateTime']['output'];
  enrolled: Scalars['Boolean']['output'];
  exhibitors: Array<SessionExhibitor>;
  featured: Scalars['Boolean']['output'];
  fee?: Maybe<SessionFee>;
  feedbackSurvey?: Maybe<SessionFeedbackSurvey>;
  floorPlan?: Maybe<FloorPlanWithoutMarkers>;
  hasPoll: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  location?: Maybe<SessionLocation>;
  name: Scalars['String']['output'];
  openForAttendeeHub: Scalars['Boolean']['output'];
  openForRegistration: Scalars['Boolean']['output'];
  participant: Scalars['Boolean']['output'];
  participationThresholdSettings?: Maybe<SessionParticipationThresholdSettings>;
  polls?: Maybe<Array<Maybe<AttendeePoll>>>;
  questions?: Maybe<QuestionConnection>;
  recommended?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<SessionSettings>;
  speakers: Array<Speaker>;
  start: Scalars['AWSDateTime']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  virtual: Scalars['Boolean']['output'];
  webcast?: Maybe<Webcast>;
  widgets?: Maybe<Array<AssignedWidgetSession>>;
};

export type SessionDetailCapacityArgs = {
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionDocument = {
  __typename?: 'SessionDocument';
  alternateText?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['AWSDateTime']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type SessionEnrollmentInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  sessionCancellationId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sessionRegistrationId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SessionEnrollmentResponse = {
  __typename?: 'SessionEnrollmentResponse';
  error?: Maybe<EnrollmentError>;
  locale?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type SessionExhibitor = {
  __typename?: 'SessionExhibitor';
  description?: Maybe<Scalars['String']['output']>;
  eventSponsor?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileLogoId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use profileLogoUrlOptimized */
  profileLogoUrl?: Maybe<Scalars['String']['output']>;
  profileLogoUrlOptimized?: Maybe<Scalars['String']['output']>;
  sponsorshipLevel?: Maybe<SponsorshipLevel>;
  sponsorshipLevelId?: Maybe<Scalars['ID']['output']>;
};

export type SessionFee = {
  __typename?: 'SessionFee';
  amount: Scalars['Float']['output'];
  chargePolicyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SessionFeedbackSurvey = FeedbackSurvey & {
  __typename?: 'SessionFeedbackSurvey';
  audience: SurveyAudience;
  chapterId: Scalars['ID']['output'];
  closeDate?: Maybe<Scalars['String']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTimeUnit?: Maybe<SurveyTimeUnit>;
  surveyAvailability: SessionSurveyAvailability;
  surveyId: Scalars['ID']['output'];
  surveyUrl: Scalars['String']['output'];
};

export type SessionFilter = {
  __typename?: 'SessionFilter';
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  /** @deprecated Use valuesWithSpeakers instead */
  value: Array<Maybe<SessionFilterValue>>;
  /** @deprecated Use valuesWithSpeakers instead */
  values: Array<Maybe<SessionFilterValue>>;
  valuesWithSpeakers: Array<Maybe<SessionFilterValueUnion>>;
};

export type SessionFilterCriteria = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SessionFilterValue = {
  __typename?: 'SessionFilterValue';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type SessionFilterValueUnion = SessionFilterValue | SessionSpeakerFilterValue;

export type SessionFilters = {
  __typename?: 'SessionFilters';
  data?: Maybe<Array<Filter>>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SessionFiltersAndDates = {
  __typename?: 'SessionFiltersAndDates';
  dates: Array<Scalars['AWSDateTime']['output']>;
  filters: Array<SessionFilter>;
  sessionGuide?: Maybe<SessionGuide>;
};

export type SessionGroup = {
  __typename?: 'SessionGroup';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionGuide = {
  __typename?: 'SessionGuide';
  preFilters: Array<PreFilterList>;
};

export type SessionGuideCriteria = {
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SessionGuideInput = {
  preFilters?: InputMaybe<Array<PreFilterListInput>>;
};

export type SessionGuideResponse = {
  __typename?: 'SessionGuideResponse';
  preFilters: Array<PreFilterListResponse>;
};

export type SessionLiveViewerCount = {
  __typename?: 'SessionLiveViewerCount';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  liveViewers: Scalars['Int']['output'];
  minute: Scalars['AWSDateTime']['output'];
};

export type SessionLiveViewerCountAtOffset = {
  __typename?: 'SessionLiveViewerCountAtOffset';
  batchSize?: Maybe<Scalars['Int']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  liveViewerCounts?: Maybe<Array<Maybe<SessionLiveViewerCount>>>;
  offset: Scalars['Int']['output'];
  sessionId: Scalars['ID']['output'];
};

export type SessionLocation = {
  __typename?: 'SessionLocation';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SessionPaginatedResults = {
  __typename?: 'SessionPaginatedResults';
  data: Array<Session>;
  pagination?: Maybe<Pagination>;
};

export type SessionPagination = {
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type SessionParticipationThresholdSettings = {
  __typename?: 'SessionParticipationThresholdSettings';
  participationLiveOnly?: Maybe<Scalars['Int']['output']>;
  participationThreshold?: Maybe<Scalars['Int']['output']>;
};

export type SessionRecommendations = {
  __typename?: 'SessionRecommendations';
  sessionIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Session Settings for Live Q&A
 * Note: DateTimes do not contain time-zones
 */
export type SessionSettings = {
  __typename?: 'SessionSettings';
  askAnonymouslyEnabled?: Maybe<Scalars['Boolean']['output']>;
  autoModerationEnabled?: Maybe<Scalars['Boolean']['output']>;
  eventId: Scalars['ID']['output'];
  qaCustomTimeFrameEnabled: Scalars['Boolean']['output'];
  qaEnabled: Scalars['Boolean']['output'];
  qaEndDateTime?: Maybe<Scalars['String']['output']>;
  qaStartDateTime?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
};

/**
 * Session Settings for Live Q&A
 * Note: DateTimes do not contain time-zones
 */
export type SessionSettingsInput = {
  askAnonymouslyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  qaCustomTimeFrameEnabled: Scalars['Boolean']['input'];
  qaEndDateTime?: InputMaybe<Scalars['String']['input']>;
  qaStartDateTime?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Planner Session Settings for Live Q&A
 * Note: DateTimes do not contain time-zones
 */
export type SessionSettingsPlannerInput = {
  askAnonymouslyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoModerationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  qaCustomTimeFrameEnabled: Scalars['Boolean']['input'];
  qaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  qaEndDateTime?: InputMaybe<Scalars['String']['input']>;
  qaStartDateTime?: InputMaybe<Scalars['String']['input']>;
};

export enum SessionSortBy {
  Name = 'NAME',
  Start = 'START'
}

export type SessionSpeakerFilterValue = {
  __typename?: 'SessionSpeakerFilterValue';
  company?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use speakerId instead */
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  profileImageUri?: Maybe<Scalars['String']['output']>;
  speakerId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SessionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Closed = 'Closed'
}

export enum SessionSurveyAvailability {
  Always = 'Always',
  Limited = 'Limited'
}

export type SessionSwapInput = {
  sessionCancellationId: Array<Scalars['ID']['input']>;
  sessionRegistrationId: Array<Scalars['ID']['input']>;
};

export type SessionsBySpeakerPaginatedResults = {
  __typename?: 'SessionsBySpeakerPaginatedResults';
  data?: Maybe<Array<Maybe<Session>>>;
  pagination?: Maybe<Pagination>;
};

/** showfloor hours of an exhibitor */
export type ShowfloorHours = {
  __typename?: 'ShowfloorHours';
  endHour?: Maybe<Scalars['Int']['output']>;
  endMinute?: Maybe<Scalars['Int']['output']>;
  startHour?: Maybe<Scalars['Int']['output']>;
  startMinute?: Maybe<Scalars['Int']['output']>;
};

/** Showfloor settings for an exhibitor */
export type ShowfloorSettings = {
  __typename?: 'ShowfloorSettings';
  active?: Maybe<Scalars['Boolean']['output']>;
  customBoothHours: Array<CustomBoothHours>;
  exhibitorChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  hours?: Maybe<ShowfloorHours>;
  useCustomBoothHours: Scalars['Boolean']['output'];
};

export type SignUpRegistrationAttendee = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum SnippetApplicableOn {
  EachPage = 'EACH_PAGE',
  Initialization = 'INITIALIZATION'
}

/** Social Media Links */
export type SocialLinks = {
  __typename?: 'SocialLinks';
  facebookUrl?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
};

/** Sort directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Space = {
  __typename?: 'Space';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
};

export type SpaceListResponse = {
  __typename?: 'SpaceListResponse';
  maxAllowedCount: Scalars['Int']['output'];
  spaces: Array<Maybe<Space>>;
};

export type Speaker = SpeakerBase & {
  __typename?: 'Speaker';
  biography?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  displayOnWebsite: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  profileImageUri?: Maybe<Scalars['String']['output']>;
  socialLinks: SocialLinks;
  speakerCategoryId?: Maybe<Scalars['ID']['output']>;
  speakerCategoryName?: Maybe<Scalars['String']['output']>;
  speakerCode: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SpeakerBase = {
  biography?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  profileImageUri?: Maybe<Scalars['String']['output']>;
  socialLinks: SocialLinks;
  speakerCategoryId?: Maybe<Scalars['ID']['output']>;
  speakerCode: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SpeakerBio = SpeakerBase & {
  __typename?: 'SpeakerBio';
  biography?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  documents: Array<SpeakerDocument>;
  email?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  profileImageUri?: Maybe<Scalars['String']['output']>;
  sessions: Array<Session>;
  socialLinks: SocialLinks;
  speakerCategoryId?: Maybe<Scalars['ID']['output']>;
  speakerCategoryName?: Maybe<Scalars['String']['output']>;
  speakerCode: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  visibility: Scalars['Boolean']['output'];
};

export type SpeakerCriteria = {
  locale?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not needed */
  recommendations?: InputMaybe<Scalars['Boolean']['input']>;
  speakerId: Scalars['ID']['input'];
  timeframes?: InputMaybe<Array<Timeframe>>;
};

export type SpeakerDocument = {
  __typename?: 'SpeakerDocument';
  displayEnabled?: Maybe<Scalars['Boolean']['output']>;
  file: SpeakerDocumentFile;
  friendlyName?: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SpeakerDocumentFile = {
  __typename?: 'SpeakerDocumentFile';
  id: Scalars['ID']['output'];
};

export type SpeakerDocumentsCriteria = {
  speakerId: Scalars['ID']['input'];
};

export type SpeakerDocumentsPaginatedResults = {
  __typename?: 'SpeakerDocumentsPaginatedResults';
  data?: Maybe<Array<Maybe<SpeakerDocument>>>;
  paging?: Maybe<Pagination>;
};

export type SpeakerListCriteria = {
  /** @deprecated Not needed */
  eventId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageCriteria?: InputMaybe<PageCriteria>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SpeakerSortBy>;
};

export type SpeakerListPaginatedResults = {
  __typename?: 'SpeakerListPaginatedResults';
  data: Array<Speaker>;
  pagination?: Maybe<Pagination>;
};

export type SpeakerPaginatedResults = {
  __typename?: 'SpeakerPaginatedResults';
  data: Array<Speaker>;
  featuredFilterable: Scalars['Boolean']['output'];
  pagination?: Maybe<Pagination>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SpeakerSortBy {
  Company = 'COMPANY',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Order = 'ORDER',
  Title = 'TITLE'
}

export type SpeedNetworkingConfiguration = {
  __typename?: 'SpeedNetworkingConfiguration';
  canExtendMeetings: Scalars['Boolean']['output'];
  extensionDuration?: Maybe<Scalars['Int']['output']>;
  lastModified: Scalars['AWSDateTime']['output'];
  meetingDuration?: Maybe<Scalars['Int']['output']>;
  restrictOn: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timeslots: Array<Maybe<Timeslot>>;
};

/** Filters for searchSponsors */
export type SponsorSearchCriteria = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  pageCriteria: ExhibitorPageCriteria;
};

/** Sponsored Session */
export type SponsoredSession = {
  __typename?: 'SponsoredSession';
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<SessionLocation>;
  sessionTags?: Maybe<Array<Scalars['String']['output']>>;
  speakersDetails?: Maybe<Array<Speaker>>;
  startDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  virtual: Scalars['Boolean']['output'];
  webcast?: Maybe<Webcast>;
};

/** Sponsorship level */
export type SponsorshipLevel = {
  __typename?: 'SponsorshipLevel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
};

export enum StandardFilterTypes {
  Category = 'CATEGORY',
  Location = 'LOCATION',
  Recommended = 'RECOMMENDED',
  Speakers = 'SPEAKERS',
  Tags = 'TAGS'
}

export enum Status {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export enum StatusType {
  Closed = 'closed',
  Open = 'open',
  Unopened = 'unopened'
}

/** Checks if documents have been saved to s3, if they have not, set them up */
export type StorageStatus = {
  __typename?: 'StorageStatus';
  eventId?: Maybe<Scalars['ID']['output']>;
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<DocumentSetupStatus>;
};

export type StreamClientConnectTriggerStatus = {
  __typename?: 'StreamClientConnectTriggerStatus';
  attendeeId?: Maybe<Scalars['ID']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** String tuple for map-like data structure */
export type StringTupleInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StudioEndSessionResponse = {
  __typename?: 'StudioEndSessionResponse';
  sessionId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
  webcastId: Scalars['ID']['output'];
};

export type SubscribableAttendeePoll = {
  __typename?: 'SubscribableAttendeePoll';
  attendeePolls: Array<AttendeePoll>;
  eventId: Scalars['ID']['output'];
  pollId?: Maybe<Scalars['ID']['output']>;
  sessionId: Scalars['ID']['output'];
};

export type SubscribablePollQuestionChoiceResultsByPoll = {
  __typename?: 'SubscribablePollQuestionChoiceResultsByPoll';
  eventId: Scalars['ID']['output'];
  pollId: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<PollQuestionChoiceResult>>>;
  sessionId: Scalars['ID']['output'];
};

export type SubscribablePollQuestionChoiceResultsByQuestion = {
  __typename?: 'SubscribablePollQuestionChoiceResultsByQuestion';
  eventId: Scalars['ID']['output'];
  pollId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<PollQuestionChoiceResult>>>;
  sessionId: Scalars['ID']['output'];
};

export type SubscribablePollQuestionChoiceResultsBySession = {
  __typename?: 'SubscribablePollQuestionChoiceResultsBySession';
  eventId: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<SubscribablePollQuestionChoiceResultsByPoll>>>;
  sessionId: Scalars['ID']['output'];
};

export type SubscribablePollQuestionStatus = PollQuestionStatusInterface & {
  __typename?: 'SubscribablePollQuestionStatus';
  closedDateTime?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  openedDateTime?: Maybe<Scalars['String']['output']>;
  pollId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
  status: StatusType;
};

export type SubscribablePublishPollsStatus = {
  __typename?: 'SubscribablePublishPollsStatus';
  eventId: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<PublishPollStatus>>>;
  sessionId: Scalars['ID']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe for real time updates to app config */
  ConfigChanged?: Maybe<AppConfig>;
  /** Subscribe to be notified of new device sessions, for a given session id, when they start. */
  NewDeviceSession?: Maybe<ConfigSession>;
  attendeeConnectionsStatusChanged: AttendeeConnectionUpdatedFields;
  /**
   * Subscribe to notifyAttendeeHasChannels mutation
   * so that we connect to the stream client when
   * an attendee first receives a new message
   */
  onAttendeeHasChannels?: Maybe<StreamClientConnectTriggerStatus>;
  onAttendeeHasChannelsV2?: Maybe<StreamClientConnectTriggerStatus>;
  /**
   * Subscribe to live caption updates by sessionId
   * Authorization: Attendees
   */
  onBroadcastLiveCaptions?: Maybe<LiveCaptionsContent>;
  /**
   * Subscribe to publish poll updates
   * Authorization: Attendees
   */
  onPublishPoll: SubscribableAttendeePoll;
  /**
   * Subscribe when a poll is unassigned to a session by planner or when a moderator deleted the poll
   * Authorization: Attendees
   */
  onRemovePoll: SubscribableAttendeePoll;
  /**
   * Subscribe to Planner poll changes
   * Authorization: Planner
   */
  onSavePoll?: Maybe<PlannerPoll>;
  /**
   * Subscribe to studio end session
   * Authorization: Attendees
   */
  onStudioEndSession?: Maybe<StudioEndSessionResponse>;
  onTestManualSubscription?: Maybe<TestSubscription>;
  onTestSubscription?: Maybe<TestSubscription>;
  /**
   * Subscribe to self updates
   * Authorization: Attendees
   */
  onUpdateAttendeeStatus?: Maybe<AttendeeStatus>;
  /**
   * Subscribe to booth staff updates
   * Authorization: Attendees
   */
  onUpdateBoothStaffStatus?: Maybe<BoothStaffStatus>;
  /**
   * Subscribe to Current Question updates for live display
   * Authorization: Live Display & Attendees
   */
  onUpdateLiveDisplayQuestion?: Maybe<CurrentQuestion>;
  /**
   * Subscribe to when a pollAggregation is updated on publishPoll/.
   * Authorization: Attendees
   */
  onUpdatePollAggregation: SubscribableAttendeePoll;
  /**
   * Subscribe to when a question status changes
   * Authorization: Attendee or LiveDisplay
   */
  onUpdatePollQuestionStatus?: Maybe<SubscribablePollQuestionStatus>;
  /**
   * Subscribe receive aggregate responses to a question
   * Client: live-display
   * Authorization: Live Display token
   */
  onUpdatePollResultsByQuestion?: Maybe<SubscribablePollQuestionChoiceResultsByQuestion>;
  /**
   * Subscribe to Question updates (optionally: by Status and attendeeId)
   * Authorization: Attendees
   */
  onUpdateQuestion?: Maybe<Question>;
  /**
   * Subscribe to Reaction updates by sessionId
   * Authorization: Attendees
   */
  onUpdateReactions?: Maybe<ReactionsBroadcastOutput>;
  /**
   * Subscribe to Update Session Settings
   * Authorization: Attendees
   */
  onUpdateSessionSettings?: Maybe<SessionSettings>;
  /**
   * This subscription is triggered by the createMessageReport, resolveMessageReport, or markReportRead mutations.
   * It returns the unread count for moderators that are subscribed to it.
   * The subscribe directive is not used due to additional filtering required.
   */
  onUpdateUnreadCount: ReportPostsUnread;
  /**
   * Subscribe to webcast config status updates (should only be used at the session level)
   * Authorization: Attendees
   */
  onUpdateWebcastConfig?: Maybe<WebcastConfigUpdateResponse>;
  /**
   * Subscribe to webcast livestream status updates
   * Authorization: Attendees
   */
  onUpdateWebcastLiveStatus?: Maybe<LiveStatusUpdateResponse>;
  /** @deprecated pushConfig deprecated, also unused */
  writeConfig?: Maybe<AppConfig>;
};

export type SubscriptionConfigChangedArgs = {
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionNewDeviceSessionArgs = {
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionAttendeeConnectionsStatusChangedArgs = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnAttendeeHasChannelsArgs = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnAttendeeHasChannelsV2Args = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnBroadcastLiveCaptionsArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnPublishPollArgs = {
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnRemovePollArgs = {
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnSavePollArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
};

export type SubscriptionOnStudioEndSessionArgs = {
  sessionId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
};

export type SubscriptionOnTestManualSubscriptionArgs = {
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnTestSubscriptionArgs = {
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateAttendeeStatusArgs = {
  attendeeId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateBoothStaffStatusArgs = {
  exhibitorId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateLiveDisplayQuestionArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdatePollAggregationArgs = {
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdatePollQuestionStatusArgs = {
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdatePollResultsByQuestionArgs = {
  eventId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateQuestionArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<QuestionStatusType>;
};

export type SubscriptionOnUpdateReactionsArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateSessionSettingsArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateUnreadCountArgs = {
  attendeeId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type SubscriptionOnUpdateWebcastConfigArgs = {
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  webcastId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionOnUpdateWebcastLiveStatusArgs = {
  eventId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  webcastId?: InputMaybe<Scalars['ID']['input']>;
};

export type SuccessfulMutationResponse = {
  __typename?: 'SuccessfulMutationResponse';
  success: Scalars['Boolean']['output'];
};

export enum SurveyAudience {
  AllEventRegistrants = 'AllEventRegistrants',
  EventParticipants = 'EventParticipants',
  EventRegistrants = 'EventRegistrants',
  SessionParticipants = 'SessionParticipants',
  SessionRegistrants = 'SessionRegistrants'
}

export enum SurveyTimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export type SystemCard = {
  __typename?: 'SystemCard';
  cardType?: Maybe<Scalars['String']['output']>;
  displayOnHome?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  range?: Maybe<Array<Maybe<Range>>>;
};

export type SystemCardInput = {
  cardType: SystemCardType;
  displayOnHome?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Array<InputMaybe<RangeInput>>>;
};

export enum SystemCardType {
  Appointments = 'APPOINTMENTS',
  Discussions = 'DISCUSSIONS',
  EventAd = 'EVENT_AD',
  FeaturedSessions = 'FEATURED_SESSIONS',
  FeaturedSpeakers = 'FEATURED_SPEAKERS',
  FeaturedSponsors = 'FEATURED_SPONSORS',
  Game = 'GAME',
  HappeningNowUpNext = 'HAPPENING_NOW_UP_NEXT',
  LiveAndUpcoming = 'LIVE_AND_UPCOMING',
  Monetize = 'MONETIZE',
  Notifications = 'NOTIFICATIONS',
  QrCodes = 'QR_CODES',
  QuickLinks = 'QUICK_LINKS',
  Surveys = 'SURVEYS',
  VenueMap = 'VENUE_MAP'
}

export type Tag = {
  __typename?: 'Tag';
  contentTagText: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  lastModifiedBy: Scalars['String']['output'];
  lastModifiedDate: Scalars['String']['output'];
  tagStatusType: Scalars['String']['output'];
  tagStub: Scalars['String']['output'];
};

export enum TagElementType {
  Session = 'Session',
  Speaker = 'Speaker'
}

export type TagSearchCriteria = {
  term?: InputMaybe<Scalars['String']['input']>;
};

export type Tags = {
  __typename?: 'Tags';
  pagination: Pagination;
  tags: Array<Tag>;
};

export type Tax = {
  __typename?: 'Tax';
  taxCode?: Maybe<Scalars['String']['output']>;
  taxId: Scalars['ID']['output'];
  taxName?: Maybe<Scalars['String']['output']>;
  totalTaxAmount?: Maybe<Scalars['Float']['output']>;
};

export type TestSubscription = {
  __typename?: 'TestSubscription';
  eventId: Scalars['ID']['output'];
  result: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum Theme {
  Capital = 'CAPITAL',
  Clean = 'CLEAN',
  Cordial = 'CORDIAL',
  Gather = 'GATHER',
  Serene = 'SERENE',
  Twist = 'TWIST',
  Vigor = 'VIGOR'
}

export enum ThemeFormulaType {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type ThemeSettings = AttendeeHubConfigInterface & {
  __typename?: 'ThemeSettings';
  add1: Scalars['String']['output'];
  add2: Scalars['String']['output'];
  add3: Scalars['String']['output'];
  bodyFont?: Maybe<FontDescriptor>;
  bottomNavMode: BottomNavMode;
  bottomNavigationTheme?: Maybe<BottomNavigationTheme>;
  headingFont?: Maybe<FontDescriptor>;
  icons?: Maybe<IconSettings>;
  illustrations?: Maybe<IllustrationSettings>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  mood?: Maybe<Scalars['String']['output']>;
  preferFormula?: Maybe<ThemeFormulaType>;
  primary: Scalars['String']['output'];
  safeMode?: Maybe<Scalars['Boolean']['output']>;
  secondary: Scalars['String']['output'];
  themeTemplate: Theme;
};

export type ThemeSettingsInput = {
  add1: Scalars['String']['input'];
  add2: Scalars['String']['input'];
  add3: Scalars['String']['input'];
  bodyFont?: InputMaybe<FontDescriptorInput>;
  bottomNavMode: BottomNavMode;
  bottomNavigationTheme?: InputMaybe<BottomNavigationTheme>;
  headingFont?: InputMaybe<FontDescriptorInput>;
  icons?: InputMaybe<IconSettingsInput>;
  illustrations?: InputMaybe<IllustrationSettingsInput>;
  mood?: InputMaybe<Scalars['String']['input']>;
  preferFormula?: InputMaybe<ThemeFormulaType>;
  primary: Scalars['String']['input'];
  safeMode?: InputMaybe<Scalars['Boolean']['input']>;
  secondary: Scalars['String']['input'];
  themeTemplate: Theme;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  endTime: Scalars['AWSDateTime']['output'];
  numberAtCapacity?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['AWSDateTime']['output'];
};

export type TimeRanges = {
  __typename?: 'TimeRanges';
  data: Array<Maybe<TimeRange>>;
};

export enum TimeSettingType {
  Automatic = 'automatic',
  Manual = 'manual'
}

export type TimeSuggestionInput = {
  apptTypeId: Scalars['String']['input'];
  excludeAgendaItemId?: InputMaybe<Scalars['String']['input']>;
  exhibitorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  requesteeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requesterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showUnavailableCount?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Timeframe */
export type Timeframe = {
  end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  start?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type Timeslot = {
  __typename?: 'Timeslot';
  localEndTime: Scalars['AWSDateTime']['output'];
  localStartTime: Scalars['AWSDateTime']['output'];
  utcEndTime: Scalars['AWSDateTime']['output'];
  utcStartTime: Scalars['AWSDateTime']['output'];
};

export type UnblockedAttendee = {
  __typename?: 'UnblockedAttendee';
  wasUnblocked: Scalars['Boolean']['output'];
};

/**
 * Response from Calendar Api returns dynamically keyed objects which cannot be represented directly in graph
 * Transformed the dynamic keyed objects to arrays
 */
export type UpcomingCalendarEntry = {
  __typename?: 'UpcomingCalendarEntry';
  calendarLinkAlternate?: Maybe<Scalars['String']['output']>;
  calendarLinkCompletedEvent?: Maybe<Scalars['String']['output']>;
  calenderLinkDestination?: Maybe<Scalars['ID']['output']>;
  connectionsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDateUtc?: Maybe<Scalars['AWSDateTime']['output']>;
  eventFormat?: Maybe<EventFormat>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inviteeStatus?: Maybe<InviteeStatus>;
  location?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  spanMultiDay?: Maybe<Scalars['Boolean']['output']>;
  startDateUtc?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<EventStatus>;
  tag?: Maybe<Array<CustomFilterFieldTag>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CalendarEventType>;
  venue?: Maybe<Venue>;
  webLinks?: Maybe<WebLinks>;
  websiteStatus?: Maybe<WebsiteStatus>;
};

export type UpcomingEventsCalendar = {
  __typename?: 'UpcomingEventsCalendar';
  config?: Maybe<FilterFieldsConfig>;
  data?: Maybe<Array<Maybe<UpcomingCalendarEntry>>>;
  id?: Maybe<Scalars['ID']['output']>;
  pagination?: Maybe<Pagination>;
};

export type UpcomingEventsFilterField = {
  cventFieldType?: InputMaybe<Scalars['ID']['input']>;
  field?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpcomingEventsPageCriteria = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchId: Scalars['ID']['input'];
};

export type UpcomingEventsPagination = {
  __typename?: 'UpcomingEventsPagination';
  searchId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

/** *@deprecated(reason: "eventFormat will be replaced by eventFormats in the future") */
export type UpcomingEventsSearchCriteria = {
  endTime?: InputMaybe<Scalars['AWSDate']['input']>;
  eventFormat?: InputMaybe<EventFormat>;
  eventFormats?: InputMaybe<Array<EventFormat>>;
  filters?: InputMaybe<Array<UpcomingEventsFilterField>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationFilter?: InputMaybe<LocationFilter>;
  pageCriteria?: InputMaybe<PageCriteria>;
  startTime?: InputMaybe<Scalars['AWSDate']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAllFloorPlansPayload = {
  description?: InputMaybe<Scalars['String']['input']>;
  floorPlanOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  image: ImagePayload;
  isFeatured: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Input Update Availability */
export type UpdateAvailabilityInput = {
  exhibitorId: Scalars['ID']['input'];
  status: Status;
};

export enum UpdateLivestreamStatusResponse {
  Failure = 'FAILURE',
  HostNotStarted = 'HOST_NOT_STARTED',
  InvalidMeeting = 'INVALID_MEETING',
  Success = 'SUCCESS'
}

/** Criteria used to invalidate / refresh live polling response aggregation for an event session */
export type UpdatePollsAggregationInput = {
  eventId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type UpdateResolutionNotesResult = {
  __typename?: 'UpdateResolutionNotesResult';
  entityId: Scalars['ID']['output'];
  entityType: ChatEntityType;
  messageId: Scalars['String']['output'];
  resolutionNotes: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UpdateSpaceInput = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateWebcastConfigInput = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
};

export type UpdateWebcastLiveStatusInput = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  playerId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  streamStatus: PlayerStreamStatus;
  webcastId: Scalars['ID']['input'];
};

export type UrlPath = {
  __typename?: 'UrlPath';
  url?: Maybe<HrefPath>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  admissionItem?: Maybe<AdmissionItem>;
  allowAppointmentPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  allowPushNotifications?: Maybe<Scalars['Boolean']['output']>;
  answers?: Maybe<Array<RegQuestionAnswer>>;
  attendeeFieldCompletion?: Maybe<AttendeeFieldCompletionResult>;
  attendeeHasChannels?: Maybe<AttendeeHasChannels>;
  bio?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use headline instead */
  biography?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Renamed to termsAndConditions */
  consent?: Maybe<AttendeeConsent>;
  contactId?: Maybe<Scalars['ID']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  doNotSell: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  event: Event;
  exhibitorConsentAnswer?: Maybe<ExhibitorConsentAnswer>;
  exhibitorConsentQuestion?: Maybe<ExhibitorConsentQuestion>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  guest: Scalars['Boolean']['output'];
  /**
   * Headline is the new name for 'biography' (200 characters max)
   * Bio is used for a longer biography (2500 characters max)
   */
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  permissions: Permissions;
  preferences: Array<AttendeePreference>;
  prefix?: Maybe<Scalars['String']['output']>;
  professionalInterests?: Maybe<Array<AttendeeInterestComparisonResult>>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<AttendeeConsent>;
  title?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NamedObject>;
  virtual: Scalars['Boolean']['output'];
  /** Use event default when visibility is null */
  visibility?: Maybe<AttendeeVisibility>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type UserAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserConsentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserExhibitorConsentQuestionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserTermsAndConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum ValidTheme {
  Add1 = 'ADD1',
  Add2 = 'ADD2',
  Add3 = 'ADD3',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VenueMapSettings = AttendeeHubConfigInterface & {
  __typename?: 'VenueMapSettings';
  imageName?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrlOptimized?: Maybe<Scalars['String']['output']>;
  lastModifiedDate: Scalars['AWSDateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type VenueMapSettingsInput = {
  imageName?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Video = {
  __typename?: 'Video';
  duration?: Maybe<Scalars['Int']['output']>;
  generatedThumbnail?: Maybe<UrlPath>;
  id: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type VideoActivityInput = {
  elapsedPlayTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  entity: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
};

export enum VideoAssociationEntityType {
  Exhibitor = 'EXHIBITOR',
  Session = 'SESSION'
}

export type VideoPlaybackDetails = {
  __typename?: 'VideoPlaybackDetails';
  poster?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  textTracks?: Maybe<Array<Maybe<VideoTextTrack>>>;
  ttl?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type VideoPlaybackDetailsForDryRun = {
  __typename?: 'VideoPlaybackDetailsForDryRun';
  textTracks?: Maybe<Array<VideoTextTrack>>;
  url: Scalars['String']['output'];
};

export enum VideoStatus {
  Available = 'Available',
  Error = 'Error',
  ReSyncing = 'ReSyncing',
  Rejected = 'Rejected',
  Scanned = 'Scanned',
  Scanning = 'Scanning',
  Started = 'Started',
  Syncing = 'Syncing',
  Upcoming = 'Upcoming',
  Uploaded = 'Uploaded'
}

export type VideoTextTrack = {
  __typename?: 'VideoTextTrack';
  default: Scalars['Boolean']['output'];
  kind: VideoTextTrackKind;
  label?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastModified: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum VideoTextTrackKind {
  Captions = 'captions',
  Chapters = 'chapters',
  Descriptions = 'descriptions',
  Metadata = 'metadata',
  Subtitles = 'subtitles'
}

export type VideoWithRenditions = {
  __typename?: 'VideoWithRenditions';
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  encodingProfile?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Scalars['ID']['output']>>;
  filename: Scalars['String']['output'];
  generatedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  renditions?: Maybe<Array<Rendition>>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  url: HrefPath;
};

export enum VirtualMeetingSolution {
  AwsChime = 'AWS_CHIME',
  Cvc = 'CVC'
}

/** Visibility for a setting on planner side */
export enum Visibility {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Hidden = 'HIDDEN'
}

/** WebConfig model. Defines the themeing for attendee website */
export type WebConfig = {
  __typename?: 'WebConfig';
  additionalColor1?: Maybe<Scalars['String']['output']>;
  additionalColor2?: Maybe<Scalars['String']['output']>;
  additionalColor3?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['AWSURL']['output']>;
  coverImageAltText?: Maybe<Scalars['String']['output']>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  coverImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  defaultProfileVisibility: Scalars['Boolean']['output'];
  footerImage?: Maybe<Scalars['AWSURL']['output']>;
  footerImageAltText?: Maybe<Scalars['String']['output']>;
  footerImageId?: Maybe<Scalars['String']['output']>;
  footerImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  headerImage?: Maybe<Scalars['AWSURL']['output']>;
  headerImageAltText?: Maybe<Scalars['String']['output']>;
  headerImageId?: Maybe<Scalars['String']['output']>;
  headerImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  loginBackgroundImage?: Maybe<Scalars['AWSURL']['output']>;
  loginBackgroundImageAltText?: Maybe<Scalars['String']['output']>;
  loginBackgroundImageId?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['AWSURL']['output']>;
  logoImageAltText?: Maybe<Scalars['String']['output']>;
  logoImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  manageProfileEnabled: Scalars['Boolean']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  secondaryHeaderImage?: Maybe<Scalars['AWSURL']['output']>;
  secondaryHeaderImageAltText?: Maybe<Scalars['String']['output']>;
  secondaryHeaderImageId?: Maybe<Scalars['String']['output']>;
  secondaryHeaderImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
  sessionHeaderImage?: Maybe<Scalars['AWSURL']['output']>;
  sessionHeaderImageAltText?: Maybe<Scalars['String']['output']>;
  sessionHeaderImageId?: Maybe<Scalars['String']['output']>;
  sessionHeaderImageOptimized?: Maybe<Scalars['AWSURL']['output']>;
};

export type WebLinks = {
  __typename?: 'WebLinks';
  agenda?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type Webcast = {
  __typename?: 'Webcast';
  details?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['ID']['output'];
  format?: Maybe<WebcastFormat>;
  id: Scalars['ID']['output'];
  isOnDemandContentPlayable?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<WebcastLinks>;
  meetingId?: Maybe<Scalars['ID']['output']>;
  onDemandVideo?: Maybe<Scalars['Boolean']['output']>;
  player?: Maybe<WebcastPlayer>;
  playerType?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
  simulatedLive?: Maybe<Scalars['Boolean']['output']>;
  solutionType?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type WebcastConfigUpdateResponse = {
  __typename?: 'WebcastConfigUpdateResponse';
  eventId?: Maybe<Scalars['ID']['output']>;
  sessionId: Scalars['ID']['output'];
  webcastId: Scalars['ID']['output'];
};

export enum WebcastFormat {
  Live = 'Live',
  PreRecorded = 'Pre_recorded'
}

export type WebcastId = {
  __typename?: 'WebcastId';
  id?: Maybe<Scalars['ID']['output']>;
};

export type WebcastLink = {
  __typename?: 'WebcastLink';
  code?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
};

export type WebcastLinks = {
  __typename?: 'WebcastLinks';
  attendee?: Maybe<WebcastLink>;
  host?: Maybe<WebcastLink>;
  join?: Maybe<WebcastLink>;
  recording?: Maybe<WebcastLink>;
  speaker?: Maybe<WebcastLink>;
};

export type WebcastPlayer = {
  __typename?: 'WebcastPlayer';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  playerTypeProvider?: Maybe<Scalars['String']['output']>;
  simuliveOffset?: Maybe<Scalars['Int']['output']>;
  stream?: Maybe<PlayerStream>;
  videoId?: Maybe<Scalars['ID']['output']>;
  videoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  webcast?: Maybe<WebcastId>;
};

export type WebcastSignature = {
  __typename?: 'WebcastSignature';
  signature: Scalars['String']['output'];
  signatureExpirationDate: Scalars['AWSDateTime']['output'];
};

export type WebcastSignatureInput = {
  role?: InputMaybe<Role>;
  signatureTTLInSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export enum WebsiteStatus {
  Archived = 'ARCHIVED',
  Launched = 'LAUNCHED',
  NotEnabled = 'NOT_ENABLED',
  NotLaunched = 'NOT_LAUNCHED',
  Undefined = 'UNDEFINED'
}

export type Widget = {
  __typename?: 'Widget';
  assignedSessions?: Maybe<Array<AssignedSession>>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type WidgetSessionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

/** Models */
export type Widgets = {
  __typename?: 'Widgets';
  pagination?: Maybe<Pagination>;
  widgets?: Maybe<Array<Widget>>;
};

export type XyCoordinates = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Returns true or false if sessions and speakers exist or not */
export type DefaultPagesInfo = {
  __typename?: 'defaultPagesInfo';
  containsSessions: Scalars['Boolean']['output'];
  containsSpeakers: Scalars['Boolean']['output'];
};

/** Returns true or false if exhibitors and sponsors exist or not */
export type ExhibitorsInfo = {
  __typename?: 'exhibitorsInfo';
  containsExhibitors: Scalars['Boolean']['output'];
  containsSponsors: Scalars['Boolean']['output'];
};

export type ImageAsset = {
  __typename?: 'imageAsset';
  altText?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['ID']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  assetUri?: Maybe<Scalars['String']['output']>;
  assetUriOptimized?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isSecure?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  thumbnailImageUri?: Maybe<Scalars['String']['output']>;
  thumbnailImageUriOptimized?: Maybe<Scalars['String']['output']>;
};

export type MeetingInviteeStatusChangedInput = {
  inviteeStatusUpdates?: InputMaybe<Array<InputMaybe<MeetingInviteeStatusUpdate>>>;
  meetingId: Scalars['ID']['input'];
  meetingMetadata: Array<InputMaybe<StringTupleInput>>;
  status: MeetingStatus;
};

export type MeetingInviteeStatusChangedResponse = {
  __typename?: 'meetingInviteeStatusChangedResponse';
  inviteeStatusNotificationResults?: Maybe<Array<Maybe<MeetingInviteeStatusNotificationResult>>>;
};

export type MeetingInviteeStatusNotificationResult = {
  __typename?: 'meetingInviteeStatusNotificationResult';
  boothStaffBroadcast: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<Status>;
};

export type MeetingInviteeStatusUpdate = {
  id: Scalars['ID']['input'];
  isRequester: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Array<InputMaybe<StringTupleInput>>>;
  status?: InputMaybe<Status>;
};

export type MeetingRequestResponseInput = {
  exhibitorId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
  status: InviteeMeetingStatus;
};

export type PagingInfo = {
  __typename?: 'pagingInfo';
  currentToken?: Maybe<Scalars['ID']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Input request to prepareRespondent */
export type PrepareRespondentsRequest = {
  eventId: Scalars['ID']['input'];
  pollIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sessionId: Scalars['ID']['input'];
};

export type PrepareRespondentsResponse = {
  __typename?: 'prepareRespondentsResponse';
  pollsWithRespondents?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  pollsWithoutRespondents?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type PublishPollStatus = {
  __typename?: 'publishPollStatus';
  pollId: Scalars['ID']['output'];
  status?: Maybe<PublishStatus>;
};

export type RequestMeetingInput = {
  boothStaffId: Scalars['ID']['input'];
  exhibitorId: Scalars['ID']['input'];
};

export type SubscriptionTokenMutationVariables = Exact<{ [key: string]: never }>;

export type SubscriptionTokenMutation = {
  __typename?: 'Mutation';
  subscriptionToken?: { __typename?: 'OneTimeToken'; token: string } | null;
};

export type Event_Info_For_ErrorQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type Event_Info_For_ErrorQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    title?: string | null;
    defaultLocale?: string | null;
    eventInfoTheme: {
      __typename?: 'EventInfoTheme';
      primary: string;
      secondary: string;
      background: string;
      mood: string;
      safeMode?: boolean | null;
      preferFormula?: ThemeFormulaType | null;
      illustrations?: { __typename?: 'IllustrationSettings'; hideAll?: boolean | null } | null;
      icons?: {
        __typename?: 'IconSettings';
        pack?: string | null;
        reassignedIcons?: Array<{ __typename?: 'ReassignedIcon'; name: string; reassignment: string }> | null;
      } | null;
      headingFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
      bodyFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
    };
  };
};

export type Get_UpgradableadmissionitemsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_UpgradableadmissionitemsQuery = {
  __typename?: 'Query';
  getUpgradableAdmissionItems?: Array<{
    __typename?: 'AdmissionItem';
    id: string;
    code?: string | null;
    name: string;
    description?: string | null;
    amount?: number | null;
  }> | null;
};

export type On_Broadcast_Live_CaptionsSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
}>;

export type On_Broadcast_Live_CaptionsSubscription = {
  __typename?: 'Subscription';
  onBroadcastLiveCaptions?: {
    __typename?: 'LiveCaptionsContent';
    sessionId: string;
    eventId: string;
    environment?: string | null;
    version: string;
    startTimeMs: number;
    endTimeMs: number;
    isPartial: boolean;
    languages: Array<{
      __typename?: 'LiveCaptionsLanguage';
      languageCode: string;
      words: Array<{
        __typename?: 'LiveCaptionsWord';
        text: string;
        startTimeMs: number;
        endTimeMs: number;
        isPunctuation: boolean;
      }>;
    }>;
  } | null;
};

export type RegisterMutationVariables = Exact<{
  input: RegisterAttendeeInput;
}>;

export type RegisterMutation = { __typename?: 'Mutation'; registerAttendee: boolean };

export type Sign_Up_Event_InfoQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type Sign_Up_Event_InfoQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    title?: string | null;
    defaultLocale?: string | null;
    faviconUrl?: string | null;
    status?: EventStatus | null;
    isPublished?: boolean | null;
    locales?: Array<{
      __typename?: 'EventLocale';
      localeId: number;
      languageName: string;
      languageCountry: string;
      isDefault: boolean;
      cultureCode: string;
    }> | null;
    eventInfoTheme: {
      __typename?: 'EventInfoTheme';
      loginBackgroundImage?: string | null;
      loginBackgroundImageAltText?: string | null;
      primary: string;
      secondary: string;
      background: string;
      mood: string;
      safeMode?: boolean | null;
      preferFormula?: ThemeFormulaType | null;
      illustrations?: { __typename?: 'IllustrationSettings'; hideAll?: boolean | null } | null;
      icons?: {
        __typename?: 'IconSettings';
        pack?: string | null;
        reassignedIcons?: Array<{ __typename?: 'ReassignedIcon'; name: string; reassignment: string }> | null;
      } | null;
      headingFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
      bodyFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
    };
    ccpaData: { __typename?: 'CCPAData'; ccpaExternalDoNotSellUrl?: string | null };
    cventPrivacyPolicy?: {
      __typename?: 'CventPrivacyPolicy';
      showCventPrivacyPolicy?: boolean | null;
      cventPrivacyPolicyLinkText?: string | null;
    } | null;
    eventPrivacyPolicy?: {
      __typename?: 'EventPrivacyPolicy';
      showPrivacyPolicy?: boolean | null;
      privacyPolicyUrl?: string | null;
      privacyPolicyLinkText?: string | null;
    } | null;
  };
};

export type Get_Promoted_Events_CalendarQueryVariables = Exact<{
  criteria?: InputMaybe<UpcomingEventsSearchCriteria>;
}>;

export type Get_Promoted_Events_CalendarQuery = {
  __typename?: 'Query';
  promotedEventsCalendar?: {
    __typename?: 'UpcomingEventsCalendar';
    data?: Array<{
      __typename?: 'UpcomingCalendarEntry';
      id: string;
      image?: string | null;
      parentId?: string | null;
      type?: CalendarEventType | null;
      description?: string | null;
      location?: string | null;
      startDateUtc?: any | null;
      endDateUtc?: any | null;
      calendarLinkAlternate?: string | null;
      calenderLinkDestination?: string | null;
      calendarLinkCompletedEvent?: string | null;
      connectionsCount: number;
      title?: string | null;
      websiteStatus?: WebsiteStatus | null;
      timeZone?: string | null;
      spanMultiDay?: boolean | null;
      eventFormat?: EventFormat | null;
      webLinks?: {
        __typename?: 'WebLinks';
        registration?: string | null;
        invitation?: string | null;
        agenda?: string | null;
        summary?: string | null;
      } | null;
      venue?: {
        __typename?: 'Venue';
        address?: {
          __typename?: 'Address';
          address1?: string | null;
          address2?: string | null;
          address3?: string | null;
          city?: string | null;
          region?: string | null;
          regionCode?: string | null;
          postalCode?: string | null;
          country?: string | null;
          countryCode?: string | null;
        } | null;
      } | null;
      tag?: Array<{ __typename?: 'CustomFilterFieldTag'; id?: string | null; values?: Array<string> | null }> | null;
    } | null> | null;
  } | null;
};

export type Get_Upcoming_Events_CalendarQueryVariables = Exact<{
  criteria?: InputMaybe<UpcomingEventsSearchCriteria>;
}>;

export type Get_Upcoming_Events_CalendarQuery = {
  __typename?: 'Query';
  upcomingEventsCalendar?: {
    __typename?: 'UpcomingEventsCalendar';
    config?: {
      __typename?: 'FilterFieldsConfig';
      filterFields?: Array<{
        __typename?: 'CalendarEventsFilterFields';
        id?: string | null;
        typeId?: string | null;
        sequence?: number | null;
        name?: string | null;
        resourceKey?: string | null;
        isCustomField?: boolean | null;
        options?: Array<{
          __typename?: 'CustomFilterOptions';
          id?: string | null;
          name?: string | null;
          resourceKey?: string | null;
        }> | null;
      }> | null;
    } | null;
    pagination?: { __typename?: 'Pagination'; totalCount: number; nextToken?: string | null } | null;
    data?: Array<{
      __typename?: 'UpcomingCalendarEntry';
      id: string;
      image?: string | null;
      parentId?: string | null;
      type?: CalendarEventType | null;
      description?: string | null;
      location?: string | null;
      startDateUtc?: any | null;
      endDateUtc?: any | null;
      calendarLinkAlternate?: string | null;
      calenderLinkDestination?: string | null;
      calendarLinkCompletedEvent?: string | null;
      connectionsCount: number;
      title?: string | null;
      websiteStatus?: WebsiteStatus | null;
      timeZone?: string | null;
      spanMultiDay?: boolean | null;
      eventFormat?: EventFormat | null;
      webLinks?: {
        __typename?: 'WebLinks';
        registration?: string | null;
        invitation?: string | null;
        agenda?: string | null;
        summary?: string | null;
      } | null;
      venue?: {
        __typename?: 'Venue';
        address?: {
          __typename?: 'Address';
          address1?: string | null;
          address2?: string | null;
          address3?: string | null;
          city?: string | null;
          region?: string | null;
          regionCode?: string | null;
          postalCode?: string | null;
          country?: string | null;
          countryCode?: string | null;
        } | null;
      } | null;
      tag?: Array<{ __typename?: 'CustomFilterFieldTag'; values?: Array<string> | null }> | null;
    } | null> | null;
  } | null;
};

export type Event_Ad_SettingsQueryVariables = Exact<{ [key: string]: never }>;

export type Event_Ad_SettingsQuery = {
  __typename?: 'Query';
  eventAdSettingsForAttendee?: {
    __typename?: 'AdLocationSettings';
    locations: Array<{
      __typename?: 'AdLocationSetting';
      location: AdLocation;
      enabled: boolean;
      adFrequency?: number | null;
      numberOfPlacements?: number | null;
    }>;
  } | null;
};

export type Update_Personal_TimeMutationVariables = Exact<{
  personalTimeId: Scalars['ID']['input'];
  data: CreatePersonalTimeInput;
}>;

export type Update_Personal_TimeMutation = {
  __typename?: 'Mutation';
  updatePersonalTime?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
  } | null;
};

export type Accept_AppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type Accept_AppointmentMutation = {
  __typename?: 'Mutation';
  acceptAppointment?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
    impactedAgendaItems?: Array<{ __typename?: 'ImpactedAgendaItem'; id: string }> | null;
  } | null;
};

export type Appointment_TypesQueryVariables = Exact<{
  params?: InputMaybe<ApptTypesInput>;
}>;

export type Appointment_TypesQuery = {
  __typename?: 'Query';
  getAppointmentTypes?: {
    __typename?: 'AppointmentTypes';
    data: Array<{
      __typename?: 'AppointmentType';
      id: string;
      name: string;
      category: string;
      description?: string | null;
      timeSlotType: string;
      needsPlannerApproval?: boolean | null;
      requireRequestees?: boolean | null;
      allowBoothStaffCreate: boolean;
      virtualMeetingSolution?: VirtualMeetingSolution | null;
      confirmRequesters?: boolean | null;
      hideAttendeesFlag?: boolean | null;
      includeBooth: boolean;
      autoAccept?: boolean | null;
      attendeeRole: string;
      requesterQuestions: Array<{
        __typename?: 'ApptQuestion';
        question: {
          __typename?: 'QuestionInfo';
          id: string;
          text: string;
          required: boolean;
          questionTypeInfo: {
            __typename?: 'QuestionTypeInfo';
            questionType: string;
            answerFormatType?: string | null;
            scores: Array<string | null>;
            displayFormatTypeId?: string | null;
            displayType?: string | null;
            min?: number | null;
            max?: number | null;
            minDate?: string | null;
            maxDate?: string | null;
            choices?: Array<{ __typename?: 'Choice'; id: string; text?: string | null } | null> | null;
            otherAnswer?: { __typename?: 'OtherAnswerMetadata'; text?: string | null } | null;
          };
        };
      } | null>;
      requesteeQuestions: Array<{
        __typename?: 'ApptQuestion';
        question: {
          __typename?: 'QuestionInfo';
          id: string;
          text: string;
          required: boolean;
          questionTypeInfo: {
            __typename?: 'QuestionTypeInfo';
            questionType: string;
            answerFormatType?: string | null;
            scores: Array<string | null>;
            displayFormatTypeId?: string | null;
            displayType?: string | null;
            min?: number | null;
            max?: number | null;
            minDate?: string | null;
            maxDate?: string | null;
            choices?: Array<{ __typename?: 'Choice'; id: string; text?: string | null } | null> | null;
            otherAnswer?: { __typename?: 'OtherAnswerMetadata'; text?: string | null } | null;
          };
        };
      } | null>;
    } | null>;
  } | null;
};

export type Appt_Event_AttendeesQueryVariables = Exact<{
  params: FilterApptEventAttendeesInput;
}>;

export type Appt_Event_AttendeesQuery = {
  __typename?: 'Query';
  getApptEventAttendees?: {
    __typename?: 'ApptEventAttendees';
    attendees?: Array<{
      __typename?: 'ApptEventAttendee';
      inviteeStub: string;
      firstName?: string | null;
      lastName?: string | null;
      isTeamMember?: boolean | null;
      title?: string | null;
      company?: string | null;
      isColleague?: boolean | null;
      exhibitorId?: string | null;
    } | null> | null;
  } | null;
};

export type Availability_By_Time_RangeQueryVariables = Exact<{
  params: AvailabilityByTimeRangeInput;
}>;

export type Availability_By_Time_RangeQuery = {
  __typename?: 'Query';
  getAvailabilityByTimeRange?: Array<{
    __typename?: 'Availability';
    attendeeId: string;
    status?: string | null;
    isAtLimit: boolean;
  } | null> | null;
};

export type Available_LocationsQueryVariables = Exact<{
  params: AvailableLocationsInput;
}>;

export type Available_LocationsQuery = {
  __typename?: 'Query';
  getAvailableLocations?: Array<{
    __typename?: 'AvailableLocation';
    id: string;
    displayName?: string | null;
    capacityPerAppointment: number;
    isConsolidated: boolean;
    hasDelayAssignment?: boolean | null;
  } | null> | null;
};

export type Available_TimesQueryVariables = Exact<{
  params: TimeSuggestionInput;
}>;

export type Available_TimesQuery = {
  __typename?: 'Query';
  getAvailableTimes?: {
    __typename?: 'TimeRanges';
    data: Array<{ __typename?: 'TimeRange'; startTime: any; endTime: any; numberAtCapacity?: number | null } | null>;
  } | null;
};

export type Cancel_AppointmentMutationVariables = Exact<{
  params: CancelDeclineApptInput;
}>;

export type Cancel_AppointmentMutation = { __typename?: 'Mutation'; cancelAppointment?: boolean | null };

export type Checkin_AppointmentMutationVariables = Exact<{
  params: CheckinApptInput;
}>;

export type Checkin_AppointmentMutation = {
  __typename?: 'Mutation';
  checkinAppointment?: {
    __typename?: 'Appointment';
    id: string;
    name: string;
    description?: string | null;
    startTime: any;
    endTime: any;
    apptEventId?: string | null;
    code?: string | null;
    status: string;
    appointmentStatus: string;
    apptConfirmationStatus?: string | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    virtualLink?: string | null;
    createdBy?: string | null;
    createdOn?: string | null;
    lastModifiedOn?: string | null;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      contactId: string;
      inviteeStub: string;
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      deleted?: boolean | null;
    } | null> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      contactId: string;
      inviteeStub: string;
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      deleted?: boolean | null;
    } | null> | null;
  } | null;
};

export type Create_AppointmentMutationVariables = Exact<{
  data: CreateApptInput;
}>;

export type Create_AppointmentMutation = {
  __typename?: 'Mutation';
  createAppointment?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
  } | null;
};

export type Create_Personal_TimeMutationVariables = Exact<{
  data: CreatePersonalTimeInput;
}>;

export type Create_Personal_TimeMutation = {
  __typename?: 'Mutation';
  createPersonalTime?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
  } | null;
};

export type Decline_AppointmentMutationVariables = Exact<{
  params: CancelDeclineApptInput;
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type Decline_AppointmentMutation = { __typename?: 'Mutation'; declineAppointment?: boolean | null };

export type Delete_Personal_TimeMutationVariables = Exact<{
  personalTimeId: Scalars['ID']['input'];
}>;

export type Delete_Personal_TimeMutation = {
  __typename?: 'Mutation';
  deletePersonalTime?: { __typename?: 'PersonalTimeDeleteResponse'; id: string; isDeleted: boolean } | null;
};

export type Exhibitor_Booth_Staff_AttendeesQueryVariables = Exact<{
  params: FilterExhibitorBoothStaffAttendeesInput;
}>;

export type Exhibitor_Booth_Staff_AttendeesQuery = {
  __typename?: 'Query';
  getExhibitorBoothStaffAttendees?: {
    __typename?: 'ApptEventAttendees';
    searchId?: string | null;
    totalCount?: number | null;
    attendees?: Array<{
      __typename?: 'ApptEventAttendee';
      apptEventId: string;
      canRequest?: boolean | null;
      company?: string | null;
      exhibitorId?: string | null;
      firstName?: string | null;
      inviteeStub: string;
      isBoothStaff?: boolean | null;
      isColleague?: boolean | null;
      isTeamMember?: boolean | null;
      lastName?: string | null;
      title?: string | null;
    } | null> | null;
  } | null;
};

export type Exhibitor_InfoQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Exhibitor_InfoQuery = {
  __typename?: 'Query';
  getExhibitorInfo?: { __typename?: 'ExhibitorInfo'; id?: string | null; name?: string | null } | null;
};

export type Exhibitors_With_Booth_LocationQueryVariables = Exact<{
  params: ExhibitorsBoothLocationInput;
}>;

export type Exhibitors_With_Booth_LocationQuery = {
  __typename?: 'Query';
  getExhibitorsWithBoothLocation?: {
    __typename?: 'ExhibitorBoothLocations';
    data: Array<{
      __typename?: 'ExhibitorBoothLocation';
      exhibitorId: string;
      name?: string | null;
      boothLocation?: string | null;
      staffInviteeIds: Array<string>;
    } | null>;
  } | null;
};

export type Get_AppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  fetchLocationAtLimit: Scalars['Boolean']['input'];
}>;

export type Get_AppointmentQuery = {
  __typename?: 'Query';
  getAppointment?: {
    __typename?: 'Appointment';
    id: string;
    name: string;
    description?: string | null;
    appointmentStatus: string;
    apptTypeId: string;
    startTime: any;
    endTime: any;
    status: string;
    virtualLink?: string | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    isPlannerCreated?: boolean | null;
    parentLocationId?: string | null;
    locationId?: string | null;
    exhibitorId?: string | null;
    createdBy?: string | null;
    createdOn?: string | null;
    requesterAnswersViewers?: Array<string | null> | null;
    otherOrganizationCount?: number | null;
    isAutoAcceptAttendees?: boolean | null;
    isEnforceScheduleRules?: boolean | null;
    selectedBoothId?: string | null;
    boothLocationName?: string | null;
    privateNote?: string | null;
    privateNoteViewers?: Array<string | null> | null;
    isLocationAtLimit?: boolean | null;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      contactId: string;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    } | null> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      contactId: string;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
      isColleague?: boolean | null;
    } | null> | null;
    actions?: {
      __typename?: 'AppointmentActions';
      canEdit?: boolean | null;
      canCancel?: boolean | null;
      canAccept?: boolean | null;
      canDecline?: boolean | null;
      canProposeNewTime?: boolean | null;
      canAddPrivateNotes?: boolean | null;
      canCheckIn?: boolean | null;
      canUndoCheckIn?: boolean | null;
    } | null;
    requesterAnswers?: Array<{
      __typename?: 'AppointmentAnswer';
      questionId: string;
      answers?: Array<{
        __typename?: 'Answer';
        decimalValue?: number | null;
        longValue?: string | null;
        choice?: string | null;
        choiceId?: string | null;
        text?: string | null;
        answerType: string;
      } | null> | null;
    } | null> | null;
    requesteeAnswers?: Array<{
      __typename?: 'AppointmentAnswer';
      questionId: string;
      answers?: Array<{
        __typename?: 'Answer';
        decimalValue?: number | null;
        longValue?: string | null;
        choice?: string | null;
        choiceId?: string | null;
        text?: string | null;
        answerType: string;
      } | null> | null;
    } | null> | null;
    apptType: {
      __typename?: 'AppointmentType';
      category: string;
      timeSlotType: string;
      id: string;
      name: string;
      description?: string | null;
      needsPlannerApproval?: boolean | null;
      allowBoothStaffCreate: boolean;
      requireRequestees?: boolean | null;
      virtualMeetingSolution?: VirtualMeetingSolution | null;
      confirmRequesters?: boolean | null;
      hideAttendeesFlag?: boolean | null;
      includeBooth: boolean;
      autoAccept?: boolean | null;
      requesterQuestions: Array<{
        __typename?: 'ApptQuestion';
        question: {
          __typename?: 'QuestionInfo';
          id: string;
          text: string;
          required: boolean;
          questionTypeInfo: {
            __typename?: 'QuestionTypeInfo';
            questionType: string;
            answerFormatType?: string | null;
            scores: Array<string | null>;
            displayFormatTypeId?: string | null;
            displayType?: string | null;
            min?: number | null;
            max?: number | null;
            minDate?: string | null;
            maxDate?: string | null;
            choices?: Array<{ __typename?: 'Choice'; id: string; text?: string | null } | null> | null;
            otherAnswer?: { __typename?: 'OtherAnswerMetadata'; text?: string | null } | null;
          };
        };
      } | null>;
      requesteeQuestions: Array<{
        __typename?: 'ApptQuestion';
        question: {
          __typename?: 'QuestionInfo';
          id: string;
          text: string;
          required: boolean;
          questionTypeInfo: {
            __typename?: 'QuestionTypeInfo';
            questionType: string;
            answerFormatType?: string | null;
            scores: Array<string | null>;
            displayFormatTypeId?: string | null;
            displayType?: string | null;
            min?: number | null;
            max?: number | null;
            minDate?: string | null;
            maxDate?: string | null;
            choices?: Array<{ __typename?: 'Choice'; id: string; text?: string | null } | null> | null;
            otherAnswer?: { __typename?: 'OtherAnswerMetadata'; text?: string | null } | null;
          };
        };
      } | null>;
    };
  } | null;
};

export type Get_Appointment_Agenda_ItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type Get_Appointment_Agenda_ItemQuery = {
  __typename?: 'Query';
  getAppointmentAgendaItem?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
  } | null;
};

export type Get_Personal_TimesQueryVariables = Exact<{
  params: PersonalTimeInput;
}>;

export type Get_Personal_TimesQuery = {
  __typename?: 'Query';
  getPersonalTimes?: Array<{
    __typename?: 'PersonalTime';
    id: string;
    name: string;
    description?: string | null;
    startTime: any;
    endTime: any;
    canDelete?: boolean | null;
  } | null> | null;
};

export type Get_Potential_ConflictsQueryVariables = Exact<{
  params: PotentialConflictsInput;
}>;

export type Get_Potential_ConflictsQuery = {
  __typename?: 'Query';
  getPotentialConflicts?: {
    __typename?: 'PotentialConflictsInfo';
    paging?: { __typename?: 'pagingInfo'; totalCount?: number | null; currentToken?: string | null } | null;
    data?: Array<{
      __typename?: 'ConflictingAgendaItems';
      id: string;
      name: string;
      start: any;
      end: any;
      conflictType: AgendaItemType;
    }> | null;
  } | null;
};

export type Get_Pre_Accept_ValidationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type Get_Pre_Accept_ValidationQuery = {
  __typename?: 'Query';
  getPreAcceptValidation?: {
    __typename?: 'PreAcceptValidationResponse';
    acceptValidation?: AcceptValidation | null;
  } | null;
};

export type Get_Proposed_TimesQueryVariables = Exact<{
  apptId: Scalars['ID']['input'];
}>;

export type Get_Proposed_TimesQuery = {
  __typename?: 'Query';
  getProposedTimes?: Array<{
    __typename?: 'ApptProposedTime';
    inviteeStub: string;
    startTime: any;
    endTime: any;
    comments?: string | null;
    locationStub?: string | null;
    locationName?: string | null;
  } | null> | null;
};

export type Get_Self_Attendee_InfoQueryVariables = Exact<{ [key: string]: never }>;

export type Get_Self_Attendee_InfoQuery = {
  __typename?: 'Query';
  getSelfAttendeeInfo?: { __typename?: 'AppointmentAttendeeInfo'; code: string } | null;
};

export type Has_Appointment_TypesQueryVariables = Exact<{ [key: string]: never }>;

export type Has_Appointment_TypesQuery = { __typename?: 'Query'; hasAppointmentTypes?: boolean | null };

export type Propose_New_TimeMutationVariables = Exact<{
  params: ProposeNewTimeInput;
}>;

export type Propose_New_TimeMutation = {
  __typename?: 'Mutation';
  proposeNewTime?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
  } | null;
};

export type Requestable_ExhibitorsQueryVariables = Exact<{
  params: RequestableExhibitorsInput;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Requestable_ExhibitorsQuery = {
  __typename?: 'Query';
  getRequestableExhibitors?: {
    __typename?: 'RequestableExhibitors';
    data: Array<{ __typename?: 'Exhibitor'; id: string; name: string } | null>;
  } | null;
};

export type Update_AppointmentMutationVariables = Exact<{
  data: CreateApptInput;
}>;

export type Update_AppointmentMutation = {
  __typename?: 'Mutation';
  updateAppointment?: {
    __typename?: 'AgendaItem';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    status?: AppointmentConfirmationStatus | null;
    enrolled?: boolean | null;
    included?: boolean | null;
    virtual?: boolean | null;
    virtualLink?: string | null;
    openForRegistration?: boolean | null;
    featured?: boolean | null;
    type: AgendaItemType;
    openForAttendeeHub?: boolean | null;
    appointmentStatus?: ApptStatus | null;
    parentLocationDisplayName?: string | null;
    locationDisplayName?: string | null;
    conflict?: boolean | null;
    category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
    location?: {
      __typename?: 'SessionLocation';
      id?: string | null;
      name?: string | null;
      code?: string | null;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoUrl?: string | null;
      featured?: boolean | null;
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      player?: {
        __typename?: 'WebcastPlayer';
        videoId?: string | null;
        videoUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
      } | null;
      links?: {
        __typename?: 'WebcastLinks';
        recording?: { __typename?: 'WebcastLink'; href?: string | null } | null;
      } | null;
    } | null;
    participants: Array<{
      __typename?: 'AppointmentParticipant';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    requesters?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    requestees?: Array<{
      __typename?: 'ApptAttendee';
      firstName: string;
      lastName: string;
      status: ApptAttendeeStatus;
      attendance?: ApptAttendeeAttendance | null;
      inviteeStub: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    }> | null;
    apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
    availableAttendeeActions?: {
      __typename?: 'AppointmentAttendeeActions';
      accept?: boolean | null;
      decline?: boolean | null;
    } | null;
  } | null;
};

export type Dismiss_Attendee_RecommendationMutationVariables = Exact<{
  input: DismissAttendeeRecommendationInput;
}>;

export type Dismiss_Attendee_RecommendationMutation = {
  __typename?: 'Mutation';
  dismissAttendeeRecommendation?: boolean | null;
};

export type Get_AttendeeQueryVariables = Exact<{
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_AttendeeQuery = {
  __typename?: 'Query';
  getAttendee?: {
    __typename?: 'Attendee';
    id: string;
    firstName: string;
    lastName: string;
    title?: string | null;
    company?: string | null;
    profilePicture?: string | null;
    prefix?: string | null;
    designation?: string | null;
    biography?: string | null;
    facebookUrl?: string | null;
    linkedInUrl?: string | null;
    twitterUrl?: string | null;
    visibility?: string | null;
    contactId?: string | null;
    canMeet: boolean;
    websiteUrl?: string | null;
    guest?: boolean | null;
    connectionStatus: AttendeeConnectionStatus;
    player?: {
      __typename?: 'Player';
      id?: string | null;
      leaderboardOptOut?: boolean | null;
      totalScore?: number | null;
      rank?: number | null;
      progress?: Array<{
        __typename?: 'AchievementProgress';
        achievementId: string;
        achievementName: string;
        level?: number | null;
        totalPoints?: number | null;
        fractionCompleted?: number | null;
        stickerName: string;
        goalProgress?: Array<{
          __typename?: 'GoalProgress';
          goalId: string;
          count?: number | null;
          points?: number | null;
          fractionCompleted?: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
    address?: { __typename?: 'Address'; city?: string | null; region?: string | null; country?: string | null } | null;
    answers?: Array<{
      __typename?: 'RegQuestionAnswer';
      questionId: string;
      filterName: string;
      filterOrder: number;
      value?: Array<string | null> | null;
    }> | null;
  } | null;
};

export type Get_Attendee_ProfileQueryVariables = Exact<{
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Attendee_ProfileQuery = {
  __typename?: 'Query';
  getAttendee?: {
    __typename?: 'Attendee';
    id: string;
    firstName: string;
    lastName: string;
    title?: string | null;
    company?: string | null;
    profilePicture?: string | null;
    prefix?: string | null;
    designation?: string | null;
    visibility?: string | null;
    virtual: boolean;
    canMeet: boolean;
    guest?: boolean | null;
    connectionStatus: AttendeeConnectionStatus;
    pronouns?: string | null;
  } | null;
};

export type Get_Attendee_RecommendationsQueryVariables = Exact<{ [key: string]: never }>;

export type Get_Attendee_RecommendationsQuery = {
  __typename?: 'Query';
  getAttendeeRecommendations?: {
    __typename?: 'RecommendationPaginatedResults';
    data?: Array<{
      __typename?: 'AttendeeRecommendation';
      id: string;
      contactId?: string | null;
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profilePicture?: string | null;
      dismissed: boolean;
    } | null> | null;
  } | null;
};

export type Get_Attendee_Recommendations_All_FieldsQueryVariables = Exact<{ [key: string]: never }>;

export type Get_Attendee_Recommendations_All_FieldsQuery = {
  __typename?: 'Query';
  getAttendeeRecommendations?: {
    __typename?: 'RecommendationPaginatedResults';
    data?: Array<{
      __typename?: 'AttendeeRecommendation';
      id: string;
      contactId?: string | null;
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profilePicture?: string | null;
      dismissed: boolean;
      prefix?: string | null;
      designation?: string | null;
      connectionStatus: AttendeeConnectionStatus;
      canMeet: boolean;
    } | null> | null;
  } | null;
};

export type Get_Attendee_With_InterestsQueryVariables = Exact<{
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Attendee_With_InterestsQuery = {
  __typename?: 'Query';
  getAttendee?: {
    __typename?: 'Attendee';
    id: string;
    firstName: string;
    lastName: string;
    title?: string | null;
    company?: string | null;
    profilePicture?: string | null;
    prefix?: string | null;
    designation?: string | null;
    headline?: string | null;
    bio?: string | null;
    pronouns?: string | null;
    facebookUrl?: string | null;
    linkedInUrl?: string | null;
    twitterUrl?: string | null;
    visibility?: string | null;
    contactId?: string | null;
    canMeet: boolean;
    websiteUrl?: string | null;
    guest?: boolean | null;
    virtual: boolean;
    connectionStatus: AttendeeConnectionStatus;
    player?: {
      __typename?: 'Player';
      id?: string | null;
      leaderboardOptOut?: boolean | null;
      totalScore?: number | null;
      rank?: number | null;
      progress?: Array<{
        __typename?: 'AchievementProgress';
        achievementId: string;
        achievementName: string;
        level?: number | null;
        totalPoints?: number | null;
        fractionCompleted?: number | null;
        stickerName: string;
        goalProgress?: Array<{
          __typename?: 'GoalProgress';
          goalId: string;
          count?: number | null;
          points?: number | null;
          fractionCompleted?: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
    address?: { __typename?: 'Address'; city?: string | null; region?: string | null; country?: string | null } | null;
    answers?: Array<{
      __typename?: 'RegQuestionAnswer';
      questionId: string;
      filterName: string;
      filterOrder: number;
      value?: Array<string | null> | null;
    }> | null;
    professionalInterests?: Array<{
      __typename?: 'AttendeeInterestComparisonResult';
      id: string;
      text: string;
      commonInterest: boolean;
    }> | null;
  } | null;
};

export type Get_PlayerQueryVariables = Exact<{
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_PlayerQuery = {
  __typename?: 'Query';
  getAttendee?: {
    __typename?: 'Attendee';
    id: string;
    player?: {
      __typename?: 'Player';
      id?: string | null;
      leaderboardOptOut?: boolean | null;
      totalScore?: number | null;
      rank?: number | null;
      progress?: Array<{
        __typename?: 'AchievementProgress';
        achievementId: string;
        achievementName: string;
        level?: number | null;
        totalPoints?: number | null;
        fractionCompleted?: number | null;
        stickerName: string;
        goalProgress?: Array<{
          __typename?: 'GoalProgress';
          goalId: string;
          count?: number | null;
          points?: number | null;
          fractionCompleted?: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type Get_Professional_Interest_ChoicesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  pageCriteria?: InputMaybe<PageCriteria>;
}>;

export type Get_Professional_Interest_ChoicesQuery = {
  __typename?: 'Query';
  getProfessionalInterestChoices?: {
    __typename?: 'InterestChoicesResponse';
    data: Array<{ __typename?: 'InterestChoice'; id: string; text: string }>;
    pagination: {
      __typename?: 'Pagination';
      limit: number;
      totalCount: number;
      previousToken?: string | null;
      currentToken: string;
      nextToken?: string | null;
    };
  } | null;
};

export type Search_AttendeesQueryVariables = Exact<{
  criteria?: InputMaybe<AttendeeSearchCriteria>;
}>;

export type Search_AttendeesQuery = {
  __typename?: 'Query';
  searchAttendees?: {
    __typename?: 'AttendeePaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      limit: number;
      totalCount: number;
      currentToken: string;
      nextToken?: string | null;
    } | null;
    data: Array<{
      __typename?: 'Attendee';
      id: string;
      contactId?: string | null;
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profilePicture?: string | null;
      canMeet: boolean;
      guest?: boolean | null;
      connectionStatus: AttendeeConnectionStatus;
      designation?: string | null;
      prefix?: string | null;
      virtual: boolean;
    } | null>;
  } | null;
};

export type Get_Attendee_Hub_ConfigQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Attendee_Hub_ConfigQuery = {
  __typename?: 'Query';
  getAttendeeHubConfig: {
    __typename?: 'AttendeeHubConfig';
    featureSettings: Array<{
      __typename?: 'FeatureSettings';
      id: string;
      type: string;
      featureCode: string;
      isEnabled: boolean;
      metadata?: any | null;
    } | null>;
    mobileAssets: {
      __typename?: 'MobileAssets';
      eventImageUrl?: any | null;
      eventImageName?: string | null;
      eventImageUrlOptimized?: any | null;
      lastModifiedDate: any;
    };
    morePageSettings: {
      __typename?: 'MorePageSettings';
      pageGroups: Array<{
        __typename?: 'PageGroup';
        id: string;
        name: string;
        pages?: Array<string | null> | null;
        description?: string | null;
      } | null>;
    };
    customPageSettings?: Array<{
      __typename?: 'CustomPageSettings';
      id: string;
      pageId: string;
      pageName: string;
      pageIcon: string;
      description?: any | null;
      imageAsset?: any | null;
      lastModifiedDate: any;
      pageType?: string | null;
      externalUrl?: string | null;
      documentAsset?: any | null;
    } | null> | null;
    pageBannerPageSettingsBulk: Array<{
      __typename?: 'PageBannerPageSettings';
      id: string;
      location: PageBannerPlacementLocation;
      locationId?: string | null;
      placementOrder: Array<string>;
      rotationInterval?: number | null;
      lastModifiedDate: any;
      placements: Array<{
        __typename?: 'PageBannerPlacementSettings';
        id: string;
        bannerId: string;
        location: PageBannerPlacementLocation;
        visibility: PageBannerPlacementVisibility;
        activeTimes?: Array<{ __typename?: 'PageBannerPlacementTime'; startTime: any; endTime: any } | null> | null;
      }>;
    }>;
    pageBannerSettings?: Array<{
      __typename?: 'PageBannerSettings';
      id: string;
      name: string;
      template: PageBannerTemplateType;
      title?: string | null;
      body?: string | null;
      linkText?: string | null;
      linkDestinationType?: PageBannerLinkDestinationType | null;
      linkAttendeeHubDestinationType?: PageBannerLinkAttendeeHubDestinationType | null;
      linkDestination?: string | null;
      exhibitorAttribution?: string | null;
      textAlignment?: PageBannerTextAlignment | null;
      imageAlignment?: PageBannerImageAlignment | null;
      fontColor?: string | null;
      containerBackground?: PageBannerContainerBackground | null;
      containerBackgroundCustomColor?: string | null;
      imageAsset?: { __typename?: 'imageAsset'; assetUriOptimized?: string | null; altText?: string | null } | null;
    }> | null;
    privacySettings: { __typename?: 'PrivacySettings'; attendeesVisible: boolean };
    securitySettings: { __typename?: 'SecuritySettings'; documentSharingEnabled: boolean };
  };
};

export type Get_Reg_Question_FiltersQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Reg_Question_FiltersQuery = {
  __typename?: 'Query';
  getRegQuestionFilters?: Array<{
    __typename?: 'RegQuestionFilters';
    questionId: string;
    filterName: string;
    filterOrder: number;
    questionType: string;
    questionServiceEntityType?: QuestionServiceEntityType | null;
    choices?: Array<{ __typename?: 'RegQuestionChoices'; id: string; text: string; value?: string | null }> | null;
  }> | null;
};

export type Check_Attendee_Has_ChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type Check_Attendee_Has_ChannelsQuery = {
  __typename?: 'Query';
  checkAttendeeHasChannels?: {
    __typename?: 'AttendeeHasChannels';
    hasChannels?: boolean | null;
    status?: string | null;
    limit?: number | null;
    remaining?: number | null;
    resetAt?: number | null;
  } | null;
};

export type Create_Messaging_ChannelMutationVariables = Exact<{
  attendeeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type Create_Messaging_ChannelMutation = {
  __typename?: 'Mutation';
  createMessagingChannelV2?: {
    __typename?: 'MessagingChannel';
    channelId?: string | null;
    status: string;
    resetAt?: number | null;
  } | null;
};

export type Leave_Group_Messaging_ChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;

export type Leave_Group_Messaging_ChannelMutation = {
  __typename?: 'Mutation';
  leaveGroupMessagingChannel?: { __typename?: 'MessagingChannel'; channelId?: string | null; status: string } | null;
};

export type On_Attendee_Has_ChannelsSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  attendeeId: Scalars['ID']['input'];
}>;

export type On_Attendee_Has_ChannelsSubscription = {
  __typename?: 'Subscription';
  onAttendeeHasChannelsV2?: {
    __typename?: 'StreamClientConnectTriggerStatus';
    status?: string | null;
    eventId?: string | null;
    attendeeId?: string | null;
  } | null;
};

export type Update_Group_NameMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
}>;

export type Update_Group_NameMutation = {
  __typename?: 'Mutation';
  updateGroupMessagingChannelName?: {
    __typename?: 'MessagingChannel';
    channelId?: string | null;
    status: string;
    resetAt?: number | null;
  } | null;
};

export type UpsertAttendeePreferencesMutationVariables = Exact<{
  preferences: Array<AttendeePreferenceInput> | AttendeePreferenceInput;
  preview: Scalars['Boolean']['input'];
}>;

export type UpsertAttendeePreferencesMutation = {
  __typename?: 'Mutation';
  upsertAttendeePreferences: Array<{
    __typename?: 'AttendeePreference';
    id: string;
    preferenceType: AttendeePreferenceType;
    preferenceValue: string;
  }>;
};

export type Create_Upload_Image_LinkMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
}>;

export type Create_Upload_Image_LinkMutation = {
  __typename?: 'Mutation';
  createUploadImageLink?: {
    __typename?: 'PresignedUploadUrl';
    location: string;
    relativePath: string;
    uniqueFilename: string;
  } | null;
};

export type Create_Upload_LinkMutationVariables = Exact<{
  filename: Scalars['String']['input'];
}>;

export type Create_Upload_LinkMutation = {
  __typename?: 'Mutation';
  createUploadLink?: {
    __typename?: 'PresignedUploadUrl';
    location: string;
    relativePath: string;
    uniqueFilename: string;
  } | null;
};

export type Generate_Chat_TokenMutationVariables = Exact<{ [key: string]: never }>;

export type Generate_Chat_TokenMutation = {
  __typename?: 'Mutation';
  generateChatToken?: {
    __typename?: 'ChatToken';
    type: string;
    apiKey: string;
    userId: string;
    token: string;
    expiration: string;
  } | null;
};

export type Get_Cdn_Image_UrlQueryVariables = Exact<{
  input: ImageInput;
}>;

export type Get_Cdn_Image_UrlQuery = {
  __typename?: 'Query';
  getCdnImageUrl?: {
    __typename?: 'ImageMeta';
    isCdnUrl?: boolean | null;
    url: string;
    width?: number | null;
    height?: number | null;
  } | null;
};

export type Get_Attendee_Field_CompletionQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type Get_Attendee_Field_CompletionQuery = {
  __typename?: 'Query';
  getAttendeeFieldCompletion?: {
    __typename?: 'AttendeeFieldCompletionResult';
    hasProfilePicture: boolean;
    unfilledFieldGroupNames?: Array<string> | null;
    allFieldGroupNames?: Array<string> | null;
    percentComplete: number;
  } | null;
};

export type Get_Attendee_Field_Completion_V2QueryVariables = Exact<{ [key: string]: never }>;

export type Get_Attendee_Field_Completion_V2Query = {
  __typename?: 'Query';
  getAttendeeFieldCompletionV2?: {
    __typename?: 'AttendeeFieldCompletionResult';
    hasProfilePicture: boolean;
    unfilledFieldGroupNames?: Array<string> | null;
    allFieldGroupNames?: Array<string> | null;
    percentComplete: number;
  } | null;
};

export type Get_Random_Invitee_Profile_ImagesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type Get_Random_Invitee_Profile_ImagesQuery = {
  __typename?: 'Query';
  getRandomInviteeProfileImages?: Array<{
    __typename?: 'InviteeProfileImage';
    profileImageUrl?: string | null;
  } | null> | null;
};

export type Create_Message_ReportMutationVariables = Exact<{
  input: ReportPostInput;
}>;

export type Create_Message_ReportMutation = {
  __typename?: 'Mutation';
  createMessageReport?: {
    __typename?: 'ReportPostResult';
    messageId?: string | null;
    status: ChatServiceStatus;
  } | null;
};

export type Delete_MessageMutationVariables = Exact<{
  input: ReportPostInput;
}>;

export type Delete_MessageMutation = {
  __typename?: 'Mutation';
  deleteMessage?: {
    __typename?: 'ReportPostResult';
    reportId?: string | null;
    messageId?: string | null;
    status: ChatServiceStatus;
  } | null;
};

export type Chat_ReportsQueryVariables = Exact<{
  entityType?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Chat_ReportsQuery = {
  __typename?: 'Query';
  chatReports: Array<{
    __typename?: 'ReportPost';
    id: string;
    eventId: string;
    status: ReportPostStatus;
    isAnonymous: boolean;
    reportComment?: string | null;
    resolutionNotes?: string | null;
    reportedAt: string;
    resolvedAt?: string | null;
    isRead: boolean;
    numberOfReports: number;
    reportCategory: Array<string>;
    entity?: {
      __typename?: 'ReportPostChatEntity';
      id?: string | null;
      title?: string | null;
      type: ChatEntityType;
    } | null;
    reportedBy?: { __typename?: 'ReportPostAttendee'; firstName: string; lastName: string; id: string } | null;
    resolvedBy?: { __typename?: 'ReportPostAttendee'; firstName: string; lastName: string; id: string } | null;
    sentBy?: { __typename?: 'ReportPostAttendee'; firstName: string; lastName: string; id: string } | null;
    message: {
      __typename?: 'ReportPostMessageSnapshot';
      id: string;
      parentMessageId?: string | null;
      channelId: string;
      text?: string | null;
      html?: string | null;
      type: string;
      attachments: Array<{
        __typename?: 'ReportPostMessageAttachment';
        type: string;
        url: string;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
      }>;
    };
  }>;
};

export type Mark_Reports_ReadMutationVariables = Exact<{
  reportIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type Mark_Reports_ReadMutation = {
  __typename?: 'Mutation';
  markReportRead: Array<{
    __typename?: 'MarkReportReadResult';
    reportId: string;
    status: string;
    message?: string | null;
  }>;
};

export type On_Update_Unread_CountSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  attendeeId: Scalars['ID']['input'];
}>;

export type On_Update_Unread_CountSubscription = {
  __typename?: 'Subscription';
  unreadReports: { __typename?: 'ReportPostsUnread'; unreadCount: number };
};

export type Resolve_Message_ReportMutationVariables = Exact<{
  messageReportId: Scalars['ID']['input'];
  status: ReportPostStatus;
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
  resolveAll?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<ChatEntityType>;
}>;

export type Resolve_Message_ReportMutation = {
  __typename?: 'Mutation';
  resolveMessageReport?: {
    __typename?: 'ReportPostResult';
    reportId?: string | null;
    status: ChatServiceStatus;
  } | null;
};

export type Unread_ReportsQueryVariables = Exact<{ [key: string]: never }>;

export type Unread_ReportsQuery = {
  __typename?: 'Query';
  unreadReports?: { __typename?: 'ReportPostsUnread'; unreadCount: number } | null;
};

export type Update_Resolution_NotesMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: ChatEntityType;
  messageId: Scalars['String']['input'];
  resolutionNotes: Scalars['String']['input'];
}>;

export type Update_Resolution_NotesMutation = {
  __typename?: 'Mutation';
  updateResolutionNotes?: {
    __typename?: 'UpdateResolutionNotesResult';
    messageId: string;
    resolutionNotes: string;
  } | null;
};

export type Accept_TermsMutationVariables = Exact<{
  termsId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Accept_TermsMutation = {
  __typename?: 'Mutation';
  updateAttendeeConsent?: { __typename?: 'AttendeeConsent'; id?: string | null; hasAccepted?: boolean | null } | null;
};

export type Update_Consent_AnswerMutationVariables = Exact<{
  consentAnswer: ExhibitorConsentAnswerInput;
}>;

export type Update_Consent_AnswerMutation = {
  __typename?: 'Mutation';
  updateExhibitorConsentAnswer?: {
    __typename?: 'ExhibitorConsentAnswerResponse';
    answer?: {
      __typename?: 'ExhibitorConsentAnswer';
      attendeeId: string;
      questionId?: string | null;
      questionText?: string | null;
      answerId?: string | null;
      locale?: string | null;
      lastModifiedDate?: any | null;
      choice?: { __typename?: 'ExhibitorConsentChoiceAnswerResponse'; id?: string | null; text?: string | null } | null;
    } | null;
  } | null;
};

export type Get_CreditsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_CreditsQuery = {
  __typename?: 'Query';
  getCredits: {
    __typename?: 'Credits';
    totalCredits: number;
    yearToDateCredits: number;
    inviteeCredits?: Array<{
      __typename?: 'InviteeCredit';
      creditName: string;
      value: number;
      creditExpirationDate?: any | null;
    }> | null;
  };
};

export type Get_Event_Locales_InfoQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['ID']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Event_Locales_InfoQuery = {
  __typename?: 'Query';
  eventLocaleInfo?: {
    __typename?: 'EventLocalesInfo';
    browserLocaleDetection?: boolean | null;
    supportedEventLocales?: Array<{
      __typename?: 'EventLocale';
      localeId: number;
      languageName: string;
      languageCountry: string;
      isDefault: boolean;
      cultureCode: string;
    }> | null;
  } | null;
};

export type Get_EventsQueryVariables = Exact<{
  criteria?: InputMaybe<EventSearchCriteria>;
}>;

export type Get_EventsQuery = {
  __typename?: 'Query';
  getEvents?: {
    __typename?: 'EventPaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      limit: number;
      totalCount: number;
      currentToken: string;
      nextToken?: string | null;
    } | null;
    data: Array<{
      __typename?: 'Event';
      id: string;
      image?: string | null;
      title: string;
      description?: string | null;
      format?: Format | null;
      start: any;
      end: any;
      websiteStatus?: WebsiteStatus | null;
      attendeeHubLaunched?: boolean | null;
      connectionsCount: number;
      totalCredit?: number | null;
      links: { __typename?: 'EventLinks'; summary?: string | null };
      inviteeCredit?: Array<{
        __typename?: 'InviteeCredit';
        creditName: string;
        creditExpirationDate?: any | null;
        value: number;
      }> | null;
      venues?: Array<{
        __typename?: 'Venue';
        name?: string | null;
        address?: {
          __typename?: 'Address';
          address1?: string | null;
          city?: string | null;
          regionCode?: string | null;
        } | null;
      } | null> | null;
    } | null>;
  } | null;
};

export type ThemeFragment = {
  __typename?: 'EventInfoTheme';
  primary: string;
  secondary: string;
  background: string;
  mood: string;
  safeMode?: boolean | null;
  preferFormula?: ThemeFormulaType | null;
  illustrations?: { __typename?: 'IllustrationSettings'; hideAll?: boolean | null } | null;
  icons?: {
    __typename?: 'IconSettings';
    pack?: string | null;
    reassignedIcons?: Array<{ __typename?: 'ReassignedIcon'; name: string; reassignment: string }> | null;
  } | null;
  headingFont?: {
    __typename?: 'FontDescriptor';
    name: string;
    fallbackFont?: string | null;
    styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
  } | null;
  bodyFont?: {
    __typename?: 'FontDescriptor';
    name: string;
    fallbackFont?: string | null;
    styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
  } | null;
};

export type Access_Exhibitor_ChatMutationVariables = Exact<{
  exhibitorId: Scalars['ID']['input'];
}>;

export type Access_Exhibitor_ChatMutation = {
  __typename?: 'Mutation';
  accessExhibitorChat?: {
    __typename?: 'ChatVerification';
    status: string;
    limit?: number | null;
    remaining?: number | null;
    resetAt?: number | null;
  } | null;
};

export type Create_Inbound_LeadMutationVariables = Exact<{
  input: ExhibitorInboundLeadInput;
}>;

export type Create_Inbound_LeadMutation = {
  __typename?: 'Mutation';
  createInboundLead?: {
    __typename?: 'ExhibitorInboundLeadResponse';
    localId: string;
    localCreatedAt: number;
    source: ExhibitorInboundLeadSource;
    application: ExhibitorInboundLeadApplication;
    sourceEventId: string;
    exhibitorId: string;
    referenceId: string;
    notes: string;
  } | null;
};

export type Exhibitor_DetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeAppt: Scalars['Boolean']['input'];
  appt?: InputMaybe<AppointmentSelector>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Exhibitor_DetailQuery = {
  __typename?: 'Query';
  fetchExhibitor?: {
    __typename?: 'ExhibitorDetails';
    id: string;
    name: string;
    logoUrl?: string | null;
    bannerUrl?: string | null;
    bannerImageAltText?: string | null;
    eventSponsor: boolean;
    location?: string | null;
    virtualBoothUrl?: string | null;
    description?: string | null;
    featured: boolean;
    inboundLeadsEnabled: boolean;
    virtualMeetingsEnabled: boolean;
    virtualMeetingsExhibitorEnabled: boolean;
    canRequestAppointment?: boolean | null;
    sponsorshipLevels?: Array<{ __typename?: 'SponsorshipLevel'; id: string; name: string }> | null;
    links?: {
      __typename?: 'ExhibitorLinks';
      website?: string | null;
      twitter?: string | null;
      linkedIn?: string | null;
      facebook?: string | null;
      instagram?: string | null;
    } | null;
    content?: {
      __typename?: 'ExhibitorContent';
      files: Array<{
        __typename?: 'ExhibitorContentFile';
        id: string;
        displayName?: string | null;
        fileName?: string | null;
        sizeBytes?: number | null;
        url?: string | null;
      }>;
      weblinks: Array<{ __typename?: 'ExhibitorContentLink'; id: string; name?: string | null; url: string }>;
    } | null;
    floorPlan?: { __typename?: 'FloorPlanWithoutMarkers'; id: string } | null;
    boothStaff: Array<{
      __typename?: 'ExhibitorBoothStaff';
      firstName?: string | null;
      lastName?: string | null;
      title?: string | null;
      profileImageUrl?: string | null;
      attendeeId?: string | null;
      visibility?: string | null;
      company?: string | null;
      availability?: {
        __typename?: 'BoothStaffAvailaility';
        status?: string | null;
        meeting?: { __typename?: 'Meeting'; status?: string | null } | null;
      } | null;
    } | null>;
    videos: Array<{
      __typename?: 'ExhibitorVideo';
      id: string;
      title?: string | null;
      sourceId?: string | null;
      thumbnail?: string | null;
      duration?: number | null;
      videoServiceId?: string | null;
    }>;
    sponsoredSessions: Array<{
      __typename?: 'SponsoredSession';
      id: string;
      description?: string | null;
      title: string;
      startDate: string;
      endDate: string;
      virtual: boolean;
      sessionTags?: Array<string> | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      webcast?: {
        __typename?: 'Webcast';
        id: string;
        format?: WebcastFormat | null;
        playerType?: string | null;
        player?: {
          __typename?: 'WebcastPlayer';
          id: string;
          duration?: number | null;
          simuliveOffset?: number | null;
          stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
        } | null;
      } | null;
    }>;
    showfloorSettings: {
      __typename?: 'ShowfloorSettings';
      active?: boolean | null;
      exhibitorChatEnabled?: boolean | null;
      useCustomBoothHours: boolean;
      hours?: {
        __typename?: 'ShowfloorHours';
        startHour?: number | null;
        startMinute?: number | null;
        endHour?: number | null;
        endMinute?: number | null;
      } | null;
      customBoothHours: Array<{ __typename?: 'CustomBoothHours'; startTime: string; endTime: string }>;
    };
    chatSettings?: {
      __typename?: 'ChatSettings';
      isEnabled: boolean;
      stream?: {
        __typename?: 'ChatStreamSettings';
        isAvailable: boolean;
        channelId: string;
        channelType: string;
      } | null;
    } | null;
    categories?: Array<{ __typename?: 'ExhibitorCategory'; id: string; name: string }> | null;
  } | null;
};

export type Exhibitor_Fact_DataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type Exhibitor_Fact_DataQuery = {
  __typename?: 'Query';
  fetchExhibitor?: {
    __typename?: 'ExhibitorDetails';
    id: string;
    name: string;
    featured: boolean;
    eventSponsor: boolean;
  } | null;
};

export type Exhibitor_With_Booth_LocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Exhibitor_With_Booth_LocationQuery = {
  __typename?: 'Query';
  fetchExhibitor?: { __typename?: 'ExhibitorDetails'; id: string; name: string; location?: string | null } | null;
};

export type Generate_Exhibitor_Chat_TokenMutationVariables = Exact<{ [key: string]: never }>;

export type Generate_Exhibitor_Chat_TokenMutation = {
  __typename?: 'Mutation';
  generateExhibitorChatToken?: {
    __typename?: 'ChatToken';
    type: string;
    apiKey: string;
    userId: string;
    token: string;
    expiration: string;
  } | null;
};

export type On_Update_Attendee_StatusSubscriptionVariables = Exact<{
  exhibitorId: Scalars['ID']['input'];
  attendeeId: Scalars['ID']['input'];
}>;

export type On_Update_Attendee_StatusSubscription = {
  __typename?: 'Subscription';
  onUpdateAttendeeStatus?: {
    __typename?: 'AttendeeStatus';
    exhibitorId: string;
    attendeeId: string;
    meetingId?: string | null;
    status: Status;
    meetingStatus?: MeetingStatus | null;
    requester?: {
      __typename?: 'MeetingRequester';
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profileImageUrl?: string | null;
    } | null;
  } | null;
};

export type On_Update_Booth_Staff_StatusSubscriptionVariables = Exact<{
  exhibitorId: Scalars['ID']['input'];
}>;

export type On_Update_Booth_Staff_StatusSubscription = {
  __typename?: 'Subscription';
  onUpdateBoothStaffStatus?: {
    __typename?: 'BoothStaffStatus';
    exhibitorId: string;
    attendeeId: string;
    status: Status;
    meetingStatus?: MeetingStatus | null;
  } | null;
};

export type Request_MeetingMutationVariables = Exact<{
  input: RequestMeetingInput;
}>;

export type Request_MeetingMutation = {
  __typename?: 'Mutation';
  requestMeeting?: {
    __typename?: 'AttendeeStatus';
    exhibitorId: string;
    attendeeId: string;
    meetingId?: string | null;
    status: Status;
    meetingStatus?: MeetingStatus | null;
  } | null;
};

export type Search_ExhibitorsQueryVariables = Exact<{
  exhibitorSearchCriteria?: InputMaybe<ExhibitorSearchCriteria>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Search_ExhibitorsQuery = {
  __typename?: 'Query';
  searchExhibitors?: {
    __typename?: 'ExhibitorPaginatedResults';
    totalInCategory?: number | null;
    hasVirtualBooths: boolean;
    pagination?: { __typename?: 'Pagination'; totalCount: number } | null;
    filterableCustomFields: Array<{
      __typename?: 'FilterableCustomFields';
      id: string;
      label?: string | null;
      choices: Array<{ __typename?: 'FilterableCustomFieldsChoice'; id: string; label?: string | null }>;
    }>;
    sponsorshipLevels: Array<{ __typename?: 'SponsorshipLevel'; id: string; name: string; rank?: number | null }>;
    data: Array<{
      __typename?: 'Exhibitor';
      id: string;
      name: string;
      location?: string | null;
      tagline?: string | null;
      logoUrl?: string | null;
      hasVirtualBooth: boolean;
      eventSponsor: boolean;
      sponsorshipLevels?: Array<string> | null;
      featured: boolean;
      categories?: Array<{ __typename?: 'ExhibitorCategory'; id: string; name: string }> | null;
    }>;
    categories?: Array<{
      __typename?: 'ExhibitorCategory';
      id: string;
      type: ExhibitorCategoryType;
      name: string;
      description?: string | null;
      imageUrl?: string | null;
      exhibitorCount: number;
      previewExhibitors: Array<{
        __typename?: 'CategoryPreviewExhibitor';
        id: string;
        name: string;
        logoUrl?: string | null;
      }>;
    }> | null;
  } | null;
};

export type Send_HeartbeatMutationVariables = Exact<{
  input?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type Send_HeartbeatMutation = {
  __typename?: 'Mutation';
  availabilityHeartbeat?: { __typename?: 'AvailabilityHeartbeatResponse'; status: number } | null;
};

export type Update_AvailabilityMutationVariables = Exact<{
  input: UpdateAvailabilityInput;
}>;

export type Update_AvailabilityMutation = {
  __typename?: 'Mutation';
  updateAvailability?: {
    __typename?: 'BoothStaffStatus';
    exhibitorId: string;
    attendeeId: string;
    status: Status;
    meetingStatus?: MeetingStatus | null;
  } | null;
};

export type Update_Meeting_Invitee_StatusMutationVariables = Exact<{
  input: MeetingRequestResponseInput;
}>;

export type Update_Meeting_Invitee_StatusMutation = {
  __typename?: 'Mutation';
  updateMeetingInviteeStatus?: {
    __typename?: 'AttendeeStatus';
    exhibitorId: string;
    attendeeId: string;
    meetingId?: string | null;
    status: Status;
    meetingStatus?: MeetingStatus | null;
  } | null;
};

export type Verify_Exhibitor_Chat_AccessMutationVariables = Exact<{
  exhibitorId: Scalars['ID']['input'];
}>;

export type Verify_Exhibitor_Chat_AccessMutation = {
  __typename?: 'Mutation';
  verifyExhibitorChatAccess?: {
    __typename?: 'ChatVerification';
    status: string;
    limit?: number | null;
    remaining?: number | null;
    resetAt?: number | null;
  } | null;
};

export type GetFloorPlanQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  floorPlanId: Scalars['ID']['input'];
  criteria?: InputMaybe<MarkerFilterCriteria>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFloorPlanQuery = {
  __typename?: 'Query';
  getFloorPlan?: {
    __typename?: 'FloorPlan';
    name: string;
    id: string;
    image: { __typename?: 'FloorPlanImage'; urlOptimized?: string | null };
    markers?: Array<{
      __typename?: 'FloorPlanMarker';
      id: string;
      location: { __typename?: 'Location'; id?: string | null; name?: string | null; type: LocationType };
      coordinates: { __typename?: 'Coordinates'; x: number; y: number };
    } | null> | null;
  } | null;
};

export type GetFloorPlansQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFloorPlansQuery = {
  __typename?: 'Query';
  getFloorPlans?: Array<{
    __typename?: 'FloorPlanWithoutMarkers';
    name: string;
    id: string;
    image: { __typename?: 'FloorPlanImage'; urlOptimized?: string | null };
  } | null> | null;
};

export type Get_GameQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_GameQuery = {
  __typename?: 'Query';
  game?: {
    __typename?: 'Game';
    id: string;
    name: string;
    description?: string | null;
    rules?: string | null;
    icon?: string | null;
    validStart: string;
    validEnd: string;
    totalJoinedPlayers?: number | null;
    leaderboardEnabled: boolean;
    achievements?: Array<{
      __typename?: 'Achievement';
      id: string;
      name: string;
      description?: string | null;
      stickerName: string;
      goals: Array<{
        __typename?: 'Goal';
        id: string;
        name: string;
        description?: string | null;
        points?: number | null;
      } | null>;
    }> | null;
    player?: {
      __typename?: 'Player';
      id?: string | null;
      leaderboardOptOut?: boolean | null;
      totalScore?: number | null;
      rank?: number | null;
      progress?: Array<{
        __typename?: 'AchievementProgress';
        achievementId: string;
        level?: number | null;
        totalPoints?: number | null;
        fractionCompleted?: number | null;
        goalProgress?: Array<{
          __typename?: 'GoalProgress';
          goalId: string;
          count?: number | null;
          points?: number | null;
          fractionCompleted?: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
    leaderboard?: {
      __typename?: 'Leaderboard';
      players?: Array<{
        __typename?: 'LeaderboardPlayer';
        id: string;
        attendeeId: string;
        firstName?: string | null;
        lastName?: string | null;
        profilePicture?: string | null;
        rank?: number | null;
        totalScore?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type Opt_In_PlayerMutationVariables = Exact<{ [key: string]: never }>;

export type Opt_In_PlayerMutation = {
  __typename?: 'Mutation';
  optInPlayer?: { __typename?: 'Player'; id?: string | null; leaderboardOptOut?: boolean | null } | null;
};

export type Opt_Out_PlayerMutationVariables = Exact<{ [key: string]: never }>;

export type Opt_Out_PlayerMutation = {
  __typename?: 'Mutation';
  optOutPlayer?: { __typename?: 'Player'; id?: string | null; leaderboardOptOut?: boolean | null } | null;
};

export type Get_Scheduled_CardsQueryVariables = Exact<{
  criteria: HomeSchedulerCriteria;
}>;

export type Get_Scheduled_CardsQuery = {
  __typename?: 'Query';
  getHomeSchedulerConfig: {
    __typename?: 'HomeSchedulerConfig';
    scheduledCards?: {
      __typename?: 'SchedulerData';
      cardsOrder?: Array<string | null> | null;
      appointmentCard?: Array<{
        __typename?: 'HomeCard';
        id: string;
        name?: string | null;
        cardType: HomeCardType;
        displayOnHome?: boolean | null;
        staffName?: string | null;
        linkText?: string | null;
        staffLinkText?: string | null;
        type?: string | null;
        staffDisplayOnHome?: boolean | null;
        targetName?: string | null;
        staffTargetName?: string | null;
        targetType?: AttendeeHubPageType | null;
        staffTargetType?: AttendeeHubPageType | null;
        thumbnail?: string | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
      } | null> | null;
      videos?: Array<{
        __typename?: 'HomeCard';
        id: string;
        name?: string | null;
        cardType: HomeCardType;
        displayOnHome?: boolean | null;
        url?: string | null;
        videoId?: string | null;
        videoName?: string | null;
        linkText?: string | null;
        parentId?: string | null;
        exhibitorId?: string | null;
        thumbnail?: string | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
      } | null> | null;
      links?: Array<{
        __typename?: 'HomeCard';
        id: string;
        name?: string | null;
        cardType: HomeCardType;
        displayOnHome?: boolean | null;
        url?: string | null;
        linkText?: string | null;
        type?: string | null;
        parentId?: string | null;
        targetName?: string | null;
        targetType?: AttendeeHubPageType | null;
        exhibitorId?: string | null;
        thumbnail?: string | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
      } | null> | null;
      linkGalleries?: Array<{
        __typename?: 'HomeCard';
        id: string;
        name?: string | null;
        cardType: HomeCardType;
        displayOnHome?: boolean | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
        associatedCards?: Array<{
          __typename?: 'HomeCard';
          id: string;
          url?: string | null;
          linkText?: string | null;
          type?: string | null;
          cardType: HomeCardType;
          thumbnail?: string | null;
          targetName?: string | null;
          targetType?: AttendeeHubPageType | null;
          exhibitorId?: string | null;
        }> | null;
      } | null> | null;
      videoGalleries?: Array<{
        __typename?: 'HomeCard';
        id: string;
        name?: string | null;
        cardType: HomeCardType;
        displayOnHome?: boolean | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
        associatedCards?: Array<{
          __typename?: 'HomeCard';
          id: string;
          url?: string | null;
          videoId?: string | null;
          videoName?: string | null;
          cardType: HomeCardType;
          linkText?: string | null;
          thumbnail?: string | null;
          exhibitorId?: string | null;
        }> | null;
      } | null> | null;
      systemCards?: Array<{
        __typename?: 'SystemCard';
        id?: string | null;
        cardType?: string | null;
        range?: Array<{ __typename?: 'Range'; start?: string | null; end?: string | null } | null> | null;
      } | null> | null;
      quickLinksSettings?: Array<{
        __typename?: 'QuickLinksSettings';
        id: string;
        icon?: string | null;
        name?: string | null;
      } | null> | null;
    } | null;
    unscheduledCards?: {
      __typename?: 'SchedulerData';
      systemCards?: Array<{ __typename?: 'SystemCard'; cardType?: string | null } | null> | null;
    } | null;
  };
};

export type Add_Moderator_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  input: PollQuestionRequest;
}>;

export type Add_Moderator_QuestionMutation = {
  __typename?: 'Mutation';
  poll?: {
    __typename?: 'AttendeePoll';
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null;
};

export type Delete_Moderator_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}>;

export type Delete_Moderator_QuestionMutation = {
  __typename?: 'Mutation';
  deletePollQuestionInModeratorPoll?: {
    __typename?: 'BulkOperation';
    ids?: Array<string> | null;
    operation: string;
  } | null;
};

export type PollAttributesFragment = {
  __typename?: 'AttendeePoll';
  pollId: string;
  eventId: string;
  sessionId: string;
  name: string;
  timeSetting?: TimeSettingType | null;
  isModeratorEditable?: boolean | null;
};

export type PollQuestionChoiceAttributesFragment = {
  __typename: 'PollQuestionChoice';
  choiceId: string;
  choice: string;
};

export type PollQuestionChoiceResultAttributesFragment = {
  __typename: 'PollQuestionChoiceResult';
  choiceId: string;
  count: number;
  percent: number;
};

export type PollQuestionAttributesFragment = {
  __typename: 'PollQuestion';
  pollId?: string | null;
  questionId: string;
  text: string;
  type: QuestionType;
  displayType: ResultsDisplayType;
  status?: {
    __typename?: 'PollQuestionStatus';
    status: StatusType;
    openedDateTime?: string | null;
    closedDateTime?: string | null;
  } | null;
  choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
  results?: Array<{
    __typename: 'PollQuestionChoiceResult';
    choiceId: string;
    count: number;
    percent: number;
  } | null> | null;
};

export type PollAttributesWithResultsFragment = {
  __typename?: 'AttendeePoll';
  pollId: string;
  eventId: string;
  sessionId: string;
  name: string;
  timeSetting?: TimeSettingType | null;
  isModeratorEditable?: boolean | null;
  questions: Array<{
    __typename?: 'PollQuestion';
    questionId: string;
    results?: Array<{
      __typename: 'PollQuestionChoiceResult';
      choiceId: string;
      count: number;
      percent: number;
    } | null> | null;
  }>;
};

export type PollAttributesWithChoicesAndResultsFragment = {
  __typename?: 'AttendeePoll';
  pollId: string;
  eventId: string;
  sessionId: string;
  name: string;
  timeSetting?: TimeSettingType | null;
  isModeratorEditable?: boolean | null;
  questions: Array<{
    __typename: 'PollQuestion';
    pollId?: string | null;
    questionId: string;
    text: string;
    type: QuestionType;
    displayType: ResultsDisplayType;
    status?: {
      __typename?: 'PollQuestionStatus';
      status: StatusType;
      openedDateTime?: string | null;
      closedDateTime?: string | null;
    } | null;
    choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
    results?: Array<{
      __typename: 'PollQuestionChoiceResult';
      choiceId: string;
      count: number;
      percent: number;
    } | null> | null;
  }>;
};

export type QaQuestionAttributesFragment = {
  __typename?: 'Question';
  id: string;
  text: string;
  answer?: string | null;
  attendeeId?: string | null;
  createDateTime: string;
  statusChangeDateTime: string;
  status: QuestionStatusType;
  attendeeName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  voteCount: number;
};

export type Get_Assigned_PollsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Assigned_PollsQuery = {
  __typename?: 'Query';
  polls: Array<{
    __typename?: 'AttendeePoll';
    myChoices?: Array<string | null> | null;
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null>;
};

export type Get_Assigned_Polls_Without_ChoicesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Assigned_Polls_Without_ChoicesQuery = {
  __typename?: 'Query';
  polls: Array<{
    __typename?: 'AttendeePoll';
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null>;
};

export type Get_Current_QuestionQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Current_QuestionQuery = {
  __typename?: 'Query';
  currentQuestion?: {
    __typename?: 'CurrentQuestion';
    currentQuestionType?: CurrentQuestionType | null;
    sessionQaQuestion?: {
      __typename?: 'Question';
      id: string;
      text: string;
      answer?: string | null;
      attendeeId?: string | null;
      createDateTime: string;
      statusChangeDateTime: string;
      status: QuestionStatusType;
      attendeeName?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      voteCount: number;
    } | null;
    livePollQuestion?: {
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    } | null;
  } | null;
};

export type Get_My_ChoicesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_My_ChoicesQuery = {
  __typename?: 'Query';
  polls: Array<{ __typename?: 'AttendeePoll'; pollId: string; myChoices?: Array<string | null> | null } | null>;
};

export type Get_PollQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_PollQuery = {
  __typename?: 'Query';
  poll: Array<{
    __typename?: 'AttendeePoll';
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null>;
};

export type Get_Poll_With_ResultsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
}>;

export type Get_Poll_With_ResultsQuery = {
  __typename?: 'Query';
  poll: Array<{
    __typename?: 'AttendeePoll';
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename?: 'PollQuestion';
      questionId: string;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null>;
};

export type Get_Poll_With_User_ChoicesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
}>;

export type Get_Poll_With_User_ChoicesQuery = {
  __typename?: 'Query';
  poll: Array<{
    __typename?: 'AttendeePoll';
    myChoices?: Array<string | null> | null;
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null>;
};

export type Modify_Moderator_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  input: PollQuestionRequest;
}>;

export type Modify_Moderator_QuestionMutation = {
  __typename?: 'Mutation';
  poll?: {
    __typename?: 'AttendeePoll';
    pollId: string;
    eventId: string;
    sessionId: string;
    name: string;
    timeSetting?: TimeSettingType | null;
    isModeratorEditable?: boolean | null;
    questions: Array<{
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    }>;
  } | null;
};

export type On_Publish_PollSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type On_Publish_PollSubscription = {
  __typename?: 'Subscription';
  onPublishPoll: {
    __typename?: 'SubscribableAttendeePoll';
    eventId: string;
    sessionId: string;
    pollId?: string | null;
    attendeePolls: Array<{
      __typename?: 'AttendeePoll';
      pollId: string;
      eventId: string;
      sessionId: string;
      name: string;
      timeSetting?: TimeSettingType | null;
      isModeratorEditable?: boolean | null;
      questions: Array<{
        __typename: 'PollQuestion';
        pollId?: string | null;
        questionId: string;
        text: string;
        type: QuestionType;
        displayType: ResultsDisplayType;
        status?: {
          __typename?: 'PollQuestionStatus';
          status: StatusType;
          openedDateTime?: string | null;
          closedDateTime?: string | null;
        } | null;
        choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
        results?: Array<{
          __typename: 'PollQuestionChoiceResult';
          choiceId: string;
          count: number;
          percent: number;
        } | null> | null;
      }>;
    }>;
  };
};

export type On_Remove_PollSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type On_Remove_PollSubscription = {
  __typename?: 'Subscription';
  onRemovePoll: { __typename?: 'SubscribableAttendeePoll'; eventId: string; sessionId: string; pollId?: string | null };
};

export type On_Update_Current_QuestionSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type On_Update_Current_QuestionSubscription = {
  __typename?: 'Subscription';
  currentQuestion?: {
    __typename?: 'CurrentQuestion';
    eventId: string;
    sessionId: string;
    currentQuestionType?: CurrentQuestionType | null;
    livePollQuestion?: {
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    } | null;
    sessionQaQuestion?: {
      __typename?: 'Question';
      id: string;
      text: string;
      answer?: string | null;
      attendeeId?: string | null;
      createDateTime: string;
      statusChangeDateTime: string;
      status: QuestionStatusType;
      attendeeName?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      voteCount: number;
    } | null;
  } | null;
};

export type On_Update_Poll_Question_StatusSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type On_Update_Poll_Question_StatusSubscription = {
  __typename?: 'Subscription';
  subscribablePollQuestionStatus?: {
    __typename?: 'SubscribablePollQuestionStatus';
    eventId: string;
    sessionId: string;
    pollId: string;
    questionId: string;
    status: StatusType;
    openedDateTime?: string | null;
    closedDateTime?: string | null;
  } | null;
};

export type On_Update_Poll_ResultsSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type On_Update_Poll_ResultsSubscription = {
  __typename?: 'Subscription';
  subscribablePollQuestionResults: {
    __typename?: 'SubscribableAttendeePoll';
    eventId: string;
    sessionId: string;
    pollId?: string | null;
    attendeePolls: Array<{
      __typename?: 'AttendeePoll';
      pollId: string;
      eventId: string;
      sessionId: string;
      name: string;
      timeSetting?: TimeSettingType | null;
      isModeratorEditable?: boolean | null;
      questions: Array<{
        __typename: 'PollQuestion';
        pollId?: string | null;
        questionId: string;
        text: string;
        type: QuestionType;
        displayType: ResultsDisplayType;
        status?: {
          __typename?: 'PollQuestionStatus';
          status: StatusType;
          openedDateTime?: string | null;
          closedDateTime?: string | null;
        } | null;
        choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
        results?: Array<{
          __typename: 'PollQuestionChoiceResult';
          choiceId: string;
          count: number;
          percent: number;
        } | null> | null;
      }>;
    }>;
  };
};

export type Prepare_RespondentsMutationVariables = Exact<{
  input: PrepareRespondentsRequest;
}>;

export type Prepare_RespondentsMutation = {
  __typename?: 'Mutation';
  prepareRespondents?: {
    __typename?: 'prepareRespondentsResponse';
    pollsWithRespondents?: Array<string | null> | null;
    pollsWithoutRespondents?: Array<string | null> | null;
  } | null;
};

export type Respond_To_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  choices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;

export type Respond_To_QuestionMutation = {
  __typename?: 'Mutation';
  subscribablePollQuestionChoiceResults?: {
    __typename?: 'SubscribablePollQuestionChoiceResultsByQuestion';
    eventId: string;
    sessionId: string;
    pollId: string;
    results?: Array<{
      __typename: 'PollQuestionChoiceResult';
      choiceId: string;
      count: number;
      percent: number;
    } | null> | null;
  } | null;
};

export type Set_Live_Display_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  currentQuestionType: CurrentQuestionType;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Set_Live_Display_QuestionMutation = {
  __typename?: 'Mutation';
  currentQuestion?: {
    __typename?: 'CurrentQuestion';
    eventId: string;
    sessionId: string;
    currentQuestionType?: CurrentQuestionType | null;
    livePollQuestion?: {
      __typename: 'PollQuestion';
      pollId?: string | null;
      questionId: string;
      text: string;
      type: QuestionType;
      displayType: ResultsDisplayType;
      status?: {
        __typename?: 'PollQuestionStatus';
        status: StatusType;
        openedDateTime?: string | null;
        closedDateTime?: string | null;
      } | null;
      choices?: Array<{ __typename: 'PollQuestionChoice'; choiceId: string; choice: string } | null> | null;
      results?: Array<{
        __typename: 'PollQuestionChoiceResult';
        choiceId: string;
        count: number;
        percent: number;
      } | null> | null;
    } | null;
    sessionQaQuestion?: {
      __typename?: 'Question';
      id: string;
      text: string;
      answer?: string | null;
      attendeeId?: string | null;
      createDateTime: string;
      statusChangeDateTime: string;
      status: QuestionStatusType;
      attendeeName?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      voteCount: number;
    } | null;
  } | null;
};

export type Update_Poll_Question_StatusMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  status?: InputMaybe<StatusType>;
}>;

export type Update_Poll_Question_StatusMutation = {
  __typename?: 'Mutation';
  subscribablePollQuestionStatus?: {
    __typename?: 'SubscribablePollQuestionStatus';
    eventId: string;
    sessionId: string;
    pollId: string;
    questionId: string;
    status: StatusType;
    openedDateTime?: string | null;
    closedDateTime?: string | null;
  } | null;
};

export type Create_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  input: NewQuestionInput;
}>;

export type Create_QuestionMutation = {
  __typename?: 'Mutation';
  createQuestion?: {
    __typename?: 'Question';
    id: string;
    attendeeId?: string | null;
    attendeeName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAnonymous: boolean;
    text: string;
    answer?: string | null;
    status: QuestionStatusType;
    voteCount: number;
    createDateTime: string;
    statusChangeDateTime: string;
    displayDateTime?: string | null;
    isCurrentQuestion?: boolean | null;
    isVoted?: boolean | null;
    eventId: string;
    sessionId: string;
  } | null;
};

export type Fetch_Config_AttendeeQueryVariables = Exact<{ [key: string]: never }>;

export type Fetch_Config_AttendeeQuery = {
  __typename?: 'Query';
  fetchConfigForAttendee?: { __typename?: 'AppConfig'; appConfigString?: string | null } | null;
};

export type Get_Moderator_Settings_And_CodesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Moderator_Settings_And_CodesQuery = {
  __typename?: 'Query';
  eventSettings?: {
    __typename?: 'EventSettings';
    liveDisplayShortUrl?: string | null;
    moderatorApprovalLimit?: number | null;
  } | null;
  sessionCodes?: {
    __typename?: 'SessionCodes';
    eventId: string;
    sessionId: string;
    accessCode?: string | null;
    locationCode?: string | null;
  } | null;
};

export type Get_QuestionsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<QuestionStatusType>> | InputMaybe<QuestionStatusType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type Get_QuestionsQuery = {
  __typename?: 'Query';
  qaQuestions?: {
    __typename?: 'QuestionConnection';
    sessionId?: string | null;
    questions?: Array<{
      __typename?: 'Question';
      id: string;
      attendeeId?: string | null;
      attendeeName?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      isAnonymous: boolean;
      text: string;
      answer?: string | null;
      status: QuestionStatusType;
      voteCount: number;
      createDateTime: string;
      statusChangeDateTime: string;
      displayDateTime?: string | null;
      isCurrentQuestion?: boolean | null;
      isVoted?: boolean | null;
    } | null> | null;
  } | null;
};

export type Get_Session_SettingsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Session_SettingsQuery = {
  __typename?: 'Query';
  liveQASessionSettings?: {
    __typename?: 'SessionSettings';
    eventId: string;
    sessionId: string;
    qaEnabled: boolean;
    qaCustomTimeFrameEnabled: boolean;
    qaStartDateTime?: string | null;
    qaEndDateTime?: string | null;
  } | null;
};

export type On_Update_QuestionSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<QuestionStatusType>;
}>;

export type On_Update_QuestionSubscription = {
  __typename?: 'Subscription';
  onUpdateQuestion?: {
    __typename?: 'Question';
    id: string;
    attendeeId?: string | null;
    attendeeName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAnonymous: boolean;
    text: string;
    answer?: string | null;
    status: QuestionStatusType;
    voteCount: number;
    createDateTime: string;
    statusChangeDateTime: string;
    displayDateTime?: string | null;
    isCurrentQuestion?: boolean | null;
    isVoted?: boolean | null;
  } | null;
};

export type On_Update_Session_SettingsSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type On_Update_Session_SettingsSubscription = {
  __typename?: 'Subscription';
  onUpdateSessionSettings?: {
    __typename?: 'SessionSettings';
    eventId: string;
    sessionId: string;
    qaEnabled: boolean;
    qaCustomTimeFrameEnabled: boolean;
    qaStartDateTime?: string | null;
    qaEndDateTime?: string | null;
    autoModerationEnabled?: boolean | null;
    askAnonymouslyEnabled?: boolean | null;
  } | null;
};

export type Set_Question_AnswerMutationVariables = Exact<{
  input: QuestionAnswerInput;
}>;

export type Set_Question_AnswerMutation = {
  __typename?: 'Mutation';
  setQuestionTextAnswer?: {
    __typename?: 'Question';
    id: string;
    attendeeId?: string | null;
    attendeeName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAnonymous: boolean;
    text: string;
    answer?: string | null;
    status: QuestionStatusType;
    voteCount: number;
    createDateTime: string;
    statusChangeDateTime: string;
    displayDateTime?: string | null;
    isCurrentQuestion?: boolean | null;
    isVoted?: boolean | null;
    eventId: string;
    sessionId: string;
  } | null;
};

export type Update_Question_StatusMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  questionStatusInput: QuestionStatusInput;
}>;

export type Update_Question_StatusMutation = {
  __typename?: 'Mutation';
  updateQuestionStatus?: {
    __typename?: 'Question';
    id: string;
    attendeeId?: string | null;
    attendeeName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAnonymous: boolean;
    text: string;
    answer?: string | null;
    status: QuestionStatusType;
    voteCount: number;
    createDateTime: string;
    statusChangeDateTime: string;
    displayDateTime?: string | null;
    isCurrentQuestion?: boolean | null;
    isVoted?: boolean | null;
    eventId: string;
    sessionId: string;
  } | null;
};

export type Update_Session_SettingsMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  input: SessionSettingsInput;
}>;

export type Update_Session_SettingsMutation = {
  __typename?: 'Mutation';
  updateSessionSettings?: {
    __typename?: 'SessionSettings';
    eventId: string;
    sessionId: string;
    qaEnabled: boolean;
    qaCustomTimeFrameEnabled: boolean;
    qaStartDateTime?: string | null;
    qaEndDateTime?: string | null;
    autoModerationEnabled?: boolean | null;
    askAnonymouslyEnabled?: boolean | null;
  } | null;
};

export type Up_Vote_QuestionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}>;

export type Up_Vote_QuestionMutation = {
  __typename?: 'Mutation';
  upVoteQuestion?: {
    __typename?: 'Question';
    id: string;
    attendeeId?: string | null;
    attendeeName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAnonymous: boolean;
    text: string;
    answer?: string | null;
    status: QuestionStatusType;
    voteCount: number;
    createDateTime: string;
    statusChangeDateTime: string;
    displayDateTime?: string | null;
    isCurrentQuestion?: boolean | null;
    isVoted?: boolean | null;
    eventId: string;
    sessionId: string;
  } | null;
};

export type Authorize_Pub_Nub_EntityQueryVariables = Exact<{
  authKey: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;

export type Authorize_Pub_Nub_EntityQuery = {
  __typename?: 'Query';
  authorizePubNubEntity?: {
    __typename?: 'PubNubConfig';
    publishKey: string;
    subscribeKey: string;
    authKey: string;
    channels?: Array<string | null> | null;
  } | null;
};

export type Get_Pub_Nub_ConfigQueryVariables = Exact<{
  clientType?: InputMaybe<PubNubClientType>;
}>;

export type Get_Pub_Nub_ConfigQuery = {
  __typename?: 'Query';
  pubNubConfig?: {
    __typename?: 'PubNubConfig';
    publishKey: string;
    subscribeKey: string;
    authKey: string;
    channels?: Array<string | null> | null;
  } | null;
};

export type Revoke_Pub_Nub_Auth_KeyMutationVariables = Exact<{
  authKey: Scalars['ID']['input'];
}>;

export type Revoke_Pub_Nub_Auth_KeyMutation = { __typename?: 'Mutation'; revokePubNubAuthKey?: boolean | null };

export type Apply_DiscountMutationVariables = Exact<{
  input: DiscountInput;
}>;

export type Apply_DiscountMutation = {
  __typename?: 'Mutation';
  applyDiscount?: {
    __typename?: 'OrderSummary';
    regCartId: string;
    paymentSummary: {
      __typename?: 'PaymentSummary';
      admissionItemPrice?: number | null;
      subTotal?: number | null;
      orderTotal?: number | null;
    };
    refundSummary: { __typename?: 'RefundSummary'; admissionItemPrice?: number | null };
    taxes?: Array<{
      __typename?: 'Tax';
      taxId: string;
      taxName?: string | null;
      taxCode?: string | null;
      totalTaxAmount?: number | null;
    } | null> | null;
    discounts?: Array<{ __typename?: 'Discount'; code: string; isAuto?: boolean | null } | null> | null;
    paymentTypeServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
    paymentAmountServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
  } | null;
};

export type Get_Order_DetailsQueryVariables = Exact<{
  regCartStatusInput: RegCartStatusInput;
}>;

export type Get_Order_DetailsQuery = {
  __typename?: 'Query';
  getOrderSummaryDetails?: {
    __typename?: 'OrderSummary';
    regCartId: string;
    configurationId?: string | null;
    applicationId?: string | null;
    paymentSummary: {
      __typename?: 'PaymentSummary';
      admissionItemPrice?: number | null;
      orderTotal?: number | null;
      subTotal?: number | null;
    };
    refundSummary: { __typename?: 'RefundSummary'; admissionItemPrice?: number | null };
    taxes?: Array<{
      __typename?: 'Tax';
      taxId: string;
      taxName?: string | null;
      taxCode?: string | null;
      totalTaxAmount?: number | null;
    } | null> | null;
    discounts?: Array<{ __typename?: 'Discount'; code: string; isAuto?: boolean | null } | null> | null;
    paymentTypeServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
    paymentAmountServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
  } | null;
};

export type Get_Order_StatusQueryVariables = Exact<{
  orderCheckoutStatusInput: OrderCheckoutStatusInput;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Order_StatusQuery = {
  __typename?: 'Query';
  getOrderCheckoutStatus?: {
    __typename?: 'OrderCheckoutStatus';
    progress: number;
    redirectUrl?: any | null;
    code: OrderCheckoutStatusCode;
    admissionItem?: { __typename?: 'AdmissionItem'; id: string; name: string } | null;
  } | null;
};

export type Get_Order_SummaryMutationVariables = Exact<{
  input: InitiateRegModInput;
}>;

export type Get_Order_SummaryMutation = {
  __typename?: 'Mutation';
  initiateRegModAndGetOrderSummaryDetails?: {
    __typename?: 'OrderSummary';
    regCartId: string;
    configurationId?: string | null;
    applicationId?: string | null;
    paymentSummary: {
      __typename?: 'PaymentSummary';
      admissionItemPrice?: number | null;
      subTotal?: number | null;
      orderTotal?: number | null;
    };
    refundSummary: { __typename?: 'RefundSummary'; admissionItemPrice?: number | null };
    taxes?: Array<{
      __typename?: 'Tax';
      taxId: string;
      taxName?: string | null;
      taxCode?: string | null;
      totalTaxAmount?: number | null;
    } | null> | null;
    discounts?: Array<{ __typename?: 'Discount'; code: string; isAuto?: boolean | null } | null> | null;
    paymentTypeServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
    paymentAmountServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
  } | null;
};

export type Get_Payment_Method_Service_FeesQueryVariables = Exact<{ [key: string]: never }>;

export type Get_Payment_Method_Service_FeesQuery = {
  __typename?: 'Query';
  getPaymentMethodServiceFees?: Array<{
    __typename?: 'PaymentMethodServiceFee';
    paymentMethod?: string | null;
    fees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
      adjustmentType?: AdjustmentType | null;
    } | null> | null;
  }> | null;
};

export type Order_CheckoutMutationVariables = Exact<{
  orderCheckoutInput: OrderCheckoutInput;
}>;

export type Order_CheckoutMutation = { __typename?: 'Mutation'; initiateOrderCheckout?: boolean | null };

export type Remove_DiscountMutationVariables = Exact<{
  input: DiscountInput;
}>;

export type Remove_DiscountMutation = {
  __typename?: 'Mutation';
  removeDiscount?: {
    __typename?: 'OrderSummary';
    regCartId: string;
    paymentSummary: {
      __typename?: 'PaymentSummary';
      admissionItemPrice?: number | null;
      subTotal?: number | null;
      orderTotal?: number | null;
    };
    refundSummary: { __typename?: 'RefundSummary'; admissionItemPrice?: number | null };
    taxes?: Array<{
      __typename?: 'Tax';
      taxId: string;
      taxName?: string | null;
      taxCode?: string | null;
      totalTaxAmount?: number | null;
    } | null> | null;
    discounts?: Array<{ __typename?: 'Discount'; code: string; isAuto?: boolean | null } | null> | null;
    paymentTypeServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
    paymentAmountServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
  } | null;
};

export type Update_RegcartMutationVariables = Exact<{
  input: RegCartInput;
}>;

export type Update_RegcartMutation = {
  __typename?: 'Mutation';
  updateRegCart?: {
    __typename?: 'OrderSummary';
    regCartId: string;
    paymentSummary: {
      __typename?: 'PaymentSummary';
      admissionItemPrice?: number | null;
      orderTotal?: number | null;
      subTotal?: number | null;
    };
    refundSummary: { __typename?: 'RefundSummary'; admissionItemPrice?: number | null };
    taxes?: Array<{
      __typename?: 'Tax';
      taxId: string;
      totalTaxAmount?: number | null;
      taxName?: string | null;
      taxCode?: string | null;
    } | null> | null;
    discounts?: Array<{ __typename?: 'Discount'; code: string; isAuto?: boolean | null } | null> | null;
    paymentTypeServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
    paymentAmountServiceFees?: Array<{
      __typename?: 'ServiceFee';
      id: string;
      amount?: number | null;
      name?: string | null;
      code?: string | null;
    } | null> | null;
  } | null;
};

export type Update_Regcart_StatusMutationVariables = Exact<{
  input: RegCartStatusInput;
}>;

export type Update_Regcart_StatusMutation = { __typename?: 'Mutation'; updateRegCartStatus?: boolean | null };

export type Get_Post_Reg_Redirect_UrlQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
  attendeeEmail: Scalars['String']['input'];
  attendeeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type Get_Post_Reg_Redirect_UrlQuery = {
  __typename?: 'Query';
  postRegRedirectUrl?: {
    __typename?: 'PostRegRedirectUrlResponse';
    redirect: boolean;
    postRegRedirectUrl?: { __typename?: 'PostRegRedirectUrl'; id: string; verificationId: string } | null;
  } | null;
};

export type Get_Event_Profile_SettingsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type Get_Event_Profile_SettingsQuery = {
  __typename?: 'Query';
  getEventProfileSettings?: {
    __typename?: 'EventProfileSettings';
    lastModifiedDate?: any | null;
    profileFieldGroupSettings: {
      __typename?: 'ProfileFieldGroupSettingsWrapper';
      lastModifiedBy?: string | null;
      lastModifiedDate?: any | null;
      profileFieldGroupsList: Array<{
        __typename?: 'ProfileFieldGroupSettings';
        name: string;
        enabled: boolean;
        readOnly: boolean;
        required: boolean;
        forceReadOnly: boolean;
        sortOrder: number;
        fields: Array<{ __typename?: 'ProfileField'; name: string; valueRequired?: boolean | null }>;
      }>;
    };
    profileCardDesignSettings: {
      __typename?: 'ProfileCardDesignSettingsWrapper';
      lastModifiedBy?: string | null;
      lastModifiedDate?: any | null;
      profileCardDesignSettingsList: Array<{
        __typename?: 'ProfileCardSettings';
        border: string;
        eventBranding: string;
        alignment: string;
      }>;
    };
  } | null;
};

export type Agenda_DatesQueryVariables = Exact<{
  params: AgendaDatesInput;
}>;

export type Agenda_DatesQuery = {
  __typename?: 'Query';
  getAgendaDates?: {
    __typename?: 'AgendaDatesResponse';
    data: Array<{ __typename?: 'AgendaDate'; agendaDate: string }>;
  } | null;
};

export type Search_ScheduleQueryVariables = Exact<{
  criteria?: InputMaybe<MyAgendaCriteria>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  enableSessionCapacity: Scalars['Boolean']['input'];
  enableSessionFee: Scalars['Boolean']['input'];
}>;

export type Search_ScheduleQuery = {
  __typename?: 'Query';
  myAgenda?: {
    __typename?: 'AgendaPaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      limit: number;
      totalCount: number;
      nextToken?: string | null;
      currentToken: string;
    } | null;
    data: Array<{
      __typename?: 'AgendaItem';
      id: string;
      name: string;
      description?: string | null;
      start: any;
      end: any;
      status?: AppointmentConfirmationStatus | null;
      enrolled?: boolean | null;
      included?: boolean | null;
      virtual?: boolean | null;
      virtualLink?: string | null;
      openForRegistration?: boolean | null;
      featured?: boolean | null;
      type: AgendaItemType;
      openForAttendeeHub?: boolean | null;
      conflict?: boolean | null;
      contentTags?: Array<{ __typename?: 'ContentTag'; name: string }> | null;
      category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      exhibitors: Array<{
        __typename?: 'SessionExhibitor';
        id: string;
        name: string;
        description?: string | null;
        profileLogoUrl?: string | null;
        featured?: boolean | null;
      }>;
      webcast?: {
        __typename?: 'Webcast';
        id: string;
        eventId: string;
        sessionId: string;
        format?: WebcastFormat | null;
        title?: string | null;
        sourceId?: string | null;
        provider?: string | null;
        meetingId?: string | null;
        details?: string | null;
        playerType?: string | null;
        type?: string | null;
        simulatedLive?: boolean | null;
        onDemandVideo?: boolean | null;
        isOnDemandContentPlayable?: boolean | null;
        solutionType?: string | null;
        player?: {
          __typename?: 'WebcastPlayer';
          id: string;
          playerTypeProvider?: string | null;
          duration?: number | null;
          simuliveOffset?: number | null;
          stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
        } | null;
      } | null;
      capacity?: {
        __typename?: 'CapacityRemaining';
        active?: boolean | null;
        availableCapacity?: number | null;
        totalCapacityAvailable?: number | null;
      } | null;
      fee?: { __typename?: 'SessionFee'; amount: number } | null;
      participants: Array<{
        __typename?: 'AppointmentParticipant';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        type?: string | null;
      }>;
      requesters?: Array<{
        __typename?: 'ApptAttendee';
        firstName: string;
        lastName: string;
        status: ApptAttendeeStatus;
      }> | null;
      requestees?: Array<{
        __typename?: 'ApptAttendee';
        firstName: string;
        lastName: string;
        status: ApptAttendeeStatus;
      }> | null;
      apptType?: { __typename?: 'AppointmentType'; category: string; timeSlotType: string } | null;
      availableAttendeeActions?: {
        __typename?: 'AppointmentAttendeeActions';
        accept?: boolean | null;
        decline?: boolean | null;
      } | null;
    }>;
  } | null;
};

export type Search_Schedule_With_SpeakersQueryVariables = Exact<{
  criteria?: InputMaybe<MyAgendaCriteria>;
}>;

export type Search_Schedule_With_SpeakersQuery = {
  __typename?: 'Query';
  myAgenda?: {
    __typename?: 'AgendaPaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      limit: number;
      totalCount: number;
      nextToken?: string | null;
      currentToken: string;
    } | null;
    data: Array<{
      __typename?: 'AgendaItem';
      id: string;
      name: string;
      description?: string | null;
      start: any;
      end: any;
      status?: AppointmentConfirmationStatus | null;
      enrolled?: boolean | null;
      included?: boolean | null;
      virtual?: boolean | null;
      virtualLink?: string | null;
      openForRegistration?: boolean | null;
      featured?: boolean | null;
      type: AgendaItemType;
      openForAttendeeHub?: boolean | null;
      contentTags?: Array<{ __typename?: 'ContentTag'; name: string }> | null;
      category?: { __typename?: 'SessionCategory'; id?: string | null; name: string } | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      exhibitors: Array<{
        __typename?: 'SessionExhibitor';
        id: string;
        name: string;
        description?: string | null;
        profileLogoUrl?: string | null;
        featured?: boolean | null;
      }>;
      webcast?: {
        __typename?: 'Webcast';
        id: string;
        eventId: string;
        sessionId: string;
        format?: WebcastFormat | null;
        title?: string | null;
        sourceId?: string | null;
        provider?: string | null;
        meetingId?: string | null;
        details?: string | null;
        playerType?: string | null;
        type?: string | null;
        simulatedLive?: boolean | null;
        onDemandVideo?: boolean | null;
        isOnDemandContentPlayable?: boolean | null;
        solutionType?: string | null;
        player?: {
          __typename?: 'WebcastPlayer';
          id: string;
          playerTypeProvider?: string | null;
          duration?: number | null;
          simuliveOffset?: number | null;
          stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
        } | null;
      } | null;
      participants: Array<{
        __typename?: 'AppointmentParticipant';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        profileImageUrl?: string | null;
        type?: string | null;
      }>;
      speakers?: Array<{
        __typename?: 'Speaker';
        id: string;
        firstName: string;
        lastName: string;
        company?: string | null;
        email?: string | null;
        title?: string | null;
        biography?: string | null;
        profileImageUri?: string | null;
        socialLinks: {
          __typename?: 'SocialLinks';
          facebookUrl?: string | null;
          twitterUrl?: string | null;
          linkedInUrl?: string | null;
        };
      }> | null;
    }>;
  } | null;
};

export type Add_ReactionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: AddReactionInput;
}>;

export type Add_ReactionMutation = {
  __typename?: 'Mutation';
  addReaction?: {
    __typename?: 'AddReactionOutput';
    environment?: string | null;
    sessionId: string;
    eventId: string;
    attendeeId: string;
    accountMappingId: string;
    reactionType: number;
    streamOffsetSecs: number;
  } | null;
};

export type Generate_Attendee_Join_UrlMutationVariables = Exact<{
  attendeeRegistrationInput?: InputMaybe<AttendeeRegistrationInput>;
}>;

export type Generate_Attendee_Join_UrlMutation = {
  __typename?: 'Mutation';
  generateAttendeeJoinUrl?: { __typename?: 'AttendeeJoinUrl'; joinUrl?: string | null } | null;
};

export type Generate_Webcast_Signature_V2MutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Generate_Webcast_Signature_V2Mutation = {
  __typename?: 'Mutation';
  generateWebcastSignatureV2?: {
    __typename?: 'WebcastSignature';
    signature: string;
    signatureExpirationDate: any;
  } | null;
};

export type Get_Attendee_On_Demand_CatalogQueryVariables = Exact<{
  criteria?: InputMaybe<OnDemandPageInput>;
}>;

export type Get_Attendee_On_Demand_CatalogQuery = {
  __typename?: 'Query';
  getAttendeeOnDemandCatalogV2?: {
    __typename?: 'OnDemandCatalog';
    id: string;
    lastModified: any;
    created: any;
    catalogType: CatalogType;
    sectionCount?: number | null;
    sections?: Array<{
      __typename?: 'OnDemandCatalogSection';
      id: string;
      title?: string | null;
      videoCount?: number | null;
      sectionType: CatalogSectionType;
      videos?: Array<{
        __typename?: 'OnDemandCatalogVideo';
        id: string;
        displayName?: string | null;
        duration?: number | null;
        thumbnail?: string | null;
        sessionId: string;
        status: VideoStatus;
        session?: {
          __typename?: 'Session';
          id: string;
          name: string;
          code?: string | null;
          start: any;
          end: any;
          description?: string | null;
          featured: boolean;
          virtual: boolean;
          openForRegistration: boolean;
          included: boolean;
          location?: {
            __typename?: 'SessionLocation';
            id?: string | null;
            name?: string | null;
            code?: string | null;
          } | null;
          category?: { __typename?: 'SessionCategory'; id?: string | null; name: string; code?: string | null } | null;
          exhibitors?: Array<{
            __typename?: 'SessionExhibitor';
            id: string;
            name: string;
            sponsorshipLevelId?: string | null;
          } | null> | null;
        } | null;
      }> | null;
    } | null> | null;
  } | null;
};

export type Get_Has_Reactions_DataQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Has_Reactions_DataQuery = {
  __typename?: 'Query';
  getHasReactionsData?: { __typename?: 'HasReactionsGetResponse'; hasData: boolean } | null;
};

export type Get_ReactionsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  startSecs: Scalars['Int']['input'];
  endSecs: Scalars['Int']['input'];
}>;

export type Get_ReactionsQuery = {
  __typename?: 'Query';
  getReactions?: {
    __typename?: 'ReactionsGetResponse';
    streamTimeStart: number;
    streamTimeEnd: number;
    reactionCountsByType: Array<{
      __typename?: 'ReactionsCountTupleOutput';
      reactionType: number;
      counts: Array<number>;
    }>;
  } | null;
};

export type Get_Reactions_ConfigQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Reactions_ConfigQuery = {
  __typename?: 'Query';
  getReactionsSessionConfigAttendee?: {
    __typename?: 'ReactionsSessionConfigOutput';
    accountId: number;
    sessionId: string;
    eventId: string;
    reactionTypes?: Array<number> | null;
    enabled: boolean;
  } | null;
};

export type Session_FiltersQueryVariables = Exact<{
  criteria?: InputMaybe<SessionFilterCriteria>;
}>;

export type Session_FiltersQuery = {
  __typename?: 'Query';
  sessionFilters: {
    __typename?: 'SessionFiltersAndDates';
    dates: Array<any>;
    filters: Array<{
      __typename?: 'SessionFilter';
      id: string;
      name: string;
      filterName?: string | null;
      type: string;
      order?: number | null;
      valuesWithSpeakers: Array<
        | { __typename?: 'SessionFilterValue'; id?: string | null; name: string }
        | {
            __typename?: 'SessionSpeakerFilterValue';
            id?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            company?: string | null;
            profileImageUri?: string | null;
            title?: string | null;
            designation?: string | null;
          }
        | null
      >;
    }>;
    sessionGuide?: {
      __typename?: 'SessionGuide';
      preFilters: Array<{
        __typename?: 'PreFilterList';
        id: string;
        name?: string | null;
        order?: number | null;
        filters?: Array<{
          __typename?: 'PreFilter';
          filterId: string;
          name?: string | null;
          type?: PreFilterType | null;
          options: Array<{ __typename?: 'PreFilterOption'; optionId?: string | null; value?: string | null }>;
        }> | null;
      }>;
    } | null;
  };
};

export type Get_Session_Live_Viewer_CountQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Session_Live_Viewer_CountQuery = {
  __typename?: 'Query';
  getSessionLiveViewerCount?: {
    __typename?: 'SessionLiveViewerCount';
    liveViewers: number;
    minute: any;
    createdAt?: any | null;
    lastModified?: any | null;
  } | null;
};

export type Get_Session_Live_Viewer_Count_At_OffsetQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  batchSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type Get_Session_Live_Viewer_Count_At_OffsetQuery = {
  __typename?: 'Query';
  getSessionLiveViewerCountAtOffset?: {
    __typename?: 'SessionLiveViewerCountAtOffset';
    environment?: string | null;
    eventId: string;
    sessionId: string;
    offset: number;
    batchSize?: number | null;
    liveViewerCounts?: Array<{
      __typename?: 'SessionLiveViewerCount';
      liveViewers: number;
      minute: any;
      createdAt?: any | null;
      lastModified?: any | null;
    } | null> | null;
  } | null;
};

export type Get_Session_Participant_StatusQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Session_Participant_StatusQuery = {
  __typename?: 'Query';
  getSessionParticipantStatus?: boolean | null;
};

export type Get_Webcast_LinksQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Get_Webcast_LinksQuery = {
  __typename?: 'Query';
  getWebcastLinks?: {
    __typename?: 'WebcastLinks';
    host?: { __typename?: 'WebcastLink'; href?: string | null } | null;
    speaker?: { __typename?: 'WebcastLink'; href?: string | null } | null;
  } | null;
};

export type Livestream_JobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type Livestream_JobQuery = {
  __typename?: 'Query';
  livestreamJob?: { __typename?: 'LivestreamJob'; id: string; status: LivestreamStatus } | null;
};

export type OnStudioEndSessionSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
}>;

export type OnStudioEndSessionSubscription = {
  __typename?: 'Subscription';
  onStudioEndSession?: { __typename?: 'StudioEndSessionResponse'; success: boolean } | null;
};

export type On_Update_Reaction_CountsSubscriptionVariables = Exact<{
  eventId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type On_Update_Reaction_CountsSubscription = {
  __typename?: 'Subscription';
  onUpdateReactions?: {
    __typename?: 'ReactionsBroadcastOutput';
    sessionId: string;
    eventId: string;
    environment?: string | null;
    version: string;
    reactionsData: Array<{
      __typename?: 'ReactionsWithOffsetOutput';
      streamOffsetSecs: number;
      reactionCountTuples: Array<{ __typename?: 'ReactionsCountTuplesOutput'; reactionType: number; counts: number }>;
    }>;
  } | null;
};

export type OnUpdateWebcastConfigSubscriptionVariables = Exact<{
  webcastId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
}>;

export type OnUpdateWebcastConfigSubscription = {
  __typename?: 'Subscription';
  onUpdateWebcastConfig?: {
    __typename?: 'WebcastConfigUpdateResponse';
    webcastId: string;
    sessionId: string;
    eventId?: string | null;
  } | null;
};

export type OnUpdateWebcastLiveStatusSubscriptionVariables = Exact<{
  webcastId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
}>;

export type OnUpdateWebcastLiveStatusSubscription = {
  __typename?: 'Subscription';
  onUpdateWebcastLiveStatus?: {
    __typename?: 'LiveStatusUpdateResponse';
    playerId: string;
    webcastId: string;
    sessionId: string;
    eventId?: string | null;
    streamStatus: PlayerStreamStatus;
  } | null;
};

export type Publish_EncounterMutationVariables = Exact<{
  session: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['AWSDateTime']['input']>;
  relative?: InputMaybe<Scalars['Int']['input']>;
  mode: EncounterMode;
}>;

export type Publish_EncounterMutation = { __typename?: 'Mutation'; publishEncounter?: boolean | null };

export type Search_SessionsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchSessionCriteria>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  enableSessionCapacity: Scalars['Boolean']['input'];
}>;

export type Search_SessionsQuery = {
  __typename?: 'Query';
  searchSessions?: {
    __typename?: 'SessionPaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      currentToken: string;
      nextToken?: string | null;
      previousToken?: string | null;
      limit: number;
      totalCount: number;
    } | null;
    data: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      code?: string | null;
      start: any;
      end: any;
      description?: string | null;
      enrolled: boolean;
      included: boolean;
      featured: boolean;
      virtual: boolean;
      openForRegistration: boolean;
      admissionItems?: Array<string | null> | null;
      upgrade?: boolean | null;
      openForAttendeeHub: boolean;
      recommended?: boolean | null;
      sessionTags?: Array<string> | null;
      capacity?: {
        __typename?: 'CapacityRemaining';
        active?: boolean | null;
        availableCapacity?: number | null;
        totalCapacityAvailable?: number | null;
      } | null;
      category?: { __typename?: 'SessionCategory'; id?: string | null; name: string; code?: string | null } | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      sessionSpeakers?: Array<{
        __typename?: 'Speaker';
        id: string;
        firstName: string;
        lastName: string;
        company?: string | null;
        title?: string | null;
        profileImageUri?: string | null;
        designation?: string | null;
        prefix?: string | null;
      }> | null;
      customFields?: Array<{
        __typename?: 'SessionCustomField';
        name: string;
        plannerSelected?: boolean | null;
        value: Array<string | null>;
      }> | null;
      exhibitors?: Array<{
        __typename?: 'SessionExhibitor';
        id: string;
        name: string;
        description?: string | null;
        profileLogoId?: string | null;
        profileLogoUrl?: string | null;
        hidden?: boolean | null;
        featured?: boolean | null;
        eventSponsor?: boolean | null;
        sponsorshipLevelId?: string | null;
      } | null> | null;
      fee?: { __typename?: 'SessionFee'; amount: number } | null;
      webcast?: {
        __typename?: 'Webcast';
        id: string;
        sessionId: string;
        eventId: string;
        format?: WebcastFormat | null;
        playerType?: string | null;
        onDemandVideo?: boolean | null;
        isOnDemandContentPlayable?: boolean | null;
        player?: {
          __typename?: 'WebcastPlayer';
          id: string;
          playerTypeProvider?: string | null;
          duration?: number | null;
          simuliveOffset?: number | null;
          stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type Search_Sessions_CountQueryVariables = Exact<{
  criteria?: InputMaybe<SearchSessionCriteria>;
}>;

export type Search_Sessions_CountQuery = {
  __typename?: 'Query';
  searchSessions?: {
    __typename?: 'SessionPaginatedResults';
    pagination?: { __typename?: 'Pagination'; totalCount: number } | null;
  } | null;
};

export type Search_Sessions_SwapQueryVariables = Exact<{
  criteria?: InputMaybe<SearchSessionCriteria>;
}>;

export type Search_Sessions_SwapQuery = {
  __typename?: 'Query';
  searchSessions?: {
    __typename?: 'SessionPaginatedResults';
    pagination?: {
      __typename?: 'Pagination';
      currentToken: string;
      nextToken?: string | null;
      previousToken?: string | null;
      limit: number;
      totalCount: number;
    } | null;
    data: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      start: any;
      end: any;
      featured: boolean;
      virtual: boolean;
      openForAttendeeHub: boolean;
      openForRegistration: boolean;
      enrolled: boolean;
      included: boolean;
      sessionTags?: Array<string> | null;
      category?: { __typename?: 'SessionCategory'; name: string } | null;
    }>;
  } | null;
};

export type Search_Sessions_With_On_DemandQueryVariables = Exact<{
  criteria?: InputMaybe<SearchSessionCriteria>;
}>;

export type Search_Sessions_With_On_DemandQuery = {
  __typename?: 'Query';
  getOnDemandSessions?: {
    __typename?: 'SessionPaginatedResults';
    pagination?: { __typename?: 'Pagination'; nextToken?: string | null } | null;
    data: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      code?: string | null;
      start: any;
      end: any;
      description?: string | null;
      enrolled: boolean;
      included: boolean;
      featured: boolean;
      virtual: boolean;
      openForRegistration: boolean;
      openForAttendeeHub: boolean;
      category?: { __typename?: 'SessionCategory'; id?: string | null; name: string; code?: string | null } | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      onDemandVideo?: {
        __typename?: 'Video';
        id: string;
        thumbnailUrl?: string | null;
        duration?: number | null;
      } | null;
    }>;
  } | null;
};

export type Session_DetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  qaLimit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  enableSessionCapacity: Scalars['Boolean']['input'];
}>;

export type Session_DetailQuery = {
  __typename?: 'Query';
  sessionDetail?: {
    __typename?: 'SessionDetail';
    id: string;
    name: string;
    description?: string | null;
    start: any;
    end: any;
    enrolled: boolean;
    participant: boolean;
    featured: boolean;
    virtual: boolean;
    included: boolean;
    status: string;
    openForRegistration: boolean;
    openForAttendeeHub: boolean;
    recommended?: boolean | null;
    tags?: Array<string> | null;
    hasPoll: boolean;
    category?: { __typename?: 'SessionCategory'; name: string } | null;
    location?: { __typename?: 'SessionLocation'; id?: string | null; name?: string | null } | null;
    speakers: Array<{
      __typename?: 'Speaker';
      id: string;
      firstName: string;
      lastName: string;
      company?: string | null;
      email?: string | null;
      title?: string | null;
      biography?: string | null;
      designation?: string | null;
      profileImageUri?: string | null;
      prefix?: string | null;
      socialLinks: {
        __typename?: 'SocialLinks';
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        linkedInUrl?: string | null;
      };
    }>;
    webcast?: {
      __typename?: 'Webcast';
      id: string;
      eventId: string;
      sessionId: string;
      format?: WebcastFormat | null;
      title?: string | null;
      sourceId?: string | null;
      provider?: string | null;
      meetingId?: string | null;
      details?: string | null;
      playerType?: string | null;
      solutionType?: string | null;
      type?: string | null;
      simulatedLive?: boolean | null;
      onDemandVideo?: boolean | null;
      links?: {
        __typename?: 'WebcastLinks';
        attendee?: { __typename?: 'WebcastLink'; href?: string | null; code?: string | null } | null;
        host?: { __typename?: 'WebcastLink'; href?: string | null; code?: string | null } | null;
        join?: { __typename?: 'WebcastLink'; href?: string | null; code?: string | null } | null;
        recording?: { __typename?: 'WebcastLink'; href?: string | null; code?: string | null } | null;
        speaker?: { __typename?: 'WebcastLink'; href?: string | null; code?: string | null } | null;
      } | null;
      player?: {
        __typename?: 'WebcastPlayer';
        id: string;
        videoId?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        password?: string | null;
        playerTypeProvider?: string | null;
        duration?: number | null;
        simuliveOffset?: number | null;
        stream?: {
          __typename?: 'PlayerStream';
          id?: string | null;
          status?: PlayerStreamStatus | null;
          recording?: {
            __typename?: 'PlayerStreamRecording';
            id?: string | null;
            status?: PlayerStreamRecordingStatus | null;
          } | null;
        } | null;
      } | null;
    } | null;
    settings?: {
      __typename?: 'SessionSettings';
      eventId: string;
      sessionId: string;
      qaEnabled: boolean;
      qaCustomTimeFrameEnabled: boolean;
      qaStartDateTime?: string | null;
      qaEndDateTime?: string | null;
      autoModerationEnabled?: boolean | null;
      askAnonymouslyEnabled?: boolean | null;
    } | null;
    customFields?: Array<{
      __typename?: 'SessionCustomField';
      id: string;
      name: string;
      value: Array<string | null>;
      type: SessionCustomFieldType;
      plannerSelected?: boolean | null;
      filterName?: string | null;
    } | null> | null;
    documents?: Array<{
      __typename?: 'SessionDocument';
      id: string;
      name: string;
      uri: string;
      size?: number | null;
      extension: string;
      sortOrder?: number | null;
    }> | null;
    chatSettings?: {
      __typename?: 'ChatSettings';
      isEnabled: boolean;
      timeRange?: { __typename?: 'ChatSettingsTimeRange'; startDate: string; endDate: string } | null;
      stream?: {
        __typename?: 'ChatStreamSettings';
        isAvailable: boolean;
        channelId: string;
        channelType: string;
        readOnly?: boolean | null;
      } | null;
    } | null;
    feedbackSurvey?: {
      __typename?: 'SessionFeedbackSurvey';
      surveyUrl: string;
      startOffset?: number | null;
      closeDate?: string | null;
      audience: SurveyAudience;
    } | null;
    exhibitors: Array<{
      __typename?: 'SessionExhibitor';
      id: string;
      name: string;
      description?: string | null;
      profileLogoId?: string | null;
      profileLogoUrl?: string | null;
      hidden?: boolean | null;
      featured?: boolean | null;
      eventSponsor?: boolean | null;
      sponsorshipLevelId?: string | null;
      sponsorshipLevel?: { __typename?: 'SponsorshipLevel'; rank?: number | null; id: string; name: string } | null;
    }>;
    fee?: { __typename?: 'SessionFee'; amount: number } | null;
    participationThresholdSettings?: {
      __typename?: 'SessionParticipationThresholdSettings';
      participationThreshold?: number | null;
      participationLiveOnly?: number | null;
    } | null;
    widgets?: Array<{
      __typename?: 'AssignedWidgetSession';
      widgetId: string;
      sessionId: string;
      widgetTitle?: string | null;
      widgetIcon?: string | null;
      code?: string | null;
      updatedAt?: any | null;
    }> | null;
    capacity?: {
      __typename?: 'CapacityRemaining';
      totalCapacityAvailable?: number | null;
      availableCapacity?: number | null;
      active?: boolean | null;
    } | null;
    floorPlan?: { __typename?: 'FloorPlanWithoutMarkers'; id: string } | null;
  } | null;
};

export type Session_EnrollmentMutationVariables = Exact<{
  sessionEnrollmentInput?: InputMaybe<SessionEnrollmentInput>;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  sessionFee: Scalars['Boolean']['input'];
  enableSessionCapacity: Scalars['Boolean']['input'];
}>;

export type Session_EnrollmentMutation = {
  __typename?: 'Mutation';
  sessionEnrollment?: {
    __typename?: 'SessionEnrollmentResponse';
    error?: {
      __typename?: 'EnrollmentError';
      details: Array<{
        __typename?: 'EnrollmentErrorDetail';
        code?: string | null;
        tokens: {
          __typename?: 'EnrollmentErrorTokens';
          quantity?: number | null;
          min?: number | null;
          max?: number | null;
          warningMessage?: string | null;
          groupId?: string | null;
          sessionId?: string | null;
          session1?: string | null;
          session2?: string | null;
        };
      }>;
    } | null;
    sessions?: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      start: any;
      end: any;
      enrolled: boolean;
      included: boolean;
      featured: boolean;
      virtual: boolean;
      openForAttendeeHub: boolean;
      openForRegistration: boolean;
      recommended?: boolean | null;
      sessionTags?: Array<string> | null;
      category?: { __typename?: 'SessionCategory'; name: string } | null;
      fee?: { __typename?: 'SessionFee'; amount: number } | null;
      capacity?: {
        __typename?: 'CapacityRemaining';
        totalCapacityAvailable?: number | null;
        availableCapacity?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type Studio_End_SessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
}>;

export type Studio_End_SessionMutation = {
  __typename?: 'Mutation';
  studioEndSession?: {
    __typename?: 'StudioEndSessionResponse';
    webcastId: string;
    sessionId: string;
    success: boolean;
  } | null;
};

export type Verify_Session_ChatMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Verify_Session_ChatMutation = {
  __typename?: 'Mutation';
  verifySessionChat?: {
    __typename?: 'ChatVerification';
    status: string;
    limit?: number | null;
    remaining?: number | null;
    resetAt?: number | null;
    errorValue?: number | null;
  } | null;
};

export type Verify_Session_Chat_ModeratorMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type Verify_Session_Chat_ModeratorMutation = {
  __typename?: 'Mutation';
  verifySessionChatModerator?: {
    __typename?: 'ChatModeratorVerification';
    isModerator?: boolean | null;
    status: string;
    limit?: number | null;
    remaining?: number | null;
    resetAt?: number | null;
  } | null;
};

export type Get_Featured_SpeakersQueryVariables = Exact<{
  criteria: SpeakerListCriteria;
}>;

export type Get_Featured_SpeakersQuery = {
  __typename?: 'Query';
  getSpeakerList: {
    __typename?: 'SpeakerPaginatedResults';
    data: Array<{
      __typename?: 'Speaker';
      id: string;
      order: number;
      firstName: string;
      lastName: string;
      prefix?: string | null;
      designation?: string | null;
      company?: string | null;
      title?: string | null;
      profileImageUri?: string | null;
      featured: boolean;
    }>;
  };
};

export type Get_Speaker_BioQueryVariables = Exact<{
  speakerCriteria: SpeakerCriteria;
  virtualAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  enableSessionCapacity: Scalars['Boolean']['input'];
  enableSessionFee: Scalars['Boolean']['input'];
}>;

export type Get_Speaker_BioQuery = {
  __typename?: 'Query';
  getSpeakerBio: {
    __typename?: 'SpeakerBio';
    id: string;
    order: number;
    firstName: string;
    lastName: string;
    email?: string | null;
    speakerCode: string;
    prefix?: string | null;
    designation?: string | null;
    company?: string | null;
    title?: string | null;
    visibility: boolean;
    biography?: string | null;
    internalNote?: string | null;
    featured: boolean;
    contactId?: string | null;
    profileImageUri?: string | null;
    speakerCategoryId?: string | null;
    speakerCategoryName?: string | null;
    tags?: Array<string> | null;
    documents: Array<{
      __typename?: 'SpeakerDocument';
      href: string;
      friendlyName?: string | null;
      type?: string | null;
      size?: number | null;
      displayEnabled?: boolean | null;
      file: { __typename?: 'SpeakerDocumentFile'; id: string };
    }>;
    socialLinks: {
      __typename?: 'SocialLinks';
      facebookUrl?: string | null;
      twitterUrl?: string | null;
      linkedInUrl?: string | null;
    };
    sessions: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      code?: string | null;
      start: any;
      end: any;
      description?: string | null;
      enrolled: boolean;
      included: boolean;
      featured: boolean;
      virtual: boolean;
      openForRegistration: boolean;
      admissionItems?: Array<string | null> | null;
      upgrade?: boolean | null;
      openForAttendeeHub: boolean;
      recommended?: boolean | null;
      sessionTags?: Array<string> | null;
      capacity?: {
        __typename?: 'CapacityRemaining';
        active?: boolean | null;
        availableCapacity?: number | null;
        totalCapacityAvailable?: number | null;
      } | null;
      fee?: { __typename?: 'SessionFee'; amount: number } | null;
      category?: { __typename?: 'SessionCategory'; id?: string | null; name: string; code?: string | null } | null;
      location?: {
        __typename?: 'SessionLocation';
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
      sessionSpeakers?: Array<{
        __typename?: 'Speaker';
        id: string;
        firstName: string;
        lastName: string;
        company?: string | null;
        title?: string | null;
        profileImageUri?: string | null;
        designation?: string | null;
        prefix?: string | null;
      }> | null;
      customFields?: Array<{
        __typename?: 'SessionCustomField';
        name: string;
        plannerSelected?: boolean | null;
        value: Array<string | null>;
      }> | null;
      exhibitors?: Array<{
        __typename?: 'SessionExhibitor';
        id: string;
        name: string;
        description?: string | null;
        profileLogoId?: string | null;
        profileLogoUrl?: string | null;
        hidden?: boolean | null;
        featured?: boolean | null;
        eventSponsor?: boolean | null;
        sponsorshipLevelId?: string | null;
      } | null> | null;
      webcast?: {
        __typename?: 'Webcast';
        id: string;
        sessionId: string;
        eventId: string;
        format?: WebcastFormat | null;
        playerType?: string | null;
        onDemandVideo?: boolean | null;
        isOnDemandContentPlayable?: boolean | null;
        player?: {
          __typename?: 'WebcastPlayer';
          id: string;
          playerTypeProvider?: string | null;
          duration?: number | null;
          simuliveOffset?: number | null;
          stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
        } | null;
      } | null;
    }>;
  };
};

export type Get_Speaker_ListQueryVariables = Exact<{
  criteria: SpeakerListCriteria;
}>;

export type Get_Speaker_ListQuery = {
  __typename?: 'Query';
  getSpeakerList: {
    __typename?: 'SpeakerPaginatedResults';
    featuredFilterable: boolean;
    data: Array<{
      __typename?: 'Speaker';
      id: string;
      order: number;
      firstName: string;
      lastName: string;
      email?: string | null;
      speakerCode: string;
      prefix?: string | null;
      designation?: string | null;
      company?: string | null;
      title?: string | null;
      biography?: string | null;
      featured: boolean;
      profileImageUri?: string | null;
      speakerCategoryId?: string | null;
    }>;
    pagination?: {
      __typename?: 'Pagination';
      currentToken: string;
      nextToken?: string | null;
      previousToken?: string | null;
      limit: number;
      totalCount: number;
    } | null;
  };
};

export type Get_Speaker_List_For_FilterQueryVariables = Exact<{
  criteria: SpeakerListCriteria;
}>;

export type Get_Speaker_List_For_FilterQuery = {
  __typename?: 'Query';
  getSpeakerList: {
    __typename?: 'SpeakerPaginatedResults';
    data: Array<{
      __typename?: 'Speaker';
      id: string;
      order: number;
      firstName: string;
      lastName: string;
      prefix?: string | null;
      designation?: string | null;
      company?: string | null;
      title?: string | null;
      profileImageUri?: string | null;
    }>;
    pagination?: {
      __typename?: 'Pagination';
      currentToken: string;
      nextToken?: string | null;
      previousToken?: string | null;
      limit: number;
      totalCount: number;
    } | null;
  };
};

export type Get_Speaker_NamesQueryVariables = Exact<{
  criteria: SpeakerListCriteria;
}>;

export type Get_Speaker_NamesQuery = {
  __typename?: 'Query';
  getSpeakerList: {
    __typename?: 'SpeakerPaginatedResults';
    data: Array<{ __typename?: 'Speaker'; id: string; firstName: string; lastName: string }>;
  };
};

export type Search_SponsorsQueryVariables = Exact<{
  sponsorSearchCriteria?: InputMaybe<SponsorSearchCriteria>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Search_SponsorsQuery = {
  __typename?: 'Query';
  searchSponsors?: {
    __typename?: 'ExhibitorPaginatedResults';
    hasVirtualBooths: boolean;
    pagination?: { __typename?: 'Pagination'; totalCount: number } | null;
    sponsorshipLevels: Array<{ __typename?: 'SponsorshipLevel'; id: string; name: string; rank?: number | null }>;
    data: Array<{
      __typename?: 'Exhibitor';
      id: string;
      name: string;
      location?: string | null;
      tagline?: string | null;
      logoUrl?: string | null;
      hasVirtualBooth: boolean;
      eventSponsor: boolean;
      sponsorshipLevels?: Array<string> | null;
      featured: boolean;
    }>;
    categories?: Array<{
      __typename?: 'ExhibitorCategory';
      previewExhibitors: Array<{
        __typename?: 'CategoryPreviewExhibitor';
        id: string;
        name: string;
        logoUrl?: string | null;
      }>;
    }> | null;
  } | null;
};

export type GetLocalizedLocationsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLocalizedLocationsQuery = {
  __typename?: 'Query';
  getLocalizedLocations?: Array<{
    __typename?: 'LocalizedLocation';
    locationCode?: string | null;
    locationTranslation?: string | null;
    locationName?: string | null;
  } | null> | null;
};

export type HeartbeatMutationVariables = Exact<{
  heartbeatInput: HeartbeatInput;
}>;

export type HeartbeatMutation = {
  __typename?: 'Mutation';
  heartbeatV2?: {
    __typename?: 'HeartbeatResponse';
    sessionExtendedStatus?: number | null;
    encounterPublished?: boolean | null;
    boothStaffAvailabilityHeartbeatStatus?: number | null;
  } | null;
};

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  logout?: { __typename?: 'LogoutResponse'; revokeStreamTokens?: ChatServiceStatus | null } | null;
};

export type MeQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  sessionCriteria?: InputMaybe<SearchSessionCriteria>;
}>;

export type MeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    contactId?: string | null;
    virtual: boolean;
    firstName: string;
    lastName: string;
    email: string;
    guest: boolean;
    confirmationNumber?: string | null;
    profileUrl?: string | null;
    profilePicture?: string | null;
    doNotSell: boolean;
    prefix?: string | null;
    designation?: string | null;
    title?: string | null;
    company?: string | null;
    headline?: string | null;
    bio?: string | null;
    pronouns?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedInUrl?: string | null;
    websiteUrl?: string | null;
    visibility?: AttendeeVisibility | null;
    allowPushNotifications?: boolean | null;
    allowAppointmentPushNotifications?: boolean | null;
    address?: {
      __typename?: 'Address';
      city?: string | null;
      region?: string | null;
      regionCode?: string | null;
      country?: string | null;
      countryCode?: string | null;
    } | null;
    professionalInterests?: Array<{
      __typename?: 'AttendeeInterestComparisonResult';
      id: string;
      text: string;
      commonInterest: boolean;
    }> | null;
    type?: { __typename?: 'NamedObject'; id: string; name: string; code: string } | null;
    admissionItem?: {
      __typename?: 'AdmissionItem';
      id: string;
      name: string;
      attendeeCanUpgradeAdmissionItem?: boolean | null;
    } | null;
    attendeeHasChannels?: {
      __typename?: 'AttendeeHasChannels';
      hasChannels?: boolean | null;
      status?: string | null;
      limit?: number | null;
      remaining?: number | null;
      resetAt?: number | null;
    } | null;
    permissions: {
      __typename?: 'Permissions';
      isGlobalModerator: boolean;
      sessionsToModerate: Array<string | null>;
      roles: {
        __typename?: 'Roles';
        audienceEngagement: Array<string | null>;
        videoHost: Array<string | null>;
        speakerRoom: Array<string | null>;
        boothStaff?: boolean | null;
      };
    };
    consent?: {
      __typename?: 'AttendeeConsent';
      hasAccepted?: boolean | null;
      id?: string | null;
      title?: string | null;
      terms?: string | null;
    } | null;
    answers?: Array<{
      __typename?: 'RegQuestionAnswer';
      questionId: string;
      filterName: string;
      filterOrder: number;
      value?: Array<string | null> | null;
    }> | null;
    exhibitorConsentQuestion?: {
      __typename?: 'ExhibitorConsentQuestion';
      id?: string | null;
      title?: string | null;
      questionText?: string | null;
      optInId?: string | null;
      optInText?: string | null;
      optOutId?: string | null;
      optOutText?: string | null;
    } | null;
    exhibitorConsentAnswer?: {
      __typename?: 'ExhibitorConsentAnswer';
      attendeeId: string;
      questionId?: string | null;
      questionText?: string | null;
      answerId?: string | null;
      locale?: string | null;
      lastModifiedDate?: any | null;
      choice?: { __typename?: 'ExhibitorConsentChoiceAnswerResponse'; text?: string | null; id?: string | null } | null;
    } | null;
    preferences: Array<{
      __typename?: 'AttendeePreference';
      id: string;
      preferenceType: AttendeePreferenceType;
      preferenceValue: string;
    }>;
    event: {
      __typename?: 'Event';
      id: string;
      cultureCode?: string | null;
      title: string;
      timezone?: string | null;
      timezoneId?: string | null;
      defaultLocale?: string | null;
      currency?: string | null;
      start: any;
      end: any;
      status?: string | null;
      cventPrivacyPolicyText?: string | null;
      showCookieBanner?: boolean | null;
      showCookieBannerPrivacyPolicyLink?: boolean | null;
      showNonEssentialCookieBanner?: boolean | null;
      format?: Format | null;
      phone?: string | null;
      gameInfo?: Array<{
        __typename?: 'GameInfo';
        id: string;
        name: string;
        validStart: string;
        validEnd: string;
      } | null> | null;
      venues?: Array<{
        __typename?: 'Venue';
        name?: string | null;
        address?: {
          __typename?: 'Address';
          address1?: string | null;
          address2?: string | null;
          address3?: string | null;
          city?: string | null;
          region?: string | null;
          regionCode?: string | null;
          postalCode?: string | null;
          country?: string | null;
          countryCode?: string | null;
        } | null;
      } | null> | null;
      links: {
        __typename?: 'EventLinks';
        summary?: string | null;
        registration?: string | null;
        surveys?: string | null;
        appointment?: string | null;
        ccpa?: string | null;
        privacyPolicy?: { __typename?: 'LinkData'; url?: string | null; text?: string | null } | null;
      };
      ccpaData: {
        __typename?: 'CCPAData';
        ccpaExternalDoNotSellUrl?: string | null;
        ccpaButtonText?: string | null;
        ccpaConfirmationText?: string | null;
        ccpaExplanationText?: string | null;
        ccpaInviteeValidationText?: string | null;
        ccpaLinkText?: string | null;
        showCcpaSectionFlag?: boolean | null;
        showCCPA?: boolean | null;
        ccpaOptOutFormType?: string | null;
        ccpaDoNotSellUrl?: string | null;
      };
      features?: {
        __typename?: 'EventFeatures';
        exhibitorManagement: boolean;
        showExhibitorList: boolean;
        sessionQA: boolean;
        sponsors: number;
        showSponsorList: boolean;
        exhibitorsPresent: boolean;
        gamePresent: boolean;
        livePolling: boolean;
        sessions: boolean;
        onDemandCatalog: boolean;
        registration: boolean;
        sessionRecommendations: boolean;
        speakers: boolean;
        floorPlans?: boolean | null;
      } | null;
      appointmentEvents: Array<{
        __typename?: 'AppointmentEvent';
        id: string;
        apptEventCode?: string | null;
        status?: string | null;
        readOnly: boolean;
        apptEventType: ApptEventType;
      }>;
      appConfig?: {
        __typename?: 'AppConfig';
        appConfigString?: string | null;
        webConfig?: {
          __typename?: 'WebConfig';
          headerImage?: any | null;
          coverImage?: any | null;
          coverImageAltText?: string | null;
          secondaryHeaderImage?: any | null;
          secondaryHeaderImageAltText?: string | null;
          sessionHeaderImage?: any | null;
          sessionHeaderImageAltText?: string | null;
          defaultProfileVisibility: boolean;
          manageProfileEnabled: boolean;
          footerImage?: any | null;
          footerImageAltText?: string | null;
          loginBackgroundImage?: any | null;
          loginBackgroundImageAltText?: string | null;
        } | null;
      } | null;
      accountConfig?: {
        __typename?: 'AccountConfig';
        faviconUrl?: string | null;
        hideCventFooter?: boolean | null;
      } | null;
      resourceOverrides?: {
        __typename?: 'ResourceOverrides';
        locale: string;
        overrides: Array<{ __typename?: 'ResourceOverride'; key: string; value: string } | null>;
      } | null;
      customFields?: Array<{
        __typename?: 'EventCustomField';
        id: string;
        name: string;
        value: Array<string | null>;
        type: string;
      } | null> | null;
      liveAndUpcoming: Array<{
        __typename?: 'Session';
        id: string;
        name: string;
        code?: string | null;
        start: any;
        end: any;
        description?: string | null;
        enrolled: boolean;
        featured: boolean;
        openForRegistration: boolean;
        openForAttendeeHub: boolean;
        virtual: boolean;
        included: boolean;
        recommended?: boolean | null;
        sessionTags?: Array<string> | null;
        capacity?: {
          __typename?: 'CapacityRemaining';
          active?: boolean | null;
          availableCapacity?: number | null;
          totalCapacityAvailable?: number | null;
        } | null;
        fee?: { __typename?: 'SessionFee'; amount: number } | null;
        category?: { __typename?: 'SessionCategory'; id?: string | null; name: string; code?: string | null } | null;
        location?: {
          __typename?: 'SessionLocation';
          id?: string | null;
          name?: string | null;
          code?: string | null;
        } | null;
        webcast?: {
          __typename?: 'Webcast';
          id: string;
          eventId: string;
          sessionId: string;
          format?: WebcastFormat | null;
          playerType?: string | null;
          player?: {
            __typename?: 'WebcastPlayer';
            id: string;
            videoId?: string | null;
            duration?: number | null;
            simuliveOffset?: number | null;
            stream?: { __typename?: 'PlayerStream'; id?: string | null; status?: PlayerStreamStatus | null } | null;
          } | null;
        } | null;
        exhibitors?: Array<{
          __typename?: 'SessionExhibitor';
          id: string;
          name: string;
          profileLogoUrl?: string | null;
        } | null> | null;
      }>;
      codeSnippets?: Array<{
        __typename?: 'CodeSnippet';
        id: string;
        dataTagCode: string;
        codeSnippetValue: string;
        applicableOn?: SnippetApplicableOn | null;
        canDisableCodeSnippet?: boolean | null;
        category: CodeSnippetCategory;
      }> | null;
      supportedEventLocales?: Array<{
        __typename?: 'EventLocale';
        localeId: number;
        languageName: string;
        languageCountry: string;
        isDefault: boolean;
        cultureCode: string;
      }> | null;
      eventTheme?: {
        __typename?: 'EventInfoTheme';
        logoImage?: string | null;
        logoImageOptimized?: string | null;
      } | null;
    };
  } | null;
};

export type Me_Admission_ItemQueryVariables = Exact<{ [key: string]: never }>;

export type Me_Admission_ItemQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    admissionItem?: { __typename?: 'AdmissionItem'; id: string; name: string } | null;
  } | null;
};

export type Me_Appt_And_Guest_CodeQueryVariables = Exact<{ [key: string]: never }>;

export type Me_Appt_And_Guest_CodeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    guest: boolean;
    confirmationNumber?: string | null;
    event: {
      __typename?: 'Event';
      start: any;
      end: any;
      format?: Format | null;
      appointmentEvents: Array<{
        __typename?: 'AppointmentEvent';
        id: string;
        apptEventCode?: string | null;
        apptEventType: ApptEventType;
        status?: string | null;
        readOnly: boolean;
      }>;
    };
    permissions: { __typename?: 'Permissions'; roles: { __typename?: 'Roles'; boothStaff?: boolean | null } };
  } | null;
};

export type Me_Confirmation_NumberQueryVariables = Exact<{ [key: string]: never }>;

export type Me_Confirmation_NumberQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'User'; confirmationNumber?: string | null } | null;
};

export type Me_Consent_Exhibitor_AnswerQueryVariables = Exact<{ [key: string]: never }>;

export type Me_Consent_Exhibitor_AnswerQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    exhibitorConsentAnswer?: {
      __typename?: 'ExhibitorConsentAnswer';
      attendeeId: string;
      questionId?: string | null;
      questionText?: string | null;
      answerId?: string | null;
      locale?: string | null;
      lastModifiedDate?: any | null;
      choice?: { __typename?: 'ExhibitorConsentChoiceAnswerResponse'; text?: string | null; id?: string | null } | null;
    } | null;
  } | null;
};

export type ProfilePictureFragment = { __typename?: 'User'; profilePicture?: string | null };

export type Update_Attendee_ComplianceMutationVariables = Exact<{ [key: string]: never }>;

export type Update_Attendee_ComplianceMutation = {
  __typename?: 'Mutation';
  updateAttendeeCompliance: { __typename?: 'RequestDoNotSellResult'; requestReceived: boolean };
};

export type Update_Profile_SecuredMutationVariables = Exact<{
  profile: ProfileSecuredUpdateInput;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Update_Profile_SecuredMutation = {
  __typename?: 'Mutation';
  updateProfileSecured?: {
    __typename?: 'User';
    id: string;
    prefix?: string | null;
    firstName: string;
    lastName: string;
    designation?: string | null;
    company?: string | null;
    title?: string | null;
    headline?: string | null;
    bio?: string | null;
    pronouns?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedInUrl?: string | null;
    websiteUrl?: string | null;
    visibility?: AttendeeVisibility | null;
    allowPushNotifications?: boolean | null;
    allowAppointmentPushNotifications?: boolean | null;
    address?: {
      __typename?: 'Address';
      country?: string | null;
      countryCode?: string | null;
      city?: string | null;
      region?: string | null;
      regionCode?: string | null;
    } | null;
  } | null;
};

export type Update_Profile_Secured_With_InterestsMutationVariables = Exact<{
  profile: ProfileSecuredUpdateInput;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type Update_Profile_Secured_With_InterestsMutation = {
  __typename?: 'Mutation';
  updateProfileSecured?: {
    __typename?: 'User';
    id: string;
    prefix?: string | null;
    firstName: string;
    lastName: string;
    designation?: string | null;
    company?: string | null;
    title?: string | null;
    headline?: string | null;
    bio?: string | null;
    pronouns?: string | null;
    facebookUrl?: string | null;
    twitterUrl?: string | null;
    linkedInUrl?: string | null;
    websiteUrl?: string | null;
    visibility?: AttendeeVisibility | null;
    allowPushNotifications?: boolean | null;
    allowAppointmentPushNotifications?: boolean | null;
    address?: {
      __typename?: 'Address';
      country?: string | null;
      countryCode?: string | null;
      city?: string | null;
      region?: string | null;
      regionCode?: string | null;
    } | null;
    professionalInterests?: Array<{
      __typename?: 'AttendeeInterestComparisonResult';
      id: string;
      text: string;
      commonInterest: boolean;
    }> | null;
  } | null;
};

export type VideoDetailsQueryVariables = Exact<{
  videoId: Scalars['ID']['input'];
}>;

export type VideoDetailsQuery = {
  __typename?: 'Query';
  videoDetails: {
    __typename?: 'VideoWithRenditions';
    id: string;
    status: string;
    title: string;
    filename: string;
    url: { __typename?: 'HrefPath'; href?: string | null };
    renditions?: Array<{
      __typename?: 'Rendition';
      type: string;
      location: { __typename?: 'HrefPath'; href?: string | null };
    }> | null;
  };
};

export type On_Demand_Video_Details_For_Dry_RunQueryVariables = Exact<{
  videoId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;

export type On_Demand_Video_Details_For_Dry_RunQuery = {
  __typename?: 'Query';
  onDemandVideoDetailsForDryRun?: {
    __typename?: 'VideoPlaybackDetailsForDryRun';
    url: string;
    textTracks?: Array<{
      __typename?: 'VideoTextTrack';
      url: string;
      label?: string | null;
      language: string;
      kind: VideoTextTrackKind;
      default: boolean;
      lastModified: string;
    }> | null;
  } | null;
};

export type Video_On_Demand_Playback_DetailsQueryVariables = Exact<{
  videoId: Scalars['ID']['input'];
  entityType: VideoAssociationEntityType;
  entityId: Scalars['ID']['input'];
}>;

export type Video_On_Demand_Playback_DetailsQuery = {
  __typename?: 'Query';
  videoOnDemandPlaybackDetails?: {
    __typename?: 'VideoPlaybackDetails';
    url: string;
    poster?: string | null;
    preview?: string | null;
    ttl?: number | null;
    textTracks?: Array<{
      __typename?: 'VideoTextTrack';
      url: string;
      label?: string | null;
      language: string;
      kind: VideoTextTrackKind;
      default: boolean;
      lastModified: string;
    } | null> | null;
  } | null;
};

export type Get_Event_FeaturesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type Get_Event_FeaturesQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    features?: Array<{
      __typename?: 'FeatureSettings';
      id: string;
      isEnabled: boolean;
      type: string;
      featureCode: string;
    }> | null;
  };
};

export type Event_Info_PageQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type Event_Info_PageQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    title?: string | null;
    description?: string | null;
    start?: any | null;
    end?: any | null;
    defaultLocale?: string | null;
    isPublished?: boolean | null;
    isArchived?: boolean | null;
    sessions?: Array<{
      __typename?: 'Session';
      id: string;
      name: string;
      description?: string | null;
      end: any;
      start: any;
    }> | null;
    features?: Array<{
      __typename?: 'FeatureSettings';
      id: string;
      isEnabled: boolean;
      type: string;
      featureCode: string;
    }> | null;
    speakers?: Array<{
      __typename?: 'Speaker';
      id: string;
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profileImageUri?: string | null;
      biography?: string | null;
    }> | null;
  };
};

export type EventInfoQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type EventInfoQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    title?: string | null;
    defaultLocale?: string | null;
    customDomain?: string | null;
    isPublished?: boolean | null;
    isArchived?: boolean | null;
    isCancelled?: boolean | null;
    isSignUpEnabled?: boolean | null;
    eventLicenseTypeName?: string | null;
    features?: Array<{
      __typename?: 'FeatureSettings';
      id: string;
      isEnabled: boolean;
      type: string;
      featureCode: string;
    }> | null;
    eventInfoTheme: {
      __typename?: 'EventInfoTheme';
      primary: string;
      secondary: string;
      background: string;
      mood: string;
      safeMode?: boolean | null;
      preferFormula?: ThemeFormulaType | null;
      illustrations?: { __typename?: 'IllustrationSettings'; hideAll?: boolean | null } | null;
      icons?: {
        __typename?: 'IconSettings';
        pack?: string | null;
        reassignedIcons?: Array<{ __typename?: 'ReassignedIcon'; name: string; reassignment: string }> | null;
      } | null;
      headingFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
      bodyFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
    };
  };
};

export type GetAppFeaturesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  appFeatures: Array<AppFeatureInput> | AppFeatureInput;
}>;

export type GetAppFeaturesQuery = {
  __typename?: 'Query';
  getAppFeatures?: Array<{
    __typename?: 'AppFeature';
    name: string;
    enabled: boolean;
    experimentVersion?: string | null;
  } | null> | null;
};

export type GetExperimentQueryVariables = Exact<{
  experimentName: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetExperimentQuery = {
  __typename?: 'Query';
  getExperiment?: { __typename?: 'Experiment'; experimentName?: string | null; version?: string | null } | null;
};

export type Get_Event_Features_And_SpeakersQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
}>;

export type Get_Event_Features_And_SpeakersQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    title?: string | null;
    description?: string | null;
    start?: any | null;
    end?: any | null;
    defaultLocale?: string | null;
    faviconUrl?: string | null;
    isPublished?: boolean | null;
    isArchived?: boolean | null;
    isCancelled?: boolean | null;
    isOpenAccessEnabled?: boolean | null;
    showCookieBanner?: boolean | null;
    showCookieBannerPrivacyPolicyLink?: boolean | null;
    showNonEssentialCookieBanner?: boolean | null;
    hideCventFooter?: boolean | null;
    status?: EventStatus | null;
    features?: Array<{
      __typename?: 'FeatureSettings';
      id: string;
      isEnabled: boolean;
      type: string;
      featureCode: string;
      metadata?: any | null;
    }> | null;
    speakers?: Array<{
      __typename?: 'Speaker';
      id: string;
      firstName: string;
      lastName: string;
      title?: string | null;
      company?: string | null;
      profileImageUri?: string | null;
      biography?: string | null;
    }> | null;
    eventInfoTheme: {
      __typename?: 'EventInfoTheme';
      coverImageOptimized?: string | null;
      coverImageAltText?: string | null;
      logoImageOptimized?: string | null;
      primary: string;
      secondary: string;
      background: string;
      mood: string;
      safeMode?: boolean | null;
      preferFormula?: ThemeFormulaType | null;
      illustrations?: { __typename?: 'IllustrationSettings'; hideAll?: boolean | null } | null;
      icons?: {
        __typename?: 'IconSettings';
        pack?: string | null;
        reassignedIcons?: Array<{ __typename?: 'ReassignedIcon'; name: string; reassignment: string }> | null;
      } | null;
      headingFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
      bodyFont?: {
        __typename?: 'FontDescriptor';
        name: string;
        fallbackFont?: string | null;
        styles?: Array<{ __typename?: 'FontStyle'; url: string; weight: number; style: FontStyleType }> | null;
      } | null;
    };
    ccpaData: { __typename?: 'CCPAData'; ccpaExternalDoNotSellUrl?: string | null };
    cventPrivacyPolicy?: {
      __typename?: 'CventPrivacyPolicy';
      showCventPrivacyPolicy?: boolean | null;
      cventPrivacyPolicyLinkText?: string | null;
    } | null;
    eventPrivacyPolicy?: {
      __typename?: 'EventPrivacyPolicy';
      showPrivacyPolicy?: boolean | null;
      privacyPolicyUrl?: string | null;
      privacyPolicyLinkText?: string | null;
    } | null;
    codeSnippets?: Array<{
      __typename?: 'CodeSnippet';
      id: string;
      dataTagCode: string;
      codeSnippetValue: string;
      applicableOn?: SnippetApplicableOn | null;
      canDisableCodeSnippet?: boolean | null;
      category: CodeSnippetCategory;
    }> | null;
    venues?: Array<{
      __typename?: 'Venue';
      name?: string | null;
      address?: {
        __typename?: 'Address';
        address1?: string | null;
        address2?: string | null;
        address3?: string | null;
        city?: string | null;
        region?: string | null;
        postalCode?: string | null;
        country?: string | null;
      } | null;
    }> | null;
    resourceOverrides?: {
      __typename?: 'ResourceOverrides';
      locale: string;
      overrides: Array<{ __typename?: 'ResourceOverride'; key: string; value: string } | null>;
    } | null;
  };
};

export type Get_Event_SessionsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type Get_Event_SessionsQuery = {
  __typename?: 'Query';
  eventInfo: {
    __typename?: 'EventInfo';
    id: string;
    isArchived?: boolean | null;
    isPublished?: boolean | null;
    sessions?: Array<{ __typename?: 'Session'; id: string }> | null;
  };
};

export const ThemeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'theme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfoTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'background' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mood' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safeMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferFormula' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'illustrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hideAll' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reassignedIcons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reassignment' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headingFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ThemeFragment, unknown>;
export const PollAttributesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollAttributesFragment, unknown>;
export const PollQuestionChoiceResultAttributesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollQuestionChoiceResultAttributesFragment, unknown>;
export const PollAttributesWithResultsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributesWithResults' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollAttributesWithResultsFragment, unknown>;
export const PollQuestionChoiceAttributesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollQuestionChoiceAttributesFragment, unknown>;
export const PollQuestionAttributesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollQuestionAttributesFragment, unknown>;
export const PollAttributesWithChoicesAndResultsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributesWithChoicesAndResults' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PollAttributesWithChoicesAndResultsFragment, unknown>;
export const QaQuestionAttributesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QAQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Question' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<QaQuestionAttributesFragment, unknown>;
export const ProfilePictureFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProfilePicture' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } }]
      }
    }
  ]
} as unknown as DocumentNode<ProfilePictureFragment, unknown>;
export const SubscriptionTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'subscriptionToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionToken' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'token' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SubscriptionTokenMutation, SubscriptionTokenMutationVariables>;
export const Event_Info_For_ErrorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EVENT_INFO_FOR_ERROR' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventInfoTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'theme' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'theme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfoTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'background' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mood' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safeMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferFormula' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'illustrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hideAll' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reassignedIcons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reassignment' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headingFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Event_Info_For_ErrorQuery, Event_Info_For_ErrorQueryVariables>;
export const Get_UpgradableadmissionitemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_UPGRADABLEADMISSIONITEMS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUpgradableAdmissionItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_UpgradableadmissionitemsQuery, Get_UpgradableadmissionitemsQueryVariables>;
export const On_Broadcast_Live_CaptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_BROADCAST_LIVE_CAPTIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onBroadcastLiveCaptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'environment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTimeMs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPartial' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'languages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'languageCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'words' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTimeMs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTimeMs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPunctuation' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Broadcast_Live_CaptionsSubscription, On_Broadcast_Live_CaptionsSubscriptionVariables>;
export const RegisterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'register' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterAttendeeInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const Sign_Up_Event_InfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SIGN_UP_EVENT_INFO' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locales' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'localeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'languageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'languageCountry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cultureCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventInfoTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'theme' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'loginBackgroundImage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'loginBackgroundImageAltText' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ccpaData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ccpaExternalDoNotSellUrl' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cventPrivacyPolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'showCventPrivacyPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cventPrivacyPolicyLinkText' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventPrivacyPolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'showPrivacyPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyPolicyUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyPolicyLinkText' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'theme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfoTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'background' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mood' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safeMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferFormula' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'illustrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hideAll' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reassignedIcons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reassignment' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headingFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Sign_Up_Event_InfoQuery, Sign_Up_Event_InfoQueryVariables>;
export const Get_Promoted_Events_CalendarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PROMOTED_EVENTS_CALENDAR' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpcomingEventsSearchCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'promotedEventsCalendar' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calendarLinkAlternate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calenderLinkDestination' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calendarLinkCompletedEvent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionsCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webLinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'registration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'invitation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agenda' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venue' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'websiteStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'spanMultiDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventFormat' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tag' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Promoted_Events_CalendarQuery, Get_Promoted_Events_CalendarQueryVariables>;
export const Get_Upcoming_Events_CalendarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_UPCOMING_EVENTS_CALENDAR' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpcomingEventsSearchCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upcomingEventsCalendar' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'config' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filterFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sequence' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCustomField' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceKey' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDateUtc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calendarLinkAlternate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calenderLinkDestination' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'calendarLinkCompletedEvent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionsCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webLinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'registration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'invitation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agenda' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venue' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'websiteStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'spanMultiDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventFormat' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tag' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'values' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Upcoming_Events_CalendarQuery, Get_Upcoming_Events_CalendarQueryVariables>;
export const Event_Ad_SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EVENT_AD_SETTINGS' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventAdSettingsForAttendee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberOfPlacements' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Event_Ad_SettingsQuery, Event_Ad_SettingsQueryVariables>;
export const Update_Personal_TimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_PERSONAL_TIME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personalTimeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePersonalTimeInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePersonalTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'personalTimeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'personalTimeId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Personal_TimeMutation, Update_Personal_TimeMutationVariables>;
export const Accept_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ACCEPT_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'impactedAgendaItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Accept_AppointmentMutation, Accept_AppointmentMutationVariables>;
export const Appointment_TypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APPOINTMENT_TYPES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApptTypesInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointmentTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsPlannerApproval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requireRequestees' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowBoothStaffCreate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualMeetingSolution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmRequesters' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideAttendeesFlag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeBooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoAccept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeRole' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requesterQuestions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'question' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'questionTypeInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'answerFormatType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'scores' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'choices' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherAnswer' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayFormatTypeId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxDate' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'required' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requesteeQuestions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'question' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'questionTypeInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'answerFormatType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'scores' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'choices' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherAnswer' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayFormatTypeId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxDate' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'required' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Appointment_TypesQuery, Appointment_TypesQueryVariables>;
export const Appt_Event_AttendeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'APPT_EVENT_ATTENDEES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterApptEventAttendeesInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getApptEventAttendees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isColleague' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Appt_Event_AttendeesQuery, Appt_Event_AttendeesQueryVariables>;
export const Availability_By_Time_RangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AVAILABILITY_BY_TIME_RANGE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailabilityByTimeRangeInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAvailabilityByTimeRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAtLimit' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Availability_By_Time_RangeQuery, Availability_By_Time_RangeQueryVariables>;
export const Available_LocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AVAILABLE_LOCATIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AvailableLocationsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAvailableLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'capacityPerAppointment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isConsolidated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDelayAssignment' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Available_LocationsQuery, Available_LocationsQueryVariables>;
export const Available_TimesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AVAILABLE_TIMES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TimeSuggestionInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAvailableTimes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'numberAtCapacity' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Available_TimesQuery, Available_TimesQueryVariables>;
export const Cancel_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CANCEL_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CancelDeclineApptInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Cancel_AppointmentMutation, Cancel_AppointmentMutationVariables>;
export const Checkin_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CHECKIN_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CheckinApptInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkinAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apptEventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apptConfirmationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deleted' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deleted' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedOn' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Checkin_AppointmentMutation, Checkin_AppointmentMutationVariables>;
export const Create_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateApptInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_AppointmentMutation, Create_AppointmentMutationVariables>;
export const Create_Personal_TimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_PERSONAL_TIME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePersonalTimeInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPersonalTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Personal_TimeMutation, Create_Personal_TimeMutationVariables>;
export const Decline_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DECLINE_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CancelDeclineApptInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'declineAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Decline_AppointmentMutation, Decline_AppointmentMutationVariables>;
export const Delete_Personal_TimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DELETE_PERSONAL_TIME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personalTimeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePersonalTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'personalTimeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'personalTimeId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Delete_Personal_TimeMutation, Delete_Personal_TimeMutationVariables>;
export const Exhibitor_Booth_Staff_AttendeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITOR_BOOTH_STAFF_ATTENDEES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterExhibitorBoothStaffAttendeesInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getExhibitorBoothStaffAttendees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'searchId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'apptEventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canRequest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isBoothStaff' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isColleague' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTeamMember' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitor_Booth_Staff_AttendeesQuery, Exhibitor_Booth_Staff_AttendeesQueryVariables>;
export const Exhibitor_InfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITOR_INFO' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getExhibitorInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitor_InfoQuery, Exhibitor_InfoQueryVariables>;
export const Exhibitors_With_Booth_LocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITORS_WITH_BOOTH_LOCATION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExhibitorsBoothLocationInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getExhibitorsWithBoothLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'boothLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'staffInviteeIds' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitors_With_Booth_LocationQuery, Exhibitors_With_Booth_LocationQueryVariables>;
export const Get_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fetchLocationAtLimit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apptTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPlannerCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isColleague' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canEdit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCancel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAccept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDecline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canProposeNewTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddPrivateNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCheckIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUndoCheckIn' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requesterAnswersViewers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesterAnswers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'decimalValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'answerType' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesteeAnswers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'decimalValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'answerType' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'otherOrganizationCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAutoAcceptAttendees' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnforceScheduleRules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectedBoothId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsPlannerApproval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowBoothStaffCreate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requireRequestees' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualMeetingSolution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmRequesters' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideAttendeesFlag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'includeBooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoAccept' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requesterQuestions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'question' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'questionTypeInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'answerFormatType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'scores' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'choices' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherAnswer' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayFormatTypeId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxDate' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'required' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requesteeQuestions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'question' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'questionTypeInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'answerFormatType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'scores' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'choices' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherAnswer' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayFormatTypeId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxDate' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'required' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'boothLocationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'privateNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'privateNoteViewers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isLocationAtLimit' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'fetchLocationAtLimit' } }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_AppointmentQuery, Get_AppointmentQueryVariables>;
export const Get_Appointment_Agenda_ItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_APPOINTMENT_AGENDA_ITEM' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppointmentAgendaItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Appointment_Agenda_ItemQuery, Get_Appointment_Agenda_ItemQueryVariables>;
export const Get_Personal_TimesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PERSONAL_TIMES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersonalTimeInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPersonalTimes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Personal_TimesQuery, Get_Personal_TimesQueryVariables>;
export const Get_Potential_ConflictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_POTENTIAL_CONFLICTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PotentialConflictsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPotentialConflicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'conflictType' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Potential_ConflictsQuery, Get_Potential_ConflictsQueryVariables>;
export const Get_Pre_Accept_ValidationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PRE_ACCEPT_VALIDATION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPreAcceptValidation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'acceptValidation' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Pre_Accept_ValidationQuery, Get_Pre_Accept_ValidationQueryVariables>;
export const Get_Proposed_TimesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PROPOSED_TIMES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apptId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProposedTimes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'apptId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'apptId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationStub' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Proposed_TimesQuery, Get_Proposed_TimesQueryVariables>;
export const Get_Self_Attendee_InfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SELF_ATTENDEE_INFO' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSelfAttendeeInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Self_Attendee_InfoQuery, Get_Self_Attendee_InfoQueryVariables>;
export const Has_Appointment_TypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HAS_APPOINTMENT_TYPES' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasAppointmentTypes' } }]
      }
    }
  ]
} as unknown as DocumentNode<Has_Appointment_TypesQuery, Has_Appointment_TypesQueryVariables>;
export const Propose_New_TimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PROPOSE_NEW_TIME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProposeNewTimeInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'proposeNewTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Propose_New_TimeMutation, Propose_New_TimeMutationVariables>;
export const Requestable_ExhibitorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'REQUESTABLE_EXHIBITORS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestableExhibitorsInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRequestableExhibitors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Requestable_ExhibitorsQuery, Requestable_ExhibitorsQueryVariables>;
export const Update_AppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_APPOINTMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateApptInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'appointmentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentLocationDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requesters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inviteeStub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'apptType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableAttendeeActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_AppointmentMutation, Update_AppointmentMutationVariables>;
export const Dismiss_Attendee_RecommendationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DISMISS_ATTENDEE_RECOMMENDATION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DismissAttendeeRecommendationInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissAttendeeRecommendation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Dismiss_Attendee_RecommendationMutation, Dismiss_Attendee_RecommendationMutationVariables>;
export const Get_AttendeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canMeet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPoints' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stickerName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goalProgress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'goalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_AttendeeQuery, Get_AttendeeQueryVariables>;
export const Get_Attendee_ProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_PROFILE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canMeet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_ProfileQuery, Get_Attendee_ProfileQueryVariables>;
export const Get_Attendee_RecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_RECOMMENDATIONS' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeRecommendations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dismissed' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_RecommendationsQuery, Get_Attendee_RecommendationsQueryVariables>;
export const Get_Attendee_Recommendations_All_FieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_RECOMMENDATIONS_ALL_FIELDS' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeRecommendations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dismissed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canMeet' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  Get_Attendee_Recommendations_All_FieldsQuery,
  Get_Attendee_Recommendations_All_FieldsQueryVariables
>;
export const Get_Attendee_With_InterestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_WITH_INTERESTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canMeet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPoints' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stickerName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goalProgress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'goalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalInterests' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'attendeeInterests', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commonInterest' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_With_InterestsQuery, Get_Attendee_With_InterestsQueryVariables>;
export const Get_PlayerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PLAYER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPoints' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stickerName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goalProgress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'goalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_PlayerQuery, Get_PlayerQueryVariables>;
export const Get_Professional_Interest_ChoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PROFESSIONAL_INTEREST_CHOICES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageCriteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProfessionalInterestChoices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageCriteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageCriteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Professional_Interest_ChoicesQuery, Get_Professional_Interest_ChoicesQueryVariables>;
export const Search_AttendeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_ATTENDEES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeeSearchCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchAttendees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canMeet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_AttendeesQuery, Search_AttendeesQueryVariables>;
export const Get_Attendee_Hub_ConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_HUB_CONFIG' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeHubConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featureSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eventImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventImageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventImageUrlOptimized' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'morePageSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customPageSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageIcon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageAsset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentAsset' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageBannerPageSettingsBulk' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placements' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bannerId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activeTimes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'placementOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rotationInterval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageBannerSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageAsset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'assetUriOptimized' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkDestinationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkAttendeeHubDestinationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkDestination' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorAttribution' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textAlignment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageAlignment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontColor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'containerBackground' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'containerBackgroundCustomColor' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'privacySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'attendeesVisible' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'securitySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'documentSharingEnabled' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_Hub_ConfigQuery, Get_Attendee_Hub_ConfigQueryVariables>;
export const Get_Reg_Question_FiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_REG_QUESTION_FILTERS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegQuestionFilters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filterOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionServiceEntityType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'choices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Reg_Question_FiltersQuery, Get_Reg_Question_FiltersQueryVariables>;
export const Check_Attendee_Has_ChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CHECK_ATTENDEE_HAS_CHANNELS' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkAttendeeHasChannels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasChannels' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Check_Attendee_Has_ChannelsQuery, Check_Attendee_Has_ChannelsQueryVariables>;
export const Create_Messaging_ChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_MESSAGING_CHANNEL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMessagingChannelV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeIds' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Messaging_ChannelMutation, Create_Messaging_ChannelMutationVariables>;
export const Leave_Group_Messaging_ChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LEAVE_GROUP_MESSAGING_CHANNEL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveGroupMessagingChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Leave_Group_Messaging_ChannelMutation, Leave_Group_Messaging_ChannelMutationVariables>;
export const On_Attendee_Has_ChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_ATTENDEE_HAS_CHANNELS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onAttendeeHasChannelsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Attendee_Has_ChannelsSubscription, On_Attendee_Has_ChannelsSubscriptionVariables>;
export const Update_Group_NameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_GROUP_NAME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGroupMessagingChannelName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelName' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Group_NameMutation, Update_Group_NameMutationVariables>;
export const UpsertAttendeePreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertAttendeePreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'preferences' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePreferenceInput' } }
              }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertAttendeePreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preferences' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'preferences' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preview' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferenceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preferenceValue' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpsertAttendeePreferencesMutation, UpsertAttendeePreferencesMutationVariables>;
export const Create_Upload_Image_LinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_UPLOAD_IMAGE_LINK' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUploadImageLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filename' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relativePath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueFilename' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Upload_Image_LinkMutation, Create_Upload_Image_LinkMutationVariables>;
export const Create_Upload_LinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_UPLOAD_LINK' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUploadLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filename' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relativePath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueFilename' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Upload_LinkMutation, Create_Upload_LinkMutationVariables>;
export const Generate_Chat_TokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GENERATE_CHAT_TOKEN' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateChatToken' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiration' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Generate_Chat_TokenMutation, Generate_Chat_TokenMutationVariables>;
export const Get_Cdn_Image_UrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_CDN_IMAGE_URL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCdnImageUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCdnUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Cdn_Image_UrlQuery, Get_Cdn_Image_UrlQueryVariables>;
export const Get_Attendee_Field_CompletionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_FIELD_COMPLETION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeFieldCompletion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unfilledFieldGroupNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allFieldGroupNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentComplete' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_Field_CompletionQuery, Get_Attendee_Field_CompletionQueryVariables>;
export const Get_Attendee_Field_Completion_V2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_FIELD_COMPLETION_V2' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeFieldCompletionV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasProfilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unfilledFieldGroupNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allFieldGroupNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentComplete' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_Field_Completion_V2Query, Get_Attendee_Field_Completion_V2QueryVariables>;
export const Get_Random_Invitee_Profile_ImagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_RANDOM_INVITEE_PROFILE_IMAGES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRandomInviteeProfileImages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Random_Invitee_Profile_ImagesQuery, Get_Random_Invitee_Profile_ImagesQueryVariables>;
export const Create_Message_ReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_MESSAGE_REPORT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReportPostInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMessageReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Message_ReportMutation, Create_Message_ReportMutationVariables>;
export const Delete_MessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DELETE_MESSAGE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReportPostInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Delete_MessageMutation, Delete_MessageMutationVariables>;
export const Chat_ReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CHAT_REPORTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'messageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportComment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolutionNotes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'numberOfReports' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reportedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resolvedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sentBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'reportCategory' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentMessageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Chat_ReportsQuery, Chat_ReportsQueryVariables>;
export const Mark_Reports_ReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MARK_REPORTS_READ' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markReportRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportIds' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Mark_Reports_ReadMutation, Mark_Reports_ReadMutationVariables>;
export const On_Update_Unread_CountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_UNREAD_COUNT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'unreadReports' },
            name: { kind: 'Name', value: 'onUpdateUnreadCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Unread_CountSubscription, On_Update_Unread_CountSubscriptionVariables>;
export const Resolve_Message_ReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RESOLVE_MESSAGE_REPORT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageReportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReportPostStatus' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resolveAll' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChatEntityType' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveMessageReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'messageReportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageReportId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resolutionNotes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resolveAll' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resolveAll' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Resolve_Message_ReportMutation, Resolve_Message_ReportMutationVariables>;
export const Unread_ReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UNREAD_REPORTS' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unreadReports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Unread_ReportsQuery, Unread_ReportsQueryVariables>;
export const Update_Resolution_NotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_RESOLUTION_NOTES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChatEntityType' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResolutionNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'messageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resolutionNotes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resolutionNotes' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolutionNotes' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Resolution_NotesMutation, Update_Resolution_NotesMutationVariables>;
export const Accept_TermsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ACCEPT_TERMS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'termsId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAttendeeConsent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'termsId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'termsId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAccepted' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Accept_TermsMutation, Accept_TermsMutationVariables>;
export const Update_Consent_AnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_CONSENT_ANSWER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consentAnswer' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExhibitorConsentAnswerInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateExhibitorConsentAnswer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consentAnswer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consentAnswer' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Consent_AnswerMutation, Update_Consent_AnswerMutationVariables>;
export const Get_CreditsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_CREDITS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCredits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCredits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearToDateCredits' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inviteeCredits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'creditName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creditExpirationDate' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_CreditsQuery, Get_CreditsQueryVariables>;
export const Get_Event_Locales_InfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENT_LOCALES_INFO' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'environment' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventLocaleInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'environment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'environment' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'browserLocaleDetection' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportedEventLocales' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'localeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'languageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'languageCountry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cultureCode' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Event_Locales_InfoQuery, Get_Event_Locales_InfoQueryVariables>;
export const Get_EventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSearchCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'summary' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'websiteStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeHubLaunched' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connectionsCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCredit' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inviteeCredit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'creditName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditExpirationDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_EventsQuery, Get_EventsQueryVariables>;
export const Access_Exhibitor_ChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ACCESS_EXHIBITOR_CHAT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessExhibitorChat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exhibitorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Access_Exhibitor_ChatMutation, Access_Exhibitor_ChatMutationVariables>;
export const Create_Inbound_LeadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_INBOUND_LEAD' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExhibitorInboundLeadInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInboundLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'localId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localCreatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'application' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceEventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_Inbound_LeadMutation, Create_Inbound_LeadMutationVariables>;
export const Exhibitor_DetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITOR_DETAIL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppointmentSelector' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchExhibitor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appt' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerImageAltText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sponsorshipLevels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualBoothUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'links' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagram' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'files' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'weblinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'inboundLeadsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualMeetingsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualMeetingsExhibitorEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'floorPlan' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'floorPlansEnabled', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boothStaff' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppt' } }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availability' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meeting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canRequestAppointment' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppt' } }
                        }
                      ]
                    }
                  ]
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'videoServiceId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sponsoredSessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webcast' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'player' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stream' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showfloorSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorChatEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hours' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startHour' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startMinute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endHour' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endMinute' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'useCustomBoothHours' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customBoothHours' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stream' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitor_DetailQuery, Exhibitor_DetailQueryVariables>;
export const Exhibitor_Fact_DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITOR_FACT_DATA' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchExhibitor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitor_Fact_DataQuery, Exhibitor_Fact_DataQueryVariables>;
export const Exhibitor_With_Booth_LocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EXHIBITOR_WITH_BOOTH_LOCATION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchExhibitor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Exhibitor_With_Booth_LocationQuery, Exhibitor_With_Booth_LocationQueryVariables>;
export const Generate_Exhibitor_Chat_TokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GENERATE_EXHIBITOR_CHAT_TOKEN' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateExhibitorChatToken' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiration' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Generate_Exhibitor_Chat_TokenMutation, Generate_Exhibitor_Chat_TokenMutationVariables>;
export const On_Update_Attendee_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_ATTENDEE_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateAttendeeStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exhibitorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requester' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Attendee_StatusSubscription, On_Update_Attendee_StatusSubscriptionVariables>;
export const On_Update_Booth_Staff_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_BOOTH_STAFF_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateBoothStaffStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exhibitorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  On_Update_Booth_Staff_StatusSubscription,
  On_Update_Booth_Staff_StatusSubscriptionVariables
>;
export const Request_MeetingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'REQUEST_MEETING' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'requestMeetingInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestMeeting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Request_MeetingMutation, Request_MeetingMutationVariables>;
export const Search_ExhibitorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_EXHIBITORS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorSearchCriteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExhibitorSearchCriteria' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchExhibitors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorSearchCriteria' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalInCategory' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filterableCustomFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sponsorshipLevels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasVirtualBooths' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasVirtualBooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exhibitorCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previewExhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_ExhibitorsQuery, Search_ExhibitorsQueryVariables>;
export const Send_HeartbeatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SEND_HEARTBEAT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availabilityHeartbeat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Send_HeartbeatMutation, Send_HeartbeatMutationVariables>;
export const Update_AvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_AVAILABILITY' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAvailabilityInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_AvailabilityMutation, Update_AvailabilityMutationVariables>;
export const Update_Meeting_Invitee_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_MEETING_INVITEE_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'meetingRequestResponseInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMeetingInviteeStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meetingStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Meeting_Invitee_StatusMutation, Update_Meeting_Invitee_StatusMutationVariables>;
export const Verify_Exhibitor_Chat_AccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VERIFY_EXHIBITOR_CHAT_ACCESS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyExhibitorChatAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exhibitorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exhibitorId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Verify_Exhibitor_Chat_AccessMutation, Verify_Exhibitor_Chat_AccessMutationVariables>;
export const GetFloorPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFloorPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'floorPlanId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarkerFilterCriteria' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFloorPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'floorPlanId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'floorPlanId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'urlOptimized' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'markers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'y' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetFloorPlanQuery, GetFloorPlanQueryVariables>;
export const GetFloorPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFloorPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFloorPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'urlOptimized' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetFloorPlansQuery, GetFloorPlansQueryVariables>;
export const Get_GameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_GAME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'game' },
            name: { kind: 'Name', value: 'getGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalJoinedPlayers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leaderboardEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'achievements' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stickerName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'goals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'points' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'achievementId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPoints' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goalProgress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'goalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fractionCompleted' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'players' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_GameQuery, Get_GameQueryVariables>;
export const Opt_In_PlayerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OPT_IN_PLAYER' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optInPlayer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Opt_In_PlayerMutation, Opt_In_PlayerMutationVariables>;
export const Opt_Out_PlayerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OPT_OUT_PLAYER' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutPlayer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leaderboardOptOut' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Opt_Out_PlayerMutation, Opt_Out_PlayerMutationVariables>;
export const Get_Scheduled_CardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SCHEDULED_CARDS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'HomeSchedulerCriteria' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getHomeSchedulerConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledCards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentCard' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayOnHome' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffLinkText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffDisplayOnHome' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'targetName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffTargetName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffTargetType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'videos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayOnHome' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayOnHome' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'targetName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkGalleries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayOnHome' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'associatedCards' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'videoGalleries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayOnHome' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'associatedCards' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'videoName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'exhibitorId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemCards' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quickLinksSettings' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'quickLinkSectionHomePage', block: false }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cardsOrder' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unscheduledCards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemCards' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cardType' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Scheduled_CardsQuery, Get_Scheduled_CardsQueryVariables>;
export const Add_Moderator_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ADD_MODERATOR_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionRequest' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'poll' },
            name: { kind: 'Name', value: 'addPollQuestionInModeratorPoll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Add_Moderator_QuestionMutation, Add_Moderator_QuestionMutationVariables>;
export const Delete_Moderator_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DELETE_MODERATOR_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePollQuestionInModeratorPoll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operation' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Delete_Moderator_QuestionMutation, Delete_Moderator_QuestionMutationVariables>;
export const Get_Assigned_PollsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ASSIGNED_POLLS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'polls' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'myChoices' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Assigned_PollsQuery, Get_Assigned_PollsQueryVariables>;
export const Get_Assigned_Polls_Without_ChoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ASSIGNED_POLLS_WITHOUT_CHOICES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'polls' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Assigned_Polls_Without_ChoicesQuery, Get_Assigned_Polls_Without_ChoicesQueryVariables>;
export const Get_Current_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_CURRENT_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'currentQuestion' },
            name: { kind: 'Name', value: 'getLiveDisplayQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currentQuestionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessionQaQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'QAQuestionAttributes' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'livePollQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QAQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Question' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Current_QuestionQuery, Get_Current_QuestionQueryVariables>;
export const Get_My_ChoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_MY_CHOICES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'polls' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'myChoices' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_My_ChoicesQuery, Get_My_ChoicesQueryVariables>;
export const Get_PollDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_POLL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'poll' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_PollQuery, Get_PollQueryVariables>;
export const Get_Poll_With_ResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_POLL_WITH_RESULTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'poll' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributesWithResults' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributesWithResults' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Poll_With_ResultsQuery, Get_Poll_With_ResultsQueryVariables>;
export const Get_Poll_With_User_ChoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_POLL_WITH_USER_CHOICES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'poll' },
            name: { kind: 'Name', value: 'getAssignedPolls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'myChoices' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Poll_With_User_ChoicesQuery, Get_Poll_With_User_ChoicesQueryVariables>;
export const Modify_Moderator_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MODIFY_MODERATOR_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionRequest' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'poll' },
            name: { kind: 'Name', value: 'modifyPollQuestionInModeratorPoll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Modify_Moderator_QuestionMutation, Modify_Moderator_QuestionMutationVariables>;
export const On_Publish_PollDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_PUBLISH_POLL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onPublishPoll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeePolls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Publish_PollSubscription, On_Publish_PollSubscriptionVariables>;
export const On_Remove_PollDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_REMOVE_POLL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onRemovePoll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Remove_PollSubscription, On_Remove_PollSubscriptionVariables>;
export const On_Update_Current_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_CURRENT_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'currentQuestion' },
            name: { kind: 'Name', value: 'onUpdateLiveDisplayQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentQuestionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'livePollQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessionQaQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'QAQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QAQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Question' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Current_QuestionSubscription, On_Update_Current_QuestionSubscriptionVariables>;
export const On_Update_Poll_Question_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_POLL_QUESTION_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'subscribablePollQuestionStatus' },
            name: { kind: 'Name', value: 'onUpdatePollQuestionStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  On_Update_Poll_Question_StatusSubscription,
  On_Update_Poll_Question_StatusSubscriptionVariables
>;
export const On_Update_Poll_ResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_POLL_RESULTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'subscribablePollQuestionResults' },
            name: { kind: 'Name', value: 'onUpdatePollAggregation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeePolls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollAttributes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeePoll' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isModeratorEditable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Poll_ResultsSubscription, On_Update_Poll_ResultsSubscriptionVariables>;
export const Prepare_RespondentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PREPARE_RESPONDENTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'prepareRespondentsRequest' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prepareRespondents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pollsWithRespondents' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollsWithoutRespondents' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Prepare_RespondentsMutation, Prepare_RespondentsMutationVariables>;
export const Respond_To_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RESPOND_TO_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'choices' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'subscribablePollQuestionChoiceResults' },
            name: { kind: 'Name', value: 'respondToQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'choices' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'choices' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Respond_To_QuestionMutation, Respond_To_QuestionMutationVariables>;
export const Set_Live_Display_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SET_LIVE_DISPLAY_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentQuestionType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CurrentQuestionType' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'currentQuestion' },
            name: { kind: 'Name', value: 'setLiveDisplayQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentQuestionType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentQuestionType' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentQuestionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'livePollQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionAttributes' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessionQaQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'QAQuestionAttributes' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoice' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'choice' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestionChoiceResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'choiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percent' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PollQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PollQuestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'choices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceAttributes' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'results' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PollQuestionChoiceResultAttributes' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QAQuestionAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Question' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Set_Live_Display_QuestionMutation, Set_Live_Display_QuestionMutationVariables>;
export const Update_Poll_Question_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_POLL_QUESTION_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StatusType' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'subscribablePollQuestionStatus' },
            name: { kind: 'Name', value: 'updatePollQuestionStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pollId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pollId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pollId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closedDateTime' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Poll_Question_StatusMutation, Update_Poll_Question_StatusMutationVariables>;
export const Create_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CREATE_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NewQuestionInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Create_QuestionMutation, Create_QuestionMutationVariables>;
export const Fetch_Config_AttendeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FETCH_CONFIG_ATTENDEE' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchConfigForAttendee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'appConfigString' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Fetch_Config_AttendeeQuery, Fetch_Config_AttendeeQueryVariables>;
export const Get_Moderator_Settings_And_CodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_MODERATOR_SETTINGS_AND_CODES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'eventSettings' },
            name: { kind: 'Name', value: 'getEventSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'liveDisplayShortUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'moderatorApprovalLimit' } }
              ]
            }
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'sessionCodes' },
            name: { kind: 'Name', value: 'getSessionCodes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationCode' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Moderator_Settings_And_CodesQuery, Get_Moderator_Settings_And_CodesQueryVariables>;
export const Get_QuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_QUESTIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'QuestionStatusType' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'qaQuestions' },
            name: { kind: 'Name', value: 'getQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'questions' },
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_QuestionsQuery, Get_QuestionsQueryVariables>;
export const Get_Session_SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SESSION_SETTINGS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'liveQASessionSettings' },
            name: { kind: 'Name', value: 'getSessionSettingsForAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaCustomTimeFrameEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaStartDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEndDateTime' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Session_SettingsQuery, Get_Session_SettingsQueryVariables>;
export const On_Update_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QuestionStatusType' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_QuestionSubscription, On_Update_QuestionSubscriptionVariables>;
export const On_Update_Session_SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_SESSION_SETTINGS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateSessionSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaCustomTimeFrameEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaStartDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEndDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoModerationEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'askAnonymouslyEnabled' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Session_SettingsSubscription, On_Update_Session_SettingsSubscriptionVariables>;
export const Set_Question_AnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SET_QUESTION_ANSWER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QuestionAnswerInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setQuestionTextAnswer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Set_Question_AnswerMutation, Set_Question_AnswerMutationVariables>;
export const Update_Question_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_QUESTION_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionStatusInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QuestionStatusInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateQuestionStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionStatusInput' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Question_StatusMutation, Update_Question_StatusMutationVariables>;
export const Update_Session_SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_SESSION_SETTINGS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SessionSettingsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSessionSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaCustomTimeFrameEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaStartDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qaEndDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoModerationEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'askAnonymouslyEnabled' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Session_SettingsMutation, Update_Session_SettingsMutationVariables>;
export const Up_Vote_QuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UP_VOTE_QUESTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upVoteQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAnonymous' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voteCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusChangeDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVoted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Up_Vote_QuestionMutation, Up_Vote_QuestionMutationVariables>;
export const Authorize_Pub_Nub_EntityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AUTHORIZE_PUB_NUB_ENTITY' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'authKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authorizePubNubEntity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'authKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'authKey' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'publishKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channels' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Authorize_Pub_Nub_EntityQuery, Authorize_Pub_Nub_EntityQueryVariables>;
export const Get_Pub_Nub_ConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PUB_NUB_CONFIG' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PubNubClientType' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pubNubConfig' },
            name: { kind: 'Name', value: 'getPubNubConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientType' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'publishKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribeKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channels' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Pub_Nub_ConfigQuery, Get_Pub_Nub_ConfigQueryVariables>;
export const Revoke_Pub_Nub_Auth_KeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'REVOKE_PUB_NUB_AUTH_KEY' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'authKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokePubNubAuthKey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'authKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'authKey' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Revoke_Pub_Nub_Auth_KeyMutation, Revoke_Pub_Nub_Auth_KeyMutationVariables>;
export const Apply_DiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'APPLY_DISCOUNT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscountInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyDiscount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'regCartId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderTotal' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTaxAmount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuto' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTypeServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAmountServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Apply_DiscountMutation, Apply_DiscountMutationVariables>;
export const Get_Order_DetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ORDER_DETAILS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'regCartStatusInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegCartStatusInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOrderSummaryDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'regCartStatusInput' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'regCartId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configurationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTotal' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTaxAmount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuto' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTypeServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAmountServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Order_DetailsQuery, Get_Order_DetailsQueryVariables>;
export const Get_Order_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ORDER_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderCheckoutStatusInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderCheckoutStatusInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOrderCheckoutStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderCheckoutStatusInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderCheckoutStatusInput' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admissionItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Order_StatusQuery, Get_Order_StatusQueryVariables>;
export const Get_Order_SummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GET_ORDER_SUMMARY' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitiateRegModInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initiateRegModAndGetOrderSummaryDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'regCartId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'configurationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderTotal' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTaxAmount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuto' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTypeServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAmountServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Order_SummaryMutation, Get_Order_SummaryMutationVariables>;
export const Get_Payment_Method_Service_FeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_PAYMENT_METHOD_SERVICE_FEES' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPaymentMethodServiceFees' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'paymentMethod' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adjustmentType' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Payment_Method_Service_FeesQuery, Get_Payment_Method_Service_FeesQueryVariables>;
export const Order_CheckoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ORDER_CHECKOUT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderCheckoutInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderCheckoutInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initiateOrderCheckout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderCheckoutInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderCheckoutInput' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Order_CheckoutMutation, Order_CheckoutMutationVariables>;
export const Remove_DiscountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'REMOVE_DISCOUNT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DiscountInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeDiscount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'regCartId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderTotal' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTaxAmount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuto' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTypeServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAmountServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Remove_DiscountMutation, Remove_DiscountMutationVariables>;
export const Update_RegcartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_REGCART' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegCartInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRegCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'regCartId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subTotal' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'admissionItemPrice' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalTaxAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAuto' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTypeServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentAmountServiceFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_RegcartMutation, Update_RegcartMutationVariables>;
export const Update_Regcart_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_REGCART_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegCartStatusInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRegCartStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Regcart_StatusMutation, Update_Regcart_StatusMutationVariables>;
export const Get_Post_Reg_Redirect_UrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_POST_REG_REDIRECT_URL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postRegRedirectUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeEmail' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'redirect' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postRegRedirectUrl' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationId' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Post_Reg_Redirect_UrlQuery, Get_Post_Reg_Redirect_UrlQueryVariables>;
export const Get_Event_Profile_SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENT_PROFILE_SETTINGS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEventProfileSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileFieldGroupSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileFieldGroupsList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'forceReadOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueRequired' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileCardDesignSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileCardDesignSettingsList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'border' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventBranding' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignment' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Event_Profile_SettingsQuery, Get_Event_Profile_SettingsQueryVariables>;
export const Agenda_DatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AGENDA_DATES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AgendaDatesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAgendaDates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'agendaDate' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Agenda_DatesQuery, Agenda_DatesQueryVariables>;
export const Search_ScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SCHEDULE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MyAgendaCriteria' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionFee' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAgenda' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webcast' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnDemandContentPlayable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'solutionType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'player' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stream' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'capacity' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'virtualAttendee' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } }
                          }
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fee' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionFee' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participants' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requesters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'apptType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timeSlotType' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'conflict' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableAttendeeActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'decline' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_ScheduleQuery, Search_ScheduleQueryVariables>;
export const Search_Schedule_With_SpeakersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SCHEDULE_WITH_SPEAKERS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MyAgendaCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAgenda' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtualLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webcast' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnDemandContentPlayable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'solutionType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'player' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stream' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participants' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileImageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speakers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'socialLinks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_Schedule_With_SpeakersQuery, Search_Schedule_With_SpeakersQueryVariables>;
export const Add_ReactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ADD_REACTION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddReactionInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addReaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'environment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountMappingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reactionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streamOffsetSecs' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Add_ReactionMutation, Add_ReactionMutationVariables>;
export const Generate_Attendee_Join_UrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GENERATE_ATTENDEE_JOIN_URL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeRegistrationInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttendeeRegistrationInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateAttendeeJoinUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendeeRegistrationInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attendeeRegistrationInput' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'joinUrl' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Generate_Attendee_Join_UrlMutation, Generate_Attendee_Join_UrlMutationVariables>;
export const Generate_Webcast_Signature_V2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GENERATE_WEBCAST_SIGNATURE_V2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateWebcastSignatureV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signatureExpirationDate' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Generate_Webcast_Signature_V2Mutation, Generate_Webcast_Signature_V2MutationVariables>;
export const Get_Attendee_On_Demand_CatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ATTENDEE_ON_DEMAND_CATALOG' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OnDemandPageInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttendeeOnDemandCatalogV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'catalogType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sectionCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'videoCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sectionType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'videos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'session' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'exhibitors' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevelId' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Attendee_On_Demand_CatalogQuery, Get_Attendee_On_Demand_CatalogQueryVariables>;
export const Get_Has_Reactions_DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_HAS_REACTIONS_DATA' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getHasReactionsData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasData' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Has_Reactions_DataQuery, Get_Has_Reactions_DataQueryVariables>;
export const Get_ReactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_REACTIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startSecs' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endSecs' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startSecs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startSecs' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endSecs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endSecs' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactionCountsByType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reactionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'counts' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'streamTimeStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streamTimeEnd' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_ReactionsQuery, Get_ReactionsQueryVariables>;
export const Get_Reactions_ConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_REACTIONS_CONFIG' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReactionsSessionConfigAttendee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reactionTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Reactions_ConfigQuery, Get_Reactions_ConfigQueryVariables>;
export const Session_FiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SESSION_FILTERS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SessionFilterCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sessionFilters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valuesWithSpeakers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SessionFilterValue' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SessionSpeakerFilterValue' }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'designation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dates' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessionGuide' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preFilters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'filters' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'filterId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Session_FiltersQuery, Session_FiltersQueryVariables>;
export const Get_Session_Live_Viewer_CountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SESSION_LIVE_VIEWER_COUNT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSessionLiveViewerCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'liveViewers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Session_Live_Viewer_CountQuery, Get_Session_Live_Viewer_CountQueryVariables>;
export const Get_Session_Live_Viewer_Count_At_OffsetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SESSION_LIVE_VIEWER_COUNT_AT_OFFSET' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'batchSize' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSessionLiveViewerCountAtOffset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'batchSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'batchSize' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'environment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                { kind: 'Field', name: { kind: 'Name', value: 'batchSize' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'liveViewerCounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'liveViewers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  Get_Session_Live_Viewer_Count_At_OffsetQuery,
  Get_Session_Live_Viewer_Count_At_OffsetQueryVariables
>;
export const Get_Session_Participant_StatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SESSION_PARTICIPANT_STATUS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSessionParticipantStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Session_Participant_StatusQuery, Get_Session_Participant_StatusQueryVariables>;
export const Get_Webcast_LinksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_WEBCAST_LINKS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getWebcastLinks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'host' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speaker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Webcast_LinksQuery, Get_Webcast_LinksQueryVariables>;
export const Livestream_JobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LIVESTREAM_JOB' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'livestreamJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Livestream_JobQuery, Livestream_JobQueryVariables>;
export const OnStudioEndSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'onStudioEndSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onStudioEndSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'webcastId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<OnStudioEndSessionSubscription, OnStudioEndSessionSubscriptionVariables>;
export const On_Update_Reaction_CountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ON_UPDATE_REACTION_COUNTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateReactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'environment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactionsData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'streamOffsetSecs' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reactionCountTuples' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'reactionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'counts' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<On_Update_Reaction_CountsSubscription, On_Update_Reaction_CountsSubscriptionVariables>;
export const OnUpdateWebcastConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'onUpdateWebcastConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateWebcastConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'webcastId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'webcastId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<OnUpdateWebcastConfigSubscription, OnUpdateWebcastConfigSubscriptionVariables>;
export const OnUpdateWebcastLiveStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'onUpdateWebcastLiveStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onUpdateWebcastLiveStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'webcastId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'playerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webcastId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streamStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<OnUpdateWebcastLiveStatusSubscription, OnUpdateWebcastLiveStatusSubscriptionVariables>;
export const Publish_EncounterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PUBLISH_ENCOUNTER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'session' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'time' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AWSDateTime' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relative' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EncounterMode' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishEncounter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'session' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'time' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'time' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relativeTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'relative' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'encounterMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Publish_EncounterMutation, Publish_EncounterMutationVariables>;
export const Search_SessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SESSIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchSessionCriteria' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchSessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'capacity' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'virtualAttendee' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } }
                          }
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'admissionItems' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'upgradeAdmissionItem', block: false }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upgrade' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'upgradeAdmissionItem', block: false }
                              }
                            ]
                          }
                        ]
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recommended' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sessionSpeakers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'prefix' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'plannerSelected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevelId' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fee' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'sessionFee', block: false }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webcast' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnDemandContentPlayable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'player' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stream' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_SessionsQuery, Search_SessionsQueryVariables>;
export const Search_Sessions_CountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SESSIONS_COUNT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchSessionCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchSessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_Sessions_CountQuery, Search_Sessions_CountQueryVariables>;
export const Search_Sessions_SwapDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SESSIONS_SWAP' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchSessionCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchSessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_Sessions_SwapQuery, Search_Sessions_SwapQueryVariables>;
export const Search_Sessions_With_On_DemandDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SESSIONS_WITH_ON_DEMAND' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchSessionCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOnDemandSessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nextToken' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onDemandVideo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_Sessions_With_On_DemandQuery, Search_Sessions_With_On_DemandQueryVariables>;
export const Session_DetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SESSION_DETAIL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'qaLimit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sessionDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'qaLimit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'qaLimit' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recommended' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPoll' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speakers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'socialLinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'webcast' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meetingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attendee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'host' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'join' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'speaker' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'solutionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'simulatedLive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'player' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoThumbnailUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'password' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stream' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'recording' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qaEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qaCustomTimeFrameEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qaStartDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'qaEndDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoModerationEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'askAnonymouslyEnabled' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'plannerSelected' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extension' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stream' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'channelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feedbackSurvey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'surveyUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startOffset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'closeDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'audience' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevelId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sponsorshipLevel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fee' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'sessionFee', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationThresholdSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'participationThreshold' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'participationLiveOnly' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'widgets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'widgetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'widgetTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'widgetIcon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'capacity' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'virtualAttendee' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } }
                    }
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'floorPlan' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'floorPlansEnabled', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Session_DetailQuery, Session_DetailQueryVariables>;
export const Session_EnrollmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SESSION_ENROLLMENT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionEnrollmentInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SessionEnrollmentInput' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionFee' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sessionEnrollment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionEnrollmentInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionEnrollmentInput' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tokens' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'warningMessage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'session1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'session2' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fee' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionFee' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'recommended' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'capacity' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'virtualAttendee' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } }
                          }
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Session_EnrollmentMutation, Session_EnrollmentMutationVariables>;
export const Studio_End_SessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'STUDIO_END_SESSION' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'studioEndSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'webcastId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'webcastId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'webcastId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Studio_End_SessionMutation, Studio_End_SessionMutationVariables>;
export const Verify_Session_ChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VERIFY_SESSION_CHAT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifySessionChat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorValue' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Verify_Session_ChatMutation, Verify_Session_ChatMutationVariables>;
export const Verify_Session_Chat_ModeratorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VERIFY_SESSION_CHAT_MODERATOR' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifySessionChatModerator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isModerator' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Verify_Session_Chat_ModeratorMutation, Verify_Session_Chat_ModeratorMutationVariables>;
export const Get_Featured_SpeakersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_FEATURED_SPEAKERS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeakerListCriteria' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSpeakerList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Featured_SpeakersQuery, Get_Featured_SpeakersQueryVariables>;
export const Get_Speaker_BioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SPEAKER_BIO' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'speakerCriteria' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeakerCriteria' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionFee' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSpeakerBio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'speakerCriteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'speakerCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'friendlyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayEnabled' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'socialLinks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'capacity' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'virtualAttendee' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'virtualAttendee' } }
                          }
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionCapacity' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fee' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enableSessionFee' } }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'admissionItems' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'upgradeAdmissionItem', block: false }
                              }
                            ]
                          }
                        ]
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upgrade' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'upgradeAdmissionItem', block: false }
                              }
                            ]
                          }
                        ]
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recommended' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sessionSpeakers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'prefix' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'plannerSelected' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevelId' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fee' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'sessionFee', block: false }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'webcast' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onDemandVideo' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isOnDemandContentPlayable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'player' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playerTypeProvider' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stream' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internalNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                { kind: 'Field', name: { kind: 'Name', value: 'speakerCategoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'speakerCategoryName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Speaker_BioQuery, Get_Speaker_BioQueryVariables>;
export const Get_Speaker_ListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SPEAKER_LIST' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeakerListCriteria' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSpeakerList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'featuredFilterable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speakerCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speakerCategoryId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Speaker_ListQuery, Get_Speaker_ListQueryVariables>;
export const Get_Speaker_List_For_FilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SPEAKER_LIST_FOR_FILTER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeakerListCriteria' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSpeakerList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currentToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previousToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Speaker_List_For_FilterQuery, Get_Speaker_List_For_FilterQueryVariables>;
export const Get_Speaker_NamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_SPEAKER_NAMES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SpeakerListCriteria' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSpeakerList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Speaker_NamesQuery, Get_Speaker_NamesQueryVariables>;
export const Search_SponsorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SEARCH_SPONSORS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sponsorSearchCriteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SponsorSearchCriteria' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchSponsors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criteria' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sponsorSearchCriteria' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sponsorshipLevels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasVirtualBooths' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasVirtualBooth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventSponsor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sponsorshipLevels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featured' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previewExhibitors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Search_SponsorsQuery, Search_SponsorsQueryVariables>;
export const GetLocalizedLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLocalizedLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLocalizedLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'locationCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationTranslation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetLocalizedLocationsQuery, GetLocalizedLocationsQueryVariables>;
export const HeartbeatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HEARTBEAT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'heartbeatInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'HeartbeatInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heartbeatV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'heartbeatInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'heartbeatInput' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionExtendedStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'encounterPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boothStaffAvailabilityHeartbeatStatus' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<HeartbeatMutation, HeartbeatMutationVariables>;
export const LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LOGOUT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'LogoutInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'revokeStreamTokens' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ME' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionCriteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchSessionCriteria' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
                { kind: 'Field', name: { kind: 'Name', value: 'doNotSell' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalInterests' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'attendeeInterests', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commonInterest' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admissionItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeCanUpgradeAdmissionItem' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeeHasChannels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasChannels' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resetAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowPushNotifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowAppointmentPushNotifications' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isGlobalModerator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionsToModerate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'audienceEngagement' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoHost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'speakerRoom' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'boothStaff' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasAccepted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terms' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'filterOrder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitorConsentQuestion' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optInId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optInText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutText' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitorConsentAnswer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preferences' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'profileOnboarding', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferenceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'preferenceValue' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'event' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cultureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezoneId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cventPrivacyPolicyText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showCookieBanner' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showCookieBannerPrivacyPolicyLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showNonEssentialCookieBanner' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validStart' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validEnd' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'surveys' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'privacyPolicy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'appointment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpa' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ccpaData' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'appFeature' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feature' },
                                value: { kind: 'StringValue', value: 'showCcpaModalEnabled', block: false }
                              }
                            ]
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaExternalDoNotSellUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaButtonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaConfirmationText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaExplanationText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaInviteeValidationText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaLinkText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showCcpaSectionFlag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showCCPA' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaOptOutFormType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ccpaDoNotSellUrl' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'features' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'exhibitorManagement' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showExhibitorList' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionQA' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sponsors' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showSponsorList' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'exhibitorsPresent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gamePresent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'livePolling' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onDemandCatalog' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionRecommendations' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'speakers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'floorPlans' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentEvents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apptEventCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apptEventType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appConfig' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'appConfigString' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'webConfig' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'headerImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coverImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'coverImageAltText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryHeaderImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryHeaderImageAltText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionHeaderImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionHeaderImageAltText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultProfileVisibility' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'manageProfileEnabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'footerImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'footerImageAltText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'loginBackgroundImage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'loginBackgroundImageAltText' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountConfig' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hideCventFooter' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceOverrides' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'locale' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'platform' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overrides' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'liveAndUpcoming' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'sessionCriteria' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionCriteria' } }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enrolled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openForRegistration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openForAttendeeHub' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'virtual' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'recommended' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'capacity' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'appFeature' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'feature' },
                                      value: { kind: 'StringValue', value: 'sessionCapacity', block: false }
                                    }
                                  ]
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'availableCapacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalCapacityAvailable' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fee' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'appFeature' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'feature' },
                                      value: { kind: 'StringValue', value: 'sessionFee', block: false }
                                    }
                                  ]
                                }
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'webcast' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playerType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'player' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'videoId' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'stream' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'simuliveOffset' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'exhibitors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'profileLogoUrl' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sessionTags' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'codeSnippets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataTagCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'codeSnippetValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'applicableOn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canDisableCodeSnippet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportedEventLocales' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'localeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'languageName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'languageCountry' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cultureCode' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventTheme' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'logoImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoImageOptimized' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const Me_Admission_ItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ME_ADMISSION_ITEM' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admissionItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Me_Admission_ItemQuery, Me_Admission_ItemQueryVariables>;
export const Me_Appt_And_Guest_CodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ME_APPT_AND_GUEST_CODE' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'event' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentEvents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apptEventCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apptEventType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readOnly' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'format' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'boothStaff' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Me_Appt_And_Guest_CodeQuery, Me_Appt_And_Guest_CodeQueryVariables>;
export const Me_Confirmation_NumberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ME_CONFIRMATION_NUMBER' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'confirmationNumber' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Me_Confirmation_NumberQuery, Me_Confirmation_NumberQueryVariables>;
export const Me_Consent_Exhibitor_AnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ME_CONSENT_EXHIBITOR_ANSWER' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exhibitorConsentAnswer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendeeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answerId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Me_Consent_Exhibitor_AnswerQuery, Me_Consent_Exhibitor_AnswerQueryVariables>;
export const Update_Attendee_ComplianceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_ATTENDEE_COMPLIANCE' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAttendeeCompliance' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestReceived' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Attendee_ComplianceMutation, Update_Attendee_ComplianceMutationVariables>;
export const Update_Profile_SecuredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_PROFILE_SECURED' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileSecuredUpdateInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfileSecured' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowPushNotifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowAppointmentPushNotifications' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Update_Profile_SecuredMutation, Update_Profile_SecuredMutationVariables>;
export const Update_Profile_Secured_With_InterestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UPDATE_PROFILE_SECURED_WITH_INTERESTS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileSecuredUpdateInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfileSecured' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regionCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedInUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalInterests' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'appFeature' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'feature' },
                          value: { kind: 'StringValue', value: 'attendeeInterests', block: false }
                        }
                      ]
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commonInterest' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowPushNotifications' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowAppointmentPushNotifications' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  Update_Profile_Secured_With_InterestsMutation,
  Update_Profile_Secured_With_InterestsMutationVariables
>;
export const VideoDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'videoDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'videoId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'href' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<VideoDetailsQuery, VideoDetailsQueryVariables>;
export const On_Demand_Video_Details_For_Dry_RunDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ON_DEMAND_VIDEO_DETAILS_FOR_DRY_RUN' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onDemandVideoDetailsForDryRun' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'videoId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textTracks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  On_Demand_Video_Details_For_Dry_RunQuery,
  On_Demand_Video_Details_For_Dry_RunQueryVariables
>;
export const Video_On_Demand_Playback_DetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VIDEO_ON_DEMAND_PLAYBACK_DETAILS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VideoAssociationEntityType' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoOnDemandPlaybackDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'videoId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'videoId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'poster' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textTracks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ttl' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Video_On_Demand_Playback_DetailsQuery, Video_On_Demand_Playback_DetailsQueryVariables>;
export const Get_Event_FeaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENT_FEATURES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'features' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'features' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'features' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureCode' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Event_FeaturesQuery, Get_Event_FeaturesQueryVariables>;
export const Event_Info_PageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EVENT_INFO_PAGE' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'features' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'features' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'features' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speakers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biography' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Event_Info_PageQuery, Event_Info_PageQueryVariables>;
export const EventInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'eventInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'features' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'features' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'features' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCancelled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSignUpEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventInfoTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'theme' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'eventLicenseTypeName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'theme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfoTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'background' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mood' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safeMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferFormula' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'illustrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hideAll' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reassignedIcons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reassignment' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headingFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<EventInfoQuery, EventInfoQueryVariables>;
export const GetAppFeaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppFeatures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appFeatures' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppFeatureInput' } }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAppFeatures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appFeatures' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appFeatures' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'experimentVersion' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetAppFeaturesQuery, GetAppFeaturesQueryVariables>;
export const GetExperimentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getExperiment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'experimentName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getExperiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'experimentName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'experimentName' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'experimentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetExperimentQuery, GetExperimentQueryVariables>;
export const Get_Event_Features_And_SpeakersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENT_FEATURES_AND_SPEAKERS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'features' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Platform' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'features' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'features' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultLocale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speakers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'company' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileImageUri' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biography' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventInfoTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'theme' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coverImageOptimized' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coverImageAltText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoImageOptimized' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCancelled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpenAccessEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showCookieBanner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showCookieBannerPrivacyPolicyLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showNonEssentialCookieBanner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideCventFooter' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ccpaData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ccpaExternalDoNotSellUrl' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cventPrivacyPolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'showCventPrivacyPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cventPrivacyPolicyLinkText' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventPrivacyPolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'showPrivacyPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyPolicyUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyPolicyLinkText' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'codeSnippets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dataTagCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'codeSnippetValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'applicableOn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDisableCodeSnippet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'venues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address3' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceOverrides' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overrides' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'theme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfoTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'background' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mood' } },
          { kind: 'Field', name: { kind: 'Name', value: 'safeMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferFormula' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'illustrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hideAll' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reassignedIcons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reassignment' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headingFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyFont' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fallbackFont' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'styles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'style' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Event_Features_And_SpeakersQuery, Get_Event_Features_And_SpeakersQueryVariables>;
export const Get_Event_SessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_EVENT_SESSIONS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'features' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'features' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'features' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<Get_Event_SessionsQuery, Get_Event_SessionsQueryVariables>;
